export const goodInfo = [
  {
    "createBy": "admin",
    "createTime": 1585797761737,
    "currency": "CNY",
    "destinationCountry": "US",
    "districtCode": "23",
    "dutyMode": "test",
    "exgNo": "12345",
    "exgVersion": "1.1",
    "goodsCode": "0201100010",
    "goodsName": "整头及半头鲜或冷藏的野牛肉",
    "goodsNo": "1",
    "goodsQuantity": "5",
    "goodsUnit": "千克",
    "id": 1245552205704953857,
    "originCountry": "CN",
    "quantityOne": "1",
    "quantityTwo": "20",
    "specification": "|test|2||",
    "totalPrice": "100",
    "trackingNumber": "1111111",
    "unitOne": "头",
    "unitPrice": "10",
    "unitTwo": "千克",
    "updateTime": 1585797761737,
    "originCode": "originCode",
    "contrItem": "contrItem",
    "ciqName": "ciqName"
  },
  {
    "createBy": "admin",
    "createTime": 1585797761740,
    "currency": "CNY",
    "destinationCountry": "US",
    "districtCode": "23",
    "dutyMode": "test",
    "exgNo": "12345",
    "exgVersion": "1.1",
    "goodsCode": "",
    "goodsName": "其他整头及半头鲜或冷藏的牛肉",
    "goodsNo": "2",
    "goodsQuantity": "5",
    "goodsUnit": "千克",
    "id": 1245552205713342466,
    "originCountry": "CN",
    "quantityOne": "1",
    "quantityTwo": "20",
    "specification": "|test|2||",
    "totalPrice": "100",
    "trackingNumber": "1111111",
    "unitOne": "头",
    "unitPrice": "10",
    "unitTwo": "千克",
    "updateTime": 1585797761740,
    "originCode": "originCode",
    "contrItem": "contrItem",
    "ciqName": "ciqName"
  }
]

export const formData = {
  "billNo": "123",
  "consigneeCompanyCn": "123",
  "consigneeCompanyEn": "123",
  "consigneeCustomMaster": "123",
  "consigneeInspectCode": "123",
  "consigneeScc": "123",
  "consignorScc": "123",
  "containerCount": "123",
  "contractNo": "1111",
  "createBy": "admin",
  "createTime": 1585797761850,
  "customMaster": "XX海关",
  "customType": "123",
  "cutMode": "123",
  "declarationStatus": 1,
  "declareCompanyCustomMaster": "123",
  "declareCompanyInspectCode": "123",
  "declareCompanyName": "123",
  "declareCompanyScc": "123",
  "declareDate": "20200103",
  "deliveryTime": "20200103",
  "distinatePort": "123",
  "draftStatus": 0,
  "ieCustoms": "PVG",
  "goodsPlace": "123",
  "grossWeight": "123",
  "id": 1245552206166327297,
  "ieDate": "20200103",
  "iePort": "123",
  "insuranceFeeType": "123",
  "insuranceFeeUnit": "123",
  "insuranceFeeValue": "123",
  "licenceNo": "123",
  "manualNo": "1111",
  "mark": "123",
  "netWeight": "123",
  "note": "123",
  "otherFeeType": "123",
  "otherFeeUnit": "123",
  "otherFeeValue": "123",
  "otherItem": "01",
  "ownerCompanyCustomMaster": "123",
  "ownerCompanyInspectCode": "123",
  "ownerCompanyName": "123",
  "ownerCompanyScc": "123",
  "packageQuantity": "123",
  "packageType": "123",
  "paymentPrivilege": 0,
  "priceImpact": 0,
  "serviceType": "01",
  "shipmentType": "01",
  "specialRelationship": 1,
  "supervisionMode": "123",
  "trackingNumber": "1111111",
  "tradeCountry": "123",
  "tradeMode": "123",
  "trafficMode": "123",
  "trafficName": "123",
  "transpotationFeeType": "123",
  "transpotationFeeUnit": "123",
  "transpotationFeeValue": "123",
  "updateTime": 1585797761850,
  "voyageNo": "123"
}

export const formProData = {
  "declarationGoodsInfo": [],
  "trackingNumber": "",
  "serviceType": "",
  "deliveryTime": "",
  "customMaster": "",
  "ieCustoms": "",
  "manualNo": "",
  "contractNo": "",
  "ieDate": "",
  "declareDate": "",
  "consigneeScc": "",
  "consigneeCustomMaster": "",
  "consigneeInspectCode": "",
  "consigneeCompanyCn": "",
  "consignorScc": "",
  "consignorCompanyEn": "",
  "ownerCompanyScc": "",
  "ownerCompanyCustomMaster": "",
  "ownerCompanyInspectCode": "",
  "ownerCompanyName": "",
  "declareCompanyName": "",
  "declareCompanyScc": "",
  "declareCompanyCustomMaster": "",
  "declareCompanyInspectCode": "",
  "trafficMode": "",
  "trafficName": "",
  "voyageNo": "",
  "billNo": "",
  "supervisionMode": "",
  "cutMode": "",
  "licenceNo": "",
  "tradeCountry": "",
  "distinatePort": "",
  "tradeMode": "",
  "transpotationFeeType": "",
  "transpotationFeeValue": "",
  "transpotationFeeUnit": "",
  "insuranceFeeType": "",
  "insuranceFeeValue": "",
  "insuranceFeeUnit": "",
  "otherFeeType": "",
  "insuranceFee": "",
  "otherFeeValue": "",
  "otherFeeUnit": "",
  "packageQuantity": "",
  "packageType": "",
  "grossWeight": "",
  "netWeight": "",
  "containerCount": "",
  "goodsPlace": "",
  "iePort": "",
  "customType": "",
  "mark": "",
  "note": "",
  "specialRelationship": 0,
  "priceImpact": 0,
  "paymentPrivilege": 0,
  "otherItem": "",
  "shipmentType": 0,
  "status": 0,
  "user": "",
  "cusCiqNo": "",
  "preEntryId": "",
  "entryId": "",
  "declarationStatus": "",
  "tradeCountryCode": "",
  "preDecLicense": "",
  "despPort": ""
}
//服务类型
export const serviceType = [
  {
    Description: "UPS Worldwide Express Plus",
    Code: "054"
  },
  {
    Description: "UPS Worldwide Express",
    Code: "007"
  },
  {
    Description: "UPS Worldwide Express Freight Midday", // 出口有，进口没有
    Code: "071"
  },
  {
    Description: "UPS Worldwide Express Freight",
    Code: "011"
  },
  {
    Description: "UPS Worldwide Express Saver",
    Code: "065"
  },
  {
    Description: "UPS Worldwide Expedited",
    Code: "008"
  }
]

// 运输方式代码	运输方式名称
export const transportMode = [
  {
    label: '航空运输',
    code: '5'
  },
  {
    label: '非保税区',
    code: '0'
  },
  {
    label: '监管仓库',
    code: '1'
  },
  {
    label: '水路运输',
    code: '2'
  },
  {
    label: '铁路运输',
    code: '3'
  },
  {
    label: '公路运输',
    code: '4'
  },
  {
    label: '邮件运输',
    code: '6'
  },
  {
    label: '保税区',
    code: '7'
  },
  {
    label: '保税仓库',
    code: '8'
  },
  {
    label: '其它运输',
    code: '9'
  },
  {
    label: '全部运输方式',
    code: 'A'
  },
  {
    label: '边境特殊海关作业区',
    code: 'H'
  },
  {
    label: '物流中心',
    code: 'W'
  },
  {
    label: '物流园区',
    code: 'X'
  },
  {
    label: '保税港区',
    code: 'Y'
  },
  {
    label: '出口加工区',
    code: 'Z'
  }
]
//报关单类型
export const CustomsType = [
  'D-无纸带清单',
  '0-有纸报关',
  'L-有纸带清单',
  'M-通关无纸化',
  'W-无纸报关'
]
// 报关/转关关系标
export const RelationshipMarkerType = ['一般报关单', '转关提前报关单']
// 报关标
export const CustomsDeclarationMarkType = ['北方转关提前', '南方转关提前', '普通报关']
// yes or no
export const YesOrNo = [
  {
    code: '0',
    label: '否'
  },
  {
    code: '1',
    label: '是'
  }
]
export const YesOrNo2 = [
  {
    code: '0',
    label: '不含'
  },
  {
    code: '1',
    label: '含有'
  }
]
// 包装种类
export const WrapType = [
  {
    code: '00',
    name: '散装'
  }, {
    code: '01',
    name: '裸装'
  }, {
    code: '04',
    name: '球状罐类'
  }, {
    code: '06',
    name: '包/装'
  }, {
    code: '22',
    name: '纸制或纤维板制盒/箱'
  }, {
    code: '23',
    name: '木制或竹藤等植物性材料制盒/箱'
  }, {
    code: '29',
    name: '其他材料制盒/箱'
  },
  {
    code: '32',
    name: '纸制或纤维板制桶'
  },
  {
    code: '33',
    name: '木制或竹藤等植物性材料制桶'
  },
  {
    code: '39',
    name: '其他材料制桶'
  },
  {
    code: '41',
    name: '中型散装容器'
  },
  {
    code: '42',
    name: '便携式罐体'
  },
  {
    code: '43',
    name: '可移动罐柜'
  },
  {
    code: '92',
    name: '再生木托'
  },
  {
    code: '93',
    name: '天然木托'
  },
  {
    code: '97',
    name: '其他木制包装'
  },
  {
    code: '98',
    name: '植物性铺垫材料'
  },
  {
    code: '99',
    name: '其他包装'
  },
]
export const WrapTypeC = [
  {
    code: '00',
    name: '纸箱'
  }, 
  {
    code: '01',
    name: '包'
  }, 
  {
    code: '04',
    name: '其他'
  }, 
  {
    code: '06',
    name: '托盘'
  }, 
  {
    code: '22',
    name: '木箱'
  }, 
  {
    code: '23',
    name: '桶装'
  }, 
  {
    code: '29',
    name: '散装'
  }
]
//交易方式
export const TransMode = [
  'CIF',
  'C&F',
  'FOB',
  'C&I',
  '市场价',
  '垫仓',
  'EXW',
]
//监管方式
export const Supervision = [
  {"TRADE_MODE":"0110","ABBR_TRADE":"一般贸易","FULL_TRADE":"一般贸易"},
  {"TRADE_MODE":"0130","ABBR_TRADE":"易货贸易","FULL_TRADE":"易货贸易"},
  {"TRADE_MODE":"0200","ABBR_TRADE":"料件销毁","FULL_TRADE":"加工贸易料件、残次品（折料）销毁"},
  {"TRADE_MODE":"0214","ABBR_TRADE":"来料加工","FULL_TRADE":"来料加工装配贸易进口料件及加工出口货物"},
  {"TRADE_MODE":"0245","ABBR_TRADE":"来料料件内销","FULL_TRADE":"来料加工料件转内销"},
  {"TRADE_MODE":"0255","ABBR_TRADE":"来料深加工","FULL_TRADE":"来料深加工结转货物"},
  {"TRADE_MODE":"0258","ABBR_TRADE":"来料余料结转","FULL_TRADE":"来料加工余料结转"},
  {"TRADE_MODE":"0265","ABBR_TRADE":"来料料件复出","FULL_TRADE":"来料加工复运出境的原进口料件"},
  {"TRADE_MODE":"0300","ABBR_TRADE":"来料料件退换","FULL_TRADE":"来料加工料件退换"},
  {"TRADE_MODE":"0314","ABBR_TRADE":"加工专用油","FULL_TRADE":"国营贸易企业代理来料加工企业进口柴油"},
  {"TRADE_MODE":"0320","ABBR_TRADE":"不作价设备","FULL_TRADE":"加工贸易外商提供的不作价进口设备"},
  {"TRADE_MODE":"0345","ABBR_TRADE":"来料成品减免","FULL_TRADE":"来料加工成品凭征免税证明转减免税"},
  {"TRADE_MODE":"0400","ABBR_TRADE":"边角料销毁","FULL_TRADE":"加工贸易边角料、副产品（按状态）销毁"},
  {"TRADE_MODE":"0420","ABBR_TRADE":"加工贸易设备","FULL_TRADE":"加工贸易项下外商提供的进口设备"},
  {"TRADE_MODE":"0444","ABBR_TRADE":"保区进料成品","FULL_TRADE":"按成品征税的保税区进料加工成品转内销货物"},
  {"TRADE_MODE":"0445","ABBR_TRADE":"保区来料成品","FULL_TRADE":"按成品征税的保税区来料加工成品转内销货物"},
  {"TRADE_MODE":"0446","ABBR_TRADE":"加工设备内销","FULL_TRADE":"加工贸易免税进口设备转内销"},
  {"TRADE_MODE":"0456","ABBR_TRADE":"加工设备结转","FULL_TRADE":"加工贸易免税进口设备结转"},
  {"TRADE_MODE":"0466","ABBR_TRADE":"加工设备退运","FULL_TRADE":"加工贸易免税进口设备退运出境"},
  {"TRADE_MODE":"0500","ABBR_TRADE":"减免设备结转","FULL_TRADE":"用于监管年限内减免税设备的结转"},
  {"TRADE_MODE":"0513","ABBR_TRADE":"补偿贸易","FULL_TRADE":"补偿贸易"},
  {"TRADE_MODE":"0544","ABBR_TRADE":"保区进料料件","FULL_TRADE":"按料件征税的保税区进料加工成品转内销货物"},
  {"TRADE_MODE":"0545","ABBR_TRADE":"保区来料料件","FULL_TRADE":"按料件征税的保税区来料加工成品转内销货物"},
  {"TRADE_MODE":"0615","ABBR_TRADE":"进料对口","FULL_TRADE":"进料加工(对口合同)"},
  {"TRADE_MODE":"0642","ABBR_TRADE":"进料以产顶进","FULL_TRADE":"进料加工成品以产顶进"},
  {"TRADE_MODE":"0644","ABBR_TRADE":"进料料件内销","FULL_TRADE":"进料加工料件转内销"},
  {"TRADE_MODE":"0654","ABBR_TRADE":"进料深加工","FULL_TRADE":"进料深加工结转货物"},
  {"TRADE_MODE":"0657","ABBR_TRADE":"进料余料结转","FULL_TRADE":"进料加工余料结转"},
  {"TRADE_MODE":"0664","ABBR_TRADE":"进料料件复出","FULL_TRADE":"进料加工复运出境的原进口料件"},
  {"TRADE_MODE":"0700","ABBR_TRADE":"进料料件退换","FULL_TRADE":"进料加工料件退换"},
  {"TRADE_MODE":"0715","ABBR_TRADE":"进料非对口","FULL_TRADE":"进料加工(非对口合同)"},
  {"TRADE_MODE":"0744","ABBR_TRADE":"进料成品减免","FULL_TRADE":"进料加工成品凭征免税证明转减免税"},
  {"TRADE_MODE":"0815","ABBR_TRADE":"低值辅料","FULL_TRADE":"低值辅料"},
  {"TRADE_MODE":"0844","ABBR_TRADE":"进料边角料内销","FULL_TRADE":"进料加工项下边角料转内销"},
  {"TRADE_MODE":"0845","ABBR_TRADE":"来料边角料内销","FULL_TRADE":"来料加工项下边角料内销"},
  {"TRADE_MODE":"0864","ABBR_TRADE":"进料边角料复出","FULL_TRADE":"进料加工项下边角料复出口"},
  {"TRADE_MODE":"0865","ABBR_TRADE":"来料边角料复出","FULL_TRADE":"来料加工项下边角料复出口"},
  {"TRADE_MODE":"1039","ABBR_TRADE":"市场采购","FULL_TRADE":"市场采购"},
  {"TRADE_MODE":"1139","ABBR_TRADE":"国轮油物料","FULL_TRADE":"中国籍运输工具境内添加的保税油料、物料"},
  {"TRADE_MODE":"1200","ABBR_TRADE":"保税间货物","FULL_TRADE":"海关保税场所及保税区域之间往来的货物"},
  {"TRADE_MODE":"1210","ABBR_TRADE":"保税电商","FULL_TRADE":"保税跨境贸易电子商务"},
  {"TRADE_MODE":"1215","ABBR_TRADE":"保税工厂","FULL_TRADE":"保税工厂"},
  {"TRADE_MODE":"1233","ABBR_TRADE":"保税仓库货物","FULL_TRADE":"保税仓库进出境货物"},
  {"TRADE_MODE":"1234","ABBR_TRADE":"保税区仓储转口","FULL_TRADE":"保税区进出境仓储转口货物"},
  {"TRADE_MODE":"1239","ABBR_TRADE":"保税电商A","FULL_TRADE":"保税跨境贸易电子商务A"},
  {"TRADE_MODE":"1300","ABBR_TRADE":"修理物品","FULL_TRADE":"进出境修理物品"},
  {"TRADE_MODE":"1371","ABBR_TRADE":"保税维修","FULL_TRADE":"保税维修"},
  {"TRADE_MODE":"1427","ABBR_TRADE":"出料加工","FULL_TRADE":"出料加工"},
  {"TRADE_MODE":"1500","ABBR_TRADE":"租赁不满1年","FULL_TRADE":"租期不满1年的租赁贸易货物"},
  {"TRADE_MODE":"1523","ABBR_TRADE":"租赁贸易","FULL_TRADE":"租期在1年及以上的租赁贸易货物"},
  {"TRADE_MODE":"1616","ABBR_TRADE":"寄售代销","FULL_TRADE":"寄售、代销贸易"},
  {"TRADE_MODE":"1741","ABBR_TRADE":"免税品","FULL_TRADE":"免税品"},
  {"TRADE_MODE":"1831","ABBR_TRADE":"外汇商品","FULL_TRADE":"免税外汇商品"},
  {"TRADE_MODE":"2025","ABBR_TRADE":"合资合作设备","FULL_TRADE":"合资合作企业作为投资进口设备物品"},
  {"TRADE_MODE":"2210","ABBR_TRADE":"对外投资","FULL_TRADE":"对外投资"},
  {"TRADE_MODE":"2225","ABBR_TRADE":"外资设备物品","FULL_TRADE":"外资企业作为投资进口的设备物品"},
  {"TRADE_MODE":"2439","ABBR_TRADE":"常驻机构公用","FULL_TRADE":"外国常驻机构进口办公用品"},
  {"TRADE_MODE":"2600","ABBR_TRADE":"暂时进出货物","FULL_TRADE":"暂时进出口货物"},
  {"TRADE_MODE":"2700","ABBR_TRADE":"展览品","FULL_TRADE":"进出境展览品"},
  {"TRADE_MODE":"2939","ABBR_TRADE":"陈列样品","FULL_TRADE":"驻华商业机构不复运出口的进口陈列样品"},
  {"TRADE_MODE":"3010","ABBR_TRADE":"货样广告品","FULL_TRADE":"进出口的货样广告品"},
  {"TRADE_MODE":"3100","ABBR_TRADE":"无代价抵偿","FULL_TRADE":"无代价抵偿进出口货物"},
  {"TRADE_MODE":"3339","ABBR_TRADE":"其他进出口免费","FULL_TRADE":"其他进出口免费提供货物"},
  {"TRADE_MODE":"3410","ABBR_TRADE":"承包工程进口","FULL_TRADE":"对外承包工程进口物资"},
  {"TRADE_MODE":"3422","ABBR_TRADE":"对外承包出口","FULL_TRADE":"对外承包工程出口物资"},
  {"TRADE_MODE":"3511","ABBR_TRADE":"援助物资","FULL_TRADE":"国家和国际组织无偿援助物资"},
  {"TRADE_MODE":"3611","ABBR_TRADE":"无偿军援","FULL_TRADE":"无偿军援"},
  {"TRADE_MODE":"3612","ABBR_TRADE":"捐赠物资","FULL_TRADE":"进出口捐赠物资"},
  {"TRADE_MODE":"3910","ABBR_TRADE":"军事装备","FULL_TRADE":"军事装备 "},
  {"TRADE_MODE":"4019","ABBR_TRADE":"边境小额","FULL_TRADE":"边境小额贸易(边民互市贸易除外)"},
  {"TRADE_MODE":"4039","ABBR_TRADE":"对台小额","FULL_TRADE":"对台小额贸易"},
  {"TRADE_MODE":"4139","ABBR_TRADE":"对台小额商品交易","FULL_TRADE":"进入对台小额商品交易专用市场的货物"},
  {"TRADE_MODE":"4200","ABBR_TRADE":"驻外机构运回","FULL_TRADE":"我驻外机构运回旧公用物品"},
  {"TRADE_MODE":"4239","ABBR_TRADE":"驻外机构购进","FULL_TRADE":"我驻外机构境外购买运回国的公务用品"},
  {"TRADE_MODE":"4400","ABBR_TRADE":"来料成品退换","FULL_TRADE":"来料加工成品退换"},
  {"TRADE_MODE":"4500","ABBR_TRADE":"直接退运","FULL_TRADE":"直接退运"},
  {"TRADE_MODE":"4539","ABBR_TRADE":"进口溢误卸","FULL_TRADE":"进口溢卸、误卸货物"},
  {"TRADE_MODE":"4561","ABBR_TRADE":"退运货物","FULL_TRADE":"因质量不符、延误交货等原因退运进出境货物"},
  {"TRADE_MODE":"4600","ABBR_TRADE":"进料成品退换","FULL_TRADE":"进料成品退换"},
  {"TRADE_MODE":"5000","ABBR_TRADE":"料件进出区","FULL_TRADE":"料件进出海关特殊监管区域"},
  {"TRADE_MODE":"5010","ABBR_TRADE":"特殊区域研发货物","FULL_TRADE":"海关特殊监管区域与境外之间进出的研发货物"},
  {"TRADE_MODE":"5014","ABBR_TRADE":"区内来料加工","FULL_TRADE":"海关特殊监管区域与境外之间进出的来料加工"},
  {"TRADE_MODE":"5015","ABBR_TRADE":"区内进料加工货物","FULL_TRADE":"海关特殊监管区域与境外之间进出的进料加工"},
  {"TRADE_MODE":"5033","ABBR_TRADE":"区内仓储货物","FULL_TRADE":"加工区内仓储企业从境外进口的货物"},
  {"TRADE_MODE":"5034","ABBR_TRADE":"区内物流货物","FULL_TRADE":"海关特殊监管区域与境外之间进出的物流货物"},
  {"TRADE_MODE":"5072","ABBR_TRADE":"海关特殊监管区域进出境展览品","FULL_TRADE":""},
  {"TRADE_MODE":"5073","ABBR_TRADE":"海关特殊监管区域国际中转货物","FULL_TRADE":""},
  {"TRADE_MODE":"5100","ABBR_TRADE":"成品进出区","FULL_TRADE":"成品进出海关特殊监管区域"},
  {"TRADE_MODE":"5300","ABBR_TRADE":"设备进出区","FULL_TRADE":"设备及物资进出海关特殊监管区域"},
  {"TRADE_MODE":"5335","ABBR_TRADE":"境外设备进区","FULL_TRADE":"海关特殊监管区域从境外进口的设备及物资"},
  {"TRADE_MODE":"5361","ABBR_TRADE":"区内设备退运","FULL_TRADE":"海关特殊监管区域设备及物资退运境外"},
  {"TRADE_MODE":"6033","ABBR_TRADE":"物流中心进出境货","FULL_TRADE":"保税物流中心与境外之间进出仓储货物"},
  {"TRADE_MODE":"6072","ABBR_TRADE":"保税物流中心进出境展览品","FULL_TRADE":""},
  {"TRADE_MODE":"6073","ABBR_TRADE":"保税物流中心国际中转货物","FULL_TRADE":""},
  {"TRADE_MODE":"9500","ABBR_TRADE":"特许权使用费后续征税","FULL_TRADE":"特许权使用费后续征税"},
  {"TRADE_MODE":"9600","ABBR_TRADE":"内贸货物跨境运输","FULL_TRADE":"内贸货物跨境运输"},
  {"TRADE_MODE":"9610","ABBR_TRADE":"电子商务","FULL_TRADE":"跨境贸易电子商务"},
  {"TRADE_MODE":"9639","ABBR_TRADE":"海关处理货物","FULL_TRADE":"海关变卖处理的超期未报货物、走私违规货物"},
  {"TRADE_MODE":"9700","ABBR_TRADE":"后续补税","FULL_TRADE":"无原始报关单的后续补税"},
  {"TRADE_MODE":"9710","ABBR_TRADE":"跨境电商B2B直接出口","FULL_TRADE":""},
  {"TRADE_MODE":"9739","ABBR_TRADE":"其他贸易","FULL_TRADE":"其他贸易"},
  {"TRADE_MODE":"9800","ABBR_TRADE":"租赁征税","FULL_TRADE":"租赁期1年及以上的租赁贸易货物的租金"},
  {"TRADE_MODE":"9810","ABBR_TRADE":"跨境电商出口海外仓","FULL_TRADE":""},
  {"TRADE_MODE":"9839","ABBR_TRADE":"留赠转卖物品","FULL_TRADE":"外交机构转售境内或国际活动留赠放弃特批货"},
  {"TRADE_MODE":"9900","ABBR_TRADE":"其他","FULL_TRADE":"其他"}
]
//征免性质
export const LevyType = [
  {"CUT_MODE":"101","ABBR_CUT":"一般征税","FULL_CUT":"一般征税进出口货物                "},
  {"CUT_MODE":"118","ABBR_CUT":"整车征税","FULL_CUT":"构成整车特征的汽车零部件纳税"},
  {"CUT_MODE":"119","ABBR_CUT":"零部件征","FULL_CUT":"不构成整车特征的汽车零部件纳税"},
  {"CUT_MODE":"201","ABBR_CUT":"无偿援助","FULL_CUT":"无偿援助进出口物资                "},
  {"CUT_MODE":"299","ABBR_CUT":"其他法定","FULL_CUT":"其他法定减免税进出口货物             "},
  {"CUT_MODE":"301","ABBR_CUT":"特定区域","FULL_CUT":"特定区域进口自用物资及出口货物          "},
  {"CUT_MODE":"307","ABBR_CUT":"保税区 ","FULL_CUT":"保税区进口自用物资                "},
  {"CUT_MODE":"399","ABBR_CUT":"其他地区","FULL_CUT":"其他执行特殊政策地区出口货物           "},
  {"CUT_MODE":"401","ABBR_CUT":"科教用品","FULL_CUT":"大专院校及科研机构进口科教用品          "},
  {"CUT_MODE":"402","ABBR_CUT":"示范平台","FULL_CUT":" "},
  {"CUT_MODE":"403","ABBR_CUT":"技术改造","FULL_CUT":"企业技术改造进口货物               "},
  {"CUT_MODE":"405","ABBR_CUT":"科技开发","FULL_CUT":"科学研究、技术开发机构进口科技开发用品"},
  {"CUT_MODE":"406","ABBR_CUT":"重大项目","FULL_CUT":"国家重大项目进口货物               "},
  {"CUT_MODE":"407","ABBR_CUT":"动漫用品","FULL_CUT":"动漫开发生产用品"},
  {"CUT_MODE":"408","ABBR_CUT":"重大技术","FULL_CUT":"生产重大技术装备进口关键零部件及原材料"},
  {"CUT_MODE":"409","ABBR_CUT":"科技重大","FULL_CUT":"科技重大专项进口关键设备、零部件和原材料"},
  {"CUT_MODE":"412","ABBR_CUT":"基础设施","FULL_CUT":"通信、港口、铁路、公路、机场建设进口设备     "},
  {"CUT_MODE":"413","ABBR_CUT":"残疾人 ","FULL_CUT":"残疾人组织和企业进出口货物            "},
  {"CUT_MODE":"417","ABBR_CUT":"远洋渔业","FULL_CUT":"远洋渔业自捕水产品                "},
  {"CUT_MODE":"418","ABBR_CUT":"国产化 ","FULL_CUT":"国家定点生产小轿车和摄录机企业进口散件      "},
  {"CUT_MODE":"419","ABBR_CUT":"整车特征","FULL_CUT":"构成整车特征的汽车零部件进口"},
  {"CUT_MODE":"422","ABBR_CUT":"集成电路","FULL_CUT":"集成电路生产企业进口货物"},
  {"CUT_MODE":"423","ABBR_CUT":"新型显示","FULL_CUT":"新型显示器件生产企业进口物资"},
  {"CUT_MODE":"426","ABBR_CUT":"软件和集","FULL_CUT":"软件生产企业、集成电路设计企业和集成电路生产企业进"},
  {"CUT_MODE":"491","ABBR_CUT":"零关税自","FULL_CUT":"海南零关税进口自用生产设备"},
  {"CUT_MODE":"492","ABBR_CUT":"零关税交","FULL_CUT":"海南零关税进口交通工具及游艇"},
  {"CUT_MODE":"493","ABBR_CUT":"零关税自","FULL_CUT":"海南零关税进口自用生产设备并自愿缴纳进口环节增值税"},
  {"CUT_MODE":"494","ABBR_CUT":"零关税交","FULL_CUT":"海南零关税进口交通工具及游艇并自愿缴纳进口环节增值"},
  {"CUT_MODE":"499","ABBR_CUT":"ITA产","FULL_CUT":"非全税号信息技术产品"},
  {"CUT_MODE":"501","ABBR_CUT":"加工设备","FULL_CUT":"加工贸易外商提供的不作价进口设备         "},
  {"CUT_MODE":"502","ABBR_CUT":"来料加工","FULL_CUT":"来料加工装配和补偿贸易进口料件及出口成品     "},
  {"CUT_MODE":"503","ABBR_CUT":"进料加工","FULL_CUT":"进料加工贸易进口料件及出口成品          "},
  {"CUT_MODE":"506","ABBR_CUT":"边境小额","FULL_CUT":"边境小额贸易进口货物               "},
  {"CUT_MODE":"510","ABBR_CUT":"港澳OP","FULL_CUT":"港澳在内地加工的纺织品获证出口"},
  {"CUT_MODE":"591","ABBR_CUT":"零关税原","FULL_CUT":"海南零关税原辅料进口"},
  {"CUT_MODE":"592","ABBR_CUT":"原辅料部","FULL_CUT":"海南零关税原辅料征收进口环节税"},
  {"CUT_MODE":"601","ABBR_CUT":"中外合资","FULL_CUT":"中外合资经营企业进出口货物            "},
  {"CUT_MODE":"602","ABBR_CUT":"中外合作","FULL_CUT":"中外合作经营企业进出口货物            "},
  {"CUT_MODE":"603","ABBR_CUT":"外资企业","FULL_CUT":"外商独资企业进出口货物              "},
  {"CUT_MODE":"605","ABBR_CUT":"勘探开发","FULL_CUT":"勘探开发煤层气"},
  {"CUT_MODE":"606","ABBR_CUT":"海洋石油","FULL_CUT":"勘探、开发海洋石油进口货物            "},
  {"CUT_MODE":"608","ABBR_CUT":"陆上石油","FULL_CUT":"勘探、开发陆上石油进口货物            "},
  {"CUT_MODE":"609","ABBR_CUT":"贷款项目","FULL_CUT":"利用贷款进口货物                 "},
  {"CUT_MODE":"611","ABBR_CUT":"贷款中标","FULL_CUT":"国际金融组织贷款、外国政府贷款中标机电设备零部件 "},
  {"CUT_MODE":"666","ABBR_CUT":"加征关税","FULL_CUT":"加征关税排除措施"},
  {"CUT_MODE":"686","ABBR_CUT":"市场化组","FULL_CUT":"市场化组织采购排除措施"},
  {"CUT_MODE":"698","ABBR_CUT":"公益收藏","FULL_CUT":"国有公益性收藏单位进口藏品"},
  {"CUT_MODE":"701","ABBR_CUT":"部分进口","FULL_CUT":"部分进口饲料、矿物质微量元素舔砖"},
  {"CUT_MODE":"702","ABBR_CUT":"中资'方'","FULL_CUT":"回国登记中资'方便旗'船"},
  {"CUT_MODE":"703","ABBR_CUT":"航空公司","FULL_CUT":"国内航空公司进口的空载重量在25吨以上的飞机"},
  {"CUT_MODE":"704","ABBR_CUT":"花卉种子","FULL_CUT":"花卉种子"},
  {"CUT_MODE":"705","ABBR_CUT":"科普影视","FULL_CUT":"科普影视"},
  {"CUT_MODE":"706","ABBR_CUT":"租赁企业","FULL_CUT":"租赁企业进口空载重量在25吨以上的客货运飞机"},
  {"CUT_MODE":"707","ABBR_CUT":"博览会留","FULL_CUT":"博览会留购展品"},
  {"CUT_MODE":"708","ABBR_CUT":"替代种植","FULL_CUT":"替代种植进口农产品"},
  {"CUT_MODE":"789","ABBR_CUT":"鼓励项目","FULL_CUT":"国家鼓励发展的内外资项目进口设备         "},
  {"CUT_MODE":"799","ABBR_CUT":"自有资金","FULL_CUT":"外商投资额度外利用自有资金进口设备、备件、配件  "},
  {"CUT_MODE":"801","ABBR_CUT":"救灾捐赠","FULL_CUT":"救灾捐赠进口物资                 "},
  {"CUT_MODE":"802","ABBR_CUT":"慈善捐赠","FULL_CUT":"境外捐赠人无偿向我境内受赠人捐赠的直接用于慈善事业"},
  {"CUT_MODE":"803","ABBR_CUT":"抗艾滋病","FULL_CUT":"进口抗艾滋病病毒药物"},
  {"CUT_MODE":"811","ABBR_CUT":"种子种源","FULL_CUT":"进口种子(苗)、种畜(禽)、鱼种(苗)和种用野生动"},
  {"CUT_MODE":"818","ABBR_CUT":"中央储备","FULL_CUT":"中央储备粮油免征进口环节增值税政策"},
  {"CUT_MODE":"819","ABBR_CUT":"科教图书","FULL_CUT":"进口科研教学用图书资料"},
  {"CUT_MODE":"888","ABBR_CUT":"航材减免","FULL_CUT":"经核准的航空公司进口维修用航空器材"},
  {"CUT_MODE":"898","ABBR_CUT":"国批减免","FULL_CUT":"国务院特准减免税的进出口货物           "},
  {"CUT_MODE":"899","ABBR_CUT":"选择征税","FULL_CUT":"选择征税"},
  {"CUT_MODE":"901","ABBR_CUT":"科研院所","FULL_CUT":"科研院所进口科学研究、科技开发和教学用品"},
  {"CUT_MODE":"902","ABBR_CUT":"高等学校","FULL_CUT":"高等学校进口科学研究、科技开发和教学用品"},
  {"CUT_MODE":"903","ABBR_CUT":"工程研究","FULL_CUT":"国家工程研究中心进口科学研究、科技开发和教学用品"},
  {"CUT_MODE":"904","ABBR_CUT":"国家企业","FULL_CUT":"国家企业技术中心进口科学研究、科技开发和教学用品"},
  {"CUT_MODE":"905","ABBR_CUT":"转制科研","FULL_CUT":"转制科研机构进口科学研究、科技开发和教学用品"},
  {"CUT_MODE":"906","ABBR_CUT":"重点实验","FULL_CUT":"国家重点实验室及企业国家重点实验室进口科学研究、科"},
  {"CUT_MODE":"907","ABBR_CUT":"国家工程","FULL_CUT":"国家工程技术研究中心进口科学研究、科技开发和教学用"},
  {"CUT_MODE":"908","ABBR_CUT":"科技民非","FULL_CUT":"科技类民办非企业单位进口科学研究、科技开发和教学用"},
  {"CUT_MODE":"909","ABBR_CUT":"示范平台","FULL_CUT":"国家中小企业公共服务示范平台（技术类）进口科学研究"},
  {"CUT_MODE":"910","ABBR_CUT":"外资研发","FULL_CUT":"外资研发中心进口科学研究、科技开发和教学用品"},
  {"CUT_MODE":"911","ABBR_CUT":"科教图书","FULL_CUT":"出版物进口单位进口用于科研、教学的图书、文献、报刊"},
  {"CUT_MODE":"921","ABBR_CUT":"大型客机","FULL_CUT":"大型客机、大型客机发动机研制进口物资"},
  {"CUT_MODE":"922","ABBR_CUT":"进博会留","FULL_CUT":"进博会留购展品"},
  {"CUT_MODE":"926","ABBR_CUT":"服贸会留","FULL_CUT":"服贸会留购展品"},
  {"CUT_MODE":"927","ABBR_CUT":"进口钻石","FULL_CUT":"自上海钻石交易所销往国内市场的毛坯钻石和成品钻石"},
  {"CUT_MODE":"928","ABBR_CUT":"三代核电","FULL_CUT":"三代核电项目进口设备"},
  {"CUT_MODE":"930","ABBR_CUT":"疫情防控","FULL_CUT":"新冠肺炎疫情防控进口物资"},
  {"CUT_MODE":"997","ABBR_CUT":"自贸协定","FULL_CUT":" "},
  {"CUT_MODE":"998","ABBR_CUT":"内部暂定","FULL_CUT":"享受内部暂定税率的进出口货物           "},
  {"CUT_MODE":"999","ABBR_CUT":"例外减免","FULL_CUT":"例外减免税进出口货物               "},

]
// 征免方式
export const LevyMethods = [
  {
    "ABBR_CUT": "照章征税",
    "CUT_MODE": "1",
  },
  {
    "ABBR_CUT": "折半征税",
    "CUT_MODE": "2",
  },
  {
    "ABBR_CUT": "全免",
    "CUT_MODE": "3",
  },
  {
    "ABBR_CUT": "特案",
    "CUT_MODE": "4",
  },
  {
    "ABBR_CUT": "征免性质",
    "CUT_MODE": "5",
  },
  {
    "ABBR_CUT": "保证金",
    "CUT_MODE": "6",
  },
  {
    "ABBR_CUT": "保函",
    "CUT_MODE": "7",
  },
  {
    "ABBR_CUT": "折半补税",
    "CUT_MODE": "8",
  },
  {
    "ABBR_CUT": "全额退税",
    "CUT_MODE": "9",
  },
]
//业务事项
export const BusinessMatter = [
  '税单无纸化',
  '自主报税',
  '水运中转',
  '自报自缴',
  '担保验放'
]
//币种
export const BillType = [
  {
    "CURR_CODE": "138",
    "CURR_SYMB": "AED",
    "CURR_NAME": "阿联酋迪拉姆"
  },
  {
    "CURR_CODE": "601",
    "CURR_SYMB": "AUD",
    "CURR_NAME": "澳大利亚元"
  },
  {
    "CURR_CODE": "501",
    "CURR_SYMB": "CAD",
    "CURR_NAME": "加拿大元"
  },
  {
    "CURR_CODE": "331",
    "CURR_SYMB": "CHF",
    "CURR_NAME": "瑞士法郎"
  },
  {
    "CURR_CODE": "142",
    "CURR_SYMB": "CNY",
    "CURR_NAME": "人民币"
  },
  {
    "CURR_CODE": "302",
    "CURR_SYMB": "DKK",
    "CURR_NAME": "丹麦克朗"
  },
  {
    "CURR_CODE": "300",
    "CURR_SYMB": "EUR",
    "CURR_NAME": "欧元"
  },
  {
    "CURR_CODE": "303",
    "CURR_SYMB": "GBP",
    "CURR_NAME": "英镑"
  },
  {
    "CURR_CODE": "110",
    "CURR_SYMB": "HKD",
    "CURR_NAME": "港币"
  },
  {
    "CURR_CODE": "321",
    "CURR_SYMB": "HUF",
    "CURR_NAME": "匈牙利福林"
  },
  {
    "CURR_CODE": "112",
    "CURR_SYMB": "IDR",
    "CURR_NAME": "印度尼西亚卢比"
  },
  {
    "CURR_CODE": "116",
    "CURR_SYMB": "JPY",
    "CURR_NAME": "日本元"
  },
  {
    "CURR_CODE": "107",
    "CURR_SYMB": "KHR",
    "CURR_NAME": "柬埔寨瑞尔"
  },
  {
    "CURR_CODE": "133",
    "CURR_SYMB": "KRW",
    "CURR_NAME": "韩国圆"
  },
  {
    "CURR_CODE": "145",
    "CURR_SYMB": "KZT",
    "CURR_NAME": "哈萨克斯坦竖戈"
  },
  {
    "CURR_CODE": "124",
    "CURR_SYMB": "MNT",
    "CURR_NAME": "蒙古图格里克"
  },
  {
    "CURR_CODE": "121",
    "CURR_SYMB": "MOP",
    "CURR_NAME": "澳门元"
  },
  {
    "CURR_CODE": "429",
    "CURR_SYMB": "MXN",
    "CURR_NAME": "墨西哥比索"
  },
  {
    "CURR_CODE": "122",
    "CURR_SYMB": "MYR",
    "CURR_NAME": "马来西亚林吉特"
  },
  {
    "CURR_CODE": "326",
    "CURR_SYMB": "NOK",
    "CURR_NAME": "挪威克朗"
  },
  {
    "CURR_CODE": "609",
    "CURR_SYMB": "NZD",
    "CURR_NAME": "新西兰元"
  },
  {
    "CURR_CODE": "327",
    "CURR_SYMB": "PLN",
    "CURR_NAME": "波兰兹罗提"
  },
  {
    "CURR_CODE": "344",
    "CURR_SYMB": "RUB",
    "CURR_NAME": "俄罗斯卢布"
  },
  {
    "CURR_CODE": "131",
    "CURR_SYMB": "SAR",
    "CURR_NAME": "沙特里亚尔"
  },
  {
    "CURR_CODE": "330",
    "CURR_SYMB": "SEK",
    "CURR_NAME": "瑞典克朗"
  },
  {
    "CURR_CODE": "132",
    "CURR_SYMB": "SGD",
    "CURR_NAME": "新加坡元"
  },
  {
    "CURR_CODE": "136",
    "CURR_SYMB": "THB",
    "CURR_NAME": "泰国铢"
  },
  {
    "CURR_CODE": "137",
    "CURR_SYMB": "TRY",
    "CURR_NAME": "土耳其里拉"
  },
  {
    "CURR_CODE": "502",
    "CURR_SYMB": "USD",
    "CURR_NAME": "美元"
  },
  {
    "CURR_CODE": "244",
    "CURR_SYMB": "ZAR",
    "CURR_NAME": "南非兰特"
  }
]
// 国别
export const Country = [
  {
    "COUNTRY_CO": "142",
    "ISO_E": "CHN",
    "COUNTRY_NA": "中国",
    "COUNTRY_EN": "China"
  },
  {
    "COUNTRY_CO": "110",
    "ISO_E": "HKG",
    "COUNTRY_NA": "中国香港",
    "COUNTRY_EN": "Hong Kong,China"
  },
  {
    "COUNTRY_CO": "121",
    "ISO_E": "MAC",
    "COUNTRY_NA": "中国澳门",
    "COUNTRY_EN": "Macao,China"
  },
  {
    "COUNTRY_CO": "143",
    "ISO_E": "TWN",
    "COUNTRY_NA": "中国台湾",
    "COUNTRY_EN": "Taiwan，China"
  },
  {
    "COUNTRY_CO": "429",
    "ISO_E": "MEX",
    "COUNTRY_NA": "墨西哥",
    "COUNTRY_EN": "Mexico"
  },
  {
    "COUNTRY_CO": "502",
    "ISO_E": "USA",
    "COUNTRY_NA": "美国",
    "COUNTRY_EN": "United States"
  },
  {
    "COUNTRY_CO": "303",
    "ISO_E": "GBR",
    "COUNTRY_NA": "英国",
    "COUNTRY_EN": "United Kingdom"
  },
  {
    "COUNTRY_CO": "304",
    "ISO_E": "DEU",
    "COUNTRY_NA": "德国",
    "COUNTRY_EN": "Germany"
  },
  {
    "COUNTRY_CO": "305",
    "ISO_E": "FRA",
    "COUNTRY_NA": "法国",
    "COUNTRY_EN": "France"
  },
  {
    "COUNTRY_CO": "501",
    "ISO_E": "CAN",
    "COUNTRY_NA": "加拿大",
    "COUNTRY_EN": "Canada"
  },
  {
    "COUNTRY_CO": "307",
    "ISO_E": "ITA",
    "COUNTRY_NA": "意大利",
    "COUNTRY_EN": "Italy"
  },
  {
    "COUNTRY_CO": "111",
    "ISO_E": "IND",
    "COUNTRY_NA": "印度",
    "COUNTRY_EN": "India"
  },
  {
    "COUNTRY_CO": "116",
    "ISO_E": "JPN",
    "COUNTRY_NA": "日本",
    "COUNTRY_EN": "Japan"
  },
  {
    "COUNTRY_CO": "122",
    "ISO_E": "MYS",
    "COUNTRY_NA": "马来西亚",
    "COUNTRY_EN": "Malaysia"
  },
  {
    "COUNTRY_CO": "129",
    "ISO_E": "PHL",
    "COUNTRY_NA": "菲律宾",
    "COUNTRY_EN": "Philippines"
  },
  {
    "COUNTRY_CO": "132",
    "ISO_E": "SGP",
    "COUNTRY_NA": "新加坡",
    "COUNTRY_EN": "Singapore"
  },
  {
    "COUNTRY_CO": "133",
    "ISO_E": "KOR",
    "COUNTRY_NA": "韩国",
    "COUNTRY_EN": "Republic of Korea"
  },
  {
    "COUNTRY_CO": "141",
    "ISO_E": "VNM",
    "COUNTRY_NA": "越南",
    "COUNTRY_EN": "Viet Nam"
  },
  {
    "COUNTRY_CO": "601",
    "ISO_E": "AUS",
    "COUNTRY_NA": "澳大利亚",
    "COUNTRY_EN": "Australia"
  },
  {
    "COUNTRY_CO": "609",
    "ISO_E": "NZL",
    "COUNTRY_NA": "新西兰",
    "COUNTRY_EN": "New Zealand"
  },
  {
    "COUNTRY_CO": "306",
    "ISO_E": "IRL",
    "COUNTRY_NA": "爱尔兰",
    "COUNTRY_EN": "Ireland"
  },
  {
    "COUNTRY_CO": "309",
    "ISO_E": "NLD",
    "COUNTRY_NA": "荷兰",
    "COUNTRY_EN": "Netherlands"
  },
  {
    "COUNTRY_CO": "315",
    "ISO_E": "AUT",
    "COUNTRY_NA": "奥地利",
    "COUNTRY_EN": "Austria"
  },
  {
    "COUNTRY_CO": "321",
    "ISO_E": "HUN",
    "COUNTRY_NA": "匈牙利",
    "COUNTRY_EN": "Hungary"
  },
  {
    "COUNTRY_CO": "311",
    "ISO_E": "PRT",
    "COUNTRY_NA": "葡萄牙",
    "COUNTRY_EN": "Portugal"
  },
  {
    "COUNTRY_CO": "312",
    "ISO_E": "ESP",
    "COUNTRY_NA": "西班牙",
    "COUNTRY_EN": "Spain"
  },
  {
    "COUNTRY_CO": "330",
    "ISO_E": "SWE",
    "COUNTRY_NA": "瑞典",
    "COUNTRY_EN": "Sweden"
  },
  {
    "COUNTRY_CO": "331",
    "ISO_E": "CHE",
    "COUNTRY_NA": "瑞士",
    "COUNTRY_EN": "Switzerland"
  },
  {
    "COUNTRY_CO": "313",
    "ISO_E": "ALB",
    "COUNTRY_NA": "阿尔巴尼亚",
    "COUNTRY_EN": "Albania"
  },
  {
    "COUNTRY_CO": "201",
    "ISO_E": "DZA",
    "COUNTRY_NA": "阿尔及利亚",
    "COUNTRY_EN": "Algeria"
  },
  {
    "COUNTRY_CO": "101",
    "ISO_E": "AFG",
    "COUNTRY_NA": "阿富汗",
    "COUNTRY_EN": "Afghanistan"
  },
  {
    "COUNTRY_CO": "402",
    "ISO_E": "ARG",
    "COUNTRY_NA": "阿根廷",
    "COUNTRY_EN": "Argentina"
  },
  {
    "COUNTRY_CO": "138",
    "ISO_E": "ARE",
    "COUNTRY_NA": "阿联酋",
    "COUNTRY_EN": "United Arab Emirates"
  },
  {
    "COUNTRY_CO": "403",
    "ISO_E": "ABW",
    "COUNTRY_NA": "阿鲁巴",
    "COUNTRY_EN": "Aruba"
  },
  {
    "COUNTRY_CO": "126",
    "ISO_E": "OMN",
    "COUNTRY_NA": "阿曼",
    "COUNTRY_EN": "Oman"
  },
  {
    "COUNTRY_CO": "152",
    "ISO_E": "AZE",
    "COUNTRY_NA": "阿塞拜疆",
    "COUNTRY_EN": "Azerbaijan"
  },
  {
    "COUNTRY_CO": "215",
    "ISO_E": "EGY",
    "COUNTRY_NA": "埃及",
    "COUNTRY_EN": "Egypt"
  },
  {
    "COUNTRY_CO": "217",
    "ISO_E": "ETH",
    "COUNTRY_NA": "埃塞俄比亚",
    "COUNTRY_EN": "Ethiopia"
  },
  {
    "COUNTRY_CO": "334",
    "ISO_E": "EST",
    "COUNTRY_NA": "爱沙尼亚",
    "COUNTRY_EN": "Estonia"
  },
  {
    "COUNTRY_CO": "314",
    "ISO_E": "AND",
    "COUNTRY_NA": "安道尔",
    "COUNTRY_EN": "Andorra"
  },
  {
    "COUNTRY_CO": "202",
    "ISO_E": "AGO",
    "COUNTRY_NA": "安哥拉",
    "COUNTRY_EN": "Angola"
  },
  {
    "COUNTRY_CO": "456",
    "ISO_E": "AIA",
    "COUNTRY_NA": "安圭拉",
    "COUNTRY_EN": "Anguilla"
  },
  {
    "COUNTRY_CO": "401",
    "ISO_E": "ATG",
    "COUNTRY_NA": "安提瓜和巴布达",
    "COUNTRY_EN": "Antigua and Barbuda"
  },
  {
    "COUNTRY_CO": "360",
    "ISO_E": "ALA",
    "COUNTRY_NA": "奥兰群岛",
    "COUNTRY_EN": "Åland Islands"
  },
  {
    "COUNTRY_CO": "405",
    "ISO_E": "BRB",
    "COUNTRY_NA": "巴巴多斯",
    "COUNTRY_EN": "Barbados"
  },
  {
    "COUNTRY_CO": "611",
    "ISO_E": "PNG",
    "COUNTRY_NA": "巴布亚新几内亚",
    "COUNTRY_EN": "Papua New Guinea"
  },
  {
    "COUNTRY_CO": "404",
    "ISO_E": "BHS",
    "COUNTRY_NA": "巴哈马",
    "COUNTRY_EN": "Bahamas"
  },
  {
    "COUNTRY_CO": "127",
    "ISO_E": "PAK",
    "COUNTRY_NA": "巴基斯坦",
    "COUNTRY_EN": "Pakistan"
  },
  {
    "COUNTRY_CO": "433",
    "ISO_E": "PRY",
    "COUNTRY_NA": "巴拉圭",
    "COUNTRY_EN": "Paraguay"
  },
  {
    "COUNTRY_CO": "128",
    "ISO_E": "PSE",
    "COUNTRY_NA": "巴勒斯坦",
    "COUNTRY_EN": "Palestine"
  },
  {
    "COUNTRY_CO": "102",
    "ISO_E": "BHR",
    "COUNTRY_NA": "巴林",
    "COUNTRY_EN": "Bahrain"
  },
  {
    "COUNTRY_CO": "432",
    "ISO_E": "PAN",
    "COUNTRY_NA": "巴拿马",
    "COUNTRY_EN": "Panama"
  },
  {
    "COUNTRY_CO": "410",
    "ISO_E": "BRA",
    "COUNTRY_NA": "巴西",
    "COUNTRY_EN": "Brazil"
  },
  {
    "COUNTRY_CO": "340",
    "ISO_E": "BLR",
    "COUNTRY_NA": "白俄罗斯",
    "COUNTRY_EN": "Belarus"
  },
  {
    "COUNTRY_CO": "504",
    "ISO_E": "BMU",
    "COUNTRY_NA": "百慕大",
    "COUNTRY_EN": "Bermuda"
  },
  {
    "COUNTRY_CO": "316",
    "ISO_E": "BGR",
    "COUNTRY_NA": "保加利亚",
    "COUNTRY_EN": "Bulgaria"
  },
  {
    "COUNTRY_CO": "631",
    "ISO_E": "MNP",
    "COUNTRY_NA": "北马里亚纳群岛",
    "COUNTRY_EN": "Northern Mariana Islands"
  },
  {
    "COUNTRY_CO": "354",
    "ISO_E": "MKD",
    "COUNTRY_NA": "北马其顿",
    "COUNTRY_EN": "North Macedonia"
  },
  {
    "COUNTRY_CO": "599",
    "ISO_E": "ZNA",
    "COUNTRY_NA": "北美洲其他国家(地区)",
    "COUNTRY_EN": "Other North American Territories"
  },
  {
    "COUNTRY_CO": "203",
    "ISO_E": "BEN",
    "COUNTRY_NA": "贝宁",
    "COUNTRY_EN": "Benin"
  },
  {
    "COUNTRY_CO": "301",
    "ISO_E": "BEL",
    "COUNTRY_NA": "比利时",
    "COUNTRY_EN": "Belgium"
  },
  {
    "COUNTRY_CO": "322",
    "ISO_E": "ISL",
    "COUNTRY_NA": "冰岛",
    "COUNTRY_EN": "Iceland"
  },
  {
    "COUNTRY_CO": "435",
    "ISO_E": "PRI",
    "COUNTRY_NA": "波多黎各",
    "COUNTRY_EN": "Puerto Rico"
  },
  {
    "COUNTRY_CO": "327",
    "ISO_E": "POL",
    "COUNTRY_NA": "波兰",
    "COUNTRY_EN": "Poland"
  },
  {
    "COUNTRY_CO": "355",
    "ISO_E": "BIH",
    "COUNTRY_NA": "波斯尼亚和黑塞哥维那",
    "COUNTRY_EN": "Bosnia and Herzegovina"
  },
  {
    "COUNTRY_CO": "408",
    "ISO_E": "BOL",
    "COUNTRY_NA": "玻利维亚",
    "COUNTRY_EN": "Bolivia"
  },
  {
    "COUNTRY_CO": "406",
    "ISO_E": "BLZ",
    "COUNTRY_NA": "伯利兹",
    "COUNTRY_EN": "Belize"
  },
  {
    "COUNTRY_CO": "204",
    "ISO_E": "BWA",
    "COUNTRY_NA": "博茨瓦纳",
    "COUNTRY_EN": "Botswana"
  },
  {
    "COUNTRY_CO": "449",
    "ISO_E": "BES",
    "COUNTRY_NA": "博纳尔，圣俄斯塔休斯和萨巴",
    "COUNTRY_EN": "Bonaire, Sint Eustatius and Saba"
  },
  {
    "COUNTRY_CO": "104",
    "ISO_E": "BTN",
    "COUNTRY_NA": "不丹",
    "COUNTRY_EN": "Bhutan"
  },
  {
    "COUNTRY_CO": "251",
    "ISO_E": "BFA",
    "COUNTRY_NA": "布基纳法索",
    "COUNTRY_EN": "Burkina Faso"
  },
  {
    "COUNTRY_CO": "205",
    "ISO_E": "BDI",
    "COUNTRY_NA": "布隆迪",
    "COUNTRY_EN": "Burundi"
  },
  {
    "COUNTRY_CO": "451",
    "ISO_E": "BVT",
    "COUNTRY_NA": "布维岛",
    "COUNTRY_EN": "Bouvet Island"
  },
  {
    "COUNTRY_CO": "109",
    "ISO_E": "PRK",
    "COUNTRY_NA": "朝鲜",
    "COUNTRY_EN": "Democratic People's Republic of Korea"
  },
  {
    "COUNTRY_CO": "216",
    "ISO_E": "GNQ",
    "COUNTRY_NA": "赤道几内亚",
    "COUNTRY_EN": "Equatorial Guinea"
  },
  {
    "COUNTRY_CO": "699",
    "ISO_E": "ZOC",
    "COUNTRY_NA": "大洋洲其他国家(地区)",
    "COUNTRY_EN": "Other Oceanian Territories"
  },
  {
    "COUNTRY_CO": "302",
    "ISO_E": "DNK",
    "COUNTRY_NA": "丹麦",
    "COUNTRY_EN": "Denmark"
  },
  {
    "COUNTRY_CO": "144",
    "ISO_E": "TLS",
    "COUNTRY_NA": "东帝汶",
    "COUNTRY_EN": "Timor-Leste"
  },
  {
    "COUNTRY_CO": "248",
    "ISO_E": "TGO",
    "COUNTRY_NA": "多哥",
    "COUNTRY_EN": "Togo"
  },
  {
    "COUNTRY_CO": "418",
    "ISO_E": "DOM",
    "COUNTRY_NA": "多米尼加",
    "COUNTRY_EN": "Dominican Republic"
  },
  {
    "COUNTRY_CO": "414",
    "ISO_E": "DMA",
    "COUNTRY_NA": "多米尼克",
    "COUNTRY_EN": "Dominica"
  },
  {
    "COUNTRY_CO": "344",
    "ISO_E": "RUS",
    "COUNTRY_NA": "俄罗斯",
    "COUNTRY_EN": "Russia"
  },
  {
    "COUNTRY_CO": "419",
    "ISO_E": "ECU",
    "COUNTRY_NA": "厄瓜多尔",
    "COUNTRY_EN": "Ecuador"
  },
  {
    "COUNTRY_CO": "258",
    "ISO_E": "ERI",
    "COUNTRY_NA": "厄立特里亚",
    "COUNTRY_EN": "Eritrea"
  },
  {
    "COUNTRY_CO": "357",
    "ISO_E": "FRO",
    "COUNTRY_NA": "法罗群岛",
    "COUNTRY_EN": "Faroe Islands"
  },
  {
    "COUNTRY_CO": "623",
    "ISO_E": "PYF",
    "COUNTRY_NA": "法属波利尼西亚",
    "COUNTRY_EN": "French Polynesia"
  },
  {
    "COUNTRY_CO": "420",
    "ISO_E": "GUF",
    "COUNTRY_NA": "法属圭亚那",
    "COUNTRY_EN": "French Guiana"
  },
  {
    "COUNTRY_CO": "261",
    "ISO_E": "ATF",
    "COUNTRY_NA": "法属南方领地",
    "COUNTRY_EN": "French Southern Territories"
  },
  {
    "COUNTRY_CO": "438",
    "ISO_E": "MAF",
    "COUNTRY_NA": "法属圣马丁",
    "COUNTRY_EN": "Saint Martin (French Part)"
  },
  {
    "COUNTRY_CO": "356",
    "ISO_E": "VAT",
    "COUNTRY_NA": "梵蒂冈",
    "COUNTRY_EN": "Holy See"
  },
  {
    "COUNTRY_CO": "299",
    "ISO_E": "ZAO",
    "COUNTRY_NA": "非洲其他国家(地区)",
    "COUNTRY_EN": "Other African Territories"
  },
  {
    "COUNTRY_CO": "603",
    "ISO_E": "FJI",
    "COUNTRY_NA": "斐济",
    "COUNTRY_EN": "Fiji"
  },
  {
    "COUNTRY_CO": "318",
    "ISO_E": "FIN",
    "COUNTRY_NA": "芬兰",
    "COUNTRY_EN": "Finland"
  },
  {
    "COUNTRY_CO": "208",
    "ISO_E": "CPV",
    "COUNTRY_NA": "佛得角",
    "COUNTRY_EN": "Cabo Verde"
  },
  {
    "COUNTRY_CO": "452",
    "ISO_E": "FLK",
    "COUNTRY_NA": "福克兰群岛（马尔维纳斯）",
    "COUNTRY_EN": "Falkland Islands (Malvinas)"
  },
  {
    "COUNTRY_CO": "219",
    "ISO_E": "GMB",
    "COUNTRY_NA": "冈比亚",
    "COUNTRY_EN": "Gambia"
  },
  {
    "COUNTRY_CO": "213",
    "ISO_E": "COG",
    "COUNTRY_NA": "刚果共和国",
    "COUNTRY_EN": "Congo"
  },
  {
    "COUNTRY_CO": "252",
    "ISO_E": "COD",
    "COUNTRY_NA": "刚果民主共和国",
    "COUNTRY_EN": "Democratic Republic of Congo"
  },
  {
    "COUNTRY_CO": "413",
    "ISO_E": "COL",
    "COUNTRY_NA": "哥伦比亚",
    "COUNTRY_EN": "Colombia"
  },
  {
    "COUNTRY_CO": "415",
    "ISO_E": "CRI",
    "COUNTRY_NA": "哥斯达黎加",
    "COUNTRY_EN": "Costa Rica"
  },
  {
    "COUNTRY_CO": "361",
    "ISO_E": "GGY",
    "COUNTRY_NA": "格恩西",
    "COUNTRY_EN": "Guernsey"
  },
  {
    "COUNTRY_CO": "421",
    "ISO_E": "GRD",
    "COUNTRY_NA": "格林纳达",
    "COUNTRY_EN": "Grenada"
  },
  {
    "COUNTRY_CO": "503",
    "ISO_E": "GRL",
    "COUNTRY_NA": "格陵兰",
    "COUNTRY_EN": "Greenland"
  },
  {
    "COUNTRY_CO": "150",
    "ISO_E": "GEO",
    "COUNTRY_NA": "格鲁吉亚",
    "COUNTRY_EN": "Georgia"
  },
  {
    "COUNTRY_CO": "416",
    "ISO_E": "CUB",
    "COUNTRY_NA": "古巴",
    "COUNTRY_EN": "Cuba"
  },
  {
    "COUNTRY_CO": "422",
    "ISO_E": "GLP",
    "COUNTRY_NA": "瓜德罗普",
    "COUNTRY_EN": "Guadeloupe"
  },
  {
    "COUNTRY_CO": "629",
    "ISO_E": "GUM",
    "COUNTRY_NA": "关岛",
    "COUNTRY_EN": "Guam"
  },
  {
    "COUNTRY_CO": "424",
    "ISO_E": "GUY",
    "COUNTRY_NA": "圭亚那",
    "COUNTRY_EN": "Guyana"
  },
  {
    "COUNTRY_CO": "701",
    "ISO_E": "ZZZ",
    "COUNTRY_NA": "国家（地区）不明",
    "COUNTRY_EN": "Countries(Territories) Unknown"
  },
  {
    "COUNTRY_CO": "145",
    "ISO_E": "KAZ",
    "COUNTRY_NA": "哈萨克斯坦",
    "COUNTRY_EN": "Kazakhstan"
  },
  {
    "COUNTRY_CO": "425",
    "ISO_E": "HTI",
    "COUNTRY_NA": "海地",
    "COUNTRY_EN": "Haiti"
  },
  {
    "COUNTRY_CO": "454",
    "ISO_E": "SXM",
    "COUNTRY_NA": "荷属圣马丁",
    "COUNTRY_EN": "Sint Maarten (Dutch part)"
  },
  {
    "COUNTRY_CO": "630",
    "ISO_E": "HMD",
    "COUNTRY_NA": "赫德岛和麦克唐纳岛",
    "COUNTRY_EN": "Heard Island and McDonald Islands"
  },
  {
    "COUNTRY_CO": "359",
    "ISO_E": "MNE",
    "COUNTRY_NA": "黑山",
    "COUNTRY_EN": "Montenegro"
  },
  {
    "COUNTRY_CO": "426",
    "ISO_E": "HND",
    "COUNTRY_NA": "洪都拉斯",
    "COUNTRY_EN": "Honduras"
  },
  {
    "COUNTRY_CO": "618",
    "ISO_E": "KIR",
    "COUNTRY_NA": "基里巴斯",
    "COUNTRY_EN": "Kiribati"
  },
  {
    "COUNTRY_CO": "214",
    "ISO_E": "DJI",
    "COUNTRY_NA": "吉布提",
    "COUNTRY_EN": "Djibouti"
  },
  {
    "COUNTRY_CO": "146",
    "ISO_E": "KGZ",
    "COUNTRY_NA": "吉尔吉斯斯坦",
    "COUNTRY_EN": "Kyrgyzstan"
  },
  {
    "COUNTRY_CO": "221",
    "ISO_E": "GIN",
    "COUNTRY_NA": "几内亚",
    "COUNTRY_EN": "Guinea"
  },
  {
    "COUNTRY_CO": "222",
    "ISO_E": "GNB",
    "COUNTRY_NA": "几内亚比绍",
    "COUNTRY_EN": "Guinea-Bissau"
  },
  {
    "COUNTRY_CO": "207",
    "ISO_E": "CAI",
    "COUNTRY_NA": "加那利群岛",
    "COUNTRY_EN": "Canary Islands"
  },
  {
    "COUNTRY_CO": "220",
    "ISO_E": "GHA",
    "COUNTRY_NA": "加纳",
    "COUNTRY_EN": "Ghana"
  },
  {
    "COUNTRY_CO": "218",
    "ISO_E": "GAB",
    "COUNTRY_NA": "加蓬",
    "COUNTRY_EN": "Gabon"
  },
  {
    "COUNTRY_CO": "107",
    "ISO_E": "KHM",
    "COUNTRY_NA": "柬埔寨",
    "COUNTRY_EN": "Cambodia"
  },
  {
    "COUNTRY_CO": "352",
    "ISO_E": "CZE",
    "COUNTRY_NA": "捷克",
    "COUNTRY_EN": "Czechia（Czech Republic）"
  },
  {
    "COUNTRY_CO": "254",
    "ISO_E": "ZWE",
    "COUNTRY_NA": "津巴布韦",
    "COUNTRY_EN": "Zimbabwe"
  },
  {
    "COUNTRY_CO": "206",
    "ISO_E": "CMR",
    "COUNTRY_NA": "喀麦隆",
    "COUNTRY_EN": "Cameroon"
  },
  {
    "COUNTRY_CO": "130",
    "ISO_E": "QAT",
    "COUNTRY_NA": "卡塔尔",
    "COUNTRY_EN": "Qatar"
  },
  {
    "COUNTRY_CO": "411",
    "ISO_E": "CYM",
    "COUNTRY_NA": "开曼群岛",
    "COUNTRY_EN": "Cayman Islands"
  },
  {
    "COUNTRY_CO": "627",
    "ISO_E": "CCK",
    "COUNTRY_NA": "科科斯（基林）群岛",
    "COUNTRY_EN": "Cocos (Keeling) Islands"
  },
  {
    "COUNTRY_CO": "212",
    "ISO_E": "COM",
    "COUNTRY_NA": "科摩罗",
    "COUNTRY_EN": "Comoros"
  },
  {
    "COUNTRY_CO": "223",
    "ISO_E": "CIV",
    "COUNTRY_NA": "科特迪瓦",
    "COUNTRY_EN": "Cote d'lvoire"
  },
  {
    "COUNTRY_CO": "118",
    "ISO_E": "KWT",
    "COUNTRY_NA": "科威特",
    "COUNTRY_EN": "Kuwait"
  },
  {
    "COUNTRY_CO": "351",
    "ISO_E": "HRV",
    "COUNTRY_NA": "克罗地亚",
    "COUNTRY_EN": "Croatia"
  },
  {
    "COUNTRY_CO": "224",
    "ISO_E": "KEN",
    "COUNTRY_NA": "肯尼亚",
    "COUNTRY_EN": "Kenya"
  },
  {
    "COUNTRY_CO": "602",
    "ISO_E": "COK",
    "COUNTRY_NA": "库克群岛",
    "COUNTRY_EN": "Cook Islands"
  },
  {
    "COUNTRY_CO": "417",
    "ISO_E": "CUW",
    "COUNTRY_NA": "库拉索",
    "COUNTRY_EN": "Curaçao"
  },
  {
    "COUNTRY_CO": "499",
    "ISO_E": "ZSA",
    "COUNTRY_NA": "拉丁美洲其他国家(地区)",
    "COUNTRY_EN": "Other Latin American Territories"
  },
  {
    "COUNTRY_CO": "335",
    "ISO_E": "LVA",
    "COUNTRY_NA": "拉脱维亚",
    "COUNTRY_EN": "Latvia"
  },
  {
    "COUNTRY_CO": "255",
    "ISO_E": "LSO",
    "COUNTRY_NA": "莱索托",
    "COUNTRY_EN": "Lesotho"
  },
  {
    "COUNTRY_CO": "119",
    "ISO_E": "LAO",
    "COUNTRY_NA": "老挝",
    "COUNTRY_EN": "Lao"
  },
  {
    "COUNTRY_CO": "120",
    "ISO_E": "LBN",
    "COUNTRY_NA": "黎巴嫩",
    "COUNTRY_EN": "Lebanon"
  },
  {
    "COUNTRY_CO": "336",
    "ISO_E": "LTU",
    "COUNTRY_NA": "立陶宛",
    "COUNTRY_EN": "Lithuania"
  },
  {
    "COUNTRY_CO": "225",
    "ISO_E": "LBR",
    "COUNTRY_NA": "利比里亚",
    "COUNTRY_EN": "Liberia"
  },
  {
    "COUNTRY_CO": "226",
    "ISO_E": "LBY",
    "COUNTRY_NA": "利比亚",
    "COUNTRY_EN": "Libya"
  },
  {
    "COUNTRY_CO": "323",
    "ISO_E": "LIE",
    "COUNTRY_NA": "列支敦士登",
    "COUNTRY_EN": "Liechtenstein"
  },
  {
    "COUNTRY_CO": "237",
    "ISO_E": "REU",
    "COUNTRY_NA": "留尼汪",
    "COUNTRY_EN": "Réunion"
  },
  {
    "COUNTRY_CO": "308",
    "ISO_E": "LUX",
    "COUNTRY_NA": "卢森堡",
    "COUNTRY_EN": "Luxembourg"
  },
  {
    "COUNTRY_CO": "238",
    "ISO_E": "RWA",
    "COUNTRY_NA": "卢旺达",
    "COUNTRY_EN": "Rwanda"
  },
  {
    "COUNTRY_CO": "328",
    "ISO_E": "ROU",
    "COUNTRY_NA": "罗马尼亚",
    "COUNTRY_EN": "Romania"
  },
  {
    "COUNTRY_CO": "227",
    "ISO_E": "MDG",
    "COUNTRY_NA": "马达加斯加",
    "COUNTRY_EN": "Madagascar"
  },
  {
    "COUNTRY_CO": "362",
    "ISO_E": "IMN",
    "COUNTRY_NA": "马恩岛",
    "COUNTRY_EN": "Isle of Man"
  },
  {
    "COUNTRY_CO": "123",
    "ISO_E": "MDV",
    "COUNTRY_NA": "马尔代夫",
    "COUNTRY_EN": "Maldives"
  },
  {
    "COUNTRY_CO": "324",
    "ISO_E": "MLT",
    "COUNTRY_NA": "马耳他",
    "COUNTRY_EN": "Malta"
  },
  {
    "COUNTRY_CO": "228",
    "ISO_E": "MWI",
    "COUNTRY_NA": "马拉维",
    "COUNTRY_EN": "Malawi"
  },
  {
    "COUNTRY_CO": "229",
    "ISO_E": "MLI",
    "COUNTRY_NA": "马里",
    "COUNTRY_EN": "Mali"
  },
  {
    "COUNTRY_CO": "621",
    "ISO_E": "MHL",
    "COUNTRY_NA": "马绍尔群岛",
    "COUNTRY_EN": "Marshall Islands"
  },
  {
    "COUNTRY_CO": "428",
    "ISO_E": "MTQ",
    "COUNTRY_NA": "马提尼克",
    "COUNTRY_EN": "Martinique"
  },
  {
    "COUNTRY_CO": "259",
    "ISO_E": "MYT",
    "COUNTRY_NA": "马约特",
    "COUNTRY_EN": "Mayotte"
  },
  {
    "COUNTRY_CO": "231",
    "ISO_E": "MUS",
    "COUNTRY_NA": "毛里求斯",
    "COUNTRY_EN": "Mauritius"
  },
  {
    "COUNTRY_CO": "230",
    "ISO_E": "MRT",
    "COUNTRY_NA": "毛里塔尼亚",
    "COUNTRY_EN": "Mauritania"
  },
  {
    "COUNTRY_CO": "256",
    "ISO_E": "MEL",
    "COUNTRY_NA": "梅利利亚",
    "COUNTRY_EN": "Melilla"
  },
  {
    "COUNTRY_CO": "635",
    "ISO_E": "UMI",
    "COUNTRY_NA": "美国本土外小岛屿",
    "COUNTRY_EN": "United States Minor Outlying Islands"
  },
  {
    "COUNTRY_CO": "626",
    "ISO_E": "ASM",
    "COUNTRY_NA": "美属萨摩亚",
    "COUNTRY_EN": "American Samoa"
  },
  {
    "COUNTRY_CO": "455",
    "ISO_E": "VIR",
    "COUNTRY_NA": "美属维尔京群岛",
    "COUNTRY_EN": "United States Virgin Islands"
  },
  {
    "COUNTRY_CO": "124",
    "ISO_E": "MNG",
    "COUNTRY_NA": "蒙古",
    "COUNTRY_EN": "Mongolia"
  },
  {
    "COUNTRY_CO": "430",
    "ISO_E": "MSR",
    "COUNTRY_NA": "蒙特塞拉特",
    "COUNTRY_EN": "Montserrat"
  },
  {
    "COUNTRY_CO": "103",
    "ISO_E": "BGD",
    "COUNTRY_NA": "孟加拉国",
    "COUNTRY_EN": "Bangladesh"
  },
  {
    "COUNTRY_CO": "434",
    "ISO_E": "PER",
    "COUNTRY_NA": "秘鲁",
    "COUNTRY_EN": "Peru"
  },
  {
    "COUNTRY_CO": "620",
    "ISO_E": "FSM",
    "COUNTRY_NA": "密克罗尼西亚联邦",
    "COUNTRY_EN": "The Federated States of Micronesia"
  },
  {
    "COUNTRY_CO": "106",
    "ISO_E": "MMR",
    "COUNTRY_NA": "缅甸",
    "COUNTRY_EN": "Myanmar"
  },
  {
    "COUNTRY_CO": "343",
    "ISO_E": "MDA",
    "COUNTRY_NA": "摩尔多瓦",
    "COUNTRY_EN": "Moldova"
  },
  {
    "COUNTRY_CO": "232",
    "ISO_E": "MAR",
    "COUNTRY_NA": "摩洛哥",
    "COUNTRY_EN": "Morocco"
  },
  {
    "COUNTRY_CO": "325",
    "ISO_E": "MCO",
    "COUNTRY_NA": "摩纳哥",
    "COUNTRY_EN": "Monaco"
  },
  {
    "COUNTRY_CO": "233",
    "ISO_E": "MOZ",
    "COUNTRY_NA": "莫桑比克",
    "COUNTRY_EN": "Mozambique"
  },
  {
    "COUNTRY_CO": "234",
    "ISO_E": "NAM",
    "COUNTRY_NA": "纳米比亚",
    "COUNTRY_EN": "Namibia"
  },
  {
    "COUNTRY_CO": "244",
    "ISO_E": "ZAF",
    "COUNTRY_NA": "南非",
    "COUNTRY_EN": "South Africa"
  },
  {
    "COUNTRY_CO": "700",
    "ISO_E": "ATA",
    "COUNTRY_NA": "南极洲",
    "COUNTRY_EN": "Antarctica"
  },
  {
    "COUNTRY_CO": "453",
    "ISO_E": "SGS",
    "COUNTRY_NA": "南乔治亚岛和南桑德韦奇岛",
    "COUNTRY_EN": "South Georgia and the South Sandwich Islands"
  },
  {
    "COUNTRY_CO": "260",
    "ISO_E": "SSD",
    "COUNTRY_NA": "南苏丹",
    "COUNTRY_EN": "South Sudan"
  },
  {
    "COUNTRY_CO": "606",
    "ISO_E": "NRU",
    "COUNTRY_NA": "瑙鲁",
    "COUNTRY_EN": "Nauru"
  },
  {
    "COUNTRY_CO": "125",
    "ISO_E": "NPL",
    "COUNTRY_NA": "尼泊尔",
    "COUNTRY_EN": "Nepal"
  },
  {
    "COUNTRY_CO": "431",
    "ISO_E": "NIC",
    "COUNTRY_NA": "尼加拉瓜",
    "COUNTRY_EN": "Nicaragua"
  },
  {
    "COUNTRY_CO": "235",
    "ISO_E": "NER",
    "COUNTRY_NA": "尼日尔",
    "COUNTRY_EN": "Niger"
  },
  {
    "COUNTRY_CO": "236",
    "ISO_E": "NGA",
    "COUNTRY_NA": "尼日利亚",
    "COUNTRY_EN": "Nigeria"
  },
  {
    "COUNTRY_CO": "632",
    "ISO_E": "NIU",
    "COUNTRY_NA": "纽埃",
    "COUNTRY_EN": "Niue"
  },
  {
    "COUNTRY_CO": "326",
    "ISO_E": "NOR",
    "COUNTRY_NA": "挪威",
    "COUNTRY_EN": "Norway"
  },
  {
    "COUNTRY_CO": "610",
    "ISO_E": "NFK",
    "COUNTRY_NA": "诺福克岛",
    "COUNTRY_EN": "Norfolk Island"
  },
  {
    "COUNTRY_CO": "399",
    "ISO_E": "ZEU",
    "COUNTRY_NA": "欧洲其他国家(地区)",
    "COUNTRY_EN": "Other European Territories"
  },
  {
    "COUNTRY_CO": "622",
    "ISO_E": "PLW",
    "COUNTRY_NA": "帕劳",
    "COUNTRY_EN": "Palau"
  },
  {
    "COUNTRY_CO": "633",
    "ISO_E": "PCN",
    "COUNTRY_NA": "皮特凯恩",
    "COUNTRY_EN": "Pitcairn"
  },
  {
    "COUNTRY_CO": "440",
    "ISO_E": "SLV",
    "COUNTRY_NA": "萨尔瓦多",
    "COUNTRY_EN": "El Salvador"
  },
  {
    "COUNTRY_CO": "617",
    "ISO_E": "WSM",
    "COUNTRY_NA": "萨摩亚",
    "COUNTRY_EN": "Samoa"
  },
  {
    "COUNTRY_CO": "210",
    "ISO_E": "CEU",
    "COUNTRY_NA": "塞卜泰(休达)",
    "COUNTRY_EN": "Ceuta"
  },
  {
    "COUNTRY_CO": "358",
    "ISO_E": "SRB",
    "COUNTRY_NA": "塞尔维亚",
    "COUNTRY_EN": "Serbia"
  },
  {
    "COUNTRY_CO": "242",
    "ISO_E": "SLE",
    "COUNTRY_NA": "塞拉利昂",
    "COUNTRY_EN": "Sierra Leone"
  },
  {
    "COUNTRY_CO": "240",
    "ISO_E": "SEN",
    "COUNTRY_NA": "塞内加尔",
    "COUNTRY_EN": "Senegal"
  },
  {
    "COUNTRY_CO": "108",
    "ISO_E": "CYP",
    "COUNTRY_NA": "塞浦路斯",
    "COUNTRY_EN": "Cyprus"
  },
  {
    "COUNTRY_CO": "241",
    "ISO_E": "SYC",
    "COUNTRY_NA": "塞舌尔",
    "COUNTRY_EN": "Seychelles"
  },
  {
    "COUNTRY_CO": "131",
    "ISO_E": "SAU",
    "COUNTRY_NA": "沙特阿拉伯",
    "COUNTRY_EN": "Saudi Arabia"
  },
  {
    "COUNTRY_CO": "450",
    "ISO_E": "BLM",
    "COUNTRY_NA": "圣巴泰勒米",
    "COUNTRY_EN": "Saint Barthélemy"
  },
  {
    "COUNTRY_CO": "628",
    "ISO_E": "CXR",
    "COUNTRY_NA": "圣诞岛",
    "COUNTRY_EN": "Christmas Island"
  },
  {
    "COUNTRY_CO": "239",
    "ISO_E": "STP",
    "COUNTRY_NA": "圣多美和普林西比",
    "COUNTRY_EN": "Sao Tome and Principe"
  },
  {
    "COUNTRY_CO": "263",
    "ISO_E": "SHN",
    "COUNTRY_NA": "圣赫勒拿",
    "COUNTRY_EN": "Saint Helena"
  },
  {
    "COUNTRY_CO": "447",
    "ISO_E": "KNA",
    "COUNTRY_NA": "圣基茨和尼维斯",
    "COUNTRY_EN": "Saint Kitts and Nevis"
  },
  {
    "COUNTRY_CO": "437",
    "ISO_E": "LCA",
    "COUNTRY_NA": "圣卢西亚",
    "COUNTRY_EN": "Saint Lucia"
  },
  {
    "COUNTRY_CO": "329",
    "ISO_E": "SMR",
    "COUNTRY_NA": "圣马力诺",
    "COUNTRY_EN": "San Marino"
  },
  {
    "COUNTRY_CO": "505",
    "ISO_E": "SPM",
    "COUNTRY_NA": "圣皮埃尔和密克隆",
    "COUNTRY_EN": "Saint Pierre and Miquelon"
  },
  {
    "COUNTRY_CO": "439",
    "ISO_E": "VCT",
    "COUNTRY_NA": "圣文森特和格林纳丁斯",
    "COUNTRY_EN": "Saint Vincent and the Grenadines"
  },
  {
    "COUNTRY_CO": "134",
    "ISO_E": "LKA",
    "COUNTRY_NA": "斯里兰卡",
    "COUNTRY_EN": "Sri Lanka"
  },
  {
    "COUNTRY_CO": "353",
    "ISO_E": "SVK",
    "COUNTRY_NA": "斯洛伐克",
    "COUNTRY_EN": "Slovakia"
  },
  {
    "COUNTRY_CO": "350",
    "ISO_E": "SVN",
    "COUNTRY_NA": "斯洛文尼亚",
    "COUNTRY_EN": "Slovenia "
  },
  {
    "COUNTRY_CO": "364",
    "ISO_E": "SJM",
    "COUNTRY_NA": "斯瓦尔巴群岛和扬马延岛",
    "COUNTRY_EN": "Svalbard and Jan Mayen Islands"
  },
  {
    "COUNTRY_CO": "257",
    "ISO_E": "SWZ",
    "COUNTRY_NA": "斯威士兰",
    "COUNTRY_EN": "Eswatini(Swaziland)"
  },
  {
    "COUNTRY_CO": "246",
    "ISO_E": "SDN",
    "COUNTRY_NA": "苏丹",
    "COUNTRY_EN": "Sudan"
  },
  {
    "COUNTRY_CO": "441",
    "ISO_E": "SUR",
    "COUNTRY_NA": "苏里南",
    "COUNTRY_EN": "Suriname"
  },
  {
    "COUNTRY_CO": "613",
    "ISO_E": "SLB",
    "COUNTRY_NA": "所罗门群岛",
    "COUNTRY_EN": "Solomon Islands"
  },
  {
    "COUNTRY_CO": "243",
    "ISO_E": "SOM",
    "COUNTRY_NA": "索马里",
    "COUNTRY_EN": "Somalia"
  },
  {
    "COUNTRY_CO": "147",
    "ISO_E": "TJK",
    "COUNTRY_NA": "塔吉克斯坦",
    "COUNTRY_EN": "Tajikistan"
  },
  {
    "COUNTRY_CO": "136",
    "ISO_E": "THA",
    "COUNTRY_NA": "泰国",
    "COUNTRY_EN": "Thailand"
  },
  {
    "COUNTRY_CO": "247",
    "ISO_E": "TZA",
    "COUNTRY_NA": "坦桑尼亚",
    "COUNTRY_EN": "Tanzania"
  },
  {
    "COUNTRY_CO": "614",
    "ISO_E": "TON",
    "COUNTRY_NA": "汤加",
    "COUNTRY_EN": "Tonga"
  },
  {
    "COUNTRY_CO": "443",
    "ISO_E": "TCA",
    "COUNTRY_NA": "特克斯和凯科斯群岛",
    "COUNTRY_EN": "Turks and Caicos Islands"
  },
  {
    "COUNTRY_CO": "442",
    "ISO_E": "TTO",
    "COUNTRY_NA": "特立尼达和多巴哥",
    "COUNTRY_EN": "Trinidad and Tobago"
  },
  {
    "COUNTRY_CO": "249",
    "ISO_E": "TUN",
    "COUNTRY_NA": "突尼斯",
    "COUNTRY_EN": "Tunisia"
  },
  {
    "COUNTRY_CO": "619",
    "ISO_E": "TUV",
    "COUNTRY_NA": "图瓦卢",
    "COUNTRY_EN": "Tuvalu"
  },
  {
    "COUNTRY_CO": "137",
    "ISO_E": "TUR",
    "COUNTRY_NA": "土耳其",
    "COUNTRY_EN": "Türkiye"
  },
  {
    "COUNTRY_CO": "148",
    "ISO_E": "TKM",
    "COUNTRY_NA": "土库曼斯坦",
    "COUNTRY_EN": "Turkmenistan"
  },
  {
    "COUNTRY_CO": "634",
    "ISO_E": "TKL",
    "COUNTRY_NA": "托克劳",
    "COUNTRY_EN": "Tokelau"
  },
  {
    "COUNTRY_CO": "625",
    "ISO_E": "WLF",
    "COUNTRY_NA": "瓦利斯和富图纳",
    "COUNTRY_EN": "Wallis and Futuna"
  },
  {
    "COUNTRY_CO": "608",
    "ISO_E": "VUT",
    "COUNTRY_NA": "瓦努阿图",
    "COUNTRY_EN": "Vanuatu"
  },
  {
    "COUNTRY_CO": "423",
    "ISO_E": "GTM",
    "COUNTRY_NA": "危地马拉",
    "COUNTRY_EN": "Guatemala"
  },
  {
    "COUNTRY_CO": "445",
    "ISO_E": "VEN",
    "COUNTRY_NA": "委内瑞拉",
    "COUNTRY_EN": "Venezuela"
  },
  {
    "COUNTRY_CO": "105",
    "ISO_E": "BRN",
    "COUNTRY_NA": "文莱",
    "COUNTRY_EN": "Brunei"
  },
  {
    "COUNTRY_CO": "250",
    "ISO_E": "UGA",
    "COUNTRY_NA": "乌干达",
    "COUNTRY_EN": "Uganda"
  },
  {
    "COUNTRY_CO": "347",
    "ISO_E": "UKR",
    "COUNTRY_NA": "乌克兰",
    "COUNTRY_EN": "Ukraine"
  },
  {
    "COUNTRY_CO": "444",
    "ISO_E": "URY",
    "COUNTRY_NA": "乌拉圭",
    "COUNTRY_EN": "Uruguay"
  },
  {
    "COUNTRY_CO": "149",
    "ISO_E": "UZB",
    "COUNTRY_NA": "乌兹别克斯坦",
    "COUNTRY_EN": "Uzbekistan"
  },
  {
    "COUNTRY_CO": "245",
    "ISO_E": "ESH",
    "COUNTRY_NA": "西撒哈拉",
    "COUNTRY_EN": "Western Sahara"
  },
  {
    "COUNTRY_CO": "310",
    "ISO_E": "GRC",
    "COUNTRY_NA": "希腊",
    "COUNTRY_EN": "Greece"
  },
  {
    "COUNTRY_CO": "607",
    "ISO_E": "NCL",
    "COUNTRY_NA": "新喀里多尼亚",
    "COUNTRY_EN": "New Caledonia"
  },
  {
    "COUNTRY_CO": "135",
    "ISO_E": "SYR",
    "COUNTRY_NA": "叙利亚",
    "COUNTRY_EN": "Syria"
  },
  {
    "COUNTRY_CO": "427",
    "ISO_E": "JAM",
    "COUNTRY_NA": "牙买加",
    "COUNTRY_EN": "Jamaica"
  },
  {
    "COUNTRY_CO": "151",
    "ISO_E": "ARM",
    "COUNTRY_NA": "亚美尼亚",
    "COUNTRY_EN": "Armenia"
  },
  {
    "COUNTRY_CO": "199",
    "ISO_E": "ZAS",
    "COUNTRY_NA": "亚洲其他国家（地区）",
    "COUNTRY_EN": "Other Asian Territories"
  },
  {
    "COUNTRY_CO": "139",
    "ISO_E": "YEM",
    "COUNTRY_NA": "也门",
    "COUNTRY_EN": "Yemen"
  },
  {
    "COUNTRY_CO": "114",
    "ISO_E": "IRQ",
    "COUNTRY_NA": "伊拉克",
    "COUNTRY_EN": "Iraq"
  },
  {
    "COUNTRY_CO": "113",
    "ISO_E": "IRN",
    "COUNTRY_NA": "伊朗",
    "COUNTRY_EN": "Iran"
  },
  {
    "COUNTRY_CO": "115",
    "ISO_E": "ISR",
    "COUNTRY_NA": "以色列",
    "COUNTRY_EN": "Israel"
  },
  {
    "COUNTRY_CO": "112",
    "ISO_E": "IDN",
    "COUNTRY_NA": "印度尼西亚",
    "COUNTRY_EN": "Indonesia"
  },
  {
    "COUNTRY_CO": "446",
    "ISO_E": "VGB",
    "COUNTRY_NA": "英属维尔京群岛",
    "COUNTRY_EN": "British Virgin Islands"
  },
  {
    "COUNTRY_CO": "262",
    "ISO_E": "IOT",
    "COUNTRY_NA": "英属印度洋领地",
    "COUNTRY_EN": "British Indian Ocean Territory"
  },
  {
    "COUNTRY_CO": "802",
    "ISO_E": "HRB",
    "COUNTRY_NA": "原产地不明（按所有成员最高税率）",
    "COUNTRY_EN": "-"
  },
  {
    "COUNTRY_CO": "801",
    "ISO_E": "HRA",
    "COUNTRY_NA": "原产地不明（按相关成员最高税率）",
    "COUNTRY_EN": "-"
  },
  {
    "COUNTRY_CO": "117",
    "ISO_E": "JOR",
    "COUNTRY_NA": "约旦",
    "COUNTRY_EN": "Jordan"
  },
  {
    "COUNTRY_CO": "253",
    "ISO_E": "ZMB",
    "COUNTRY_NA": "赞比亚",
    "COUNTRY_EN": "Zambia"
  },
  {
    "COUNTRY_CO": "363",
    "ISO_E": "JEY",
    "COUNTRY_NA": "泽西",
    "COUNTRY_EN": "Jersey"
  },
  {
    "COUNTRY_CO": "211",
    "ISO_E": "TCD",
    "COUNTRY_NA": "乍得",
    "COUNTRY_EN": "Chad"
  },
  {
    "COUNTRY_CO": "320",
    "ISO_E": "GIB",
    "COUNTRY_NA": "直布罗陀",
    "COUNTRY_EN": "Gibraltar"
  },
  {
    "COUNTRY_CO": "412",
    "ISO_E": "CHL",
    "COUNTRY_NA": "智利",
    "COUNTRY_EN": "Chile"
  },
  {
    "COUNTRY_CO": "209",
    "ISO_E": "CAF",
    "COUNTRY_NA": "中非",
    "COUNTRY_EN": "Central African Republic"
  }
]
/*
[
  {"COUNTRY_CO":"101","ISO_E":"AFG","COUNTRY_NA":"阿富汗","COUNTRY_EN":"Afghanistan"},
  {"COUNTRY_CO":"102","ISO_E":"BHR","COUNTRY_NA":"巴林","COUNTRY_EN":"Bahrain"},
  {"COUNTRY_CO":"103","ISO_E":"BGD","COUNTRY_NA":"孟加拉国","COUNTRY_EN":"Bangladesh"},
  {"COUNTRY_CO":"104","ISO_E":"BTN","COUNTRY_NA":"不丹","COUNTRY_EN":"Bhutan"},
  {"COUNTRY_CO":"105","ISO_E":"BRN","COUNTRY_NA":"文莱","COUNTRY_EN":"Brunei"},
  {"COUNTRY_CO":"106","ISO_E":"MMR","COUNTRY_NA":"缅甸","COUNTRY_EN":"Myanmar"},
  {"COUNTRY_CO":"107","ISO_E":"KHM","COUNTRY_NA":"柬埔寨","COUNTRY_EN":"Cambodia"},
  {"COUNTRY_CO":"108","ISO_E":"CYP","COUNTRY_NA":"塞浦路斯","COUNTRY_EN":"Cyprus"},
  {"COUNTRY_CO":"109","ISO_E":"PRK","COUNTRY_NA":"朝鲜","COUNTRY_EN":"Democratic People's Republic of Korea"},
  {"COUNTRY_CO":"110","ISO_E":"HKG","COUNTRY_NA":"中国香港","COUNTRY_EN":"Hong Kong,China"},
  {"COUNTRY_CO":"111","ISO_E":"IND","COUNTRY_NA":"印度","COUNTRY_EN":"India"},
  {"COUNTRY_CO":"112","ISO_E":"IDN","COUNTRY_NA":"印度尼西亚","COUNTRY_EN":"Indonesia"},
  {"COUNTRY_CO":"113","ISO_E":"IRN","COUNTRY_NA":"伊朗","COUNTRY_EN":"Iran"},
  {"COUNTRY_CO":"114","ISO_E":"IRQ","COUNTRY_NA":"伊拉克","COUNTRY_EN":"Iraq"},
  {"COUNTRY_CO":"115","ISO_E":"ISR","COUNTRY_NA":"以色列","COUNTRY_EN":"Israel"},
  {"COUNTRY_CO":"116","ISO_E":"JPN","COUNTRY_NA":"日本","COUNTRY_EN":"Japan"},
  {"COUNTRY_CO":"117","ISO_E":"JOR","COUNTRY_NA":"约旦","COUNTRY_EN":"Jordan"},
  {"COUNTRY_CO":"118","ISO_E":"KWT","COUNTRY_NA":"科威特","COUNTRY_EN":"Kuwait"},
  {"COUNTRY_CO":"119","ISO_E":"LAO","COUNTRY_NA":"老挝","COUNTRY_EN":"Lao"},
  {"COUNTRY_CO":"120","ISO_E":"LBN","COUNTRY_NA":"黎巴嫩","COUNTRY_EN":"Lebanon"},
  {"COUNTRY_CO":"121","ISO_E":"MAC","COUNTRY_NA":"中国澳门","COUNTRY_EN":"Macao,China"},
  {"COUNTRY_CO":"122","ISO_E":"MYS","COUNTRY_NA":"马来西亚","COUNTRY_EN":"Malaysia"},
  {"COUNTRY_CO":"123","ISO_E":"MDV","COUNTRY_NA":"马尔代夫","COUNTRY_EN":"Maldives"},
  {"COUNTRY_CO":"124","ISO_E":"MNG","COUNTRY_NA":"蒙古","COUNTRY_EN":"Mongolia"},
  {"COUNTRY_CO":"125","ISO_E":"NPL","COUNTRY_NA":"尼泊尔","COUNTRY_EN":"Nepal"},
  {"COUNTRY_CO":"126","ISO_E":"OMN","COUNTRY_NA":"阿曼","COUNTRY_EN":"Oman"},
  {"COUNTRY_CO":"127","ISO_E":"PAK","COUNTRY_NA":"巴基斯坦","COUNTRY_EN":"Pakistan"},
  {"COUNTRY_CO":"128","ISO_E":"PSE","COUNTRY_NA":"巴勒斯坦","COUNTRY_EN":"Palestine"},
  {"COUNTRY_CO":"129","ISO_E":"PHL","COUNTRY_NA":"菲律宾","COUNTRY_EN":"Philippines"},
  {"COUNTRY_CO":"130","ISO_E":"QAT","COUNTRY_NA":"卡塔尔","COUNTRY_EN":"Qatar"},
  {"COUNTRY_CO":"131","ISO_E":"SAU","COUNTRY_NA":"沙特阿拉伯","COUNTRY_EN":"Saudi Arabia"},
  {"COUNTRY_CO":"132","ISO_E":"SGP","COUNTRY_NA":"新加坡","COUNTRY_EN":"Singapore"},
  {"COUNTRY_CO":"133","ISO_E":"KOR","COUNTRY_NA":"韩国","COUNTRY_EN":"Republic of Korea"},
  {"COUNTRY_CO":"134","ISO_E":"LKA","COUNTRY_NA":"斯里兰卡","COUNTRY_EN":"Sri Lanka"},
  {"COUNTRY_CO":"135","ISO_E":"SYR","COUNTRY_NA":"叙利亚","COUNTRY_EN":"Syria"},
  {"COUNTRY_CO":"136","ISO_E":"THA","COUNTRY_NA":"泰国","COUNTRY_EN":"Thailand"},
  {"COUNTRY_CO":"137","ISO_E":"TUR","COUNTRY_NA":"土耳其","COUNTRY_EN":"Türkiye"},
  {"COUNTRY_CO":"138","ISO_E":"ARE","COUNTRY_NA":"阿联酋","COUNTRY_EN":"United Arab Emirates"},
  {"COUNTRY_CO":"139","ISO_E":"YEM","COUNTRY_NA":"也门","COUNTRY_EN":"Yemen"},
  {"COUNTRY_CO":"141","ISO_E":"VNM","COUNTRY_NA":"越南","COUNTRY_EN":"Viet Nam"},
  {"COUNTRY_CO":"142","ISO_E":"CHN","COUNTRY_NA":"中国","COUNTRY_EN":"China"},
  {"COUNTRY_CO":"143","ISO_E":"TWN","COUNTRY_NA":"中国台湾","COUNTRY_EN":"Taiwan，China"},
  {"COUNTRY_CO":"144","ISO_E":"TLS","COUNTRY_NA":"东帝汶","COUNTRY_EN":"Timor-Leste"},
  {"COUNTRY_CO":"145","ISO_E":"KAZ","COUNTRY_NA":"哈萨克斯坦","COUNTRY_EN":"Kazakhstan"},
  {"COUNTRY_CO":"146","ISO_E":"KGZ","COUNTRY_NA":"吉尔吉斯斯坦","COUNTRY_EN":"Kyrgyzstan"},
  {"COUNTRY_CO":"147","ISO_E":"TJK","COUNTRY_NA":"塔吉克斯坦","COUNTRY_EN":"Tajikistan"},
  {"COUNTRY_CO":"148","ISO_E":"TKM","COUNTRY_NA":"土库曼斯坦","COUNTRY_EN":"Turkmenistan"},
  {"COUNTRY_CO":"149","ISO_E":"UZB","COUNTRY_NA":"乌兹别克斯坦","COUNTRY_EN":"Uzbekistan"},
  {"COUNTRY_CO":"150","ISO_E":"GEO","COUNTRY_NA":"格鲁吉亚","COUNTRY_EN":"Georgia"},
  {"COUNTRY_CO":"151","ISO_E":"ARM","COUNTRY_NA":"亚美尼亚","COUNTRY_EN":"Armenia"},
  {"COUNTRY_CO":"152","ISO_E":"AZE","COUNTRY_NA":"阿塞拜疆","COUNTRY_EN":"Azerbaijan"},
  {"COUNTRY_CO":"199","ISO_E":"ZAS","COUNTRY_NA":"亚洲其他国家（地区）","COUNTRY_EN":"Other Asian Territories"},
  {"COUNTRY_CO":"201","ISO_E":"DZA","COUNTRY_NA":"阿尔及利亚","COUNTRY_EN":"Algeria"},
  {"COUNTRY_CO":"202","ISO_E":"AGO","COUNTRY_NA":"安哥拉","COUNTRY_EN":"Angola"},
  {"COUNTRY_CO":"203","ISO_E":"BEN","COUNTRY_NA":"贝宁","COUNTRY_EN":"Benin"},
  {"COUNTRY_CO":"204","ISO_E":"BWA","COUNTRY_NA":"博茨瓦纳","COUNTRY_EN":"Botswana"},
  {"COUNTRY_CO":"205","ISO_E":"BDI","COUNTRY_NA":"布隆迪","COUNTRY_EN":"Burundi"},
  {"COUNTRY_CO":"206","ISO_E":"CMR","COUNTRY_NA":"喀麦隆","COUNTRY_EN":"Cameroon"},
  {"COUNTRY_CO":"207","ISO_E":"CAI","COUNTRY_NA":"加那利群岛","COUNTRY_EN":"Canary Islands"},
  {"COUNTRY_CO":"208","ISO_E":"CPV","COUNTRY_NA":"佛得角","COUNTRY_EN":"Cabo Verde"},
  {"COUNTRY_CO":"209","ISO_E":"CAF","COUNTRY_NA":"中非","COUNTRY_EN":"Central African Republic"},
  {"COUNTRY_CO":"210","ISO_E":"CEU","COUNTRY_NA":"塞卜泰(休达)","COUNTRY_EN":"Ceuta"},
  {"COUNTRY_CO":"211","ISO_E":"TCD","COUNTRY_NA":"乍得","COUNTRY_EN":"Chad"},
  {"COUNTRY_CO":"212","ISO_E":"COM","COUNTRY_NA":"科摩罗","COUNTRY_EN":"Comoros"},
  {"COUNTRY_CO":"213","ISO_E":"COG","COUNTRY_NA":"刚果共和国","COUNTRY_EN":"Congo"},
  {"COUNTRY_CO":"214","ISO_E":"DJI","COUNTRY_NA":"吉布提","COUNTRY_EN":"Djibouti"},
  {"COUNTRY_CO":"215","ISO_E":"EGY","COUNTRY_NA":"埃及","COUNTRY_EN":"Egypt"},
  {"COUNTRY_CO":"216","ISO_E":"GNQ","COUNTRY_NA":"赤道几内亚","COUNTRY_EN":"Equatorial Guinea"},
  {"COUNTRY_CO":"217","ISO_E":"ETH","COUNTRY_NA":"埃塞俄比亚","COUNTRY_EN":"Ethiopia"},
  {"COUNTRY_CO":"218","ISO_E":"GAB","COUNTRY_NA":"加蓬","COUNTRY_EN":"Gabon"},
  {"COUNTRY_CO":"219","ISO_E":"GMB","COUNTRY_NA":"冈比亚","COUNTRY_EN":"Gambia"},
  {"COUNTRY_CO":"220","ISO_E":"GHA","COUNTRY_NA":"加纳","COUNTRY_EN":"Ghana"},
  {"COUNTRY_CO":"221","ISO_E":"GIN","COUNTRY_NA":"几内亚","COUNTRY_EN":"Guinea"},
  {"COUNTRY_CO":"222","ISO_E":"GNB","COUNTRY_NA":"几内亚比绍","COUNTRY_EN":"Guinea-Bissau"},
  {"COUNTRY_CO":"223","ISO_E":"CIV","COUNTRY_NA":"科特迪瓦","COUNTRY_EN":"Cote d'lvoire"},
  {"COUNTRY_CO":"224","ISO_E":"KEN","COUNTRY_NA":"肯尼亚","COUNTRY_EN":"Kenya"},
  {"COUNTRY_CO":"225","ISO_E":"LBR","COUNTRY_NA":"利比里亚","COUNTRY_EN":"Liberia"},
  {"COUNTRY_CO":"226","ISO_E":"LBY","COUNTRY_NA":"利比亚","COUNTRY_EN":"Libya"},
  {"COUNTRY_CO":"227","ISO_E":"MDG","COUNTRY_NA":"马达加斯加","COUNTRY_EN":"Madagascar"},
  {"COUNTRY_CO":"228","ISO_E":"MWI","COUNTRY_NA":"马拉维","COUNTRY_EN":"Malawi"},
  {"COUNTRY_CO":"229","ISO_E":"MLI","COUNTRY_NA":"马里","COUNTRY_EN":"Mali"},
  {"COUNTRY_CO":"230","ISO_E":"MRT","COUNTRY_NA":"毛里塔尼亚","COUNTRY_EN":"Mauritania"},
  {"COUNTRY_CO":"231","ISO_E":"MUS","COUNTRY_NA":"毛里求斯","COUNTRY_EN":"Mauritius"},
  {"COUNTRY_CO":"232","ISO_E":"MAR","COUNTRY_NA":"摩洛哥","COUNTRY_EN":"Morocco"},
  {"COUNTRY_CO":"233","ISO_E":"MOZ","COUNTRY_NA":"莫桑比克","COUNTRY_EN":"Mozambique"},
  {"COUNTRY_CO":"234","ISO_E":"NAM","COUNTRY_NA":"纳米比亚","COUNTRY_EN":"Namibia"},
  {"COUNTRY_CO":"235","ISO_E":"NER","COUNTRY_NA":"尼日尔","COUNTRY_EN":"Niger"},
  {"COUNTRY_CO":"236","ISO_E":"NGA","COUNTRY_NA":"尼日利亚","COUNTRY_EN":"Nigeria"},
  {"COUNTRY_CO":"237","ISO_E":"REU","COUNTRY_NA":"留尼汪","COUNTRY_EN":"Réunion"},
  {"COUNTRY_CO":"238","ISO_E":"RWA","COUNTRY_NA":"卢旺达","COUNTRY_EN":"Rwanda"},
  {"COUNTRY_CO":"239","ISO_E":"STP","COUNTRY_NA":"圣多美和普林西比","COUNTRY_EN":"Sao Tome and Principe"},
  {"COUNTRY_CO":"240","ISO_E":"SEN","COUNTRY_NA":"塞内加尔","COUNTRY_EN":"Senegal"},
  {"COUNTRY_CO":"241","ISO_E":"SYC","COUNTRY_NA":"塞舌尔","COUNTRY_EN":"Seychelles"},
  {"COUNTRY_CO":"242","ISO_E":"SLE","COUNTRY_NA":"塞拉利昂","COUNTRY_EN":"Sierra Leone"},
  {"COUNTRY_CO":"243","ISO_E":"SOM","COUNTRY_NA":"索马里","COUNTRY_EN":"Somalia"},
  {"COUNTRY_CO":"244","ISO_E":"ZAF","COUNTRY_NA":"南非","COUNTRY_EN":"South Africa"},
  {"COUNTRY_CO":"245","ISO_E":"ESH","COUNTRY_NA":"西撒哈拉","COUNTRY_EN":"Western Sahara"},
  {"COUNTRY_CO":"246","ISO_E":"SDN","COUNTRY_NA":"苏丹","COUNTRY_EN":"Sudan"},
  {"COUNTRY_CO":"247","ISO_E":"TZA","COUNTRY_NA":"坦桑尼亚","COUNTRY_EN":"Tanzania"},
  {"COUNTRY_CO":"248","ISO_E":"TGO","COUNTRY_NA":"多哥","COUNTRY_EN":"Togo"},
  {"COUNTRY_CO":"249","ISO_E":"TUN","COUNTRY_NA":"突尼斯","COUNTRY_EN":"Tunisia"},
  {"COUNTRY_CO":"250","ISO_E":"UGA","COUNTRY_NA":"乌干达","COUNTRY_EN":"Uganda"},
  {"COUNTRY_CO":"251","ISO_E":"BFA","COUNTRY_NA":"布基纳法索","COUNTRY_EN":"Burkina Faso"},
  {"COUNTRY_CO":"252","ISO_E":"COD","COUNTRY_NA":"刚果民主共和国","COUNTRY_EN":"Democratic Republic of Congo"},
  {"COUNTRY_CO":"253","ISO_E":"ZMB","COUNTRY_NA":"赞比亚","COUNTRY_EN":"Zambia"},
  {"COUNTRY_CO":"254","ISO_E":"ZWE","COUNTRY_NA":"津巴布韦","COUNTRY_EN":"Zimbabwe"},
  {"COUNTRY_CO":"255","ISO_E":"LSO","COUNTRY_NA":"莱索托","COUNTRY_EN":"Lesotho"},
  {"COUNTRY_CO":"256","ISO_E":"MEL","COUNTRY_NA":"梅利利亚","COUNTRY_EN":"Melilla"},
  {"COUNTRY_CO":"257","ISO_E":"SWZ","COUNTRY_NA":"斯威士兰","COUNTRY_EN":"Eswatini(Swaziland)"},
  {"COUNTRY_CO":"258","ISO_E":"ERI","COUNTRY_NA":"厄立特里亚","COUNTRY_EN":"Eritrea"},
  {"COUNTRY_CO":"259","ISO_E":"MYT","COUNTRY_NA":"马约特","COUNTRY_EN":"Mayotte"},
  {"COUNTRY_CO":"260","ISO_E":"SSD","COUNTRY_NA":"南苏丹","COUNTRY_EN":"South Sudan"},
  {"COUNTRY_CO":"261","ISO_E":"ATF","COUNTRY_NA":"法属南方领地","COUNTRY_EN":"French Southern Territories"},
  {"COUNTRY_CO":"262","ISO_E":"IOT","COUNTRY_NA":"英属印度洋领地","COUNTRY_EN":"British Indian Ocean Territory"},
  {"COUNTRY_CO":"263","ISO_E":"SHN","COUNTRY_NA":"圣赫勒拿","COUNTRY_EN":"Saint Helena"}, 
  {"COUNTRY_CO":"299","ISO_E":"ZAO","COUNTRY_NA":"非洲其他国家(地区)","COUNTRY_EN":"Other African Territories"},
  {"COUNTRY_CO":"301","ISO_E":"BEL","COUNTRY_NA":"比利时","COUNTRY_EN":"Belgium"},
  {"COUNTRY_CO":"302","ISO_E":"DNK","COUNTRY_NA":"丹麦","COUNTRY_EN":"Denmark"},
  {"COUNTRY_CO":"303","ISO_E":"GBR","COUNTRY_NA":"英国","COUNTRY_EN":"United Kingdom"},
  {"COUNTRY_CO":"304","ISO_E":"DEU","COUNTRY_NA":"德国","COUNTRY_EN":"Germany"},
  {"COUNTRY_CO":"305","ISO_E":"FRA","COUNTRY_NA":"法国","COUNTRY_EN":"France"},
  {"COUNTRY_CO":"306","ISO_E":"IRL","COUNTRY_NA":"爱尔兰","COUNTRY_EN":"Ireland"},
  {"COUNTRY_CO":"307","ISO_E":"ITA","COUNTRY_NA":"意大利","COUNTRY_EN":"Italy"},
  {"COUNTRY_CO":"308","ISO_E":"LUX","COUNTRY_NA":"卢森堡","COUNTRY_EN":"Luxembourg"},
  {"COUNTRY_CO":"309","ISO_E":"NLD","COUNTRY_NA":"荷兰","COUNTRY_EN":"Netherlands"},
  {"COUNTRY_CO":"310","ISO_E":"GRC","COUNTRY_NA":"希腊","COUNTRY_EN":"Greece"},
  {"COUNTRY_CO":"311","ISO_E":"PRT","COUNTRY_NA":"葡萄牙","COUNTRY_EN":"Portugal"},
  {"COUNTRY_CO":"312","ISO_E":"ESP","COUNTRY_NA":"西班牙","COUNTRY_EN":"Spain"},
  {"COUNTRY_CO":"313","ISO_E":"ALB","COUNTRY_NA":"阿尔巴尼亚","COUNTRY_EN":"Albania"},
  {"COUNTRY_CO":"314","ISO_E":"AND","COUNTRY_NA":"安道尔","COUNTRY_EN":"Andorra"},
  {"COUNTRY_CO":"315","ISO_E":"AUT","COUNTRY_NA":"奥地利","COUNTRY_EN":"Austria"},
  {"COUNTRY_CO":"316","ISO_E":"BGR","COUNTRY_NA":"保加利亚","COUNTRY_EN":"Bulgaria"},
  {"COUNTRY_CO":"318","ISO_E":"FIN","COUNTRY_NA":"芬兰","COUNTRY_EN":"Finland"},
  {"COUNTRY_CO":"320","ISO_E":"GIB","COUNTRY_NA":"直布罗陀","COUNTRY_EN":"Gibraltar"},
  {"COUNTRY_CO":"321","ISO_E":"HUN","COUNTRY_NA":"匈牙利","COUNTRY_EN":"Hungary"},
  {"COUNTRY_CO":"322","ISO_E":"ISL","COUNTRY_NA":"冰岛","COUNTRY_EN":"Iceland"},
  {"COUNTRY_CO":"323","ISO_E":"LIE","COUNTRY_NA":"列支敦士登","COUNTRY_EN":"Liechtenstein"},
  {"COUNTRY_CO":"324","ISO_E":"MLT","COUNTRY_NA":"马耳他","COUNTRY_EN":"Malta"},
  {"COUNTRY_CO":"325","ISO_E":"MCO","COUNTRY_NA":"摩纳哥","COUNTRY_EN":"Monaco"},
  {"COUNTRY_CO":"326","ISO_E":"NOR","COUNTRY_NA":"挪威","COUNTRY_EN":"Norway"},
  {"COUNTRY_CO":"327","ISO_E":"POL","COUNTRY_NA":"波兰","COUNTRY_EN":"Poland"},
  {"COUNTRY_CO":"328","ISO_E":"ROU","COUNTRY_NA":"罗马尼亚","COUNTRY_EN":"Romania"},
  {"COUNTRY_CO":"329","ISO_E":"SMR","COUNTRY_NA":"圣马力诺","COUNTRY_EN":"San Marino"},
  {"COUNTRY_CO":"330","ISO_E":"SWE","COUNTRY_NA":"瑞典","COUNTRY_EN":"Sweden"},
  {"COUNTRY_CO":"331","ISO_E":"CHE","COUNTRY_NA":"瑞士","COUNTRY_EN":"Switzerland"},
  {"COUNTRY_CO":"334","ISO_E":"EST","COUNTRY_NA":"爱沙尼亚","COUNTRY_EN":"Estonia"},
  {"COUNTRY_CO":"335","ISO_E":"LVA","COUNTRY_NA":"拉脱维亚","COUNTRY_EN":"Latvia"},
  {"COUNTRY_CO":"336","ISO_E":"LTU","COUNTRY_NA":"立陶宛","COUNTRY_EN":"Lithuania"},
  // {"COUNTRY_CO":"337","ISO_E":"GEO","COUNTRY_NA":"格鲁吉亚","COUNTRY_EN":"Georgia"},
  // {"COUNTRY_CO":"338","ISO_E":"ARM","COUNTRY_NA":"亚美尼亚","COUNTRY_EN":"Armenia"},
  // {"COUNTRY_CO":"339","ISO_E":"AZE","COUNTRY_NA":"阿塞拜疆","COUNTRY_EN":"Azerbai jan"},
  {"COUNTRY_CO":"340","ISO_E":"BLR","COUNTRY_NA":"白俄罗斯","COUNTRY_EN":"Belarus"},
  {"COUNTRY_CO":"343","ISO_E":"MDA","COUNTRY_NA":"摩尔多瓦","COUNTRY_EN":"Moldova"},
  {"COUNTRY_CO":"344","ISO_E":"RUS","COUNTRY_NA":"俄罗斯","COUNTRY_EN":"Russia"},
  {"COUNTRY_CO":"347","ISO_E":"UKR","COUNTRY_NA":"乌克兰","COUNTRY_EN":"Ukraine"},
  // {"COUNTRY_CO":"349","ISO_E":" ","COUNTRY_NA":"塞尔维亚和黑山","COUNTRY_EN":""},
  {"COUNTRY_CO":"350","ISO_E":"SVN","COUNTRY_NA":"斯洛文尼亚","COUNTRY_EN":"Slovenia "},
  {"COUNTRY_CO":"351","ISO_E":"HRV","COUNTRY_NA":"克罗地亚","COUNTRY_EN":"Croatia"},
  {"COUNTRY_CO":"352","ISO_E":"CZE","COUNTRY_NA":"捷克","COUNTRY_EN":"Czechia（Czech Republic）"},
  {"COUNTRY_CO":"353","ISO_E":"SVK","COUNTRY_NA":"斯洛伐克","COUNTRY_EN":"Slovakia"},
  {"COUNTRY_CO":"354","ISO_E":"MKD","COUNTRY_NA":"北马其顿","COUNTRY_EN":"North Macedonia"},
  {"COUNTRY_CO":"355","ISO_E":"BIH","COUNTRY_NA":"波斯尼亚和黑塞哥维那","COUNTRY_EN":"Bosnia and Herzegovina"},
  {"COUNTRY_CO":"356","ISO_E":"VAT","COUNTRY_NA":"梵蒂冈","COUNTRY_EN":"Holy See"},
  {"COUNTRY_CO":"357","ISO_E":"FRO","COUNTRY_NA":"法罗群岛","COUNTRY_EN":"Faroe Islands"},
  {"COUNTRY_CO":"358","ISO_E":"SRB","COUNTRY_NA":"塞尔维亚","COUNTRY_EN":"Serbia"},
  {"COUNTRY_CO":"359","ISO_E":"MNE","COUNTRY_NA":"黑山","COUNTRY_EN":"Montenegro"},
  {"COUNTRY_CO":"360","ISO_E":"ALA","COUNTRY_NA":"奥兰群岛","COUNTRY_EN":"Åland Islands"},
  {"COUNTRY_CO":"361","ISO_E":"GGY","COUNTRY_NA":"格恩西","COUNTRY_EN":"Guernsey"},
  {"COUNTRY_CO":"362","ISO_E":"IMN","COUNTRY_NA":"马恩岛","COUNTRY_EN":"Isle of Man"},
  {"COUNTRY_CO":"363","ISO_E":"JEY","COUNTRY_NA":"泽西","COUNTRY_EN":"Jersey"},
  {"COUNTRY_CO":"364","ISO_E":"SJM","COUNTRY_NA":"斯瓦尔巴群岛和扬马延岛","COUNTRY_EN":"Svalbard and Jan Mayen Islands"},
  {"COUNTRY_CO":"399","ISO_E":"ZEU","COUNTRY_NA":"欧洲其他国家(地区)","COUNTRY_EN":"Other European Territories"},
  {"COUNTRY_CO":"401","ISO_E":"ATG","COUNTRY_NA":"安提瓜和巴布达","COUNTRY_EN":"Antigua and Barbuda"},
  {"COUNTRY_CO":"402","ISO_E":"ARG","COUNTRY_NA":"阿根廷","COUNTRY_EN":"Argentina"},
  {"COUNTRY_CO":"403","ISO_E":"ABW","COUNTRY_NA":"阿鲁巴","COUNTRY_EN":"Aruba"},
  {"COUNTRY_CO":"404","ISO_E":"BHS","COUNTRY_NA":"巴哈马","COUNTRY_EN":"Bahamas"},
  {"COUNTRY_CO":"405","ISO_E":"BRB","COUNTRY_NA":"巴巴多斯","COUNTRY_EN":"Barbados"},
  {"COUNTRY_CO":"406","ISO_E":"BLZ","COUNTRY_NA":"伯利兹","COUNTRY_EN":"Belize"},
  {"COUNTRY_CO":"408","ISO_E":"BOL","COUNTRY_NA":"玻利维亚","COUNTRY_EN":"Bolivia"},
  // {"COUNTRY_CO":"409","ISO_E":"","COUNTRY_NA":"博内尔","COUNTRY_EN":"Bonaire"},
  {"COUNTRY_CO":"410","ISO_E":"BRA","COUNTRY_NA":"巴西","COUNTRY_EN":"Brazil"},
  {"COUNTRY_CO":"411","ISO_E":"CYM","COUNTRY_NA":"开曼群岛","COUNTRY_EN":"Cayman Islands"},
  {"COUNTRY_CO":"412","ISO_E":"CHL","COUNTRY_NA":"智利","COUNTRY_EN":"Chile"},
  {"COUNTRY_CO":"413","ISO_E":"COL","COUNTRY_NA":"哥伦比亚","COUNTRY_EN":"Colombia"},
  {"COUNTRY_CO":"414","ISO_E":"DMA","COUNTRY_NA":"多米尼克","COUNTRY_EN":"Dominica"},
  {"COUNTRY_CO":"415","ISO_E":"CRI","COUNTRY_NA":"哥斯达黎加","COUNTRY_EN":"Costa Rica"},
  {"COUNTRY_CO":"416","ISO_E":"CUB","COUNTRY_NA":"古巴","COUNTRY_EN":"Cuba"},
  {"COUNTRY_CO":"417","ISO_E":"CUW","COUNTRY_NA":"库拉索","COUNTRY_EN":"Curaçao"},
  {"COUNTRY_CO":"418","ISO_E":"DOM","COUNTRY_NA":"多米尼加","COUNTRY_EN":"Dominican Republic"},
  {"COUNTRY_CO":"419","ISO_E":"ECU","COUNTRY_NA":"厄瓜多尔","COUNTRY_EN":"Ecuador"},
  {"COUNTRY_CO":"420","ISO_E":"GUF","COUNTRY_NA":"法属圭亚那","COUNTRY_EN":"French Guiana"},
  {"COUNTRY_CO":"421","ISO_E":"GRD","COUNTRY_NA":"格林纳达","COUNTRY_EN":"Grenada"},
  {"COUNTRY_CO":"422","ISO_E":"GLP","COUNTRY_NA":"瓜德罗普","COUNTRY_EN":"Guadeloupe"},
  {"COUNTRY_CO":"423","ISO_E":"GTM","COUNTRY_NA":"危地马拉","COUNTRY_EN":"Guatemala"},
  {"COUNTRY_CO":"424","ISO_E":"GUY","COUNTRY_NA":"圭亚那","COUNTRY_EN":"Guyana"},
  {"COUNTRY_CO":"425","ISO_E":"HTI","COUNTRY_NA":"海地","COUNTRY_EN":"Haiti"},
  {"COUNTRY_CO":"426","ISO_E":"HND","COUNTRY_NA":"洪都拉斯","COUNTRY_EN":"Honduras"},
  {"COUNTRY_CO":"427","ISO_E":"JAM","COUNTRY_NA":"牙买加","COUNTRY_EN":"Jamaica"},
  {"COUNTRY_CO":"428","ISO_E":"MTQ","COUNTRY_NA":"马提尼克","COUNTRY_EN":"Martinique"},
  {"COUNTRY_CO":"429","ISO_E":"MEX","COUNTRY_NA":"墨西哥","COUNTRY_EN":"Mexico"},
  {"COUNTRY_CO":"430","ISO_E":"MSR","COUNTRY_NA":"蒙特塞拉特","COUNTRY_EN":"Montserrat"},
  {"COUNTRY_CO":"431","ISO_E":"NIC","COUNTRY_NA":"尼加拉瓜","COUNTRY_EN":"Nicaragua"},
  {"COUNTRY_CO":"432","ISO_E":"PAN","COUNTRY_NA":"巴拿马","COUNTRY_EN":"Panama"},
  {"COUNTRY_CO":"433","ISO_E":"PRY","COUNTRY_NA":"巴拉圭","COUNTRY_EN":"Paraguay"},
  {"COUNTRY_CO":"434","ISO_E":"PER","COUNTRY_NA":"秘鲁","COUNTRY_EN":"Peru"},
  {"COUNTRY_CO":"435","ISO_E":"PRI","COUNTRY_NA":"波多黎各","COUNTRY_EN":"Puerto Rico"},
  // {"COUNTRY_CO":"436","ISO_E":"","COUNTRY_NA":"萨巴","COUNTRY_EN":"Saba"},
  {"COUNTRY_CO":"437","ISO_E":"LCA","COUNTRY_NA":"圣卢西亚","COUNTRY_EN":"Saint Lucia"},
  {"COUNTRY_CO":"438","ISO_E":"MAF","COUNTRY_NA":"法属圣马丁","COUNTRY_EN":"Saint Martin (French Part)"},
  {"COUNTRY_CO":"439","ISO_E":"VCT","COUNTRY_NA":"圣文森特和格林纳丁斯","COUNTRY_EN":"Saint Vincent and the Grenadines"},
  {"COUNTRY_CO":"440","ISO_E":"SLV","COUNTRY_NA":"萨尔瓦多","COUNTRY_EN":"El Salvador"},
  {"COUNTRY_CO":"441","ISO_E":"SUR","COUNTRY_NA":"苏里南","COUNTRY_EN":"Suriname"},
  {"COUNTRY_CO":"442","ISO_E":"TTO","COUNTRY_NA":"特立尼达和多巴哥","COUNTRY_EN":"Trinidad and Tobago"},
  {"COUNTRY_CO":"443","ISO_E":"TCA","COUNTRY_NA":"特克斯和凯科斯群岛","COUNTRY_EN":"Turks and Caicos Islands"},
  {"COUNTRY_CO":"444","ISO_E":"URY","COUNTRY_NA":"乌拉圭","COUNTRY_EN":"Uruguay"},
  {"COUNTRY_CO":"445","ISO_E":"VEN","COUNTRY_NA":"委内瑞拉","COUNTRY_EN":"Venezuela"},
  {"COUNTRY_CO":"446","ISO_E":"VGB","COUNTRY_NA":"英属维尔京群岛","COUNTRY_EN":"British Virgin Islands"},
  {"COUNTRY_CO":"447","ISO_E":"KNA","COUNTRY_NA":"圣基茨和尼维斯","COUNTRY_EN":"Saint Kitts and Nevis"},
  // {"COUNTRY_CO":"448","ISO_E":"SPM","COUNTRY_NA":"圣皮埃尔和密克隆","COUNTRY_EN":"Saint.Pierre and Miquelon"},
  {"COUNTRY_CO":"449","ISO_E":"BES","COUNTRY_NA":"博纳尔，圣俄斯塔休斯和萨巴","COUNTRY_EN":"Bonaire, Sint Eustatius and Saba"},
  {"COUNTRY_CO":"450","ISO_E":"BLM","COUNTRY_NA":"圣巴泰勒米","COUNTRY_EN":"Saint Barthélemy"},
  {"COUNTRY_CO":"451","ISO_E":"BVT","COUNTRY_NA":"布维岛","COUNTRY_EN":"Bouvet Island"},
  {"COUNTRY_CO":"452","ISO_E":"FLK","COUNTRY_NA":"福克兰群岛（马尔维纳斯）","COUNTRY_EN":"Falkland Islands (Malvinas)"},
  {"COUNTRY_CO":"453","ISO_E":"SGS","COUNTRY_NA":"南乔治亚岛和南桑德韦奇岛","COUNTRY_EN":"South Georgia and the South Sandwich Islands"},
  {"COUNTRY_CO":"454","ISO_E":"SXM","COUNTRY_NA":"荷属圣马丁","COUNTRY_EN":"Sint Maarten (Dutch part)"},
  {"COUNTRY_CO":"455","ISO_E":"VIR","COUNTRY_NA":"美属维尔京群岛","COUNTRY_EN":"United States Virgin Islands"},
  {"COUNTRY_CO":"456","ISO_E":"AIA","COUNTRY_NA":"安圭拉","COUNTRY_EN":"Anguilla"},
  {"COUNTRY_CO":"499","ISO_E":"ZSA","COUNTRY_NA":"拉丁美洲其他国家(地区)","COUNTRY_EN":"Other Latin American Territories"},
  {"COUNTRY_CO":"501","ISO_E":"CAN","COUNTRY_NA":"加拿大","COUNTRY_EN":"Canada"},
  {"COUNTRY_CO":"502","ISO_E":"USA","COUNTRY_NA":"美国","COUNTRY_EN":"United States"},
  {"COUNTRY_CO":"503","ISO_E":"GRL","COUNTRY_NA":"格陵兰","COUNTRY_EN":"Greenland"},
  {"COUNTRY_CO":"504","ISO_E":"BMU","COUNTRY_NA":"百慕大","COUNTRY_EN":"Bermuda"},
  {"COUNTRY_CO":"505","ISO_E":"SPM","COUNTRY_NA":"圣皮埃尔和密克隆","COUNTRY_EN":"Saint Pierre and Miquelon"},
  {"COUNTRY_CO":"599","ISO_E":"ZNA","COUNTRY_NA":"北美洲其他国家(地区)","COUNTRY_EN":"Other North American Territories"},
  {"COUNTRY_CO":"601","ISO_E":"AUS","COUNTRY_NA":"澳大利亚","COUNTRY_EN":"Australia"},
  {"COUNTRY_CO":"602","ISO_E":"COK","COUNTRY_NA":"库克群岛","COUNTRY_EN":"Cook Islands"},
  {"COUNTRY_CO":"603","ISO_E":"FJI","COUNTRY_NA":"斐济","COUNTRY_EN":"Fiji"},
  // {"COUNTRY_CO":"604","ISO_E":"","COUNTRY_NA":"盖比群岛","COUNTRY_EN":"Gambier Islands"},
  // {"COUNTRY_CO":"605","ISO_E":"","COUNTRY_NA":"马克萨斯群岛","COUNTRY_EN":"Marquesas Islands"},
  {"COUNTRY_CO":"606","ISO_E":"NRU","COUNTRY_NA":"瑙鲁","COUNTRY_EN":"Nauru"},
  {"COUNTRY_CO":"607","ISO_E":"NCL","COUNTRY_NA":"新喀里多尼亚","COUNTRY_EN":"New Caledonia"},
  {"COUNTRY_CO":"608","ISO_E":"VUT","COUNTRY_NA":"瓦努阿图","COUNTRY_EN":"Vanuatu"},
  {"COUNTRY_CO":"609","ISO_E":"NZL","COUNTRY_NA":"新西兰","COUNTRY_EN":"New Zealand"},
  {"COUNTRY_CO":"610","ISO_E":"NFK","COUNTRY_NA":"诺福克岛","COUNTRY_EN":"Norfolk Island"},
  {"COUNTRY_CO":"611","ISO_E":"PNG","COUNTRY_NA":"巴布亚新几内亚","COUNTRY_EN":"Papua New Guinea"},
  // {"COUNTRY_CO":"612","ISO_E":"","COUNTRY_NA":"社会群岛","COUNTRY_EN":"Society Islands"},
  {"COUNTRY_CO":"613","ISO_E":"SLB","COUNTRY_NA":"所罗门群岛","COUNTRY_EN":"Solomon Islands"},
  {"COUNTRY_CO":"614","ISO_E":"TON","COUNTRY_NA":"汤加","COUNTRY_EN":"Tonga"},
  // {"COUNTRY_CO":"615","ISO_E":"","COUNTRY_NA":"土阿莫土群岛","COUNTRY_EN":"Tuamotu Islands"},
  // {"COUNTRY_CO":"616","ISO_E":"","COUNTRY_NA":"土布艾群岛","COUNTRY_EN":"Tubai Islands"},
  {"COUNTRY_CO":"617","ISO_E":"WSM","COUNTRY_NA":"萨摩亚","COUNTRY_EN":"Samoa"},
  {"COUNTRY_CO":"618","ISO_E":"KIR","COUNTRY_NA":"基里巴斯","COUNTRY_EN":"Kiribati"},
  {"COUNTRY_CO":"619","ISO_E":"TUV","COUNTRY_NA":"图瓦卢","COUNTRY_EN":"Tuvalu"},
  {"COUNTRY_CO":"620","ISO_E":"FSM","COUNTRY_NA":"密克罗尼西亚联邦","COUNTRY_EN":"The Federated States of Micronesia"},
  {"COUNTRY_CO":"621","ISO_E":"MHL","COUNTRY_NA":"马绍尔群岛","COUNTRY_EN":"Marshall Islands"},
  {"COUNTRY_CO":"622","ISO_E":"PLW","COUNTRY_NA":"帕劳","COUNTRY_EN":"Palau"},
  {"COUNTRY_CO":"623","ISO_E":"PYF","COUNTRY_NA":"法属波利尼西亚","COUNTRY_EN":"French Polynesia"},
  {"COUNTRY_CO":"625","ISO_E":"WLF","COUNTRY_NA":"瓦利斯和富图纳","COUNTRY_EN":"Wallis and Futuna"},
  {"COUNTRY_CO":"626","ISO_E":"ASM","COUNTRY_NA":"美属萨摩亚","COUNTRY_EN":"American Samoa"},
  {"COUNTRY_CO":"627","ISO_E":"CCK","COUNTRY_NA":"科科斯（基林）群岛","COUNTRY_EN":"Cocos (Keeling) Islands"},
  {"COUNTRY_CO":"628","ISO_E":"CXR","COUNTRY_NA":"圣诞岛","COUNTRY_EN":"Christmas Island"},
  {"COUNTRY_CO":"629","ISO_E":"GUM","COUNTRY_NA":"关岛","COUNTRY_EN":"Guam"},
  {"COUNTRY_CO":"630","ISO_E":"HMD","COUNTRY_NA":"赫德岛和麦克唐纳岛","COUNTRY_EN":"Heard Island and McDonald Islands"},
  {"COUNTRY_CO":"631","ISO_E":"MNP","COUNTRY_NA":"北马里亚纳群岛","COUNTRY_EN":"Northern Mariana Islands"},
  {"COUNTRY_CO":"632","ISO_E":"NIU","COUNTRY_NA":"纽埃","COUNTRY_EN":"Niue"},
  {"COUNTRY_CO":"633","ISO_E":"PCN","COUNTRY_NA":"皮特凯恩","COUNTRY_EN":"Pitcairn"},
  {"COUNTRY_CO":"634","ISO_E":"TKL","COUNTRY_NA":"托克劳","COUNTRY_EN":"Tokelau"},
  {"COUNTRY_CO":"635","ISO_E":"UMI","COUNTRY_NA":"美国本土外小岛屿","COUNTRY_EN":"United States Minor Outlying Islands"},
  {"COUNTRY_CO":"699","ISO_E":"ZOC","COUNTRY_NA":"大洋洲其他国家(地区)","COUNTRY_EN":"Other Oceanian Territories"},
  {"COUNTRY_CO":"700","ISO_E":"ATA","COUNTRY_NA":"南极洲","COUNTRY_EN":"Antarctica"},
  {"COUNTRY_CO":"701","ISO_E":"ZZZ","COUNTRY_NA":"国家（地区）不明","COUNTRY_EN":"Countries(Territories) Unknown"},
  {"COUNTRY_CO":"801","ISO_E":"HRA","COUNTRY_NA":"原产地不明（按相关成员最高税率）","COUNTRY_EN":"-"},
  {"COUNTRY_CO":"802","ISO_E":"HRB","COUNTRY_NA":"原产地不明（按所有成员最高税率）","COUNTRY_EN":"-"},
  // {"COUNTRY_CO":"702","ISO_E":"","COUNTRY_NA":"联合国及机构和国际组织","COUNTRY_EN":"UN and oth. int'l  org."},
  // {"COUNTRY_CO":"999","ISO_E":"","COUNTRY_NA":"中性包装原产国别","COUNTRY_EN":"Conutries of Neutral Package"},
]
  */

// export const lastCountry = [
//   {"COUNTRY_CO":"101","ISO_E":"AFG","COUNTRY_NA":"阿富汗","COUNTRY_EN":"Afghanistan"},
//   {"COUNTRY_CO":"102","ISO_E":"BHR","COUNTRY_NA":"巴林","COUNTRY_EN":"Bahrain"},
//   {"COUNTRY_CO":"103","ISO_E":"BGD","COUNTRY_NA":"孟加拉国","COUNTRY_EN":"Bangladesh"},
//   {"COUNTRY_CO":"104","ISO_E":"BTN","COUNTRY_NA":"不丹","COUNTRY_EN":"Bhutan"},
//   {"COUNTRY_CO":"105","ISO_E":"BRN","COUNTRY_NA":"文莱","COUNTRY_EN":"Brunei"},
//   {"COUNTRY_CO":"106","ISO_E":"MMR","COUNTRY_NA":"缅甸","COUNTRY_EN":"Myanmar"},
//   {"COUNTRY_CO":"107","ISO_E":"KHM","COUNTRY_NA":"柬埔寨","COUNTRY_EN":"Cambodia"},
//   {"COUNTRY_CO":"108","ISO_E":"CYP","COUNTRY_NA":"塞浦路斯","COUNTRY_EN":"Cyprus"},
//   {"COUNTRY_CO":"109","ISO_E":"PRK","COUNTRY_NA":"朝鲜","COUNTRY_EN":"Korea,DPR"},
//   {"COUNTRY_CO":"110","ISO_E":"HKG","COUNTRY_NA":"中国香港","COUNTRY_EN":"Hong Kong，China"},
//   {"COUNTRY_CO":"111","ISO_E":"IND","COUNTRY_NA":"印度","COUNTRY_EN":"India"},
//   {"COUNTRY_CO":"112","ISO_E":"IDN","COUNTRY_NA":"印度尼西亚","COUNTRY_EN":"Indonesia"},
//   {"COUNTRY_CO":"113","ISO_E":"IRN","COUNTRY_NA":"伊朗","COUNTRY_EN":"Iran"},
//   {"COUNTRY_CO":"114","ISO_E":"IRQ","COUNTRY_NA":"伊拉克","COUNTRY_EN":"Iraq"},
//   {"COUNTRY_CO":"115","ISO_E":"ISR","COUNTRY_NA":"以色列","COUNTRY_EN":"Israel"},
//   {"COUNTRY_CO":"116","ISO_E":"JPN","COUNTRY_NA":"日本","COUNTRY_EN":"Japan"},
//   {"COUNTRY_CO":"117","ISO_E":"JOR","COUNTRY_NA":"约旦","COUNTRY_EN":"Jordan"},
//   {"COUNTRY_CO":"118","ISO_E":"KWT","COUNTRY_NA":"科威特","COUNTRY_EN":"Kuwait"},
//   {"COUNTRY_CO":"119","ISO_E":"LAO","COUNTRY_NA":"老挝","COUNTRY_EN":"Lao PDR"},
//   {"COUNTRY_CO":"120","ISO_E":"LBN","COUNTRY_NA":"黎巴嫩","COUNTRY_EN":"Lebanon"},
//   {"COUNTRY_CO":"121","ISO_E":"MAC","COUNTRY_NA":"中国澳门","COUNTRY_EN":"Macau，China"},
//   {"COUNTRY_CO":"122","ISO_E":"MYS","COUNTRY_NA":"马来西亚","COUNTRY_EN":"Malaysia"},
//   {"COUNTRY_CO":"123","ISO_E":"MDV","COUNTRY_NA":"马尔代夫","COUNTRY_EN":"Maldives"},
//   {"COUNTRY_CO":"124","ISO_E":"MNG","COUNTRY_NA":"蒙古","COUNTRY_EN":"Mongolia"},
//   {"COUNTRY_CO":"125","ISO_E":"NPL","COUNTRY_NA":"尼泊尔联邦民主共和国","COUNTRY_EN":"Nepal, FDR"},
//   {"COUNTRY_CO":"126","ISO_E":"OMN","COUNTRY_NA":"阿曼","COUNTRY_EN":"Oman"},
//   {"COUNTRY_CO":"127","ISO_E":"PAK","COUNTRY_NA":"巴基斯坦","COUNTRY_EN":"Pakistan"},
//   {"COUNTRY_CO":"128","ISO_E":"PSE","COUNTRY_NA":"巴勒斯坦","COUNTRY_EN":"Palestine"},
//   {"COUNTRY_CO":"129","ISO_E":"PHL","COUNTRY_NA":"菲律宾","COUNTRY_EN":"Philippines"},
//   {"COUNTRY_CO":"130","ISO_E":"QAT","COUNTRY_NA":"卡塔尔","COUNTRY_EN":"Qatar"},
//   {"COUNTRY_CO":"131","ISO_E":"SAU","COUNTRY_NA":"沙特阿拉伯","COUNTRY_EN":"Saudi Arabia"},
//   {"COUNTRY_CO":"132","ISO_E":"SGP","COUNTRY_NA":"新加坡","COUNTRY_EN":"Singapore"},
//   {"COUNTRY_CO":"133","ISO_E":"KOR","COUNTRY_NA":"韩国","COUNTRY_EN":"Korea, Rep."},
//   {"COUNTRY_CO":"134","ISO_E":"LKA","COUNTRY_NA":"斯里兰卡","COUNTRY_EN":"Sri Lanka"},
//   {"COUNTRY_CO":"135","ISO_E":"SYR","COUNTRY_NA":"叙利亚","COUNTRY_EN":"Syrian Arab Republic"},
//   {"COUNTRY_CO":"136","ISO_E":"THA","COUNTRY_NA":"泰国","COUNTRY_EN":"Thailand"},
//   {"COUNTRY_CO":"137","ISO_E":"TUR","COUNTRY_NA":"土耳其","COUNTRY_EN":"Türkiye"},
//   {"COUNTRY_CO":"138","ISO_E":"ARE","COUNTRY_NA":"阿联酋","COUNTRY_EN":"United Arab Emirates"},
//   {"COUNTRY_CO":"139","ISO_E":"YEM","COUNTRY_NA":"也门","COUNTRY_EN":"Yemen"},
//   {"COUNTRY_CO":"141","ISO_E":"VNM","COUNTRY_NA":"越南","COUNTRY_EN":"Viet Nam"},
//   {"COUNTRY_CO":"142","ISO_E":"CHN","COUNTRY_NA":"中国","COUNTRY_EN":"China"},
//   {"COUNTRY_CO":"143","ISO_E":"TWN","COUNTRY_NA":"中国台湾","COUNTRY_EN":"Taiwan，China"},
//   {"COUNTRY_CO":"144","ISO_E":"TLS","COUNTRY_NA":"东帝汶","COUNTRY_EN":"Timor-Leste"},
//   {"COUNTRY_CO":"145","ISO_E":"KAZ","COUNTRY_NA":"哈萨克斯坦","COUNTRY_EN":"Kazakhstan"},
//   {"COUNTRY_CO":"146","ISO_E":"KGZ","COUNTRY_NA":"吉尔吉斯斯坦","COUNTRY_EN":"Kyrgyzstan"},
//   {"COUNTRY_CO":"147","ISO_E":"TJK","COUNTRY_NA":"塔吉克斯坦","COUNTRY_EN":"Tajikistan"},
//   {"COUNTRY_CO":"148","ISO_E":"TKM","COUNTRY_NA":"土库曼斯坦","COUNTRY_EN":"Turkmenistan"},
//   {"COUNTRY_CO":"149","ISO_E":"UZB","COUNTRY_NA":"乌兹别克斯坦","COUNTRY_EN":"Uzbekistan"},
//   {"COUNTRY_CO":"199","ISO_E":"","COUNTRY_NA":"亚洲其他国家（地区）","COUNTRY_EN":"Oth. Asia nes"},
//   {"COUNTRY_CO":"201","ISO_E":"DZA","COUNTRY_NA":"阿尔及利亚","COUNTRY_EN":"Algeria"},
//   {"COUNTRY_CO":"202","ISO_E":"AGO","COUNTRY_NA":"安哥拉","COUNTRY_EN":"Angola"},
//   {"COUNTRY_CO":"203","ISO_E":"BEN","COUNTRY_NA":"贝宁","COUNTRY_EN":"Benin"},
//   {"COUNTRY_CO":"204","ISO_E":"BWA","COUNTRY_NA":"博茨瓦纳","COUNTRY_EN":"Botswana"},
//   {"COUNTRY_CO":"205","ISO_E":"BDI","COUNTRY_NA":"布隆迪","COUNTRY_EN":"Burundi"},
//   {"COUNTRY_CO":"206","ISO_E":"CMR","COUNTRY_NA":"喀麦隆","COUNTRY_EN":"Cameroon"},
//   {"COUNTRY_CO":"207","ISO_E":"","COUNTRY_NA":"加那利群岛","COUNTRY_EN":"Canary Islands"},
//   {"COUNTRY_CO":"208","ISO_E":"CPV","COUNTRY_NA":"佛得角","COUNTRY_EN":"Cabo Verde"},
//   {"COUNTRY_CO":"209","ISO_E":"CAF","COUNTRY_NA":"中非","COUNTRY_EN":"Central African Republic."},
//   {"COUNTRY_CO":"210","ISO_E":"","COUNTRY_NA":"塞卜泰(休达)","COUNTRY_EN":"Ceuta"},
//   {"COUNTRY_CO":"211","ISO_E":"TCD","COUNTRY_NA":"乍得","COUNTRY_EN":"Chad"},
//   {"COUNTRY_CO":"212","ISO_E":"COM","COUNTRY_NA":"科摩罗","COUNTRY_EN":"Comoros"},
//   {"COUNTRY_CO":"213","ISO_E":"COG","COUNTRY_NA":"刚果(布)","COUNTRY_EN":"Congo"},
//   {"COUNTRY_CO":"214","ISO_E":"DJI","COUNTRY_NA":"吉布提","COUNTRY_EN":"Djibouti"},
//   {"COUNTRY_CO":"215","ISO_E":"EGY","COUNTRY_NA":"埃及","COUNTRY_EN":"Egypt"},
//   {"COUNTRY_CO":"216","ISO_E":"GNQ","COUNTRY_NA":"赤道几内亚","COUNTRY_EN":"Equatorial Guinea"},
//   {"COUNTRY_CO":"217","ISO_E":"ETH","COUNTRY_NA":"埃塞俄比亚","COUNTRY_EN":"Ethiopia"},
//   {"COUNTRY_CO":"218","ISO_E":"GAB","COUNTRY_NA":"加蓬","COUNTRY_EN":"Gabon"},
//   {"COUNTRY_CO":"219","ISO_E":"GMB","COUNTRY_NA":"冈比亚","COUNTRY_EN":"Gambia"},
//   {"COUNTRY_CO":"220","ISO_E":"GHA","COUNTRY_NA":"加纳","COUNTRY_EN":"Ghana"},
//   {"COUNTRY_CO":"221","ISO_E":"GIN","COUNTRY_NA":"几内亚","COUNTRY_EN":"Guinea"},
//   {"COUNTRY_CO":"222","ISO_E":"GNB","COUNTRY_NA":"几内亚比绍","COUNTRY_EN":"Guinea-Bissau"},
//   {"COUNTRY_CO":"223","ISO_E":"CIV","COUNTRY_NA":"科特迪瓦","COUNTRY_EN":"Cote d'lvoire"},
//   {"COUNTRY_CO":"224","ISO_E":"KEN","COUNTRY_NA":"肯尼亚","COUNTRY_EN":"Kenya"},
//   {"COUNTRY_CO":"225","ISO_E":"LBR","COUNTRY_NA":"利比里亚","COUNTRY_EN":"Liberia"},
//   {"COUNTRY_CO":"226","ISO_E":"LBY","COUNTRY_NA":"利比亚","COUNTRY_EN":"Libyan Arab Jamahiriya"},
//   {"COUNTRY_CO":"227","ISO_E":"MDG","COUNTRY_NA":"马达加斯加","COUNTRY_EN":"Madagascar"},
//   {"COUNTRY_CO":"228","ISO_E":"MWI","COUNTRY_NA":"马拉维","COUNTRY_EN":"Malawi"},
//   {"COUNTRY_CO":"229","ISO_E":"MLI","COUNTRY_NA":"马里","COUNTRY_EN":"Mali"},
//   {"COUNTRY_CO":"230","ISO_E":"MRT","COUNTRY_NA":"毛里塔尼亚","COUNTRY_EN":"Mauritania"},
//   {"COUNTRY_CO":"231","ISO_E":"MUS","COUNTRY_NA":"毛里求斯","COUNTRY_EN":"Mauritius"},
//   {"COUNTRY_CO":"232","ISO_E":"MAR","COUNTRY_NA":"摩洛哥","COUNTRY_EN":"Morocco"},
//   {"COUNTRY_CO":"233","ISO_E":"MOZ","COUNTRY_NA":"莫桑比克","COUNTRY_EN":"Mozambique"},
//   {"COUNTRY_CO":"234","ISO_E":"NAM","COUNTRY_NA":"纳米比亚","COUNTRY_EN":"Namibia"},
//   {"COUNTRY_CO":"235","ISO_E":"NER","COUNTRY_NA":"尼日尔","COUNTRY_EN":"Niger"},
//   {"COUNTRY_CO":"236","ISO_E":"NGA","COUNTRY_NA":"尼日利亚","COUNTRY_EN":"Nigeria"},
//   {"COUNTRY_CO":"237","ISO_E":"REU","COUNTRY_NA":"留尼汪","COUNTRY_EN":"Réunion"},
//   {"COUNTRY_CO":"238","ISO_E":"RWA","COUNTRY_NA":"卢旺达","COUNTRY_EN":"Rwanda"},
//   {"COUNTRY_CO":"239","ISO_E":"STP","COUNTRY_NA":"圣多美和普林西比","COUNTRY_EN":"Sao Tome and Principe"},
//   {"COUNTRY_CO":"240","ISO_E":"SEN","COUNTRY_NA":"塞内加尔","COUNTRY_EN":"Senegal"},
//   {"COUNTRY_CO":"241","ISO_E":"SYC","COUNTRY_NA":"塞舌尔","COUNTRY_EN":"Seychelles"},
//   {"COUNTRY_CO":"242","ISO_E":"SLE","COUNTRY_NA":"塞拉利昂","COUNTRY_EN":"Sierra Leone"},
//   {"COUNTRY_CO":"243","ISO_E":"SOM","COUNTRY_NA":"索马里","COUNTRY_EN":"Somalia"},
//   {"COUNTRY_CO":"244","ISO_E":"ZAF","COUNTRY_NA":"南非","COUNTRY_EN":"South Africa"},
//   {"COUNTRY_CO":"245","ISO_E":"ESH","COUNTRY_NA":"西撒哈拉","COUNTRY_EN":"Western Sahara"},
//   {"COUNTRY_CO":"246","ISO_E":"SDN","COUNTRY_NA":"苏丹","COUNTRY_EN":"Sudan"},
//   {"COUNTRY_CO":"247","ISO_E":"TZA","COUNTRY_NA":"坦桑尼亚","COUNTRY_EN":"Tanzania"},
//   {"COUNTRY_CO":"248","ISO_E":"TGO","COUNTRY_NA":"多哥","COUNTRY_EN":"Togo"},
//   {"COUNTRY_CO":"249","ISO_E":"TUN","COUNTRY_NA":"突尼斯","COUNTRY_EN":"Tunisia"},
//   {"COUNTRY_CO":"250","ISO_E":"UGA","COUNTRY_NA":"乌干达","COUNTRY_EN":"Uganda"},
//   {"COUNTRY_CO":"251","ISO_E":"BFA","COUNTRY_NA":"布基纳法索","COUNTRY_EN":"Burkina Faso"},
//   {"COUNTRY_CO":"252","ISO_E":"COD","COUNTRY_NA":"刚果(金)","COUNTRY_EN":"Congo,DR"},
//   {"COUNTRY_CO":"253","ISO_E":"ZMB","COUNTRY_NA":"赞比亚","COUNTRY_EN":"Zambia"},
//   {"COUNTRY_CO":"254","ISO_E":"ZWE","COUNTRY_NA":"津巴布韦","COUNTRY_EN":"Zimbabwe"},
//   {"COUNTRY_CO":"255","ISO_E":"LSO","COUNTRY_NA":"莱索托","COUNTRY_EN":"Lesotho"},
//   {"COUNTRY_CO":"256","ISO_E":"","COUNTRY_NA":"梅利利亚","COUNTRY_EN":"Melilla"},
//   {"COUNTRY_CO":"257","ISO_E":"SWZ","COUNTRY_NA":"斯威士兰","COUNTRY_EN":"Eswatini(Swaziland)"},
//   {"COUNTRY_CO":"258","ISO_E":"ERI","COUNTRY_NA":"厄立特里亚","COUNTRY_EN":"Eritrea"},
//   {"COUNTRY_CO":"259","ISO_E":"MYT","COUNTRY_NA":"马约特","COUNTRY_EN":"Mayotte"},
//   {"COUNTRY_CO":"260","ISO_E":" ","COUNTRY_NA":"南苏丹共和国","COUNTRY_EN":"Republic of South Sudan "},
//   {"COUNTRY_CO":"299","ISO_E":"","COUNTRY_NA":"非洲其他国家(地区)","COUNTRY_EN":"Oth. Afr. nes"},
//   {"COUNTRY_CO":"301","ISO_E":"BEL","COUNTRY_NA":"比利时","COUNTRY_EN":"Belgium"},
//   {"COUNTRY_CO":"302","ISO_E":"DNK","COUNTRY_NA":"丹麦","COUNTRY_EN":"Denmark"},
//   {"COUNTRY_CO":"303","ISO_E":"GBR","COUNTRY_NA":"英国","COUNTRY_EN":"United Kingdom"},
//   {"COUNTRY_CO":"304","ISO_E":"DEU","COUNTRY_NA":"德国","COUNTRY_EN":"Germany"},
//   {"COUNTRY_CO":"305","ISO_E":"FRA","COUNTRY_NA":"法国","COUNTRY_EN":"France"},
//   {"COUNTRY_CO":"306","ISO_E":"IRL","COUNTRY_NA":"爱尔兰","COUNTRY_EN":"Ireland"},
//   {"COUNTRY_CO":"307","ISO_E":"ITA","COUNTRY_NA":"意大利","COUNTRY_EN":"Italy"},
//   {"COUNTRY_CO":"308","ISO_E":"LUX","COUNTRY_NA":"卢森堡","COUNTRY_EN":"Luxembourg"},
//   {"COUNTRY_CO":"309","ISO_E":"NLD","COUNTRY_NA":"荷兰","COUNTRY_EN":"Netherlands"},
//   {"COUNTRY_CO":"310","ISO_E":"GRC","COUNTRY_NA":"希腊","COUNTRY_EN":"Greece"},
//   {"COUNTRY_CO":"311","ISO_E":"PRT","COUNTRY_NA":"葡萄牙","COUNTRY_EN":"Portugal"},
//   {"COUNTRY_CO":"312","ISO_E":"ESP","COUNTRY_NA":"西班牙","COUNTRY_EN":"Spain"},
//   {"COUNTRY_CO":"313","ISO_E":"ALB","COUNTRY_NA":"阿尔巴尼亚","COUNTRY_EN":"Albania"},
//   {"COUNTRY_CO":"314","ISO_E":"AND","COUNTRY_NA":"安道尔","COUNTRY_EN":"Andorra"},
//   {"COUNTRY_CO":"315","ISO_E":"AUT","COUNTRY_NA":"奥地利","COUNTRY_EN":"Austria"},
//   {"COUNTRY_CO":"316","ISO_E":"BGR","COUNTRY_NA":"保加利亚","COUNTRY_EN":"Bulgaria"},
//   {"COUNTRY_CO":"318","ISO_E":"FIN","COUNTRY_NA":"芬兰","COUNTRY_EN":"Finland"},
//   {"COUNTRY_CO":"320","ISO_E":"GIB","COUNTRY_NA":"直布罗陀","COUNTRY_EN":"Gibraltar"},
//   {"COUNTRY_CO":"321","ISO_E":"HUN","COUNTRY_NA":"匈牙利","COUNTRY_EN":"Hungary"},
//   {"COUNTRY_CO":"322","ISO_E":"ISL","COUNTRY_NA":"冰岛","COUNTRY_EN":"Iceland"},
//   {"COUNTRY_CO":"323","ISO_E":"LIE","COUNTRY_NA":"列支敦士登","COUNTRY_EN":"Liechtenstein"},
//   {"COUNTRY_CO":"324","ISO_E":"MLT","COUNTRY_NA":"马耳他","COUNTRY_EN":"Malta"},
//   {"COUNTRY_CO":"325","ISO_E":"MCO","COUNTRY_NA":"摩纳哥","COUNTRY_EN":"Monaco"},
//   {"COUNTRY_CO":"326","ISO_E":"NOR","COUNTRY_NA":"挪威","COUNTRY_EN":"Norway"},
//   {"COUNTRY_CO":"327","ISO_E":"POL","COUNTRY_NA":"波兰","COUNTRY_EN":"Poland"},
//   {"COUNTRY_CO":"328","ISO_E":"ROU","COUNTRY_NA":"罗马尼亚","COUNTRY_EN":"Romania"},
//   {"COUNTRY_CO":"329","ISO_E":"SMR","COUNTRY_NA":"圣马力诺","COUNTRY_EN":"San Marino"},
//   {"COUNTRY_CO":"330","ISO_E":"SWE","COUNTRY_NA":"瑞典","COUNTRY_EN":"Sweden"},
//   {"COUNTRY_CO":"331","ISO_E":"CHE","COUNTRY_NA":"瑞士","COUNTRY_EN":"Switzerland"},
//   {"COUNTRY_CO":"334","ISO_E":"EST","COUNTRY_NA":"爱沙尼亚","COUNTRY_EN":"Estonia"},
//   {"COUNTRY_CO":"335","ISO_E":"LVA","COUNTRY_NA":"拉脱维亚","COUNTRY_EN":"Latvia"},
//   {"COUNTRY_CO":"336","ISO_E":"LTU","COUNTRY_NA":"立陶宛","COUNTRY_EN":"Lithuania"},
//   {"COUNTRY_CO":"337","ISO_E":"GEO","COUNTRY_NA":"格鲁吉亚","COUNTRY_EN":"Georgia"},
//   {"COUNTRY_CO":"338","ISO_E":"ARM","COUNTRY_NA":"亚美尼亚","COUNTRY_EN":"Armenia"},
//   {"COUNTRY_CO":"339","ISO_E":"AZE","COUNTRY_NA":"阿塞拜疆","COUNTRY_EN":"Azerbai jan"},
//   {"COUNTRY_CO":"340","ISO_E":"BLR","COUNTRY_NA":"白俄罗斯","COUNTRY_EN":"Belarus"},
//   {"COUNTRY_CO":"343","ISO_E":"MDA","COUNTRY_NA":"摩尔多瓦","COUNTRY_EN":"Moldova"},
//   {"COUNTRY_CO":"344","ISO_E":"RUS","COUNTRY_NA":"俄罗斯联邦","COUNTRY_EN":"Russian Federation"},
//   {"COUNTRY_CO":"347","ISO_E":"UKR","COUNTRY_NA":"乌克兰","COUNTRY_EN":"Ukraine"},
//   {"COUNTRY_CO":"349","ISO_E":" ","COUNTRY_NA":"塞尔维亚和黑山","COUNTRY_EN":""},
//   {"COUNTRY_CO":"350","ISO_E":"SVN","COUNTRY_NA":"斯洛文尼亚","COUNTRY_EN":"Slovenia "},
//   {"COUNTRY_CO":"351","ISO_E":"HRV","COUNTRY_NA":"克罗地亚","COUNTRY_EN":"Croatia"},
//   {"COUNTRY_CO":"352","ISO_E":"CZE","COUNTRY_NA":"捷克","COUNTRY_EN":"Czech Republic"},
//   {"COUNTRY_CO":"353","ISO_E":"SVK","COUNTRY_NA":"斯洛伐克","COUNTRY_EN":"Slovakia"},
//   {"COUNTRY_CO":"354","ISO_E":"MKD","COUNTRY_NA":"北马其顿共和国","COUNTRY_EN":"Republic of North Macedonia"},
//   {"COUNTRY_CO":"355","ISO_E":"BIH","COUNTRY_NA":"波黑","COUNTRY_EN":"Bosnia and Hercegovina"},
//   {"COUNTRY_CO":"356","ISO_E":"VAT","COUNTRY_NA":"梵蒂冈城国","COUNTRY_EN":"Vatican City State"},
//   {"COUNTRY_CO":"357","ISO_E":"FRO","COUNTRY_NA":"法罗群岛","COUNTRY_EN":"Faroe Islands"},
//   {"COUNTRY_CO":"358","ISO_E":"SRB","COUNTRY_NA":"塞尔维亚","COUNTRY_EN":"Serbia"},
//   {"COUNTRY_CO":"359","ISO_E":"MNE","COUNTRY_NA":"黑山","COUNTRY_EN":"Montenegro"},
//   {"COUNTRY_CO":"399","ISO_E":"","COUNTRY_NA":"欧洲其他国家(地区)","COUNTRY_EN":"Oth. Eur. nes"},
//   {"COUNTRY_CO":"401","ISO_E":"ATG","COUNTRY_NA":"安提瓜和巴布达","COUNTRY_EN":"Antigua & Barbuda"},
//   {"COUNTRY_CO":"402","ISO_E":"ARG","COUNTRY_NA":"阿根廷","COUNTRY_EN":"Argentina"},
//   {"COUNTRY_CO":"403","ISO_E":"ABW","COUNTRY_NA":"阿鲁巴","COUNTRY_EN":"Aruba"},
//   {"COUNTRY_CO":"404","ISO_E":"BHS","COUNTRY_NA":"巴哈马","COUNTRY_EN":"Bahamas"},
//   {"COUNTRY_CO":"405","ISO_E":"BRB","COUNTRY_NA":"巴巴多斯","COUNTRY_EN":"Barbados"},
//   {"COUNTRY_CO":"406","ISO_E":"BLZ","COUNTRY_NA":"伯利兹","COUNTRY_EN":"Belize"},
//   {"COUNTRY_CO":"408","ISO_E":"BOL","COUNTRY_NA":"多民族玻利维亚国","COUNTRY_EN":"Estado Plurinacional de Bolivia"},
//   {"COUNTRY_CO":"409","ISO_E":"","COUNTRY_NA":"博内尔","COUNTRY_EN":"Bonaire"},
//   {"COUNTRY_CO":"410","ISO_E":"BRA","COUNTRY_NA":"巴西","COUNTRY_EN":"Brazil"},
//   {"COUNTRY_CO":"411","ISO_E":"CYM","COUNTRY_NA":"开曼群岛","COUNTRY_EN":"Cayman Islands"},
//   {"COUNTRY_CO":"412","ISO_E":"CHL","COUNTRY_NA":"智利","COUNTRY_EN":"Chile"},
//   {"COUNTRY_CO":"413","ISO_E":"COL","COUNTRY_NA":"哥伦比亚","COUNTRY_EN":"Colombia"},
//   {"COUNTRY_CO":"414","ISO_E":"DMA","COUNTRY_NA":"多米尼克","COUNTRY_EN":"Dominica"},
//   {"COUNTRY_CO":"415","ISO_E":"CRI","COUNTRY_NA":"哥斯达黎加","COUNTRY_EN":"Costa Rica"},
//   {"COUNTRY_CO":"416","ISO_E":"CUB","COUNTRY_NA":"古巴","COUNTRY_EN":"Cuba"},
//   {"COUNTRY_CO":"417","ISO_E":"CUW","COUNTRY_NA":"库腊索岛","COUNTRY_EN":"Curacao"},
//   {"COUNTRY_CO":"418","ISO_E":"DOM","COUNTRY_NA":"多米尼加共和国","COUNTRY_EN":"Dominican Republic"},
//   {"COUNTRY_CO":"419","ISO_E":"ECU","COUNTRY_NA":"厄瓜多尔","COUNTRY_EN":"Ecuador"},
//   {"COUNTRY_CO":"420","ISO_E":"GUF","COUNTRY_NA":"法属圭亚那","COUNTRY_EN":"French Guiana"},
//   {"COUNTRY_CO":"421","ISO_E":"GRD","COUNTRY_NA":"格林纳达","COUNTRY_EN":"Grenada"},
//   {"COUNTRY_CO":"422","ISO_E":"GLP","COUNTRY_NA":"瓜德罗普","COUNTRY_EN":"Guadeloupe"},
//   {"COUNTRY_CO":"423","ISO_E":"GTM","COUNTRY_NA":"危地马拉","COUNTRY_EN":"Guatemala"},
//   {"COUNTRY_CO":"424","ISO_E":"GUY","COUNTRY_NA":"圭亚那","COUNTRY_EN":"Guyana"},
//   {"COUNTRY_CO":"425","ISO_E":"HTI","COUNTRY_NA":"海地","COUNTRY_EN":"Haiti"},
//   {"COUNTRY_CO":"426","ISO_E":"HND","COUNTRY_NA":"洪都拉斯","COUNTRY_EN":"Honduras"},
//   {"COUNTRY_CO":"427","ISO_E":"JAM","COUNTRY_NA":"牙买加","COUNTRY_EN":"Jamaica"},
//   {"COUNTRY_CO":"428","ISO_E":"MTQ","COUNTRY_NA":"马提尼克","COUNTRY_EN":"Martinique"},
//   {"COUNTRY_CO":"429","ISO_E":"MEX","COUNTRY_NA":"墨西哥","COUNTRY_EN":"Mexico"},
//   {"COUNTRY_CO":"430","ISO_E":"MSR","COUNTRY_NA":"蒙特塞拉特","COUNTRY_EN":"Montserrat"},
//   {"COUNTRY_CO":"431","ISO_E":"NIC","COUNTRY_NA":"尼加拉瓜","COUNTRY_EN":"Nicaragua"},
//   {"COUNTRY_CO":"432","ISO_E":"PAN","COUNTRY_NA":"巴拿马","COUNTRY_EN":"Panama"},
//   {"COUNTRY_CO":"433","ISO_E":"PRY","COUNTRY_NA":"巴拉圭","COUNTRY_EN":"Paraguay"},
//   {"COUNTRY_CO":"434","ISO_E":"PER","COUNTRY_NA":"秘鲁","COUNTRY_EN":"Peru"},
//   {"COUNTRY_CO":"435","ISO_E":"PRI","COUNTRY_NA":"波多黎各","COUNTRY_EN":"Puerto Rico"},
//   {"COUNTRY_CO":"436","ISO_E":"","COUNTRY_NA":"萨巴","COUNTRY_EN":"Saba"},
//   {"COUNTRY_CO":"437","ISO_E":"LCA","COUNTRY_NA":"圣卢西亚","COUNTRY_EN":"Saint Lucia"},
//   {"COUNTRY_CO":"438","ISO_E":"","COUNTRY_NA":"圣马丁岛","COUNTRY_EN":"Saint Martin Islands"},
//   {"COUNTRY_CO":"439","ISO_E":"VCT","COUNTRY_NA":"圣文森特和格林纳丁斯","COUNTRY_EN":"Saint Vincent and Grenadines"},
//   {"COUNTRY_CO":"440","ISO_E":"SLV","COUNTRY_NA":"萨尔瓦多","COUNTRY_EN":"El Salvador"},
//   {"COUNTRY_CO":"441","ISO_E":"SUR","COUNTRY_NA":"苏里南","COUNTRY_EN":"Suriname"},
//   {"COUNTRY_CO":"442","ISO_E":"TTO","COUNTRY_NA":"特立尼达和多巴哥","COUNTRY_EN":"Trinidad and Tobago"},
//   {"COUNTRY_CO":"443","ISO_E":"TCA","COUNTRY_NA":"特克斯和凯科斯群岛","COUNTRY_EN":"Turks and Caicos Islands"},
//   {"COUNTRY_CO":"444","ISO_E":"URY","COUNTRY_NA":"乌拉圭","COUNTRY_EN":"Uruguay"},
//   {"COUNTRY_CO":"445","ISO_E":"VEN","COUNTRY_NA":"委内瑞拉","COUNTRY_EN":"Venezuela"},
//   {"COUNTRY_CO":"446","ISO_E":"VGB","COUNTRY_NA":"英属维尔京群岛","COUNTRY_EN":"Virgin  Islands, British"},
//   {"COUNTRY_CO":"447","ISO_E":"KNA","COUNTRY_NA":"圣基茨和尼维斯","COUNTRY_EN":"Saint  Kitts and Nevis"},
//   {"COUNTRY_CO":"448","ISO_E":"SPM","COUNTRY_NA":"圣皮埃尔和密克隆","COUNTRY_EN":"Saint.Pierre and Miquelon"},
//   {"COUNTRY_CO":"449","ISO_E":"ANT","COUNTRY_NA":"荷属安地列斯","COUNTRY_EN":"Netherlands Antilles"},
//   {"COUNTRY_CO":"499","ISO_E":"BES","COUNTRY_NA":"拉丁美洲其他国家(地区)","COUNTRY_EN":"Oth. L.Amer. nes"},
//   {"COUNTRY_CO":"501","ISO_E":"CAN","COUNTRY_NA":"加拿大","COUNTRY_EN":"Canada"},
//   {"COUNTRY_CO":"502","ISO_E":"USA","COUNTRY_NA":"美国","COUNTRY_EN":"United States"},
//   {"COUNTRY_CO":"503","ISO_E":"GRL","COUNTRY_NA":"格陵兰","COUNTRY_EN":"Greenland"},
//   {"COUNTRY_CO":"504","ISO_E":"BMU","COUNTRY_NA":"百慕大","COUNTRY_EN":"Bermuda"},
//   {"COUNTRY_CO":"599","ISO_E":"","COUNTRY_NA":"北美洲其他国家(地区)","COUNTRY_EN":"Oth. N.Amer. nes"},
//   {"COUNTRY_CO":"601","ISO_E":"AUS","COUNTRY_NA":"澳大利亚","COUNTRY_EN":"Australia"},
//   {"COUNTRY_CO":"602","ISO_E":"COK","COUNTRY_NA":"库克群岛","COUNTRY_EN":"Cook Islands"},
//   {"COUNTRY_CO":"603","ISO_E":"FJI","COUNTRY_NA":"斐济","COUNTRY_EN":"Fiji"},
//   {"COUNTRY_CO":"604","ISO_E":"","COUNTRY_NA":"盖比群岛","COUNTRY_EN":"Gambier Islands"},
//   {"COUNTRY_CO":"605","ISO_E":"","COUNTRY_NA":"马克萨斯群岛","COUNTRY_EN":"Marquesas Islands"},
//   {"COUNTRY_CO":"606","ISO_E":"NRU","COUNTRY_NA":"瑙鲁","COUNTRY_EN":"Nauru"},
//   {"COUNTRY_CO":"607","ISO_E":"NCL","COUNTRY_NA":"新喀里多尼亚","COUNTRY_EN":"New Caledonia"},
//   {"COUNTRY_CO":"608","ISO_E":"VUT","COUNTRY_NA":"瓦努阿图","COUNTRY_EN":"Vanuatu"},
//   {"COUNTRY_CO":"609","ISO_E":"NZL","COUNTRY_NA":"新西兰","COUNTRY_EN":"New Zealand"},
//   {"COUNTRY_CO":"610","ISO_E":"NFK","COUNTRY_NA":"诺福克岛","COUNTRY_EN":"Norfolk Island"},
//   {"COUNTRY_CO":"611","ISO_E":"PNG","COUNTRY_NA":"巴布亚新几内亚","COUNTRY_EN":"Papua New Guinea"},
//   {"COUNTRY_CO":"612","ISO_E":"","COUNTRY_NA":"社会群岛","COUNTRY_EN":"Society Islands"},
//   {"COUNTRY_CO":"613","ISO_E":"SLB","COUNTRY_NA":"所罗门群岛","COUNTRY_EN":"Solomon Islands"},
//   {"COUNTRY_CO":"614","ISO_E":"TON","COUNTRY_NA":"汤加","COUNTRY_EN":"Tonga"},
//   {"COUNTRY_CO":"615","ISO_E":"","COUNTRY_NA":"土阿莫土群岛","COUNTRY_EN":"Tuamotu Islands"},
//   {"COUNTRY_CO":"616","ISO_E":"","COUNTRY_NA":"土布艾群岛","COUNTRY_EN":"Tubai Islands"},
//   {"COUNTRY_CO":"617","ISO_E":"WSM","COUNTRY_NA":"萨摩亚","COUNTRY_EN":"Samoa"},
//   {"COUNTRY_CO":"618","ISO_E":"KIR","COUNTRY_NA":"基里巴斯","COUNTRY_EN":"Kiribati"},
//   {"COUNTRY_CO":"619","ISO_E":"TUV","COUNTRY_NA":"图瓦卢","COUNTRY_EN":"Tuvalu"},
//   {"COUNTRY_CO":"620","ISO_E":"FSM","COUNTRY_NA":"密克罗尼西亚联邦","COUNTRY_EN":"Micronesia, Fs"},
//   {"COUNTRY_CO":"621","ISO_E":"MHL","COUNTRY_NA":"马绍尔群岛","COUNTRY_EN":"Marshall Islands"},
//   {"COUNTRY_CO":"622","ISO_E":"PLW","COUNTRY_NA":"帕劳","COUNTRY_EN":"Palau"},
//   {"COUNTRY_CO":"623","ISO_E":"PYF","COUNTRY_NA":"法属波利尼西亚","COUNTRY_EN":"French Polynesia"},
//   {"COUNTRY_CO":"625","ISO_E":"WLF","COUNTRY_NA":"瓦利斯和浮图纳","COUNTRY_EN":"Wallis and Futuna"},
//   {"COUNTRY_CO":"699","ISO_E":"MNP","COUNTRY_NA":"大洋洲其他国家(地区)","COUNTRY_EN":"Oth. Ocean. nes"},
//   {"COUNTRY_CO":"701","ISO_E":"","COUNTRY_NA":"国(地)别不详","COUNTRY_EN":"Countries(reg.) unknown"},
//   {"COUNTRY_CO":"702","ISO_E":"","COUNTRY_NA":"联合国及机构和国际组织","COUNTRY_EN":"UN and oth. int'l  org."},
//   {"COUNTRY_CO":"999","ISO_E":"","COUNTRY_NA":"中性包装原产国别","COUNTRY_EN":"Conutries of Neutral Package"},

// ]

//境内货源地
export const District = [
  {
    "DISTRICT_C": "44013",
    "DISTRICT_N": "广州天河高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "44014",
    "DISTRICT_N": "广州保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "44015",
    "DISTRICT_N": "广东广州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44016",
    "DISTRICT_N": "广州白云机场、黄埔综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44017",
    "DISTRICT_N": "广州保税物流园区",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44019",
    "DISTRICT_N": "广州其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "44029",
    "DISTRICT_N": "韶关",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44031",
    "DISTRICT_N": "深圳特区",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "44033",
    "DISTRICT_N": "深圳科技工业园",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "44034",
    "DISTRICT_N": "福田盐田沙头角保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "44035",
    "DISTRICT_N": "广东深圳出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44036",
    "DISTRICT_N": "深圳前海、坪山综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44037",
    "DISTRICT_N": "深圳盐田保税物流园",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "44039",
    "DISTRICT_N": "深圳其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4403W",
    "DISTRICT_N": "深圳机场保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44041",
    "DISTRICT_N": "珠海特区",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "44043",
    "DISTRICT_N": "珠海高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "44044",
    "DISTRICT_N": "珠海保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "44045",
    "DISTRICT_N": "珠澳跨境工业区珠海园区",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44046",
    "DISTRICT_N": "珠海高栏港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44048",
    "DISTRICT_N": "横琴粤澳深度合作区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44049",
    "DISTRICT_N": "珠海其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44051",
    "DISTRICT_N": "汕头特区",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "44054",
    "DISTRICT_N": "汕头保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "44056",
    "DISTRICT_N": "汕头综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44059",
    "DISTRICT_N": "汕头其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4405W",
    "DISTRICT_N": "汕头保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44063",
    "DISTRICT_N": "佛山高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "44069",
    "DISTRICT_N": "佛山其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44079",
    "DISTRICT_N": "江门",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4407W",
    "DISTRICT_N": "江门大广海湾保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44082",
    "DISTRICT_N": "湛江经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "44083",
    "DISTRICT_N": "湛江高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44086",
    "DISTRICT_N": "湛江综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44089",
    "DISTRICT_N": "湛江其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "4408W",
    "DISTRICT_N": "湛江保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44093",
    "DISTRICT_N": "茂名高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44099",
    "DISTRICT_N": "茂名",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44129",
    "DISTRICT_N": "肇庆",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44133",
    "DISTRICT_N": "惠州高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "44139",
    "DISTRICT_N": "惠州其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44146",
    "DISTRICT_N": "梅州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44149",
    "DISTRICT_N": "梅州",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44159",
    "DISTRICT_N": "汕尾",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44169",
    "DISTRICT_N": "河源",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44179",
    "DISTRICT_N": "阳江",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44189",
    "DISTRICT_N": "清远",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44193",
    "DISTRICT_N": "东莞松山湖高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44196",
    "DISTRICT_N": "东莞虎门港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44199",
    "DISTRICT_N": "东莞",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4419W",
    "DISTRICT_N": "东莞保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44203",
    "DISTRICT_N": "中山火炬高技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "44209",
    "DISTRICT_N": "中山其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4420W",
    "DISTRICT_N": "中山保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44219",
    "DISTRICT_N": "潮州",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44226",
    "DISTRICT_N": "佛山综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44229",
    "DISTRICT_N": "顺德",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4422W",
    "DISTRICT_N": "佛山国通保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44235",
    "DISTRICT_N": "广东南沙出口加工区",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44236",
    "DISTRICT_N": "广州南沙保税港区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44239",
    "DISTRICT_N": "番禺",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44249",
    "DISTRICT_N": "揭阳",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44289",
    "DISTRICT_N": "南海",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "4428W",
    "DISTRICT_N": "佛山国际陆港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44299",
    "DISTRICT_N": "云浮市",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "44306",
    "DISTRICT_N": "广州南沙综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44309",
    "DISTRICT_N": "南沙其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44536",
    "DISTRICT_N": "深圳盐田综合保税区（一期）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4469W",
    "DISTRICT_N": "东莞清溪保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44909",
    "DISTRICT_N": "广东其他",
    "DISTRICT_T": "7"
  },
  {
    "DISTRICT_C": "45012",
    "DISTRICT_N": "广西-东盟、南宁经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45013",
    "DISTRICT_N": "南宁高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "45016",
    "DISTRICT_N": "南宁综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45019",
    "DISTRICT_N": "南宁其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "4501W",
    "DISTRICT_N": "南宁保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45023",
    "DISTRICT_N": "柳州高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45029",
    "DISTRICT_N": "柳州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4502W",
    "DISTRICT_N": "柳州保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45033",
    "DISTRICT_N": "桂林高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "45039",
    "DISTRICT_N": "桂林其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45046",
    "DISTRICT_N": "梧州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45049",
    "DISTRICT_N": "梧州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45052",
    "DISTRICT_N": "北海经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45053",
    "DISTRICT_N": "北海高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45055",
    "DISTRICT_N": "广西北海出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45056",
    "DISTRICT_N": "北海综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45059",
    "DISTRICT_N": "北海",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "45069",
    "DISTRICT_N": "玉林",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45079",
    "DISTRICT_N": "百色",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45089",
    "DISTRICT_N": "河池",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45092",
    "DISTRICT_N": "钦州港经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45096",
    "DISTRICT_N": "钦州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45099",
    "DISTRICT_N": "钦州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45106",
    "DISTRICT_N": "广西凭祥综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45109",
    "DISTRICT_N": "凭祥",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "45119",
    "DISTRICT_N": "东兴",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "45129",
    "DISTRICT_N": "防城港市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4512W",
    "DISTRICT_N": "防城港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45139",
    "DISTRICT_N": "贵港市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45149",
    "DISTRICT_N": "崇左",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45159",
    "DISTRICT_N": "来宾",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45169",
    "DISTRICT_N": "贺州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "45909",
    "DISTRICT_N": "广西其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46011",
    "DISTRICT_N": "海口",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "46013",
    "DISTRICT_N": "海南国际科技园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "46014",
    "DISTRICT_N": "海南海口保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "46016",
    "DISTRICT_N": "海口综合保税区及海口空港综合保税区",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "46021",
    "DISTRICT_N": "三亚",
    "DISTRICT_T": "5"
  },
  {
    "DISTRICT_C": "4602W",
    "DISTRICT_N": "海南三亚保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46031",
    "DISTRICT_N": "三沙",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46041",
    "DISTRICT_N": "五指山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46051",
    "DISTRICT_N": "琼海",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46061",
    "DISTRICT_N": "儋州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46062",
    "DISTRICT_N": "洋浦经济开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46066",
    "DISTRICT_N": "洋浦保税港区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46071",
    "DISTRICT_N": "文昌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46081",
    "DISTRICT_N": "万宁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46091",
    "DISTRICT_N": "东方",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42149",
    "DISTRICT_N": "恩施土家族苗族自治区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42159",
    "DISTRICT_N": "随州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42169",
    "DISTRICT_N": "老河口",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42172",
    "DISTRICT_N": "枣阳经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42179",
    "DISTRICT_N": "枣阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42189",
    "DISTRICT_N": "神农架",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42199",
    "DISTRICT_N": "仙桃市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4219W",
    "DISTRICT_N": "仙桃保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42209",
    "DISTRICT_N": "潜江市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42219",
    "DISTRICT_N": "天门市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42506",
    "DISTRICT_N": "武汉新港空港",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42909",
    "DISTRICT_N": "湖北其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43012",
    "DISTRICT_N": "长沙经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43013",
    "DISTRICT_N": "长沙科技开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "43016",
    "DISTRICT_N": "长沙黄花综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43019",
    "DISTRICT_N": "长沙其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "4301W",
    "DISTRICT_N": "长沙金霞保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43023",
    "DISTRICT_N": "株洲高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "43029",
    "DISTRICT_N": "株洲其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4302W",
    "DISTRICT_N": "株洲铜塘湾保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43032",
    "DISTRICT_N": "湘潭经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43033",
    "DISTRICT_N": "湘潭高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43036",
    "DISTRICT_N": "湘潭综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43039",
    "DISTRICT_N": "湘潭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43043",
    "DISTRICT_N": "衡阳高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43046",
    "DISTRICT_N": "衡阳综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43049",
    "DISTRICT_N": "衡阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43059",
    "DISTRICT_N": "邵阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43062",
    "DISTRICT_N": "岳阳经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43066",
    "DISTRICT_N": "岳阳城陵矶综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43069",
    "DISTRICT_N": "岳阳",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "43072",
    "DISTRICT_N": "常德经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43073",
    "DISTRICT_N": "常德高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43079",
    "DISTRICT_N": "常德",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43089",
    "DISTRICT_N": "张家界",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43093",
    "DISTRICT_N": "益阳高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43099",
    "DISTRICT_N": "益阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43102",
    "DISTRICT_N": "娄底经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43109",
    "DISTRICT_N": "娄底",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43113",
    "DISTRICT_N": "郴州高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43115",
    "DISTRICT_N": "湖南郴州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43116",
    "DISTRICT_N": "郴州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43119",
    "DISTRICT_N": "郴州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43129",
    "DISTRICT_N": "永州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43133",
    "DISTRICT_N": "怀化高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43139",
    "DISTRICT_N": "怀化",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43149",
    "DISTRICT_N": "湘西",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43159",
    "DISTRICT_N": "醴陵",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43169",
    "DISTRICT_N": "湘乡",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43179",
    "DISTRICT_N": "耒阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43189",
    "DISTRICT_N": "汩罗",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43199",
    "DISTRICT_N": "津市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43202",
    "DISTRICT_N": "浏阳经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43209",
    "DISTRICT_N": "浏阳其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "43909",
    "DISTRICT_N": "湖南其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4609W",
    "DISTRICT_N": "东方市保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46101",
    "DISTRICT_N": "定安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46111",
    "DISTRICT_N": "屯昌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46121",
    "DISTRICT_N": "澄迈",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46131",
    "DISTRICT_N": "临高",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46141",
    "DISTRICT_N": "白沙",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46151",
    "DISTRICT_N": "昌江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46161",
    "DISTRICT_N": "乐东",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46171",
    "DISTRICT_N": "陵水",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46181",
    "DISTRICT_N": "保亭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46191",
    "DISTRICT_N": "琼中",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "46901",
    "DISTRICT_N": "海南其他",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "46902",
    "DISTRICT_N": "海南洋浦经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "46906",
    "DISTRICT_N": "海南洋浦保税港区",
    "DISTRICT_T": "5"
  },
  {
    "DISTRICT_C": "50012",
    "DISTRICT_N": "万州经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50016",
    "DISTRICT_N": "重庆万州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50019",
    "DISTRICT_N": "万州区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50022",
    "DISTRICT_N": "涪陵经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50026",
    "DISTRICT_N": "重庆涪陵综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50029",
    "DISTRICT_N": "涪陵区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50039",
    "DISTRICT_N": "渝中区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50049",
    "DISTRICT_N": "大渡口区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50052",
    "DISTRICT_N": "重庆两江新区江北区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "50056",
    "DISTRICT_N": "重庆两路果园港综合保税区果园港片区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50059",
    "DISTRICT_N": "江北区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5005W",
    "DISTRICT_N": "重庆果园保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50066",
    "DISTRICT_N": "重庆西永、国际铁路港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50069",
    "DISTRICT_N": "沙坪坝区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5006W",
    "DISTRICT_N": "重庆铁路保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50073",
    "DISTRICT_N": "重庆高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "50079",
    "DISTRICT_N": "九龙坡区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50082",
    "DISTRICT_N": "重庆经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "50089",
    "DISTRICT_N": "南岸区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50092",
    "DISTRICT_N": "重庆两江新区北碚区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "50099",
    "DISTRICT_N": "北碚区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50109",
    "DISTRICT_N": "万盛区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50119",
    "DISTRICT_N": "双桥区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50122",
    "DISTRICT_N": "重庆两江新区渝北区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "50125",
    "DISTRICT_N": "重庆出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50126",
    "DISTRICT_N": "重庆两路果园港综合保税区两路片区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50129",
    "DISTRICT_N": "渝北区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50139",
    "DISTRICT_N": "巴南区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5013W",
    "DISTRICT_N": "重庆南彭公路保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50212",
    "DISTRICT_N": "长寿经济技术开发区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "50219",
    "DISTRICT_N": "长寿县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50229",
    "DISTRICT_N": "綦江区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50239",
    "DISTRICT_N": "潼南县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50249",
    "DISTRICT_N": "重庆市铜梁区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50259",
    "DISTRICT_N": "大足区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50269",
    "DISTRICT_N": "荣昌县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50273",
    "DISTRICT_N": "璧山高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50279",
    "DISTRICT_N": "重庆市璧山区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50289",
    "DISTRICT_N": "梁平县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50299",
    "DISTRICT_N": "城口县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50309",
    "DISTRICT_N": "丰都县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50319",
    "DISTRICT_N": "垫江县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50329",
    "DISTRICT_N": "武隆县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50339",
    "DISTRICT_N": "忠县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50349",
    "DISTRICT_N": "开县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50359",
    "DISTRICT_N": "云阳县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50369",
    "DISTRICT_N": "奉节县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50379",
    "DISTRICT_N": "巫山县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50389",
    "DISTRICT_N": "巫溪县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50399",
    "DISTRICT_N": "黔江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50409",
    "DISTRICT_N": "石柱土家族自治县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50419",
    "DISTRICT_N": "秀山土家族苗族自治县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50429",
    "DISTRICT_N": "酉阳土家族苗族自治县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50439",
    "DISTRICT_N": "彭水苗族土家族自治县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50816",
    "DISTRICT_N": "重庆江津综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50819",
    "DISTRICT_N": "江津区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50829",
    "DISTRICT_N": "合川区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50836",
    "DISTRICT_N": "重庆永川综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50839",
    "DISTRICT_N": "永川区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "50849",
    "DISTRICT_N": "南川区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51012",
    "DISTRICT_N": "成都经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "51013",
    "DISTRICT_N": "成都高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "51015",
    "DISTRICT_N": "四川成都出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51016",
    "DISTRICT_N": "成都高新、国际铁路港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51019",
    "DISTRICT_N": "成都其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "5101W",
    "DISTRICT_N": "成都空港、天府新区成都片区保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51039",
    "DISTRICT_N": "自贡",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51049",
    "DISTRICT_N": "攀枝花",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51053",
    "DISTRICT_N": "泸州高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51056",
    "DISTRICT_N": "泸州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51059",
    "DISTRICT_N": "泸州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5105W",
    "DISTRICT_N": "泸州港保税物流中心（Ｂ型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51069",
    "DISTRICT_N": "德阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51072",
    "DISTRICT_N": "绵阳经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51073",
    "DISTRICT_N": "绵阳高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "51075",
    "DISTRICT_N": "四川绵阳出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51076",
    "DISTRICT_N": "绵阳综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51079",
    "DISTRICT_N": "绵阳其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51082",
    "DISTRICT_N": "广元经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51089",
    "DISTRICT_N": "广元",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51099",
    "DISTRICT_N": "遂宁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51102",
    "DISTRICT_N": "内江经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51103",
    "DISTRICT_N": "内江高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51109",
    "DISTRICT_N": "内江市其他地区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5110W",
    "DISTRICT_N": "内江保税物流中心（ B 型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51113",
    "DISTRICT_N": "乐山高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51119",
    "DISTRICT_N": "乐山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51142",
    "DISTRICT_N": "宜宾临港经济开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51146",
    "DISTRICT_N": "宜宾综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51149",
    "DISTRICT_N": "宜宾",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5114W",
    "DISTRICT_N": "宜宾港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51159",
    "DISTRICT_N": "南充",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5115W",
    "DISTRICT_N": "南充保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51169",
    "DISTRICT_N": "达州市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51179",
    "DISTRICT_N": "雅安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51189",
    "DISTRICT_N": "阿坝",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51199",
    "DISTRICT_N": "甘孜",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51209",
    "DISTRICT_N": "凉山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51229",
    "DISTRICT_N": "广汉",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51239",
    "DISTRICT_N": "江油",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51249",
    "DISTRICT_N": "都江堰",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51259",
    "DISTRICT_N": "峨眉山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51269",
    "DISTRICT_N": "资阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51279",
    "DISTRICT_N": "眉山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51289",
    "DISTRICT_N": "广安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51299",
    "DISTRICT_N": "巴中",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5151W",
    "DISTRICT_N": "成都铁路保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "51909",
    "DISTRICT_N": "四川其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52013",
    "DISTRICT_N": "贵阳高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "52016",
    "DISTRICT_N": "贵阳综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52019",
    "DISTRICT_N": "贵阳其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "5201W",
    "DISTRICT_N": "贵州双龙保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52029",
    "DISTRICT_N": "六盘水",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52036",
    "DISTRICT_N": "遵义综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52039",
    "DISTRICT_N": "遵义",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52049",
    "DISTRICT_N": "铜仁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52059",
    "DISTRICT_N": "黔西南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52069",
    "DISTRICT_N": "毕节",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52079",
    "DISTRICT_N": "安顺",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52089",
    "DISTRICT_N": "黔东南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52099",
    "DISTRICT_N": "黔南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52502",
    "DISTRICT_N": "贵阳贵安新区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52506",
    "DISTRICT_N": "贵安综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "52909",
    "DISTRICT_N": "贵州其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53012",
    "DISTRICT_N": "昆明经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "53013",
    "DISTRICT_N": "昆明高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "53015",
    "DISTRICT_N": "云南昆明出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53016",
    "DISTRICT_N": "昆明综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53019",
    "DISTRICT_N": "昆明其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "5301W",
    "DISTRICT_N": "昆明高新保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53029",
    "DISTRICT_N": "东川",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53039",
    "DISTRICT_N": "昭通",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53042",
    "DISTRICT_N": "曲靖经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "53049",
    "DISTRICT_N": "曲靖",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53059",
    "DISTRICT_N": "楚雄",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53069",
    "DISTRICT_N": "玉溪",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53072",
    "DISTRICT_N": "云南省蒙自经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53076",
    "DISTRICT_N": "云南红河综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53079",
    "DISTRICT_N": "红河",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53089",
    "DISTRICT_N": "文山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53099",
    "DISTRICT_N": "普洱",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53109",
    "DISTRICT_N": "西双版纳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53112",
    "DISTRICT_N": "大理经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53119",
    "DISTRICT_N": "大理",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53129",
    "DISTRICT_N": "保山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53139",
    "DISTRICT_N": "德宏",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53149",
    "DISTRICT_N": "丽江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53159",
    "DISTRICT_N": "怒江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53169",
    "DISTRICT_N": "迪庆",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53179",
    "DISTRICT_N": "临沧",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53189",
    "DISTRICT_N": "畹町",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "53199",
    "DISTRICT_N": "瑞丽",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "53209",
    "DISTRICT_N": "河口",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "5351W",
    "DISTRICT_N": "腾俊国际陆港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "53909",
    "DISTRICT_N": "云南其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "54012",
    "DISTRICT_N": "拉萨经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "54016",
    "DISTRICT_N": "拉萨综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "54019",
    "DISTRICT_N": "拉萨",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54029",
    "DISTRICT_N": "昌都",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54039",
    "DISTRICT_N": "山南",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54049",
    "DISTRICT_N": "日喀则",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54059",
    "DISTRICT_N": "那曲",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54069",
    "DISTRICT_N": "阿里",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54079",
    "DISTRICT_N": "林芝",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "54909",
    "DISTRICT_N": "西藏其他",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "61012",
    "DISTRICT_N": "陕西航天、陕西航空、西安市经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61013",
    "DISTRICT_N": "西安新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "61015",
    "DISTRICT_N": "陕西西安出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61016",
    "DISTRICT_N": "西安、西安高新、西安航空基地和西安关中综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61019",
    "DISTRICT_N": "西安其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "61029",
    "DISTRICT_N": "铜川",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61033",
    "DISTRICT_N": "宝鸡高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "61036",
    "DISTRICT_N": "宝鸡综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61039",
    "DISTRICT_N": "宝鸡其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61043",
    "DISTRICT_N": "杨凌农业高新技术产业示范区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61046",
    "DISTRICT_N": "陕西西咸空港、杨凌综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61049",
    "DISTRICT_N": "咸阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "6104W",
    "DISTRICT_N": "陕西西咸保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61059",
    "DISTRICT_N": "渭南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61062",
    "DISTRICT_N": "汉中经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61069",
    "DISTRICT_N": "汉中",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61079",
    "DISTRICT_N": "安康",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61089",
    "DISTRICT_N": "商洛",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61099",
    "DISTRICT_N": "延安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61102",
    "DISTRICT_N": "陕西榆林经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61109",
    "DISTRICT_N": "榆林",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "61909",
    "DISTRICT_N": "陕西其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62013",
    "DISTRICT_N": "兰州宁卧庄新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "62016",
    "DISTRICT_N": "兰州新区综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62019",
    "DISTRICT_N": "兰州其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "62029",
    "DISTRICT_N": "嘉峪关",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62039",
    "DISTRICT_N": "金昌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62049",
    "DISTRICT_N": "白银",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62059",
    "DISTRICT_N": "天水",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62069",
    "DISTRICT_N": "酒泉",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62079",
    "DISTRICT_N": "张掖",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62089",
    "DISTRICT_N": "武威",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "6208W",
    "DISTRICT_N": "武威保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62099",
    "DISTRICT_N": "定西",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62109",
    "DISTRICT_N": "陇南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62119",
    "DISTRICT_N": "平凉",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62129",
    "DISTRICT_N": "庆阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62139",
    "DISTRICT_N": "临夏",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62149",
    "DISTRICT_N": "甘南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "62909",
    "DISTRICT_N": "甘肃其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63012",
    "DISTRICT_N": "西宁经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "63013",
    "DISTRICT_N": "青海高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "63016",
    "DISTRICT_N": "西宁综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63019",
    "DISTRICT_N": "西宁",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "63029",
    "DISTRICT_N": "海东",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "6302W",
    "DISTRICT_N": "青海曹家堡保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63039",
    "DISTRICT_N": "海北",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63049",
    "DISTRICT_N": "黄南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63059",
    "DISTRICT_N": "海南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63069",
    "DISTRICT_N": "果洛",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63079",
    "DISTRICT_N": "玉树",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63082",
    "DISTRICT_N": "格尔木昆仑经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63089",
    "DISTRICT_N": "海西",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "63909",
    "DISTRICT_N": "青海其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "64012",
    "DISTRICT_N": "银川经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "64016",
    "DISTRICT_N": "银川综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "64019",
    "DISTRICT_N": "银川",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "64029",
    "DISTRICT_N": "石嘴山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "6402W",
    "DISTRICT_N": "石嘴山保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "64039",
    "DISTRICT_N": "吴忠",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "64049",
    "DISTRICT_N": "固原",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "64059",
    "DISTRICT_N": "中卫",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "64909",
    "DISTRICT_N": "宁夏其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65012",
    "DISTRICT_N": "乌鲁木齐经济技术开发区和甘泉堡经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "65013",
    "DISTRICT_N": "乌鲁木齐高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "65015",
    "DISTRICT_N": "新疆乌鲁木齐出口加工区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65016",
    "DISTRICT_N": "乌鲁木齐综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65019",
    "DISTRICT_N": "乌鲁木齐其他",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65029",
    "DISTRICT_N": "克拉玛依",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65036",
    "DISTRICT_N": "阿拉山口综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65039",
    "DISTRICT_N": "博乐",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65049",
    "DISTRICT_N": "巴音",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65059",
    "DISTRICT_N": "阿克苏",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65069",
    "DISTRICT_N": "克孜",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65076",
    "DISTRICT_N": "喀什综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65079",
    "DISTRICT_N": "喀什",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65089",
    "DISTRICT_N": "和田",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65095",
    "DISTRICT_N": "中哈霍尔果斯国际边境合作中心中方配套区（一期）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65096",
    "DISTRICT_N": "霍尔果斯综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65099",
    "DISTRICT_N": "伊宁",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "6509A",
    "DISTRICT_N": "中哈霍尔果斯国际边境合作中心中方区域",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "6509W",
    "DISTRICT_N": "奎屯保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "65109",
    "DISTRICT_N": "塔城",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "65119",
    "DISTRICT_N": "阿勒泰",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65122",
    "DISTRICT_N": "石河子经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "65129",
    "DISTRICT_N": "石河子",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65219",
    "DISTRICT_N": "吐鲁番",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65229",
    "DISTRICT_N": "哈密",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65239",
    "DISTRICT_N": "昌吉回族自治州",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "65909",
    "DISTRICT_N": "新疆其他",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11013",
    "DISTRICT_N": "中关村国家自主创新示范区（东城园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11019",
    "DISTRICT_N": "东城区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11023",
    "DISTRICT_N": "中关村国家自主创新示范区（西城园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11029",
    "DISTRICT_N": "西城区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11039",
    "DISTRICT_N": "崇文区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11049",
    "DISTRICT_N": "宣武区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11053",
    "DISTRICT_N": "中关村国家自主创新示范区（朝阳园）",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "11059",
    "DISTRICT_N": "朝阳区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11063",
    "DISTRICT_N": "中关村国家自主创新示范区（丰台园）",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "11069",
    "DISTRICT_N": "丰台区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11073",
    "DISTRICT_N": "中关村国家自主创新示范区（石景山园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11079",
    "DISTRICT_N": "石景山",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11083",
    "DISTRICT_N": "中关村国家自主创新示范区（海淀园）",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "11086",
    "DISTRICT_N": "中关村综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11089",
    "DISTRICT_N": "海淀区其他",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11093",
    "DISTRICT_N": "中关村国家自主创新示范区（门头沟园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11099",
    "DISTRICT_N": "门头沟",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11103",
    "DISTRICT_N": "中关村国家自主创新示范区（房山园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11109",
    "DISTRICT_N": "房山",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11113",
    "DISTRICT_N": "中关村国家自主创新示范区（顺义园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11115",
    "DISTRICT_N": "北京天竺出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11116",
    "DISTRICT_N": "北京天竺综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11119",
    "DISTRICT_N": "顺义",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11123",
    "DISTRICT_N": "中关村国家自主创新示范区（昌平园）",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "11129",
    "DISTRICT_N": "昌平",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11132",
    "DISTRICT_N": "北京经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "11133",
    "DISTRICT_N": "中关村国家自主创新示范区（大兴-亦庄园）",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "11136",
    "DISTRICT_N": "北京亦庄、北京大兴国际机场（北京区域）综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11139",
    "DISTRICT_N": "大兴其他",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "1113W",
    "DISTRICT_N": "北京亦庄保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11143",
    "DISTRICT_N": "中关村国家自主创新示范区（通州园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11149",
    "DISTRICT_N": "通州区",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11153",
    "DISTRICT_N": "中关村国家自主创新示范区（怀柔园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11159",
    "DISTRICT_N": "怀柔",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11163",
    "DISTRICT_N": "中关村国家自主创新示范区（平谷园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11169",
    "DISTRICT_N": "平谷",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11173",
    "DISTRICT_N": "中关村国家自主创新示范区（延庆园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11179",
    "DISTRICT_N": "延庆",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11183",
    "DISTRICT_N": "中关村国家自主创新示范区（密云园）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "11189",
    "DISTRICT_N": "密云",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "11909",
    "DISTRICT_N": "北京其他",
    "DISTRICT_T": "9"
  },
  {
    "DISTRICT_C": "12019",
    "DISTRICT_N": "和平区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12029",
    "DISTRICT_N": "河东区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12039",
    "DISTRICT_N": "河西区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12043",
    "DISTRICT_N": "天津新技术产业园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "12049",
    "DISTRICT_N": "南开区其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12059",
    "DISTRICT_N": "河北区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12069",
    "DISTRICT_N": "红桥区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12072",
    "DISTRICT_N": "天津经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "12074",
    "DISTRICT_N": "天津港保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "12075",
    "DISTRICT_N": "天津出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "12076",
    "DISTRICT_N": "天津东疆、泰达、天津港、临港综合保税区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12077",
    "DISTRICT_N": "天津保税物流园",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12079",
    "DISTRICT_N": "滨海新区(塘沽其他)",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "1207W",
    "DISTRICT_N": "天津经济技术开发区保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "12089",
    "DISTRICT_N": "滨海新区(汉沽)",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12099",
    "DISTRICT_N": "滨海新区(大港)",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12106",
    "DISTRICT_N": "天津滨海新区综合保税区",
    "DISTRICT_T": "6"
  },
  {
    "DISTRICT_C": "12109",
    "DISTRICT_N": "东丽区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12119",
    "DISTRICT_N": "西青区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12129",
    "DISTRICT_N": "津南区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12139",
    "DISTRICT_N": "北辰区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12149",
    "DISTRICT_N": "宁河县",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12159",
    "DISTRICT_N": "武清县",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12169",
    "DISTRICT_N": "静海县",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12179",
    "DISTRICT_N": "宝坻区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "12189",
    "DISTRICT_N": "蓟县",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "1218W",
    "DISTRICT_N": "蓟州保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "12909",
    "DISTRICT_N": "天津其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "13013",
    "DISTRICT_N": "石家庄高新技术产业开发实验区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "13016",
    "DISTRICT_N": "石家庄综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13019",
    "DISTRICT_N": "石家庄其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "1301W",
    "DISTRICT_N": "辛集、石 家庄国际陆港保税物流中心（ B 型 ）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13022",
    "DISTRICT_N": "曹妃甸经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13026",
    "DISTRICT_N": "曹妃甸综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13029",
    "DISTRICT_N": "唐山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1302W",
    "DISTRICT_N": "唐山港京唐港区保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13032",
    "DISTRICT_N": "秦皇岛经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "13035",
    "DISTRICT_N": "河北秦皇岛出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "13036",
    "DISTRICT_N": "秦皇岛综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13039",
    "DISTRICT_N": "秦皇岛其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "13049",
    "DISTRICT_N": "邯郸",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13059",
    "DISTRICT_N": "邢台",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13063",
    "DISTRICT_N": "保定高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "13069",
    "DISTRICT_N": "保定其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1306N",
    "DISTRICT_N": "雄安新区（保定）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13079",
    "DISTRICT_N": "张家口",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13089",
    "DISTRICT_N": "承德",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13099",
    "DISTRICT_N": "沧州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1309N",
    "DISTRICT_N": "雄安新区（沧州）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13102",
    "DISTRICT_N": "廊坊经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13105",
    "DISTRICT_N": "河北廊坊出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13106",
    "DISTRICT_N": "廊坊、北京大兴国际机场（河北区域）综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13109",
    "DISTRICT_N": "廊坊",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13119",
    "DISTRICT_N": "衡水",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13129",
    "DISTRICT_N": "武安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1312W",
    "DISTRICT_N": "河北武安保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13316",
    "DISTRICT_N": "雄安综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1331N",
    "DISTRICT_N": "河北雄安新区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "13909",
    "DISTRICT_N": "河北其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14012",
    "DISTRICT_N": "山西太原经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "14013",
    "DISTRICT_N": "太原高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "14016",
    "DISTRICT_N": "太原武宿综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14019",
    "DISTRICT_N": "太原其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "14022",
    "DISTRICT_N": "大同经济技术开发区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "14029",
    "DISTRICT_N": "大同",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1402W",
    "DISTRICT_N": "大同国际陆港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14039",
    "DISTRICT_N": "阳泉",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14043",
    "DISTRICT_N": "长治高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14049",
    "DISTRICT_N": "长治",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14059",
    "DISTRICT_N": "晋城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1405W",
    "DISTRICT_N": "山西兰花保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14069",
    "DISTRICT_N": "朔州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14079",
    "DISTRICT_N": "雁北",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14089",
    "DISTRICT_N": "忻州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14099",
    "DISTRICT_N": "吕梁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14102",
    "DISTRICT_N": "晋中经济技术开发区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "14109",
    "DISTRICT_N": "晋中",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14119",
    "DISTRICT_N": "临汾",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1411W",
    "DISTRICT_N": "山西方略保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14129",
    "DISTRICT_N": "运城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14139",
    "DISTRICT_N": "古交",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "14909",
    "DISTRICT_N": "山西其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15015",
    "DISTRICT_N": "内蒙古呼和浩特出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15016",
    "DISTRICT_N": "呼和浩特综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15019",
    "DISTRICT_N": "呼和浩特",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15023",
    "DISTRICT_N": "包头高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "15029",
    "DISTRICT_N": "包头其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1502W",
    "DISTRICT_N": "包头保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15039",
    "DISTRICT_N": "乌海",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15049",
    "DISTRICT_N": "赤峰",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1504W",
    "DISTRICT_N": "赤峰保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15059",
    "DISTRICT_N": "二连",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "15066",
    "DISTRICT_N": "满洲里综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15069",
    "DISTRICT_N": "满洲里",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "15079",
    "DISTRICT_N": "呼伦贝尔市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15089",
    "DISTRICT_N": "通辽市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1508W",
    "DISTRICT_N": "通辽保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15099",
    "DISTRICT_N": "兴安盟",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15109",
    "DISTRICT_N": "乌兰察布市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1510W",
    "DISTRICT_N": "七苏木保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15119",
    "DISTRICT_N": "巴彦淖尔市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "1511W",
    "DISTRICT_N": "巴彦淖尔市保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15126",
    "DISTRICT_N": "鄂尔多斯综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15129",
    "DISTRICT_N": "鄂尔多斯市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15139",
    "DISTRICT_N": "阿拉善盟",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15149",
    "DISTRICT_N": "锡林郭勒盟",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "15909",
    "DISTRICT_N": "内蒙古其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21012",
    "DISTRICT_N": "沈阳经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "21013",
    "DISTRICT_N": "沈阳南湖科技开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "21015",
    "DISTRICT_N": "辽宁沈阳、张士出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21016",
    "DISTRICT_N": "沈阳综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21019",
    "DISTRICT_N": "沈阳其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21022",
    "DISTRICT_N": "大连经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "21023",
    "DISTRICT_N": "大连高新技术产业园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "21024",
    "DISTRICT_N": "大连大窑湾保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "21025",
    "DISTRICT_N": "辽宁大连出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21026",
    "DISTRICT_N": "大连大窑湾、湾里综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21027",
    "DISTRICT_N": "大连保税物流园区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "21029",
    "DISTRICT_N": "大连其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "2102W",
    "DISTRICT_N": "大连大窑湾保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21033",
    "DISTRICT_N": "鞍山高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "21039",
    "DISTRICT_N": "鞍山其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21049",
    "DISTRICT_N": "抚顺",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21059",
    "DISTRICT_N": "本溪",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21069",
    "DISTRICT_N": "丹东",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21079",
    "DISTRICT_N": "锦州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2107W",
    "DISTRICT_N": "锦州港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21082",
    "DISTRICT_N": "营口经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21086",
    "DISTRICT_N": "营口综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21089",
    "DISTRICT_N": "营口",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2108W",
    "DISTRICT_N": "营口港保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21099",
    "DISTRICT_N": "阜新",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21109",
    "DISTRICT_N": "辽阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21119",
    "DISTRICT_N": "盘锦",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2111W",
    "DISTRICT_N": "盘锦港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21129",
    "DISTRICT_N": "铁岭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2112W",
    "DISTRICT_N": "铁岭保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21139",
    "DISTRICT_N": "朝阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21149",
    "DISTRICT_N": "葫芦岛市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21159",
    "DISTRICT_N": "瓦房店",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21169",
    "DISTRICT_N": "海城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21179",
    "DISTRICT_N": "兴城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21189",
    "DISTRICT_N": "调兵山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21199",
    "DISTRICT_N": "北票",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21209",
    "DISTRICT_N": "开原",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "21909",
    "DISTRICT_N": "辽宁其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22012",
    "DISTRICT_N": "长春经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "22013",
    "DISTRICT_N": "长春南湖-南岭新技术产业园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "22016",
    "DISTRICT_N": "长春兴隆综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22019",
    "DISTRICT_N": "长春其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "22023",
    "DISTRICT_N": "吉林高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "22029",
    "DISTRICT_N": "吉林其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2202W",
    "DISTRICT_N": "吉林市保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22039",
    "DISTRICT_N": "四平",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22049",
    "DISTRICT_N": "辽源",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22059",
    "DISTRICT_N": "通化",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22069",
    "DISTRICT_N": "白山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22075",
    "DISTRICT_N": "吉林珲春出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22076",
    "DISTRICT_N": "珲春综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22079",
    "DISTRICT_N": "珲春",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "22089",
    "DISTRICT_N": "图们",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22099",
    "DISTRICT_N": "白城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22109",
    "DISTRICT_N": "延边",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22119",
    "DISTRICT_N": "公主岭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22129",
    "DISTRICT_N": "梅河口",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22139",
    "DISTRICT_N": "集安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22149",
    "DISTRICT_N": "桦甸",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22159",
    "DISTRICT_N": "九台",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22169",
    "DISTRICT_N": "蛟河",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22179",
    "DISTRICT_N": "松原",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22189",
    "DISTRICT_N": "延吉市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2218W",
    "DISTRICT_N": "延吉国际空港经济开发区保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "22909",
    "DISTRICT_N": "吉林其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23012",
    "DISTRICT_N": "哈尔滨经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "23013",
    "DISTRICT_N": "哈尔滨高技术开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "23016",
    "DISTRICT_N": "哈尔滨综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23019",
    "DISTRICT_N": "哈尔滨其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "23029",
    "DISTRICT_N": "齐齐哈尔",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23039",
    "DISTRICT_N": "鸡西",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23049",
    "DISTRICT_N": "鹤岗",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23059",
    "DISTRICT_N": "双鸭山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23063",
    "DISTRICT_N": "大庆高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "23069",
    "DISTRICT_N": "大庆其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23079",
    "DISTRICT_N": "伊春",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23089",
    "DISTRICT_N": "佳木斯",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23099",
    "DISTRICT_N": "七台河",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23109",
    "DISTRICT_N": "牡丹江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "2310W",
    "DISTRICT_N": "牡丹江保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23119",
    "DISTRICT_N": "黑河",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "2311W",
    "DISTRICT_N": "黑河保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23126",
    "DISTRICT_N": "绥芬河综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23129",
    "DISTRICT_N": "绥芬河",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "23139",
    "DISTRICT_N": "松花江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23142",
    "DISTRICT_N": "绥化经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23149",
    "DISTRICT_N": "绥化",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23159",
    "DISTRICT_N": "大兴安岭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23169",
    "DISTRICT_N": "阿城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23179",
    "DISTRICT_N": "同江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23189",
    "DISTRICT_N": "富锦",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23199",
    "DISTRICT_N": "铁力",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23209",
    "DISTRICT_N": "密山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "23909",
    "DISTRICT_N": "黑龙江其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31019",
    "DISTRICT_N": "黄浦",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31029",
    "DISTRICT_N": "南市",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31039",
    "DISTRICT_N": "卢湾",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31043",
    "DISTRICT_N": "上海漕河泾新技术开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "31049",
    "DISTRICT_N": "徐汇其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31052",
    "DISTRICT_N": "上海经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "31059",
    "DISTRICT_N": "长宁",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31069",
    "DISTRICT_N": "静安",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31079",
    "DISTRICT_N": "普陀",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3107W",
    "DISTRICT_N": "上海西北物流园区保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31089",
    "DISTRICT_N": "闸北",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31099",
    "DISTRICT_N": "虹口",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31109",
    "DISTRICT_N": "杨浦",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31112",
    "DISTRICT_N": "上海闵行经济技术开发区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31113",
    "DISTRICT_N": "上海浦江高科技园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "31115",
    "DISTRICT_N": "上海漕河泾出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31116",
    "DISTRICT_N": "漕河泾综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31119",
    "DISTRICT_N": "闵行其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3111W",
    "DISTRICT_N": "虹桥商务区保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31129",
    "DISTRICT_N": "宝山",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31145",
    "DISTRICT_N": "上海嘉定出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31146",
    "DISTRICT_N": "上海嘉定综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31149",
    "DISTRICT_N": "嘉定",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31159",
    "DISTRICT_N": "川沙",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31162",
    "DISTRICT_N": "上海闵行经济技术开发区（临港新城）",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "31166",
    "DISTRICT_N": "洋山保税港区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31169",
    "DISTRICT_N": "南汇",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31175",
    "DISTRICT_N": "上海闵行出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31176",
    "DISTRICT_N": "奉贤综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31179",
    "DISTRICT_N": "奉贤",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31185",
    "DISTRICT_N": "上海松江出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31186",
    "DISTRICT_N": "松江综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31189",
    "DISTRICT_N": "松江",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31199",
    "DISTRICT_N": "金山",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31205",
    "DISTRICT_N": "上海青浦出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31206",
    "DISTRICT_N": "青浦综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31209",
    "DISTRICT_N": "青浦",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31219",
    "DISTRICT_N": "崇明",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31222",
    "DISTRICT_N": "上海浦东新区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "31224",
    "DISTRICT_N": "上海外高桥保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "31225",
    "DISTRICT_N": "上海金桥出口加工区南区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31226",
    "DISTRICT_N": "上海浦东机场、上海金桥、上海外高桥港综合保税区和上海东方枢纽国际商务合作区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31227",
    "DISTRICT_N": "上海保税物流园区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "31229",
    "DISTRICT_N": "浦东其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3122S",
    "DISTRICT_N": "洋山特殊综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "31909",
    "DISTRICT_N": "上海其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "32013",
    "DISTRICT_N": "南京浦口高新技术外向型开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "32015",
    "DISTRICT_N": "江苏南京出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32016",
    "DISTRICT_N": "南京综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32019",
    "DISTRICT_N": "南京其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3201W",
    "DISTRICT_N": "南京空港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32023",
    "DISTRICT_N": "无锡高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "32025",
    "DISTRICT_N": "江苏无锡出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32026",
    "DISTRICT_N": "无锡高新区综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32029",
    "DISTRICT_N": "无锡其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32036",
    "DISTRICT_N": "徐州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32039",
    "DISTRICT_N": "徐州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3203W",
    "DISTRICT_N": "徐州、新沂保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32043",
    "DISTRICT_N": "常州高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "32045",
    "DISTRICT_N": "江苏常州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32046",
    "DISTRICT_N": "常州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32049",
    "DISTRICT_N": "常州其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32052",
    "DISTRICT_N": "苏州工业园区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "32053",
    "DISTRICT_N": "苏州高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "32055",
    "DISTRICT_N": "江苏苏州工业园区加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32056",
    "DISTRICT_N": "苏州工业园综合保税区、苏州高新综保区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32059",
    "DISTRICT_N": "苏州其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32062",
    "DISTRICT_N": "南通经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "32065",
    "DISTRICT_N": "江苏南通出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32066",
    "DISTRICT_N": "南通综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32069",
    "DISTRICT_N": "南通其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3206W",
    "DISTRICT_N": "如皋港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32072",
    "DISTRICT_N": "连云港经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "32075",
    "DISTRICT_N": "江苏连云港出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "32076",
    "DISTRICT_N": "连云港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32079",
    "DISTRICT_N": "连云港其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3207W",
    "DISTRICT_N": "连云港保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32085",
    "DISTRICT_N": "江苏省淮安出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32086",
    "DISTRICT_N": "淮安综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32089",
    "DISTRICT_N": "淮安市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32096",
    "DISTRICT_N": "盐城综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32099",
    "DISTRICT_N": "盐城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3209W",
    "DISTRICT_N": "大丰港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32105",
    "DISTRICT_N": "江苏扬州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32106",
    "DISTRICT_N": "扬州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32109",
    "DISTRICT_N": "扬州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32115",
    "DISTRICT_N": "江苏镇江出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32116",
    "DISTRICT_N": "镇江综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32119",
    "DISTRICT_N": "镇江",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32125",
    "DISTRICT_N": "江苏泰州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32126",
    "DISTRICT_N": "泰州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32129",
    "DISTRICT_N": "泰州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3212W",
    "DISTRICT_N": "靖江保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32166",
    "DISTRICT_N": "江阴综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32169",
    "DISTRICT_N": "江阴",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3216W",
    "DISTRICT_N": "江阴保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32179",
    "DISTRICT_N": "宿迁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3217W",
    "DISTRICT_N": "宿迁保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32189",
    "DISTRICT_N": "丹阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32199",
    "DISTRICT_N": "东台",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32209",
    "DISTRICT_N": "兴化",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32229",
    "DISTRICT_N": "宜兴",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32235",
    "DISTRICT_N": "江苏昆山出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32236",
    "DISTRICT_N": "昆山综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32239",
    "DISTRICT_N": "昆山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32249",
    "DISTRICT_N": "启东",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32255",
    "DISTRICT_N": "江苏吴江出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32256",
    "DISTRICT_N": "吴江综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32259",
    "DISTRICT_N": "吴江市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32266",
    "DISTRICT_N": "太仓港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32269",
    "DISTRICT_N": "太仓市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3226W",
    "DISTRICT_N": "太仓保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32546",
    "DISTRICT_N": "武进综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3256W",
    "DISTRICT_N": "江苏海安保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32909",
    "DISTRICT_N": "江苏其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33012",
    "DISTRICT_N": "杭州经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "33013",
    "DISTRICT_N": "杭州高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "33015",
    "DISTRICT_N": "浙江杭州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33016",
    "DISTRICT_N": "杭州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33019",
    "DISTRICT_N": "杭州其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33022",
    "DISTRICT_N": "宁波经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "33023",
    "DISTRICT_N": "宁波高新技术产业开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "33024",
    "DISTRICT_N": "宁波北仑港保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "33025",
    "DISTRICT_N": "浙江宁波出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "33026",
    "DISTRICT_N": "宁波梅山、北仑港综合保税区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "33027",
    "DISTRICT_N": "宁波保税物流园",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "33029",
    "DISTRICT_N": "宁波其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3302W",
    "DISTRICT_N": "宁波栎社保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33032",
    "DISTRICT_N": "温州经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "33036",
    "DISTRICT_N": "温州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33039",
    "DISTRICT_N": "温州其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3303W",
    "DISTRICT_N": "温州保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33045",
    "DISTRICT_N": "浙江嘉兴出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33046",
    "DISTRICT_N": "嘉兴综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33049",
    "DISTRICT_N": "嘉兴",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33052",
    "DISTRICT_N": "湖州经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33053",
    "DISTRICT_N": "湖州莫干山高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33059",
    "DISTRICT_N": "湖州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3305W",
    "DISTRICT_N": "湖州及湖州德清物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33066",
    "DISTRICT_N": "绍兴综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33069",
    "DISTRICT_N": "绍兴",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33072",
    "DISTRICT_N": "金华经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "33076",
    "DISTRICT_N": "金义综合保税区（一期）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33079",
    "DISTRICT_N": "金华",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33086",
    "DISTRICT_N": "衢州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33089",
    "DISTRICT_N": "衢州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33096",
    "DISTRICT_N": "舟山港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33099",
    "DISTRICT_N": "舟山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33109",
    "DISTRICT_N": "丽水",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33112",
    "DISTRICT_N": "台州湾经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33116",
    "DISTRICT_N": "台州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33119",
    "DISTRICT_N": "台州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33129",
    "DISTRICT_N": "余姚",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33139",
    "DISTRICT_N": "海宁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33149",
    "DISTRICT_N": "兰溪",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33159",
    "DISTRICT_N": "瑞安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33169",
    "DISTRICT_N": "萧山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3316W",
    "DISTRICT_N": "杭州保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33179",
    "DISTRICT_N": "江山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33186",
    "DISTRICT_N": "义乌综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33189",
    "DISTRICT_N": "义乌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3318W",
    "DISTRICT_N": "义乌保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33199",
    "DISTRICT_N": "东阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33202",
    "DISTRICT_N": "宁波杭州湾经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33205",
    "DISTRICT_N": "浙江慈溪出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33206",
    "DISTRICT_N": "宁波前湾综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33209",
    "DISTRICT_N": "慈溪",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33219",
    "DISTRICT_N": "奉化",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33229",
    "DISTRICT_N": "诸暨",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33239",
    "DISTRICT_N": "黄岩",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3352W",
    "DISTRICT_N": "宁波镇海保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "33909",
    "DISTRICT_N": "浙江其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34012",
    "DISTRICT_N": "合肥经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34013",
    "DISTRICT_N": "合肥科技工业园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "34015",
    "DISTRICT_N": "安徽合肥出口加工区",
    "DISTRICT_T": "5"
  },
  {
    "DISTRICT_C": "34016",
    "DISTRICT_N": "合肥或合肥经济技术开发区综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34019",
    "DISTRICT_N": "合肥其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3401W",
    "DISTRICT_N": "合肥空港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34022",
    "DISTRICT_N": "芜湖经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34023",
    "DISTRICT_N": "芜湖高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34025",
    "DISTRICT_N": "安徽芜湖出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34026",
    "DISTRICT_N": "芜湖综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34029",
    "DISTRICT_N": "芜湖其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "34033",
    "DISTRICT_N": "蚌埠高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34036",
    "DISTRICT_N": "蚌埠综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34039",
    "DISTRICT_N": "蚌埠",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3403W",
    "DISTRICT_N": "蚌埠（皖北）保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34042",
    "DISTRICT_N": "安徽淮南经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34043",
    "DISTRICT_N": "淮南高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34049",
    "DISTRICT_N": "淮南",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34052",
    "DISTRICT_N": "马鞍山经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34053",
    "DISTRICT_N": "马鞍山慈湖高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34056",
    "DISTRICT_N": "马鞍山综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34059",
    "DISTRICT_N": "马鞍山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34069",
    "DISTRICT_N": "淮北",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34072",
    "DISTRICT_N": "铜陵经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34079",
    "DISTRICT_N": "铜陵",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3407W",
    "DISTRICT_N": "铜陵（皖中南）保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34082",
    "DISTRICT_N": "安庆桐城经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34086",
    "DISTRICT_N": "安庆综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34089",
    "DISTRICT_N": "安庆",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3408W",
    "DISTRICT_N": "安庆（皖西南）保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34099",
    "DISTRICT_N": "黄山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34109",
    "DISTRICT_N": "阜阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34119",
    "DISTRICT_N": "宿州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34122",
    "DISTRICT_N": "滁州经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34129",
    "DISTRICT_N": "滁州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34132",
    "DISTRICT_N": "安徽六安经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34139",
    "DISTRICT_N": "六安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34142",
    "DISTRICT_N": "宣城宁国经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34149",
    "DISTRICT_N": "宣城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3414W",
    "DISTRICT_N": "安徽皖东南保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34159",
    "DISTRICT_N": "巢湖",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34162",
    "DISTRICT_N": "池州经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "34169",
    "DISTRICT_N": "池州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3416W",
    "DISTRICT_N": "皖江江南保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34179",
    "DISTRICT_N": "亳州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "34909",
    "DISTRICT_N": "安徽其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35012",
    "DISTRICT_N": "福州经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "35013",
    "DISTRICT_N": "福州科技园区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "35014",
    "DISTRICT_N": "福建马尾保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "35015",
    "DISTRICT_N": "福建福州、福清出口加工区",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35016",
    "DISTRICT_N": "福州江阴港、福州长乐国际机场和福州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35017",
    "DISTRICT_N": "福州保税物流园区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "35019",
    "DISTRICT_N": "福州其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3501W",
    "DISTRICT_N": "翔福保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35021",
    "DISTRICT_N": "厦门特区",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "35023",
    "DISTRICT_N": "厦门火炬高技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "35024",
    "DISTRICT_N": "厦门象屿保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "35025",
    "DISTRICT_N": "福建厦门出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35026",
    "DISTRICT_N": "厦门海沧港、象屿综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35027",
    "DISTRICT_N": "厦门象屿保税物流园",
    "DISTRICT_T": "1"
  },
  {
    "DISTRICT_C": "35029",
    "DISTRICT_N": "厦门其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3502W",
    "DISTRICT_N": "厦门火炬（翔安）保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35039",
    "DISTRICT_N": "莆田",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35049",
    "DISTRICT_N": "三明",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35055",
    "DISTRICT_N": "福建泉州出口加工区",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35056",
    "DISTRICT_N": "泉州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35059",
    "DISTRICT_N": "泉州",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35069",
    "DISTRICT_N": "漳州",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "3506W",
    "DISTRICT_N": "漳州台商投资区保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35079",
    "DISTRICT_N": "南平",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35089",
    "DISTRICT_N": "宁德",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "3508W",
    "DISTRICT_N": "宁德保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35099",
    "DISTRICT_N": "龙岩",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35109",
    "DISTRICT_N": "永安",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35119",
    "DISTRICT_N": "石狮",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "3511W",
    "DISTRICT_N": "泉州石湖港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35128",
    "DISTRICT_N": "平潭综合试验区",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "35129",
    "DISTRICT_N": "平潭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "35909",
    "DISTRICT_N": "福建其他",
    "DISTRICT_T": "8"
  },
  {
    "DISTRICT_C": "32139",
    "DISTRICT_N": "仪征",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32145",
    "DISTRICT_N": "江苏常熟出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32146",
    "DISTRICT_N": "常熟综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32149",
    "DISTRICT_N": "常熟",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32154",
    "DISTRICT_N": "江苏张家港保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "32156",
    "DISTRICT_N": "张家港保税港区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32157",
    "DISTRICT_N": "张家港保税物流园",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "32159",
    "DISTRICT_N": "张家港其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36012",
    "DISTRICT_N": "南昌及南昌小蓝经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "36013",
    "DISTRICT_N": "南昌高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "36015",
    "DISTRICT_N": "江西南昌出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36016",
    "DISTRICT_N": "南昌综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36019",
    "DISTRICT_N": "南昌其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36045",
    "DISTRICT_N": "江西九江出口加工区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "36046",
    "DISTRICT_N": "九江综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36049",
    "DISTRICT_N": "九江",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "36053",
    "DISTRICT_N": "新余高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "36059",
    "DISTRICT_N": "新余",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36062",
    "DISTRICT_N": "贵溪经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36063",
    "DISTRICT_N": "鹰潭高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36069",
    "DISTRICT_N": "鹰潭",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36072",
    "DISTRICT_N": "赣州、龙南及瑞金经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "36073",
    "DISTRICT_N": "赣州高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36075",
    "DISTRICT_N": "江西赣州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36076",
    "DISTRICT_N": "赣州综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36079",
    "DISTRICT_N": "赣州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3607W",
    "DISTRICT_N": "龙南保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36082",
    "DISTRICT_N": "宜春经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36083",
    "DISTRICT_N": "宜春丰城高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36089",
    "DISTRICT_N": "宜春",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36092",
    "DISTRICT_N": "上饶经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "36096",
    "DISTRICT_N": "上饶综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36099",
    "DISTRICT_N": "上饶",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36102",
    "DISTRICT_N": "井冈山经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "36103",
    "DISTRICT_N": "吉安高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36105",
    "DISTRICT_N": "井冈山出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36106",
    "DISTRICT_N": "井冈山综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36109",
    "DISTRICT_N": "吉安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36113",
    "DISTRICT_N": "抚州高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36119",
    "DISTRICT_N": "抚州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36129",
    "DISTRICT_N": "瑞昌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36909",
    "DISTRICT_N": "江西其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37013",
    "DISTRICT_N": "济南高技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "37015",
    "DISTRICT_N": "山东济南出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37016",
    "DISTRICT_N": "济南或济南章锦综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37019",
    "DISTRICT_N": "济南其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37022",
    "DISTRICT_N": "青岛经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "37023",
    "DISTRICT_N": "青岛高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "37024",
    "DISTRICT_N": "青岛保税区",
    "DISTRICT_T": "A"
  },
  {
    "DISTRICT_C": "37025",
    "DISTRICT_N": "山东青岛出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37026",
    "DISTRICT_N": "青岛前湾保税港区、青岛西海岸和胶州湾综合保税区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "37027",
    "DISTRICT_N": "青岛保税物流园",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "37029",
    "DISTRICT_N": "青岛其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3702W",
    "DISTRICT_N": "青岛保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37033",
    "DISTRICT_N": "淄博高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "37036",
    "DISTRICT_N": "淄博综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37039",
    "DISTRICT_N": "淄博",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3703W",
    "DISTRICT_N": "淄博保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37049",
    "DISTRICT_N": "枣庄",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37056",
    "DISTRICT_N": "东营综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37059",
    "DISTRICT_N": "东营",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37062",
    "DISTRICT_N": "烟台经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "37065",
    "DISTRICT_N": "山东烟台出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37066",
    "DISTRICT_N": "烟台综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37069",
    "DISTRICT_N": "烟台其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "3706W",
    "DISTRICT_N": "烟台福山回里保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37073",
    "DISTRICT_N": "潍坊高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "37075",
    "DISTRICT_N": "山东潍坊出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37076",
    "DISTRICT_N": "潍坊综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37079",
    "DISTRICT_N": "潍坊其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37083",
    "DISTRICT_N": "济宁高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37089",
    "DISTRICT_N": "济宁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3708W",
    "DISTRICT_N": "济宁高新保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37099",
    "DISTRICT_N": "泰安",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37103",
    "DISTRICT_N": "威海火炬高技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "37105",
    "DISTRICT_N": "山东威海出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37106",
    "DISTRICT_N": "威海综合保税区北区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37109",
    "DISTRICT_N": "威海其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37112",
    "DISTRICT_N": "日照经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37116",
    "DISTRICT_N": "日照综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37119",
    "DISTRICT_N": "日照",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3711W",
    "DISTRICT_N": "日照保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37129",
    "DISTRICT_N": "山东省滨州其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3712W",
    "DISTRICT_N": "鲁中运达保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37139",
    "DISTRICT_N": "德州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37149",
    "DISTRICT_N": "聊城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37156",
    "DISTRICT_N": "临沂综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37159",
    "DISTRICT_N": "临沂",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37169",
    "DISTRICT_N": "菏泽",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3716W",
    "DISTRICT_N": "菏泽内陆港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37179",
    "DISTRICT_N": "青州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37189",
    "DISTRICT_N": "龙口",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37199",
    "DISTRICT_N": "曲阜",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37209",
    "DISTRICT_N": "莱芜",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37219",
    "DISTRICT_N": "新泰",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37226",
    "DISTRICT_N": "青岛空港综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37229",
    "DISTRICT_N": "胶州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37239",
    "DISTRICT_N": "诸城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "3723W",
    "DISTRICT_N": "青岛保税港区诸城功能区保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37249",
    "DISTRICT_N": "莱阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37259",
    "DISTRICT_N": "滕州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37266",
    "DISTRICT_N": "威海综合保税区南区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37269",
    "DISTRICT_N": "文登",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37279",
    "DISTRICT_N": "荣城",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37286",
    "DISTRICT_N": "青岛即墨综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37289",
    "DISTRICT_N": "即墨",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37299",
    "DISTRICT_N": "平度",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "37909",
    "DISTRICT_N": "山东其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41012",
    "DISTRICT_N": "郑州经济技术开发区",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "41013",
    "DISTRICT_N": "郑州高新技术开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "41015",
    "DISTRICT_N": "河南郑州出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41016",
    "DISTRICT_N": "郑州新郑、经开综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41018",
    "DISTRICT_N": "郑州航空港经济综合实验区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41019",
    "DISTRICT_N": "郑州其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "4101W",
    "DISTRICT_N": "河南保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41026",
    "DISTRICT_N": "开封综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41029",
    "DISTRICT_N": "开封",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41033",
    "DISTRICT_N": "洛阳高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "41036",
    "DISTRICT_N": "洛阳综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41039",
    "DISTRICT_N": "洛阳其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41049",
    "DISTRICT_N": "平顶山",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41059",
    "DISTRICT_N": "安阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41069",
    "DISTRICT_N": "鹤壁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41079",
    "DISTRICT_N": "新乡",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41089",
    "DISTRICT_N": "焦作",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4108W",
    "DISTRICT_N": "河南德众保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41099",
    "DISTRICT_N": "濮阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41109",
    "DISTRICT_N": "许昌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4110W",
    "DISTRICT_N": "河南许昌保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41119",
    "DISTRICT_N": "漯河",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41129",
    "DISTRICT_N": "三门峡",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41139",
    "DISTRICT_N": "商丘",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4113W",
    "DISTRICT_N": "河南商丘、民权保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41149",
    "DISTRICT_N": "周口",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41159",
    "DISTRICT_N": "驻马店",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41166",
    "DISTRICT_N": "南阳卧龙综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41169",
    "DISTRICT_N": "南阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41179",
    "DISTRICT_N": "信阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41189",
    "DISTRICT_N": "义马",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41199",
    "DISTRICT_N": "汝州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41209",
    "DISTRICT_N": "济源",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41219",
    "DISTRICT_N": "禹州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41229",
    "DISTRICT_N": "卫辉",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41239",
    "DISTRICT_N": "辉县",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41249",
    "DISTRICT_N": "沁阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "41909",
    "DISTRICT_N": "河南其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42012",
    "DISTRICT_N": "武汉经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "42013",
    "DISTRICT_N": "武汉东湖新技术开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "42015",
    "DISTRICT_N": "湖北武汉出口加工区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42016",
    "DISTRICT_N": "武汉东湖、经开综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42019",
    "DISTRICT_N": "武汉其他",
    "DISTRICT_T": "2"
  },
  {
    "DISTRICT_C": "4201W",
    "DISTRICT_N": "武汉东西湖保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42022",
    "DISTRICT_N": "黄石经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "3601W",
    "DISTRICT_N": "南昌保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36023",
    "DISTRICT_N": "景德镇高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "36029",
    "DISTRICT_N": "景德镇",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36032",
    "DISTRICT_N": "萍乡经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "36039",
    "DISTRICT_N": "萍乡",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36042",
    "DISTRICT_N": "九江经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "42026",
    "DISTRICT_N": "黄石棋盘洲综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42029",
    "DISTRICT_N": "黄石",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4202W",
    "DISTRICT_N": "黄石棋盘洲保税物流中心",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42032",
    "DISTRICT_N": "十堰经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42039",
    "DISTRICT_N": "十堰",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42049",
    "DISTRICT_N": "沙市",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42056",
    "DISTRICT_N": "宜昌综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42059",
    "DISTRICT_N": "宜昌",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4205W",
    "DISTRICT_N": "宜昌三峡保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42062",
    "DISTRICT_N": "襄阳经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "42063",
    "DISTRICT_N": "襄阳高新技术产业开发区",
    "DISTRICT_T": "B"
  },
  {
    "DISTRICT_C": "42066",
    "DISTRICT_N": "襄阳综合保税区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42069",
    "DISTRICT_N": "襄阳其他",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4206W",
    "DISTRICT_N": "襄阳保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42072",
    "DISTRICT_N": "鄂州葛店经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "36043",
    "DISTRICT_N": "九江共青城高新技术产业开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42079",
    "DISTRICT_N": "鄂州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4207W",
    "DISTRICT_N": "鄂州空港保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42089",
    "DISTRICT_N": "荆门",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "4208W",
    "DISTRICT_N": "荆门保税物流中心（B型）",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42099",
    "DISTRICT_N": "黄冈",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42102",
    "DISTRICT_N": "汉川经济技术开发区",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42109",
    "DISTRICT_N": "孝感",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42119",
    "DISTRICT_N": "咸宁",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42122",
    "DISTRICT_N": "荆州经济技术开发区",
    "DISTRICT_T": "3"
  },
  {
    "DISTRICT_C": "42129",
    "DISTRICT_N": "荆州",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "42139",
    "DISTRICT_N": "郧阳",
    "DISTRICT_T": ""
  },
  {
    "DISTRICT_C": "44012",
    "DISTRICT_N": "广州经济技术开发区",
    "DISTRICT_T": "3"
  }
]
//申报地海关
export const CustomMasters = [
  {"CUSTOMS_CO":"0000","CUSTOMS_NA":"海关总署"},
  {"CUSTOMS_CO":"0100","CUSTOMS_NA":"北京关区"},
  {"CUSTOMS_CO":"0101","CUSTOMS_NA":"京机场关"},
  {"CUSTOMS_CO":"0102","CUSTOMS_NA":"京监管处"},
  {"CUSTOMS_CO":"0103","CUSTOMS_NA":"京关展览"},
  {"CUSTOMS_CO":"0104","CUSTOMS_NA":"京西城关"},
  {"CUSTOMS_CO":"0105","CUSTOMS_NA":"京会展关"},
  {"CUSTOMS_CO":"0106","CUSTOMS_NA":"大兴机场"},
  {"CUSTOMS_CO":"0107","CUSTOMS_NA":"机场库区"},
  {"CUSTOMS_CO":"0108","CUSTOMS_NA":"京综合处"},
  {"CUSTOMS_CO":"0109","CUSTOMS_NA":"机场旅检"},
  {"CUSTOMS_CO":"0110","CUSTOMS_NA":"平谷海关"},
  {"CUSTOMS_CO":"0111","CUSTOMS_NA":"京车站关"},
  {"CUSTOMS_CO":"0112","CUSTOMS_NA":"京邮局关"},
  {"CUSTOMS_CO":"0113","CUSTOMS_NA":"京中关村"},
  {"CUSTOMS_CO":"0114","CUSTOMS_NA":"海淀海关"},
  {"CUSTOMS_CO":"0115","CUSTOMS_NA":"京东城关"},
  {"CUSTOMS_CO":"0116","CUSTOMS_NA":"大兴旅检"},
  {"CUSTOMS_CO":"0117","CUSTOMS_NA":"亦庄海关"},
  {"CUSTOMS_CO":"0118","CUSTOMS_NA":"京朝阳关"},
  {"CUSTOMS_CO":"0119","CUSTOMS_NA":"通州海关"},
  {"CUSTOMS_CO":"0121","CUSTOMS_NA":"京稽查处"},
  {"CUSTOMS_CO":"0123","CUSTOMS_NA":"机场调技"},
  {"CUSTOMS_CO":"0124","CUSTOMS_NA":"北京站"},
  {"CUSTOMS_CO":"0125","CUSTOMS_NA":"西客站"},
  {"CUSTOMS_CO":"0126","CUSTOMS_NA":"丰台海关"},
  {"CUSTOMS_CO":"0127","CUSTOMS_NA":"京快件"},
  {"CUSTOMS_CO":"0128","CUSTOMS_NA":"顺义海关"},
  {"CUSTOMS_CO":"0129","CUSTOMS_NA":"天竺海关"},
  {"CUSTOMS_CO":"0130","CUSTOMS_NA":"亦庄物流"},
  {"CUSTOMS_CO":"0200","CUSTOMS_NA":"天津海关"},
  {"CUSTOMS_CO":"0201","CUSTOMS_NA":"津南开关"},
  {"CUSTOMS_CO":"0202","CUSTOMS_NA":"新港海关"},
  {"CUSTOMS_CO":"0203","CUSTOMS_NA":"塘沽海关"},
  {"CUSTOMS_CO":"0204","CUSTOMS_NA":"东港海关"},
  {"CUSTOMS_CO":"0205","CUSTOMS_NA":"津塘沽办"},
  {"CUSTOMS_CO":"0206","CUSTOMS_NA":"津邮局关"},
  {"CUSTOMS_CO":"0207","CUSTOMS_NA":"津机场办"},
  {"CUSTOMS_CO":"0208","CUSTOMS_NA":"津保税区"},
  {"CUSTOMS_CO":"0209","CUSTOMS_NA":"津蓟州关"},
  {"CUSTOMS_CO":"0210","CUSTOMS_NA":"武清海关"},
  {"CUSTOMS_CO":"0211","CUSTOMS_NA":"津加工区"},
  {"CUSTOMS_CO":"0212","CUSTOMS_NA":"津物流园"},
  {"CUSTOMS_CO":"0213","CUSTOMS_NA":"天津东疆"},
  {"CUSTOMS_CO":"0214","CUSTOMS_NA":"津滨综保"},
  {"CUSTOMS_CO":"0215","CUSTOMS_NA":"津机快件"},
  {"CUSTOMS_CO":"0216","CUSTOMS_NA":"津开物流"},
  {"CUSTOMS_CO":"0217","CUSTOMS_NA":"东疆港区"},
  {"CUSTOMS_CO":"0218","CUSTOMS_NA":"静海海关"},
  {"CUSTOMS_CO":"0219","CUSTOMS_NA":"津北辰关"},
  {"CUSTOMS_CO":"0220","CUSTOMS_NA":"津关税处"},
  {"CUSTOMS_CO":"0221","CUSTOMS_NA":"津宁河关"},
  {"CUSTOMS_CO":"0222","CUSTOMS_NA":"津大港关"},
  {"CUSTOMS_CO":"0223","CUSTOMS_NA":"津临港关"},
  {"CUSTOMS_CO":"0224","CUSTOMS_NA":"津南疆关"},
  {"CUSTOMS_CO":"0225","CUSTOMS_NA":"津西青关"},
  {"CUSTOMS_CO":"0226","CUSTOMS_NA":"津北塘关"},
  {"CUSTOMS_CO":"0227","CUSTOMS_NA":"津河西关"},
  {"CUSTOMS_CO":"0228","CUSTOMS_NA":"津东丽关"},
  {"CUSTOMS_CO":"0229","CUSTOMS_NA":"津蓟物流"},
  {"CUSTOMS_CO":"0400","CUSTOMS_NA":"石家庄区"},
  {"CUSTOMS_CO":"0401","CUSTOMS_NA":"鹿泉海关"},
  {"CUSTOMS_CO":"0402","CUSTOMS_NA":"秦皇岛关"},
  {"CUSTOMS_CO":"0403","CUSTOMS_NA":"唐山海关"},
  {"CUSTOMS_CO":"0404","CUSTOMS_NA":"廊坊海关"},
  {"CUSTOMS_CO":"0405","CUSTOMS_NA":"保定海关"},
  {"CUSTOMS_CO":"0406","CUSTOMS_NA":"邯郸海关"},
  {"CUSTOMS_CO":"0407","CUSTOMS_NA":"秦加工区"},
  {"CUSTOMS_CO":"0408","CUSTOMS_NA":"沧州海关"},
  {"CUSTOMS_CO":"0409","CUSTOMS_NA":"廊坊综保"},
  {"CUSTOMS_CO":"0410","CUSTOMS_NA":"石机场关"},
  {"CUSTOMS_CO":"0411","CUSTOMS_NA":"张家口关"},
  {"CUSTOMS_CO":"0412","CUSTOMS_NA":"曹妃甸关"},
  {"CUSTOMS_CO":"0413","CUSTOMS_NA":"邢台海关"},
  {"CUSTOMS_CO":"0414","CUSTOMS_NA":"曹综保区"},
  {"CUSTOMS_CO":"0415","CUSTOMS_NA":"衡水海关"},
  {"CUSTOMS_CO":"0416","CUSTOMS_NA":"石关快件"},
  {"CUSTOMS_CO":"0417","CUSTOMS_NA":"承德海关"},
  {"CUSTOMS_CO":"0418","CUSTOMS_NA":"石综保区"},
  {"CUSTOMS_CO":"0419","CUSTOMS_NA":"武安物流"},
  {"CUSTOMS_CO":"0420","CUSTOMS_NA":"京唐物流"},
  {"CUSTOMS_CO":"0421","CUSTOMS_NA":"正定海关"},
  {"CUSTOMS_CO":"0422","CUSTOMS_NA":"京唐港关"},
  {"CUSTOMS_CO":"0423","CUSTOMS_NA":"雄安海关"},
  {"CUSTOMS_CO":"0424","CUSTOMS_NA":"黄骅港关"},
  {"CUSTOMS_CO":"0425","CUSTOMS_NA":"辛集物流"},
  {"CUSTOMS_CO":"0426","CUSTOMS_NA":"北戴河关"},
  {"CUSTOMS_CO":"0500","CUSTOMS_NA":"太原关区"},
  {"CUSTOMS_CO":"0501","CUSTOMS_NA":"晋阳海关"},
  {"CUSTOMS_CO":"0502","CUSTOMS_NA":"并机场关"},
  {"CUSTOMS_CO":"0503","CUSTOMS_NA":"大同海关"},
  {"CUSTOMS_CO":"0504","CUSTOMS_NA":"临汾海关"},
  {"CUSTOMS_CO":"0505","CUSTOMS_NA":"方略物流"},
  {"CUSTOMS_CO":"0506","CUSTOMS_NA":"太原综保"},
  {"CUSTOMS_CO":"0507","CUSTOMS_NA":"运城海关"},
  {"CUSTOMS_CO":"0508","CUSTOMS_NA":"晋城海关"},
  {"CUSTOMS_CO":"0509","CUSTOMS_NA":"兰花物流"},
  {"CUSTOMS_CO":"0510","CUSTOMS_NA":"太原邮件"},
  {"CUSTOMS_CO":"0511","CUSTOMS_NA":"武宿海关"},
  {"CUSTOMS_CO":"0512","CUSTOMS_NA":"长治海关"},
  {"CUSTOMS_CO":"0513","CUSTOMS_NA":"阳泉海关"},
  {"CUSTOMS_CO":"0514","CUSTOMS_NA":"朔州海关"},
  {"CUSTOMS_CO":"0515","CUSTOMS_NA":"忻州海关"},
  {"CUSTOMS_CO":"0600","CUSTOMS_NA":"满洲里关"},
  {"CUSTOMS_CO":"0601","CUSTOMS_NA":"海拉尔关"},
  {"CUSTOMS_CO":"0602","CUSTOMS_NA":"额尔古纳"},
  {"CUSTOMS_CO":"0603","CUSTOMS_NA":"满十八里"},
  {"CUSTOMS_CO":"0604","CUSTOMS_NA":"赤峰海关"},
  {"CUSTOMS_CO":"0605","CUSTOMS_NA":"通辽海关"},
  {"CUSTOMS_CO":"0606","CUSTOMS_NA":"满哈沙特"},
  {"CUSTOMS_CO":"0607","CUSTOMS_NA":"满室韦"},
  {"CUSTOMS_CO":"0608","CUSTOMS_NA":"满互贸区"},
  {"CUSTOMS_CO":"0609","CUSTOMS_NA":"满铁路"},
  {"CUSTOMS_CO":"0610","CUSTOMS_NA":"满市区"},
  {"CUSTOMS_CO":"0611","CUSTOMS_NA":"满机场"},
  {"CUSTOMS_CO":"0612","CUSTOMS_NA":"阿尔山关"},
  {"CUSTOMS_CO":"0613","CUSTOMS_NA":"赤峰物流"},
  {"CUSTOMS_CO":"0614","CUSTOMS_NA":"额布都格"},
  {"CUSTOMS_CO":"0615","CUSTOMS_NA":"满综保区"},
  {"CUSTOMS_CO":"0616","CUSTOMS_NA":"满关邮办"},
  {"CUSTOMS_CO":"0700","CUSTOMS_NA":"呼特关区"},
  {"CUSTOMS_CO":"0701","CUSTOMS_NA":"赛罕海关"},
  {"CUSTOMS_CO":"0702","CUSTOMS_NA":"二关铁路"},
  {"CUSTOMS_CO":"0703","CUSTOMS_NA":"包头海关"},
  {"CUSTOMS_CO":"0704","CUSTOMS_NA":"呼关邮办"},
  {"CUSTOMS_CO":"0705","CUSTOMS_NA":"二关公路"},
  {"CUSTOMS_CO":"0706","CUSTOMS_NA":"包头箱站"},
  {"CUSTOMS_CO":"0707","CUSTOMS_NA":"额济纳关"},
  {"CUSTOMS_CO":"0708","CUSTOMS_NA":"乌拉特关"},
  {"CUSTOMS_CO":"0709","CUSTOMS_NA":"满达口岸"},
  {"CUSTOMS_CO":"0710","CUSTOMS_NA":"东乌海关"},
  {"CUSTOMS_CO":"0711","CUSTOMS_NA":"机场海关"},
  {"CUSTOMS_CO":"0712","CUSTOMS_NA":"呼综保区"},
  {"CUSTOMS_CO":"0713","CUSTOMS_NA":"鄂尔多斯"},
  {"CUSTOMS_CO":"0714","CUSTOMS_NA":"集宁海关"},
  {"CUSTOMS_CO":"0715","CUSTOMS_NA":"乌海海关"},
  {"CUSTOMS_CO":"0716","CUSTOMS_NA":"鄂综保区"},
  {"CUSTOMS_CO":"0717","CUSTOMS_NA":"包头保B"},
  {"CUSTOMS_CO":"0718","CUSTOMS_NA":"巴市保B"},
  {"CUSTOMS_CO":"0719","CUSTOMS_NA":"二关公直"},
  {"CUSTOMS_CO":"0720","CUSTOMS_NA":"七苏保B"},
  {"CUSTOMS_CO":"0800","CUSTOMS_NA":"沈阳关区"},
  {"CUSTOMS_CO":"0801","CUSTOMS_NA":"浑南海关"},
  {"CUSTOMS_CO":"0802","CUSTOMS_NA":"锦州海关"},
  {"CUSTOMS_CO":"0803","CUSTOMS_NA":"沈邮局关"},
  {"CUSTOMS_CO":"0804","CUSTOMS_NA":"抚顺海关"},
  {"CUSTOMS_CO":"0805","CUSTOMS_NA":"铁西海关"},
  {"CUSTOMS_CO":"0806","CUSTOMS_NA":"辽阳海关"},
  {"CUSTOMS_CO":"0807","CUSTOMS_NA":"沈机场关"},
  {"CUSTOMS_CO":"0808","CUSTOMS_NA":"辽中海关"},
  {"CUSTOMS_CO":"0809","CUSTOMS_NA":"沈快件"},
  {"CUSTOMS_CO":"0810","CUSTOMS_NA":"葫芦岛关"},
  {"CUSTOMS_CO":"0811","CUSTOMS_NA":"辽宁朝阳"},
  {"CUSTOMS_CO":"0812","CUSTOMS_NA":"沈抚新区"},
  {"CUSTOMS_CO":"0813","CUSTOMS_NA":"铁岭海关"},
  {"CUSTOMS_CO":"0814","CUSTOMS_NA":"铁保（B"},
  {"CUSTOMS_CO":"0815","CUSTOMS_NA":"阜新海关"},
  {"CUSTOMS_CO":"0900","CUSTOMS_NA":"大连海关"},
  {"CUSTOMS_CO":"0901","CUSTOMS_NA":"大连港湾"},
  {"CUSTOMS_CO":"0902","CUSTOMS_NA":"大连机场"},
  {"CUSTOMS_CO":"0903","CUSTOMS_NA":"连开发区"},
  {"CUSTOMS_CO":"0904","CUSTOMS_NA":"连加工区"},
  {"CUSTOMS_CO":"0905","CUSTOMS_NA":"北良港关"},
  {"CUSTOMS_CO":"0906","CUSTOMS_NA":"连保税区"},
  {"CUSTOMS_CO":"0907","CUSTOMS_NA":"连物流园"},
  {"CUSTOMS_CO":"0908","CUSTOMS_NA":"连大窑湾"},
  {"CUSTOMS_CO":"0909","CUSTOMS_NA":"连邮局关"},
  {"CUSTOMS_CO":"0910","CUSTOMS_NA":"连保税港"},
  {"CUSTOMS_CO":"0911","CUSTOMS_NA":"长兴岛关"},
  {"CUSTOMS_CO":"0912","CUSTOMS_NA":"大连快件"},
  {"CUSTOMS_CO":"0915","CUSTOMS_NA":"庄河海关"},
  {"CUSTOMS_CO":"0916","CUSTOMS_NA":"七贤岭关"},
  {"CUSTOMS_CO":"0917","CUSTOMS_NA":"旅顺海关"},
  {"CUSTOMS_CO":"0919","CUSTOMS_NA":"金石滩关"},
  {"CUSTOMS_CO":"0930","CUSTOMS_NA":"丹东海关"},
  {"CUSTOMS_CO":"0931","CUSTOMS_NA":"本溪海关"},
  {"CUSTOMS_CO":"0932","CUSTOMS_NA":"丹太平湾"},
  {"CUSTOMS_CO":"0940","CUSTOMS_NA":"营口海关"},
  {"CUSTOMS_CO":"0941","CUSTOMS_NA":"盘锦海关"},
  {"CUSTOMS_CO":"0942","CUSTOMS_NA":"盘港物流"},
  {"CUSTOMS_CO":"0943","CUSTOMS_NA":"营口综保"},
  {"CUSTOMS_CO":"0950","CUSTOMS_NA":"鲅鱼圈关"},
  {"CUSTOMS_CO":"0951","CUSTOMS_NA":"营港物流"},
  {"CUSTOMS_CO":"0953","CUSTOMS_NA":"仙人岛办"},
  {"CUSTOMS_CO":"0960","CUSTOMS_NA":"大东港关"},
  {"CUSTOMS_CO":"0980","CUSTOMS_NA":"鞍山海关"},
  {"CUSTOMS_CO":"1500","CUSTOMS_NA":"长春关区"},
  {"CUSTOMS_CO":"1501","CUSTOMS_NA":"绿园海关"},
  {"CUSTOMS_CO":"1502","CUSTOMS_NA":"兴隆海关"},
  {"CUSTOMS_CO":"1503","CUSTOMS_NA":"长白海关"},
  {"CUSTOMS_CO":"1504","CUSTOMS_NA":"临江口岸"},
  {"CUSTOMS_CO":"1505","CUSTOMS_NA":"图们海关"},
  {"CUSTOMS_CO":"1506","CUSTOMS_NA":"通化海关"},
  {"CUSTOMS_CO":"1507","CUSTOMS_NA":"珲春海关"},
  {"CUSTOMS_CO":"1508","CUSTOMS_NA":"吉林海关"},
  {"CUSTOMS_CO":"1509","CUSTOMS_NA":"延吉海关"},
  {"CUSTOMS_CO":"1510","CUSTOMS_NA":"长春综保"},
  {"CUSTOMS_CO":"1511","CUSTOMS_NA":"龙嘉机场"},
  {"CUSTOMS_CO":"1512","CUSTOMS_NA":"松原海关"},
  {"CUSTOMS_CO":"1513","CUSTOMS_NA":"白城海关"},
  {"CUSTOMS_CO":"1514","CUSTOMS_NA":"白山海关"},
  {"CUSTOMS_CO":"1515","CUSTOMS_NA":"图们车办"},
  {"CUSTOMS_CO":"1516","CUSTOMS_NA":"通海关村"},
  {"CUSTOMS_CO":"1517","CUSTOMS_NA":"珲长岭子"},
  {"CUSTOMS_CO":"1518","CUSTOMS_NA":"吉关车办"},
  {"CUSTOMS_CO":"1519","CUSTOMS_NA":"图们三合"},
  {"CUSTOMS_CO":"1521","CUSTOMS_NA":"一汽场站"},
  {"CUSTOMS_CO":"1522","CUSTOMS_NA":"长白山海"},
  {"CUSTOMS_CO":"1523","CUSTOMS_NA":"四平海关"},
  {"CUSTOMS_CO":"1524","CUSTOMS_NA":"辽源海关"},
  {"CUSTOMS_CO":"1525","CUSTOMS_NA":"图们桥办"},
  {"CUSTOMS_CO":"1526","CUSTOMS_NA":"通集青石"},
  {"CUSTOMS_CO":"1527","CUSTOMS_NA":"珲春圈河"},
  {"CUSTOMS_CO":"1528","CUSTOMS_NA":"吉林物流"},
  {"CUSTOMS_CO":"1529","CUSTOMS_NA":"延吉南坪"},
  {"CUSTOMS_CO":"1531","CUSTOMS_NA":"兴隆铁路"},
  {"CUSTOMS_CO":"1536","CUSTOMS_NA":"通集铁路"},
  {"CUSTOMS_CO":"1537","CUSTOMS_NA":"珲沙坨子"},
  {"CUSTOMS_CO":"1539","CUSTOMS_NA":"图开山屯"},
  {"CUSTOMS_CO":"1546","CUSTOMS_NA":"通集公路"},
  {"CUSTOMS_CO":"1547","CUSTOMS_NA":"珲综保区"},
  {"CUSTOMS_CO":"1549","CUSTOMS_NA":"延古城里"},
  {"CUSTOMS_CO":"1557","CUSTOMS_NA":"珲春车办"},
  {"CUSTOMS_CO":"1559","CUSTOMS_NA":"延吉邮办"},
  {"CUSTOMS_CO":"1569","CUSTOMS_NA":"延吉机办"},
  {"CUSTOMS_CO":"1579","CUSTOMS_NA":"延关快件"},
  {"CUSTOMS_CO":"1589","CUSTOMS_NA":"延吉保B"},
  {"CUSTOMS_CO":"1591","CUSTOMS_NA":"长邮海关"},
  {"CUSTOMS_CO":"1593","CUSTOMS_NA":"长白邮办"},
  {"CUSTOMS_CO":"1595","CUSTOMS_NA":"图们邮办"},
  {"CUSTOMS_CO":"1596","CUSTOMS_NA":"通集邮办"},
  {"CUSTOMS_CO":"1900","CUSTOMS_NA":"哈尔滨区"},
  {"CUSTOMS_CO":"1901","CUSTOMS_NA":"哈尔滨关"},
  {"CUSTOMS_CO":"1902","CUSTOMS_NA":"绥关铁路"},
  {"CUSTOMS_CO":"1903","CUSTOMS_NA":"黑河海关"},
  {"CUSTOMS_CO":"1904","CUSTOMS_NA":"同江海关"},
  {"CUSTOMS_CO":"1905","CUSTOMS_NA":"佳木斯海"},
  {"CUSTOMS_CO":"1906","CUSTOMS_NA":"牡丹江关"},
  {"CUSTOMS_CO":"1907","CUSTOMS_NA":"东宁海关"},
  {"CUSTOMS_CO":"1908","CUSTOMS_NA":"逊克海关"},
  {"CUSTOMS_CO":"1909","CUSTOMS_NA":"齐齐哈尔"},
  {"CUSTOMS_CO":"1910","CUSTOMS_NA":"大庆海关"},
  {"CUSTOMS_CO":"1911","CUSTOMS_NA":"密山海关"},
  {"CUSTOMS_CO":"1912","CUSTOMS_NA":"虎林海关"},
  {"CUSTOMS_CO":"1913","CUSTOMS_NA":"同江富锦"},
  {"CUSTOMS_CO":"1914","CUSTOMS_NA":"抚远海关"},
  {"CUSTOMS_CO":"1915","CUSTOMS_NA":"漠河海关"},
  {"CUSTOMS_CO":"1916","CUSTOMS_NA":"萝北海关"},
  {"CUSTOMS_CO":"1917","CUSTOMS_NA":"嘉荫海关"},
  {"CUSTOMS_CO":"1918","CUSTOMS_NA":"饶河海关"},
  {"CUSTOMS_CO":"1919","CUSTOMS_NA":"冰城香办"},
  {"CUSTOMS_CO":"1920","CUSTOMS_NA":"哈开发区"},
  {"CUSTOMS_CO":"1921","CUSTOMS_NA":"绥综保区"},
  {"CUSTOMS_CO":"1922","CUSTOMS_NA":"冰城邮办"},
  {"CUSTOMS_CO":"1923","CUSTOMS_NA":"哈关车办"},
  {"CUSTOMS_CO":"1924","CUSTOMS_NA":"哈机场关"},
  {"CUSTOMS_CO":"1925","CUSTOMS_NA":"绥关公路"},
  {"CUSTOMS_CO":"1926","CUSTOMS_NA":"哈综保区"},
  {"CUSTOMS_CO":"1927","CUSTOMS_NA":"哈综口岸"},
  {"CUSTOMS_CO":"1928","CUSTOMS_NA":"绥综口岸"},
  {"CUSTOMS_CO":"1929","CUSTOMS_NA":"牡保B型"},
  {"CUSTOMS_CO":"1930","CUSTOMS_NA":"冰城海关"},
  {"CUSTOMS_CO":"1931","CUSTOMS_NA":"鹤岗海关"},
  {"CUSTOMS_CO":"1932","CUSTOMS_NA":"黑河保B"},
  {"CUSTOMS_CO":"2200","CUSTOMS_NA":"上海海关"},
  {"CUSTOMS_CO":"2201","CUSTOMS_NA":"浦江海关"},
  {"CUSTOMS_CO":"2202","CUSTOMS_NA":"吴淞海关"},
  {"CUSTOMS_CO":"2203","CUSTOMS_NA":"虹桥机场"},
  {"CUSTOMS_CO":"2204","CUSTOMS_NA":"闵开发区"},
  {"CUSTOMS_CO":"2205","CUSTOMS_NA":"车站海关"},
  {"CUSTOMS_CO":"2206","CUSTOMS_NA":"邮局海关"},
  {"CUSTOMS_CO":"2207","CUSTOMS_NA":"洋山海关"},
  {"CUSTOMS_CO":"2208","CUSTOMS_NA":"宝山海关"},
  {"CUSTOMS_CO":"2209","CUSTOMS_NA":"龙吴海关"},
  {"CUSTOMS_CO":"2210","CUSTOMS_NA":"浦东海关"},
  {"CUSTOMS_CO":"2211","CUSTOMS_NA":"卢湾监管"},
  {"CUSTOMS_CO":"2212","CUSTOMS_NA":"奉贤海关"},
  {"CUSTOMS_CO":"2213","CUSTOMS_NA":"莘庄海关"},
  {"CUSTOMS_CO":"2214","CUSTOMS_NA":"漕河泾发"},
  {"CUSTOMS_CO":"2215","CUSTOMS_NA":"西北物流"},
  {"CUSTOMS_CO":"2216","CUSTOMS_NA":"浦机综保"},
  {"CUSTOMS_CO":"2217","CUSTOMS_NA":"嘉定海关"},
  {"CUSTOMS_CO":"2218","CUSTOMS_NA":"外高桥关"},
  {"CUSTOMS_CO":"2219","CUSTOMS_NA":"沪杨浦关"},
  {"CUSTOMS_CO":"2220","CUSTOMS_NA":"金山海关"},
  {"CUSTOMS_CO":"2221","CUSTOMS_NA":"松江海关"},
  {"CUSTOMS_CO":"2222","CUSTOMS_NA":"青浦海关"},
  {"CUSTOMS_CO":"2223","CUSTOMS_NA":"沪科创关"},
  {"CUSTOMS_CO":"2224","CUSTOMS_NA":"崇明海关"},
  {"CUSTOMS_CO":"2225","CUSTOMS_NA":"外港海关"},
  {"CUSTOMS_CO":"2226","CUSTOMS_NA":"贸易网点"},
  {"CUSTOMS_CO":"2227","CUSTOMS_NA":"普陀区站"},
  {"CUSTOMS_CO":"2228","CUSTOMS_NA":"沪会展关"},
  {"CUSTOMS_CO":"2229","CUSTOMS_NA":"航交办"},
  {"CUSTOMS_CO":"2230","CUSTOMS_NA":"沪徐汇关"},
  {"CUSTOMS_CO":"2231","CUSTOMS_NA":"洋山市内"},
  {"CUSTOMS_CO":"2232","CUSTOMS_NA":"嘉定出口"},
  {"CUSTOMS_CO":"2233","CUSTOMS_NA":"浦东机场"},
  {"CUSTOMS_CO":"2234","CUSTOMS_NA":"沪钻交所"},
  {"CUSTOMS_CO":"2235","CUSTOMS_NA":"松江综A"},
  {"CUSTOMS_CO":"2236","CUSTOMS_NA":"洋山芦潮"},
  {"CUSTOMS_CO":"2237","CUSTOMS_NA":"松江综B"},
  {"CUSTOMS_CO":"2238","CUSTOMS_NA":"青浦综保"},
  {"CUSTOMS_CO":"2239","CUSTOMS_NA":"奉贤综保"},
  {"CUSTOMS_CO":"2240","CUSTOMS_NA":"漕河泾综"},
  {"CUSTOMS_CO":"2241","CUSTOMS_NA":"沪黄浦关"},
  {"CUSTOMS_CO":"2242","CUSTOMS_NA":"沪业二处"},
  {"CUSTOMS_CO":"2243","CUSTOMS_NA":"沪虹口关"},
  {"CUSTOMS_CO":"2244","CUSTOMS_NA":"上海快件"},
  {"CUSTOMS_CO":"2245","CUSTOMS_NA":"金桥综保"},
  {"CUSTOMS_CO":"2246","CUSTOMS_NA":"保税物流"},
  {"CUSTOMS_CO":"2247","CUSTOMS_NA":"沪化工区"},
  {"CUSTOMS_CO":"2248","CUSTOMS_NA":"洋山港区"},
  {"CUSTOMS_CO":"2249","CUSTOMS_NA":"洋山特综"},
  {"CUSTOMS_CO":"2250","CUSTOMS_NA":"沪空港办"},
  {"CUSTOMS_CO":"2251","CUSTOMS_NA":"沪金桥办"},
  {"CUSTOMS_CO":"2252","CUSTOMS_NA":"虹桥B保"},
  {"CUSTOMS_CO":"2300","CUSTOMS_NA":"南京海关"},
  {"CUSTOMS_CO":"2301","CUSTOMS_NA":"连云港关"},
  {"CUSTOMS_CO":"2302","CUSTOMS_NA":"南通海关"},
  {"CUSTOMS_CO":"2303","CUSTOMS_NA":"苏州海关"},
  {"CUSTOMS_CO":"2304","CUSTOMS_NA":"无锡海关"},
  {"CUSTOMS_CO":"2305","CUSTOMS_NA":"张家港关"},
  {"CUSTOMS_CO":"2306","CUSTOMS_NA":"常州海关"},
  {"CUSTOMS_CO":"2307","CUSTOMS_NA":"镇江海关"},
  {"CUSTOMS_CO":"2308","CUSTOMS_NA":"新生圩关"},
  {"CUSTOMS_CO":"2309","CUSTOMS_NA":"盐城海关"},
  {"CUSTOMS_CO":"2310","CUSTOMS_NA":"扬州海关"},
  {"CUSTOMS_CO":"2311","CUSTOMS_NA":"徐州海关"},
  {"CUSTOMS_CO":"2312","CUSTOMS_NA":"江阴海关"},
  {"CUSTOMS_CO":"2313","CUSTOMS_NA":"张保税区"},
  {"CUSTOMS_CO":"2314","CUSTOMS_NA":"苏工业区"},
  {"CUSTOMS_CO":"2315","CUSTOMS_NA":"淮安海关"},
  {"CUSTOMS_CO":"2316","CUSTOMS_NA":"泰州海关"},
  {"CUSTOMS_CO":"2317","CUSTOMS_NA":"禄口机场"},
  {"CUSTOMS_CO":"2318","CUSTOMS_NA":"金陵江北"},
  {"CUSTOMS_CO":"2319","CUSTOMS_NA":"如皋海关"},
  {"CUSTOMS_CO":"2320","CUSTOMS_NA":"锡关机办"},
  {"CUSTOMS_CO":"2321","CUSTOMS_NA":"常溧阳办"},
  {"CUSTOMS_CO":"2322","CUSTOMS_NA":"镇丹阳办"},
  {"CUSTOMS_CO":"2323","CUSTOMS_NA":"金陵海关"},
  {"CUSTOMS_CO":"2324","CUSTOMS_NA":"常熟海关"},
  {"CUSTOMS_CO":"2325","CUSTOMS_NA":"昆山海关"},
  {"CUSTOMS_CO":"2326","CUSTOMS_NA":"吴江海关"},
  {"CUSTOMS_CO":"2327","CUSTOMS_NA":"太仓海关"},
  {"CUSTOMS_CO":"2328","CUSTOMS_NA":"苏吴中办"},
  {"CUSTOMS_CO":"2329","CUSTOMS_NA":"启东海关"},
  {"CUSTOMS_CO":"2330","CUSTOMS_NA":"泰泰兴办"},
  {"CUSTOMS_CO":"2331","CUSTOMS_NA":"宜兴海关"},
  {"CUSTOMS_CO":"2332","CUSTOMS_NA":"锡锡山办"},
  {"CUSTOMS_CO":"2333","CUSTOMS_NA":"南通关办"},
  {"CUSTOMS_CO":"2334","CUSTOMS_NA":"新沂保B"},
  {"CUSTOMS_CO":"2335","CUSTOMS_NA":"昆山加工"},
  {"CUSTOMS_CO":"2336","CUSTOMS_NA":"苏园加工"},
  {"CUSTOMS_CO":"2337","CUSTOMS_NA":"徐州综保"},
  {"CUSTOMS_CO":"2338","CUSTOMS_NA":"苏关邮办"},
  {"CUSTOMS_CO":"2339","CUSTOMS_NA":"南通加工"},
  {"CUSTOMS_CO":"2340","CUSTOMS_NA":"无锡加工"},
  {"CUSTOMS_CO":"2341","CUSTOMS_NA":"连关加工"},
  {"CUSTOMS_CO":"2342","CUSTOMS_NA":"连赣榆办"},
  {"CUSTOMS_CO":"2343","CUSTOMS_NA":"宁南加工"},
  {"CUSTOMS_CO":"2344","CUSTOMS_NA":"苏高加工"},
  {"CUSTOMS_CO":"2345","CUSTOMS_NA":"镇江加工"},
  {"CUSTOMS_CO":"2346","CUSTOMS_NA":"连关综保"},
  {"CUSTOMS_CO":"2347","CUSTOMS_NA":"苏园B区"},
  {"CUSTOMS_CO":"2348","CUSTOMS_NA":"金港海关"},
  {"CUSTOMS_CO":"2349","CUSTOMS_NA":"金陵邮办"},
  {"CUSTOMS_CO":"2350","CUSTOMS_NA":"苏高物流"},
  {"CUSTOMS_CO":"2351","CUSTOMS_NA":"金陵江宁"},
  {"CUSTOMS_CO":"2352","CUSTOMS_NA":"宁空保B"},
  {"CUSTOMS_CO":"2353","CUSTOMS_NA":"常关出加"},
  {"CUSTOMS_CO":"2354","CUSTOMS_NA":"扬关出加"},
  {"CUSTOMS_CO":"2355","CUSTOMS_NA":"常熟出加"},
  {"CUSTOMS_CO":"2356","CUSTOMS_NA":"吴江出加"},
  {"CUSTOMS_CO":"2357","CUSTOMS_NA":"常关武办"},
  {"CUSTOMS_CO":"2358","CUSTOMS_NA":"苏园保税"},
  {"CUSTOMS_CO":"2359","CUSTOMS_NA":"吴中出加"},
  {"CUSTOMS_CO":"2360","CUSTOMS_NA":"盐关港办"},
  {"CUSTOMS_CO":"2361","CUSTOMS_NA":"淮关出加"},
  {"CUSTOMS_CO":"2362","CUSTOMS_NA":"澄关物流"},
  {"CUSTOMS_CO":"2363","CUSTOMS_NA":"太仓物流"},
  {"CUSTOMS_CO":"2364","CUSTOMS_NA":"武进出加"},
  {"CUSTOMS_CO":"2365","CUSTOMS_NA":"张保税港"},
  {"CUSTOMS_CO":"2366","CUSTOMS_NA":"宿迁海关"},
  {"CUSTOMS_CO":"2367","CUSTOMS_NA":"泰出加区"},
  {"CUSTOMS_CO":"2368","CUSTOMS_NA":"苏高综保"},
  {"CUSTOMS_CO":"2369","CUSTOMS_NA":"昆山综保"},
  {"CUSTOMS_CO":"2370","CUSTOMS_NA":"连关物流"},
  {"CUSTOMS_CO":"2371","CUSTOMS_NA":"盐机场办"},
  {"CUSTOMS_CO":"2372","CUSTOMS_NA":"盐城综保"},
  {"CUSTOMS_CO":"2373","CUSTOMS_NA":"淮安综保"},
  {"CUSTOMS_CO":"2374","CUSTOMS_NA":"锡高综保"},
  {"CUSTOMS_CO":"2375","CUSTOMS_NA":"靖江海关"},
  {"CUSTOMS_CO":"2376","CUSTOMS_NA":"南通综保"},
  {"CUSTOMS_CO":"2377","CUSTOMS_NA":"龙潭综保"},
  {"CUSTOMS_CO":"2378","CUSTOMS_NA":"江宁综保"},
  {"CUSTOMS_CO":"2379","CUSTOMS_NA":"苏相城办"},
  {"CUSTOMS_CO":"2380","CUSTOMS_NA":"太仓综保"},
  {"CUSTOMS_CO":"2381","CUSTOMS_NA":"苏园贸易"},
  {"CUSTOMS_CO":"2382","CUSTOMS_NA":"苏虎丘办"},
  {"CUSTOMS_CO":"2383","CUSTOMS_NA":"如东海关"},
  {"CUSTOMS_CO":"2384","CUSTOMS_NA":"如皋物流"},
  {"CUSTOMS_CO":"2385","CUSTOMS_NA":"泰州综保"},
  {"CUSTOMS_CO":"2386","CUSTOMS_NA":"镇江综保"},
  {"CUSTOMS_CO":"2387","CUSTOMS_NA":"常州综保"},
  {"CUSTOMS_CO":"2388","CUSTOMS_NA":"武进综保"},
  {"CUSTOMS_CO":"2389","CUSTOMS_NA":"常熟综保"},
  {"CUSTOMS_CO":"2390","CUSTOMS_NA":"吴江综保"},
  {"CUSTOMS_CO":"2391","CUSTOMS_NA":"徐州物流"},
  {"CUSTOMS_CO":"2392","CUSTOMS_NA":"通海门办"},
  {"CUSTOMS_CO":"2393","CUSTOMS_NA":"通海安办"},
  {"CUSTOMS_CO":"2394","CUSTOMS_NA":"吴中综保"},
  {"CUSTOMS_CO":"2395","CUSTOMS_NA":"大丰物流"},
  {"CUSTOMS_CO":"2396","CUSTOMS_NA":"海安物流"},
  {"CUSTOMS_CO":"2397","CUSTOMS_NA":"江阴综保"},
  {"CUSTOMS_CO":"2398","CUSTOMS_NA":"扬州综保"},
  {"CUSTOMS_CO":"2900","CUSTOMS_NA":"杭州关区"},
  {"CUSTOMS_CO":"2901","CUSTOMS_NA":"钱综三处"},
  {"CUSTOMS_CO":"2902","CUSTOMS_NA":"钱江海关"},
  {"CUSTOMS_CO":"2903","CUSTOMS_NA":"温州海关"},
  {"CUSTOMS_CO":"2904","CUSTOMS_NA":"舟山海关"},
  {"CUSTOMS_CO":"2905","CUSTOMS_NA":"台州海关"},
  {"CUSTOMS_CO":"2906","CUSTOMS_NA":"绍兴海关"},
  {"CUSTOMS_CO":"2907","CUSTOMS_NA":"湖州海关"},
  {"CUSTOMS_CO":"2908","CUSTOMS_NA":"嘉兴海关"},
  {"CUSTOMS_CO":"2909","CUSTOMS_NA":"钱关下沙"},
  {"CUSTOMS_CO":"2910","CUSTOMS_NA":"杭州机场"},
  {"CUSTOMS_CO":"2911","CUSTOMS_NA":"钱关邮办"},
  {"CUSTOMS_CO":"2912","CUSTOMS_NA":"钱关萧办"},
  {"CUSTOMS_CO":"2915","CUSTOMS_NA":"丽水海关"},
  {"CUSTOMS_CO":"2916","CUSTOMS_NA":"杭州快件"},
  {"CUSTOMS_CO":"2917","CUSTOMS_NA":"衢州海关"},
  {"CUSTOMS_CO":"2918","CUSTOMS_NA":"钱关余办"},
  {"CUSTOMS_CO":"2919","CUSTOMS_NA":"钱关富办"},
  {"CUSTOMS_CO":"2920","CUSTOMS_NA":"金华海关"},
  {"CUSTOMS_CO":"2921","CUSTOMS_NA":"义乌海关"},
  {"CUSTOMS_CO":"2922","CUSTOMS_NA":"金关永办"},
  {"CUSTOMS_CO":"2923","CUSTOMS_NA":"义乌物流"},
  {"CUSTOMS_CO":"2924","CUSTOMS_NA":"金义综保"},
  {"CUSTOMS_CO":"2927","CUSTOMS_NA":"义关机办"},
  {"CUSTOMS_CO":"2928","CUSTOMS_NA":"杭关电商"},
  {"CUSTOMS_CO":"2929","CUSTOMS_NA":"钱关建办"},
  {"CUSTOMS_CO":"2931","CUSTOMS_NA":"温关邮办"},
  {"CUSTOMS_CO":"2932","CUSTOMS_NA":"温经开关"},
  {"CUSTOMS_CO":"2933","CUSTOMS_NA":"温关机办"},
  {"CUSTOMS_CO":"2934","CUSTOMS_NA":"温关鳌办"},
  {"CUSTOMS_CO":"2935","CUSTOMS_NA":"温关瑞办"},
  {"CUSTOMS_CO":"2936","CUSTOMS_NA":"温关乐办"},
  {"CUSTOMS_CO":"2937","CUSTOMS_NA":"温州物流"},
  {"CUSTOMS_CO":"2938","CUSTOMS_NA":"温州综保"},
  {"CUSTOMS_CO":"2941","CUSTOMS_NA":"嵊泗海关"},
  {"CUSTOMS_CO":"2942","CUSTOMS_NA":"舟关金塘"},
  {"CUSTOMS_CO":"2943","CUSTOMS_NA":"舟关综保"},
  {"CUSTOMS_CO":"2951","CUSTOMS_NA":"台关临办"},
  {"CUSTOMS_CO":"2952","CUSTOMS_NA":"台关温办"},
  {"CUSTOMS_CO":"2953","CUSTOMS_NA":"台关玉办"},
  {"CUSTOMS_CO":"2961","CUSTOMS_NA":"绍关虞办"},
  {"CUSTOMS_CO":"2962","CUSTOMS_NA":"绍关诸办"},
  {"CUSTOMS_CO":"2963","CUSTOMS_NA":"绍关新办"},
  {"CUSTOMS_CO":"2971","CUSTOMS_NA":"湖关安办"},
  {"CUSTOMS_CO":"2972","CUSTOMS_NA":"湖关德办"},
  {"CUSTOMS_CO":"2979","CUSTOMS_NA":"湖州保B"},
  {"CUSTOMS_CO":"2981","CUSTOMS_NA":"嘉关乍办"},
  {"CUSTOMS_CO":"2982","CUSTOMS_NA":"嘉关善办"},
  {"CUSTOMS_CO":"2983","CUSTOMS_NA":"嘉兴综保"},
  {"CUSTOMS_CO":"2984","CUSTOMS_NA":"嘉关宁办"},
  {"CUSTOMS_CO":"2985","CUSTOMS_NA":"嘉兴桐办"},
  {"CUSTOMS_CO":"2986","CUSTOMS_NA":"嘉综B区"},
  {"CUSTOMS_CO":"2991","CUSTOMS_NA":"杭州综保"},
  {"CUSTOMS_CO":"2992","CUSTOMS_NA":"杭州物流"},
  {"CUSTOMS_CO":"3100","CUSTOMS_NA":"宁波关区"},
  {"CUSTOMS_CO":"3101","CUSTOMS_NA":"海曙海关"},
  {"CUSTOMS_CO":"3102","CUSTOMS_NA":"镇海海关"},
  {"CUSTOMS_CO":"3103","CUSTOMS_NA":"甬北城办"},
  {"CUSTOMS_CO":"3104","CUSTOMS_NA":"北仑海关"},
  {"CUSTOMS_CO":"3105","CUSTOMS_NA":"甬保税区"},
  {"CUSTOMS_CO":"3106","CUSTOMS_NA":"大榭海关"},
  {"CUSTOMS_CO":"3107","CUSTOMS_NA":"余姚海关"},
  {"CUSTOMS_CO":"3108","CUSTOMS_NA":"慈溪海关"},
  {"CUSTOMS_CO":"3109","CUSTOMS_NA":"甬机场关"},
  {"CUSTOMS_CO":"3110","CUSTOMS_NA":"象山海关"},
  {"CUSTOMS_CO":"3111","CUSTOMS_NA":"甬加工区"},
  {"CUSTOMS_CO":"3112","CUSTOMS_NA":"甬物流区"},
  {"CUSTOMS_CO":"3113","CUSTOMS_NA":"慈加工区"},
  {"CUSTOMS_CO":"3114","CUSTOMS_NA":"鄞州海关"},
  {"CUSTOMS_CO":"3115","CUSTOMS_NA":"栎社海关"},
  {"CUSTOMS_CO":"3116","CUSTOMS_NA":"梅山港区"},
  {"CUSTOMS_CO":"3117","CUSTOMS_NA":"梅山保税"},
  {"CUSTOMS_CO":"3118","CUSTOMS_NA":"宁波快件"},
  {"CUSTOMS_CO":"3119","CUSTOMS_NA":"甬邮局关"},
  {"CUSTOMS_CO":"3120","CUSTOMS_NA":"镇海物流"},
  {"CUSTOMS_CO":"3121","CUSTOMS_NA":"甬北港办"},
  {"CUSTOMS_CO":"3122","CUSTOMS_NA":"甬北穿办"},
  {"CUSTOMS_CO":"3123","CUSTOMS_NA":"甬江海关"},
  {"CUSTOMS_CO":"3124","CUSTOMS_NA":"奉化海关"},
  {"CUSTOMS_CO":"3125","CUSTOMS_NA":"宁海海关"},
  {"CUSTOMS_CO":"3126","CUSTOMS_NA":"甬新区关"},
  {"CUSTOMS_CO":"3300","CUSTOMS_NA":"合肥海关"},
  {"CUSTOMS_CO":"3301","CUSTOMS_NA":"芜湖海关"},
  {"CUSTOMS_CO":"3302","CUSTOMS_NA":"安庆海关"},
  {"CUSTOMS_CO":"3303","CUSTOMS_NA":"马鞍山关"},
  {"CUSTOMS_CO":"3304","CUSTOMS_NA":"黄山海关"},
  {"CUSTOMS_CO":"3305","CUSTOMS_NA":"蚌埠海关"},
  {"CUSTOMS_CO":"3306","CUSTOMS_NA":"铜陵海关"},
  {"CUSTOMS_CO":"3307","CUSTOMS_NA":"阜阳海关"},
  {"CUSTOMS_CO":"3308","CUSTOMS_NA":"池州海关"},
  {"CUSTOMS_CO":"3309","CUSTOMS_NA":"滁州海关"},
  {"CUSTOMS_CO":"3310","CUSTOMS_NA":"庐州海关"},
  {"CUSTOMS_CO":"3311","CUSTOMS_NA":"新桥机场"},
  {"CUSTOMS_CO":"3312","CUSTOMS_NA":"芜湖综保"},
  {"CUSTOMS_CO":"3313","CUSTOMS_NA":"经开综保"},
  {"CUSTOMS_CO":"3315","CUSTOMS_NA":"宣城海关"},
  {"CUSTOMS_CO":"3316","CUSTOMS_NA":"蚌埠物流"},
  {"CUSTOMS_CO":"3317","CUSTOMS_NA":"合肥综保"},
  {"CUSTOMS_CO":"3318","CUSTOMS_NA":"淮南海关"},
  {"CUSTOMS_CO":"3319","CUSTOMS_NA":"宿州海关"},
  {"CUSTOMS_CO":"3320","CUSTOMS_NA":"合关快件"},
  {"CUSTOMS_CO":"3321","CUSTOMS_NA":"安庆物流"},
  {"CUSTOMS_CO":"3322","CUSTOMS_NA":"宣城物流"},
  {"CUSTOMS_CO":"3323","CUSTOMS_NA":"空港物流"},
  {"CUSTOMS_CO":"3324","CUSTOMS_NA":"马综保区"},
  {"CUSTOMS_CO":"3325","CUSTOMS_NA":"六安海关"},
  {"CUSTOMS_CO":"3326","CUSTOMS_NA":"淮北海关"},
  {"CUSTOMS_CO":"3327","CUSTOMS_NA":"亳州海关"},
  {"CUSTOMS_CO":"3328","CUSTOMS_NA":"铜陵物流"},
  {"CUSTOMS_CO":"3500","CUSTOMS_NA":"福州关区"},
  {"CUSTOMS_CO":"3501","CUSTOMS_NA":"马尾海关"},
  {"CUSTOMS_CO":"3502","CUSTOMS_NA":"榕福清办"},
  {"CUSTOMS_CO":"3503","CUSTOMS_NA":"宁德海关"},
  {"CUSTOMS_CO":"3504","CUSTOMS_NA":"三明海关"},
  {"CUSTOMS_CO":"3505","CUSTOMS_NA":"榕罗源办"},
  {"CUSTOMS_CO":"3506","CUSTOMS_NA":"莆田海关"},
  {"CUSTOMS_CO":"3507","CUSTOMS_NA":"机场海关"},
  {"CUSTOMS_CO":"3508","CUSTOMS_NA":"福州新港"},
  {"CUSTOMS_CO":"3509","CUSTOMS_NA":"榕邮局办"},
  {"CUSTOMS_CO":"3510","CUSTOMS_NA":"南平海关"},
  {"CUSTOMS_CO":"3511","CUSTOMS_NA":"武夷山关"},
  {"CUSTOMS_CO":"3512","CUSTOMS_NA":"黄岐监管"},
  {"CUSTOMS_CO":"3513","CUSTOMS_NA":"榕快安办"},
  {"CUSTOMS_CO":"3515","CUSTOMS_NA":"平潭港区"},
  {"CUSTOMS_CO":"3516","CUSTOMS_NA":"平潭海关"},
  {"CUSTOMS_CO":"3520","CUSTOMS_NA":"福州加工"},
  {"CUSTOMS_CO":"3521","CUSTOMS_NA":"翔福保B"},
  {"CUSTOMS_CO":"3522","CUSTOMS_NA":"福物流园"},
  {"CUSTOMS_CO":"3523","CUSTOMS_NA":"福保税港"},
  {"CUSTOMS_CO":"3700","CUSTOMS_NA":"厦门关区"},
  {"CUSTOMS_CO":"3701","CUSTOMS_NA":"厦门海关"},
  {"CUSTOMS_CO":"3702","CUSTOMS_NA":"泉刺桐办"},
  {"CUSTOMS_CO":"3703","CUSTOMS_NA":"漳州海关"},
  {"CUSTOMS_CO":"3704","CUSTOMS_NA":"东山海关"},
  {"CUSTOMS_CO":"3705","CUSTOMS_NA":"泉石狮办"},
  {"CUSTOMS_CO":"3706","CUSTOMS_NA":"龙岩海关"},
  {"CUSTOMS_CO":"3707","CUSTOMS_NA":"泉泉港办"},
  {"CUSTOMS_CO":"3708","CUSTOMS_NA":"海沧港区"},
  {"CUSTOMS_CO":"3709","CUSTOMS_NA":"海沧保税"},
  {"CUSTOMS_CO":"3710","CUSTOMS_NA":"高崎海关"},
  {"CUSTOMS_CO":"3711","CUSTOMS_NA":"东渡海关"},
  {"CUSTOMS_CO":"3712","CUSTOMS_NA":"海沧海关"},
  {"CUSTOMS_CO":"3713","CUSTOMS_NA":"邮局海关"},
  {"CUSTOMS_CO":"3714","CUSTOMS_NA":"象屿保税"},
  {"CUSTOMS_CO":"3715","CUSTOMS_NA":"机场海关"},
  {"CUSTOMS_CO":"3716","CUSTOMS_NA":"集同海关"},
  {"CUSTOMS_CO":"3717","CUSTOMS_NA":"厦物流园"},
  {"CUSTOMS_CO":"3718","CUSTOMS_NA":"泉综保区"},
  {"CUSTOMS_CO":"3719","CUSTOMS_NA":"厦门加工"},
  {"CUSTOMS_CO":"3720","CUSTOMS_NA":"厦门物流"},
  {"CUSTOMS_CO":"3722","CUSTOMS_NA":"大嶝监管"},
  {"CUSTOMS_CO":"3723","CUSTOMS_NA":"泉晋江办"},
  {"CUSTOMS_CO":"3724","CUSTOMS_NA":"邮轮海关"},
  {"CUSTOMS_CO":"3725","CUSTOMS_NA":"翔安海关"},
  {"CUSTOMS_CO":"3726","CUSTOMS_NA":"泉陆地港"},
  {"CUSTOMS_CO":"3727","CUSTOMS_NA":"古雷海关"},
  {"CUSTOMS_CO":"3728","CUSTOMS_NA":"泉安溪办"},
  {"CUSTOMS_CO":"3729","CUSTOMS_NA":"泉南安办"},
  {"CUSTOMS_CO":"3730","CUSTOMS_NA":"厦五通办"},
  {"CUSTOMS_CO":"3731","CUSTOMS_NA":"漳招银办"},
  {"CUSTOMS_CO":"3732","CUSTOMS_NA":"泉州海关"},
  {"CUSTOMS_CO":"3733","CUSTOMS_NA":"漳州保B"},
  {"CUSTOMS_CO":"3777","CUSTOMS_NA":"厦稽查处"},
  {"CUSTOMS_CO":"3788","CUSTOMS_NA":"厦侦查局"},
  {"CUSTOMS_CO":"4000","CUSTOMS_NA":"南昌关区"},
  {"CUSTOMS_CO":"4001","CUSTOMS_NA":"赣江海关"},
  {"CUSTOMS_CO":"4002","CUSTOMS_NA":"九江海关"},
  {"CUSTOMS_CO":"4003","CUSTOMS_NA":"赣州海关"},
  {"CUSTOMS_CO":"4004","CUSTOMS_NA":"景德镇关"},
  {"CUSTOMS_CO":"4005","CUSTOMS_NA":"吉安海关"},
  {"CUSTOMS_CO":"4006","CUSTOMS_NA":"昌北机场"},
  {"CUSTOMS_CO":"4007","CUSTOMS_NA":"青山湖关"},
  {"CUSTOMS_CO":"4008","CUSTOMS_NA":"龙南海关"},
  {"CUSTOMS_CO":"4009","CUSTOMS_NA":"新余海关"},
  {"CUSTOMS_CO":"4010","CUSTOMS_NA":"浔关区办"},
  {"CUSTOMS_CO":"4011","CUSTOMS_NA":"洪关区办"},
  {"CUSTOMS_CO":"4012","CUSTOMS_NA":"虔关区办"},
  {"CUSTOMS_CO":"4013","CUSTOMS_NA":"上饶海关"},
  {"CUSTOMS_CO":"4014","CUSTOMS_NA":"南昌物流"},
  {"CUSTOMS_CO":"4015","CUSTOMS_NA":"吉井加工"},
  {"CUSTOMS_CO":"4016","CUSTOMS_NA":"鹰潭海关"},
  {"CUSTOMS_CO":"4017","CUSTOMS_NA":"赣州综保"},
  {"CUSTOMS_CO":"4018","CUSTOMS_NA":"宜春海关"},
  {"CUSTOMS_CO":"4019","CUSTOMS_NA":"南昌综保"},
  {"CUSTOMS_CO":"4020","CUSTOMS_NA":"龙南物流"},
  {"CUSTOMS_CO":"4021","CUSTOMS_NA":"萍乡海关"},
  {"CUSTOMS_CO":"4022","CUSTOMS_NA":"抚州海关"},
  {"CUSTOMS_CO":"4023","CUSTOMS_NA":"九江综保"},
  {"CUSTOMS_CO":"4024","CUSTOMS_NA":"南昌快件"},
  {"CUSTOMS_CO":"4025","CUSTOMS_NA":"南昌邮件"},
  {"CUSTOMS_CO":"4200","CUSTOMS_NA":"青岛海关"},
  {"CUSTOMS_CO":"4201","CUSTOMS_NA":"烟台海关"},
  {"CUSTOMS_CO":"4202","CUSTOMS_NA":"日照海关"},
  {"CUSTOMS_CO":"4203","CUSTOMS_NA":"龙口海关"},
  {"CUSTOMS_CO":"4204","CUSTOMS_NA":"威海海关"},
  {"CUSTOMS_CO":"4205","CUSTOMS_NA":"济南海关"},
  {"CUSTOMS_CO":"4206","CUSTOMS_NA":"潍坊海关"},
  {"CUSTOMS_CO":"4207","CUSTOMS_NA":"淄博海关"},
  {"CUSTOMS_CO":"4208","CUSTOMS_NA":"烟加B区"},
  {"CUSTOMS_CO":"4209","CUSTOMS_NA":"荣成海关"},
  {"CUSTOMS_CO":"4210","CUSTOMS_NA":"青保税区"},
  {"CUSTOMS_CO":"4211","CUSTOMS_NA":"济宁海关"},
  {"CUSTOMS_CO":"4212","CUSTOMS_NA":"泰安海关"},
  {"CUSTOMS_CO":"4213","CUSTOMS_NA":"临沂海关"},
  {"CUSTOMS_CO":"4214","CUSTOMS_NA":"青前湾港"},
  {"CUSTOMS_CO":"4215","CUSTOMS_NA":"菏泽海关"},
  {"CUSTOMS_CO":"4216","CUSTOMS_NA":"东营海关"},
  {"CUSTOMS_CO":"4217","CUSTOMS_NA":"枣庄海关"},
  {"CUSTOMS_CO":"4218","CUSTOMS_NA":"青开发区"},
  {"CUSTOMS_CO":"4219","CUSTOMS_NA":"蓬莱海关"},
  {"CUSTOMS_CO":"4220","CUSTOMS_NA":"青机场关"},
  {"CUSTOMS_CO":"4221","CUSTOMS_NA":"烟机场办"},
  {"CUSTOMS_CO":"4222","CUSTOMS_NA":"莱州海关"},
  {"CUSTOMS_CO":"4223","CUSTOMS_NA":"青岛邮关"},
  {"CUSTOMS_CO":"4224","CUSTOMS_NA":"烟关长办"},
  {"CUSTOMS_CO":"4225","CUSTOMS_NA":"威海港办"},
  {"CUSTOMS_CO":"4226","CUSTOMS_NA":"青聊城办"},
  {"CUSTOMS_CO":"4227","CUSTOMS_NA":"青岛大港"},
  {"CUSTOMS_CO":"4228","CUSTOMS_NA":"烟关快件"},
  {"CUSTOMS_CO":"4229","CUSTOMS_NA":"德州海关"},
  {"CUSTOMS_CO":"4230","CUSTOMS_NA":"前湾保税"},
  {"CUSTOMS_CO":"4231","CUSTOMS_NA":"烟开发区"},
  {"CUSTOMS_CO":"4232","CUSTOMS_NA":"日岚山办"},
  {"CUSTOMS_CO":"4233","CUSTOMS_NA":"济机场办"},
  {"CUSTOMS_CO":"4234","CUSTOMS_NA":"济加工区"},
  {"CUSTOMS_CO":"4235","CUSTOMS_NA":"济邮局办"},
  {"CUSTOMS_CO":"4236","CUSTOMS_NA":"荣龙眼办"},
  {"CUSTOMS_CO":"4237","CUSTOMS_NA":"现场业务"},
  {"CUSTOMS_CO":"4238","CUSTOMS_NA":"威邮局办"},
  {"CUSTOMS_CO":"4239","CUSTOMS_NA":"潍诸城办"},
  {"CUSTOMS_CO":"4240","CUSTOMS_NA":"青关快件"},
  {"CUSTOMS_CO":"4241","CUSTOMS_NA":"烟加工区"},
  {"CUSTOMS_CO":"4242","CUSTOMS_NA":"威综保北"},
  {"CUSTOMS_CO":"4243","CUSTOMS_NA":"济曲阜办"},
  {"CUSTOMS_CO":"4244","CUSTOMS_NA":"青滨州办"},
  {"CUSTOMS_CO":"4245","CUSTOMS_NA":"烟台邮办"},
  {"CUSTOMS_CO":"4246","CUSTOMS_NA":"青胶综保"},
  {"CUSTOMS_CO":"4247","CUSTOMS_NA":"威机场办"},
  {"CUSTOMS_CO":"4248","CUSTOMS_NA":"青莱芜办"},
  {"CUSTOMS_CO":"4249","CUSTOMS_NA":"潍加工区"},
  {"CUSTOMS_CO":"4250","CUSTOMS_NA":"青西综区"},
  {"CUSTOMS_CO":"4251","CUSTOMS_NA":"淄博物流"},
  {"CUSTOMS_CO":"4253","CUSTOMS_NA":"日照物流"},
  {"CUSTOMS_CO":"4254","CUSTOMS_NA":"青岛物流"},
  {"CUSTOMS_CO":"4255","CUSTOMS_NA":"潍寿光办"},
  {"CUSTOMS_CO":"4256","CUSTOMS_NA":"威港快件"},
  {"CUSTOMS_CO":"4257","CUSTOMS_NA":"临综保区"},
  {"CUSTOMS_CO":"4258","CUSTOMS_NA":"前湾口岸"},
  {"CUSTOMS_CO":"4259","CUSTOMS_NA":"黄关快件"},
  {"CUSTOMS_CO":"4260","CUSTOMS_NA":"青港快件"},
  {"CUSTOMS_CO":"4261","CUSTOMS_NA":"烟港快件"},
  {"CUSTOMS_CO":"4262","CUSTOMS_NA":"威综保南"},
  {"CUSTOMS_CO":"4263","CUSTOMS_NA":"海阳海关"},
  {"CUSTOMS_CO":"4264","CUSTOMS_NA":"烟莱阳办"},
  {"CUSTOMS_CO":"4265","CUSTOMS_NA":"胶州海关"},
  {"CUSTOMS_CO":"4266","CUSTOMS_NA":"即墨海关"},
  {"CUSTOMS_CO":"4267","CUSTOMS_NA":"烟招远办"},
  {"CUSTOMS_CO":"4268","CUSTOMS_NA":"青董港关"},
  {"CUSTOMS_CO":"4269","CUSTOMS_NA":"石港快件"},
  {"CUSTOMS_CO":"4270","CUSTOMS_NA":"威文登办"},
  {"CUSTOMS_CO":"4271","CUSTOMS_NA":"日照综保"},
  {"CUSTOMS_CO":"4272","CUSTOMS_NA":"大港快件"},
  {"CUSTOMS_CO":"4273","CUSTOMS_NA":"即墨综保"},
  {"CUSTOMS_CO":"4274","CUSTOMS_NA":"烟福保B"},
  {"CUSTOMS_CO":"4275","CUSTOMS_NA":"烟芝罘办"},
  {"CUSTOMS_CO":"4277","CUSTOMS_NA":"青西保B"},
  {"CUSTOMS_CO":"4288","CUSTOMS_NA":"烟八角办"},
  {"CUSTOMS_CO":"4300","CUSTOMS_NA":"济南海关"},
  {"CUSTOMS_CO":"4301","CUSTOMS_NA":"泉城海关"},
  {"CUSTOMS_CO":"4302","CUSTOMS_NA":"济机场关"},
  {"CUSTOMS_CO":"4303","CUSTOMS_NA":"济综保区"},
  {"CUSTOMS_CO":"4305","CUSTOMS_NA":"济邮局关"},
  {"CUSTOMS_CO":"4306","CUSTOMS_NA":"章锦综保"},
  {"CUSTOMS_CO":"4310","CUSTOMS_NA":"潍坊海关"},
  {"CUSTOMS_CO":"4311","CUSTOMS_NA":"潍诸城办"},
  {"CUSTOMS_CO":"4312","CUSTOMS_NA":"潍综保区"},
  {"CUSTOMS_CO":"4313","CUSTOMS_NA":"潍寿光办"},
  {"CUSTOMS_CO":"4315","CUSTOMS_NA":"诸城物流"},
  {"CUSTOMS_CO":"4320","CUSTOMS_NA":"淄博海关"},
  {"CUSTOMS_CO":"4321","CUSTOMS_NA":"淄博物流"},
  {"CUSTOMS_CO":"4322","CUSTOMS_NA":"淄博综保"},
  {"CUSTOMS_CO":"4330","CUSTOMS_NA":"泰安海关"},
  {"CUSTOMS_CO":"4341","CUSTOMS_NA":"济机快件"},
  {"CUSTOMS_CO":"4342","CUSTOMS_NA":"济邮快件"},
  {"CUSTOMS_CO":"4350","CUSTOMS_NA":"东营海关"},
  {"CUSTOMS_CO":"4351","CUSTOMS_NA":"东营综保"},
  {"CUSTOMS_CO":"4360","CUSTOMS_NA":"聊城海关"},
  {"CUSTOMS_CO":"4370","CUSTOMS_NA":"德州海关"},
  {"CUSTOMS_CO":"4380","CUSTOMS_NA":"滨州海关"},
  {"CUSTOMS_CO":"4381","CUSTOMS_NA":"滨州物流"},
  {"CUSTOMS_CO":"4390","CUSTOMS_NA":"莱芜海关"},
  {"CUSTOMS_CO":"4600","CUSTOMS_NA":"郑州关区"},
  {"CUSTOMS_CO":"4601","CUSTOMS_NA":"金水海关"},
  {"CUSTOMS_CO":"4602","CUSTOMS_NA":"洛阳海关"},
  {"CUSTOMS_CO":"4603","CUSTOMS_NA":"南阳海关"},
  {"CUSTOMS_CO":"4604","CUSTOMS_NA":"郑机场关"},
  {"CUSTOMS_CO":"4605","CUSTOMS_NA":"郑邮局关"},
  {"CUSTOMS_CO":"4606","CUSTOMS_NA":"郑车站关"},
  {"CUSTOMS_CO":"4607","CUSTOMS_NA":"安阳海关"},
  {"CUSTOMS_CO":"4608","CUSTOMS_NA":"新区海关"},
  {"CUSTOMS_CO":"4609","CUSTOMS_NA":"商丘海关"},
  {"CUSTOMS_CO":"4610","CUSTOMS_NA":"周口海关"},
  {"CUSTOMS_CO":"4611","CUSTOMS_NA":"经开综保"},
  {"CUSTOMS_CO":"4612","CUSTOMS_NA":"新郑海关"},
  {"CUSTOMS_CO":"4613","CUSTOMS_NA":"郑州空港"},
  {"CUSTOMS_CO":"4614","CUSTOMS_NA":"焦作海关"},
  {"CUSTOMS_CO":"4615","CUSTOMS_NA":"三门峡关"},
  {"CUSTOMS_CO":"4616","CUSTOMS_NA":"新乡海关"},
  {"CUSTOMS_CO":"4617","CUSTOMS_NA":"信阳海关"},
  {"CUSTOMS_CO":"4618","CUSTOMS_NA":"鹤壁海关"},
  {"CUSTOMS_CO":"4619","CUSTOMS_NA":"德众物流"},
  {"CUSTOMS_CO":"4620","CUSTOMS_NA":"郑航空港"},
  {"CUSTOMS_CO":"4621","CUSTOMS_NA":"许昌海关"},
  {"CUSTOMS_CO":"4622","CUSTOMS_NA":"南阳综保"},
  {"CUSTOMS_CO":"4623","CUSTOMS_NA":"商丘物流"},
  {"CUSTOMS_CO":"4624","CUSTOMS_NA":"漯河海关"},
  {"CUSTOMS_CO":"4625","CUSTOMS_NA":"濮阳海关"},
  {"CUSTOMS_CO":"4626","CUSTOMS_NA":"民权办"},
  {"CUSTOMS_CO":"4627","CUSTOMS_NA":"民权保B"},
  {"CUSTOMS_CO":"4628","CUSTOMS_NA":"济源海关"},
  {"CUSTOMS_CO":"4629","CUSTOMS_NA":"驻马店海"},
  {"CUSTOMS_CO":"4630","CUSTOMS_NA":"平顶山海"},
  {"CUSTOMS_CO":"4631","CUSTOMS_NA":"开封海关"},
  {"CUSTOMS_CO":"4700","CUSTOMS_NA":"武汉海关"},
  {"CUSTOMS_CO":"4701","CUSTOMS_NA":"宜昌海关"},
  {"CUSTOMS_CO":"4702","CUSTOMS_NA":"荆州海关"},
  {"CUSTOMS_CO":"4703","CUSTOMS_NA":"襄阳海关"},
  {"CUSTOMS_CO":"4704","CUSTOMS_NA":"黄石海关"},
  {"CUSTOMS_CO":"4705","CUSTOMS_NA":"汉阳海关"},
  {"CUSTOMS_CO":"4706","CUSTOMS_NA":"宜三峡办"},
  {"CUSTOMS_CO":"4707","CUSTOMS_NA":"鄂加工区"},
  {"CUSTOMS_CO":"4708","CUSTOMS_NA":"现场一处"},
  {"CUSTOMS_CO":"4709","CUSTOMS_NA":"武江物流"},
  {"CUSTOMS_CO":"4710","CUSTOMS_NA":"武关货管"},
  {"CUSTOMS_CO":"4711","CUSTOMS_NA":"武关快件"},
  {"CUSTOMS_CO":"4712","CUSTOMS_NA":"武关机场"},
  {"CUSTOMS_CO":"4713","CUSTOMS_NA":"邮局海关"},
  {"CUSTOMS_CO":"4714","CUSTOMS_NA":"新港海关"},
  {"CUSTOMS_CO":"4715","CUSTOMS_NA":"汉口海关"},
  {"CUSTOMS_CO":"4716","CUSTOMS_NA":"十堰海关"},
  {"CUSTOMS_CO":"4718","CUSTOMS_NA":"武昌海关"},
  {"CUSTOMS_CO":"4719","CUSTOMS_NA":"东湖综保"},
  {"CUSTOMS_CO":"4720","CUSTOMS_NA":"黄石物流"},
  {"CUSTOMS_CO":"4721","CUSTOMS_NA":"仙桃海关"},
  {"CUSTOMS_CO":"4722","CUSTOMS_NA":"东湖陆港"},
  {"CUSTOMS_CO":"4723","CUSTOMS_NA":"宜昌物流"},
  {"CUSTOMS_CO":"4724","CUSTOMS_NA":"襄阳物流"},
  {"CUSTOMS_CO":"4725","CUSTOMS_NA":"空港综保"},
  {"CUSTOMS_CO":"4726","CUSTOMS_NA":"新港综保"},
  {"CUSTOMS_CO":"4727","CUSTOMS_NA":"荆门海关"},
  {"CUSTOMS_CO":"4728","CUSTOMS_NA":"鄂州海关"},
  {"CUSTOMS_CO":"4729","CUSTOMS_NA":"随州海关"},
  {"CUSTOMS_CO":"4730","CUSTOMS_NA":"恩施海关"},
  {"CUSTOMS_CO":"4731","CUSTOMS_NA":"经开综保"},
  {"CUSTOMS_CO":"4732","CUSTOMS_NA":"仙桃物流"},
  {"CUSTOMS_CO":"4733","CUSTOMS_NA":"荆门保B"},
  {"CUSTOMS_CO":"4734","CUSTOMS_NA":"宜昌综保"},
  {"CUSTOMS_CO":"4900","CUSTOMS_NA":"长沙关区"},
  {"CUSTOMS_CO":"4901","CUSTOMS_NA":"衡阳海关"},
  {"CUSTOMS_CO":"4902","CUSTOMS_NA":"岳阳海关"},
  {"CUSTOMS_CO":"4903","CUSTOMS_NA":"郴州海关"},
  {"CUSTOMS_CO":"4904","CUSTOMS_NA":"常德海关"},
  {"CUSTOMS_CO":"4905","CUSTOMS_NA":"星关霞办"},
  {"CUSTOMS_CO":"4906","CUSTOMS_NA":"株洲海关"},
  {"CUSTOMS_CO":"4907","CUSTOMS_NA":"韶山海关"},
  {"CUSTOMS_CO":"4908","CUSTOMS_NA":"湘机场关"},
  {"CUSTOMS_CO":"4909","CUSTOMS_NA":"株关醴办"},
  {"CUSTOMS_CO":"4910","CUSTOMS_NA":"郴州综保"},
  {"CUSTOMS_CO":"4911","CUSTOMS_NA":"永州海关"},
  {"CUSTOMS_CO":"4913","CUSTOMS_NA":"金霞物流"},
  {"CUSTOMS_CO":"4914","CUSTOMS_NA":"张家界关"},
  {"CUSTOMS_CO":"4915","CUSTOMS_NA":"衡阳综保"},
  {"CUSTOMS_CO":"4916","CUSTOMS_NA":"星沙海关"},
  {"CUSTOMS_CO":"4917","CUSTOMS_NA":"湘潭综保"},
  {"CUSTOMS_CO":"4918","CUSTOMS_NA":"星关浏办"},
  {"CUSTOMS_CO":"4919","CUSTOMS_NA":"岳阳综保"},
  {"CUSTOMS_CO":"4920","CUSTOMS_NA":"湘邮海关"},
  {"CUSTOMS_CO":"4921","CUSTOMS_NA":"黄花综保"},
  {"CUSTOMS_CO":"4922","CUSTOMS_NA":"株洲物流"},
  {"CUSTOMS_CO":"4923","CUSTOMS_NA":"邵阳海关"},
  {"CUSTOMS_CO":"4924","CUSTOMS_NA":"益阳海关"},
  {"CUSTOMS_CO":"4925","CUSTOMS_NA":"怀化海关"},
  {"CUSTOMS_CO":"4926","CUSTOMS_NA":"湘西海关"},
  {"CUSTOMS_CO":"4927","CUSTOMS_NA":"星关铁运"},
  {"CUSTOMS_CO":"4928","CUSTOMS_NA":"娄底海关"},
  {"CUSTOMS_CO":"5000","CUSTOMS_NA":"广东分署"},
  {"CUSTOMS_CO":"5100","CUSTOMS_NA":"广州海关"},
  {"CUSTOMS_CO":"5101","CUSTOMS_NA":"内港新风"},
  {"CUSTOMS_CO":"5102","CUSTOMS_NA":"越秀海关"},
  {"CUSTOMS_CO":"5103","CUSTOMS_NA":"清远海关"},
  {"CUSTOMS_CO":"5104","CUSTOMS_NA":"清远英德"},
  {"CUSTOMS_CO":"5105","CUSTOMS_NA":"天河保税"},
  {"CUSTOMS_CO":"5106","CUSTOMS_NA":"南沙散货"},
  {"CUSTOMS_CO":"5107","CUSTOMS_NA":"肇庆大旺"},
  {"CUSTOMS_CO":"5108","CUSTOMS_NA":"肇庆德庆"},
  {"CUSTOMS_CO":"5109","CUSTOMS_NA":"海珠滘心"},
  {"CUSTOMS_CO":"5110","CUSTOMS_NA":"南海海关"},
  {"CUSTOMS_CO":"5111","CUSTOMS_NA":"南海官窑"},
  {"CUSTOMS_CO":"5112","CUSTOMS_NA":"南海九江"},
  {"CUSTOMS_CO":"5113","CUSTOMS_NA":"南海北村"},
  {"CUSTOMS_CO":"5114","CUSTOMS_NA":"南海平洲"},
  {"CUSTOMS_CO":"5115","CUSTOMS_NA":"荔湾海关"},
  {"CUSTOMS_CO":"5116","CUSTOMS_NA":"南海业务"},
  {"CUSTOMS_CO":"5117","CUSTOMS_NA":"桂江车场"},
  {"CUSTOMS_CO":"5118","CUSTOMS_NA":"平洲旅检"},
  {"CUSTOMS_CO":"5119","CUSTOMS_NA":"南海三山"},
  {"CUSTOMS_CO":"5120","CUSTOMS_NA":"海珠海关"},
  {"CUSTOMS_CO":"5121","CUSTOMS_NA":"内港芳村"},
  {"CUSTOMS_CO":"5122","CUSTOMS_NA":"内港洲嘴"},
  {"CUSTOMS_CO":"5123","CUSTOMS_NA":"内港四仓"},
  {"CUSTOMS_CO":"5124","CUSTOMS_NA":"双东车场"},
  {"CUSTOMS_CO":"5125","CUSTOMS_NA":"从化海关"},
  {"CUSTOMS_CO":"5126","CUSTOMS_NA":"内港赤航"},
  {"CUSTOMS_CO":"5130","CUSTOMS_NA":"广州萝岗"},
  {"CUSTOMS_CO":"5131","CUSTOMS_NA":"花都海关"},
  {"CUSTOMS_CO":"5132","CUSTOMS_NA":"花都码头"},
  {"CUSTOMS_CO":"5133","CUSTOMS_NA":"穗知识城"},
  {"CUSTOMS_CO":"5134","CUSTOMS_NA":"穗保税处"},
  {"CUSTOMS_CO":"5135","CUSTOMS_NA":"天河海关"},
  {"CUSTOMS_CO":"5136","CUSTOMS_NA":"穗统计处"},
  {"CUSTOMS_CO":"5137","CUSTOMS_NA":"穗价格处"},
  {"CUSTOMS_CO":"5138","CUSTOMS_NA":"高明食出"},
  {"CUSTOMS_CO":"5139","CUSTOMS_NA":"穗监管处"},
  {"CUSTOMS_CO":"5140","CUSTOMS_NA":"穗关税处"},
  {"CUSTOMS_CO":"5141","CUSTOMS_NA":"广州机场"},
  {"CUSTOMS_CO":"5142","CUSTOMS_NA":"民航快件"},
  {"CUSTOMS_CO":"5143","CUSTOMS_NA":"广州车站"},
  {"CUSTOMS_CO":"5144","CUSTOMS_NA":"穗机综保"},
  {"CUSTOMS_CO":"5145","CUSTOMS_NA":"广州邮办"},
  {"CUSTOMS_CO":"5146","CUSTOMS_NA":"穗关会展"},
  {"CUSTOMS_CO":"5147","CUSTOMS_NA":"穗邮办监"},
  {"CUSTOMS_CO":"5148","CUSTOMS_NA":"穗大郎站"},
  {"CUSTOMS_CO":"5149","CUSTOMS_NA":"大铲海关"},
  {"CUSTOMS_CO":"5150","CUSTOMS_NA":"顺德海关"},
  {"CUSTOMS_CO":"5151","CUSTOMS_NA":"顺德保税"},
  {"CUSTOMS_CO":"5152","CUSTOMS_NA":"顺德食出"},
  {"CUSTOMS_CO":"5153","CUSTOMS_NA":"顺德车场"},
  {"CUSTOMS_CO":"5154","CUSTOMS_NA":"北窖车场"},
  {"CUSTOMS_CO":"5155","CUSTOMS_NA":"顺德旅检"},
  {"CUSTOMS_CO":"5157","CUSTOMS_NA":"陈村车场"},
  {"CUSTOMS_CO":"5158","CUSTOMS_NA":"顺德勒流"},
  {"CUSTOMS_CO":"5160","CUSTOMS_NA":"番禺海关"},
  {"CUSTOMS_CO":"5161","CUSTOMS_NA":"沙湾车场"},
  {"CUSTOMS_CO":"5162","CUSTOMS_NA":"番禺旅检"},
  {"CUSTOMS_CO":"5163","CUSTOMS_NA":"番禺货柜"},
  {"CUSTOMS_CO":"5164","CUSTOMS_NA":"番禺船舶"},
  {"CUSTOMS_CO":"5165","CUSTOMS_NA":"南沙保税"},
  {"CUSTOMS_CO":"5166","CUSTOMS_NA":"南沙新港"},
  {"CUSTOMS_CO":"5167","CUSTOMS_NA":"南沙货港"},
  {"CUSTOMS_CO":"5168","CUSTOMS_NA":"南沙汽车"},
  {"CUSTOMS_CO":"5169","CUSTOMS_NA":"南沙海关"},
  {"CUSTOMS_CO":"5170","CUSTOMS_NA":"肇庆海关"},
  {"CUSTOMS_CO":"5171","CUSTOMS_NA":"肇庆高要"},
  {"CUSTOMS_CO":"5172","CUSTOMS_NA":"肇庆车场"},
  {"CUSTOMS_CO":"5173","CUSTOMS_NA":"肇庆新港"},
  {"CUSTOMS_CO":"5174","CUSTOMS_NA":"肇庆旅检"},
  {"CUSTOMS_CO":"5175","CUSTOMS_NA":"肇庆码头"},
  {"CUSTOMS_CO":"5176","CUSTOMS_NA":"肇庆四会"},
  {"CUSTOMS_CO":"5177","CUSTOMS_NA":"肇庆三榕"},
  {"CUSTOMS_CO":"5178","CUSTOMS_NA":"云浮海关"},
  {"CUSTOMS_CO":"5179","CUSTOMS_NA":"罗定海关"},
  {"CUSTOMS_CO":"5180","CUSTOMS_NA":"佛山海关"},
  {"CUSTOMS_CO":"5181","CUSTOMS_NA":"高明海关"},
  {"CUSTOMS_CO":"5182","CUSTOMS_NA":"佛山澜石"},
  {"CUSTOMS_CO":"5183","CUSTOMS_NA":"三水码头"},
  {"CUSTOMS_CO":"5184","CUSTOMS_NA":"佛山窖口"},
  {"CUSTOMS_CO":"5185","CUSTOMS_NA":"佛山快件"},
  {"CUSTOMS_CO":"5186","CUSTOMS_NA":"佛山保税"},
  {"CUSTOMS_CO":"5187","CUSTOMS_NA":"佛山车场"},
  {"CUSTOMS_CO":"5188","CUSTOMS_NA":"佛山火车"},
  {"CUSTOMS_CO":"5189","CUSTOMS_NA":"佛山新港"},
  {"CUSTOMS_CO":"5190","CUSTOMS_NA":"韶关海关"},
  {"CUSTOMS_CO":"5191","CUSTOMS_NA":"韶关乐昌"},
  {"CUSTOMS_CO":"5192","CUSTOMS_NA":"三水海关"},
  {"CUSTOMS_CO":"5193","CUSTOMS_NA":"三水车场"},
  {"CUSTOMS_CO":"5194","CUSTOMS_NA":"三水港"},
  {"CUSTOMS_CO":"5195","CUSTOMS_NA":"审单中心"},
  {"CUSTOMS_CO":"5196","CUSTOMS_NA":"云浮新港"},
  {"CUSTOMS_CO":"5197","CUSTOMS_NA":"白云电商"},
  {"CUSTOMS_CO":"5198","CUSTOMS_NA":"穗河源关"},
  {"CUSTOMS_CO":"5199","CUSTOMS_NA":"穗技术处"},
  {"CUSTOMS_CO":"5200","CUSTOMS_NA":"黄埔关区"},
  {"CUSTOMS_CO":"5201","CUSTOMS_NA":"埔老港关"},
  {"CUSTOMS_CO":"5202","CUSTOMS_NA":"埔新港关"},
  {"CUSTOMS_CO":"5203","CUSTOMS_NA":"增城海关"},
  {"CUSTOMS_CO":"5204","CUSTOMS_NA":"东莞海关"},
  {"CUSTOMS_CO":"5205","CUSTOMS_NA":"太平海关"},
  {"CUSTOMS_CO":"5206","CUSTOMS_NA":"惠州海关"},
  {"CUSTOMS_CO":"5207","CUSTOMS_NA":"凤岗海关"},
  {"CUSTOMS_CO":"5208","CUSTOMS_NA":"穗东海关"},
  {"CUSTOMS_CO":"5209","CUSTOMS_NA":"埔东海关"},
  {"CUSTOMS_CO":"5210","CUSTOMS_NA":"埔红海办"},
  {"CUSTOMS_CO":"5211","CUSTOMS_NA":"河源海关"},
  {"CUSTOMS_CO":"5212","CUSTOMS_NA":"新沙海关"},
  {"CUSTOMS_CO":"5213","CUSTOMS_NA":"埔长安关"},
  {"CUSTOMS_CO":"5214","CUSTOMS_NA":"常平海关"},
  {"CUSTOMS_CO":"5216","CUSTOMS_NA":"沙田海关"},
  {"CUSTOMS_CO":"5217","CUSTOMS_NA":"寮步车场"},
  {"CUSTOMS_CO":"5218","CUSTOMS_NA":"江龙车场"},
  {"CUSTOMS_CO":"5219","CUSTOMS_NA":"埔物流园"},
  {"CUSTOMS_CO":"5220","CUSTOMS_NA":"东莞物流"},
  {"CUSTOMS_CO":"5221","CUSTOMS_NA":"埔荔城办"},
  {"CUSTOMS_CO":"5222","CUSTOMS_NA":"清溪物流"},
  {"CUSTOMS_CO":"5223","CUSTOMS_NA":"东莞邮办"},
  {"CUSTOMS_CO":"5224","CUSTOMS_NA":"萝岗海关"},
  {"CUSTOMS_CO":"5225","CUSTOMS_NA":"虎门综保"},
  {"CUSTOMS_CO":"5300","CUSTOMS_NA":"深圳海关"},
  {"CUSTOMS_CO":"5301","CUSTOMS_NA":"皇岗海关"},
  {"CUSTOMS_CO":"5302","CUSTOMS_NA":"罗湖海关"},
  {"CUSTOMS_CO":"5303","CUSTOMS_NA":"沙头角关"},
  {"CUSTOMS_CO":"5304","CUSTOMS_NA":"蛇口海关"},
  {"CUSTOMS_CO":"5305","CUSTOMS_NA":"福强海关"},
  {"CUSTOMS_CO":"5306","CUSTOMS_NA":"笋岗海关"},
  {"CUSTOMS_CO":"5307","CUSTOMS_NA":"南头海关"},
  {"CUSTOMS_CO":"5308","CUSTOMS_NA":"龙岗海关"},
  {"CUSTOMS_CO":"5309","CUSTOMS_NA":"布吉海关"},
  {"CUSTOMS_CO":"5310","CUSTOMS_NA":"淡水办"},
  {"CUSTOMS_CO":"5311","CUSTOMS_NA":"深关车站"},
  {"CUSTOMS_CO":"5312","CUSTOMS_NA":"深监管处"},
  {"CUSTOMS_CO":"5313","CUSTOMS_NA":"深调查局"},
  {"CUSTOMS_CO":"5314","CUSTOMS_NA":"深关邮局"},
  {"CUSTOMS_CO":"5315","CUSTOMS_NA":"惠东海关"},
  {"CUSTOMS_CO":"5316","CUSTOMS_NA":"大鹏海关"},
  {"CUSTOMS_CO":"5317","CUSTOMS_NA":"深机场关"},
  {"CUSTOMS_CO":"5318","CUSTOMS_NA":"梅林海关"},
  {"CUSTOMS_CO":"5319","CUSTOMS_NA":"同乐海关"},
  {"CUSTOMS_CO":"5320","CUSTOMS_NA":"文锦渡关"},
  {"CUSTOMS_CO":"5321","CUSTOMS_NA":"福田海关"},
  {"CUSTOMS_CO":"5322","CUSTOMS_NA":"沙保税关"},
  {"CUSTOMS_CO":"5323","CUSTOMS_NA":"深审单处"},
  {"CUSTOMS_CO":"5324","CUSTOMS_NA":"深审价办"},
  {"CUSTOMS_CO":"5325","CUSTOMS_NA":"深关税处"},
  {"CUSTOMS_CO":"5326","CUSTOMS_NA":"深数统处"},
  {"CUSTOMS_CO":"5327","CUSTOMS_NA":"深法规处"},
  {"CUSTOMS_CO":"5328","CUSTOMS_NA":"深规范处"},
  {"CUSTOMS_CO":"5329","CUSTOMS_NA":"深保税处"},
  {"CUSTOMS_CO":"5330","CUSTOMS_NA":"盐保税关"},
  {"CUSTOMS_CO":"5331","CUSTOMS_NA":"三门岛办"},
  {"CUSTOMS_CO":"5332","CUSTOMS_NA":"深财务处"},
  {"CUSTOMS_CO":"5333","CUSTOMS_NA":"深侦查局"},
  {"CUSTOMS_CO":"5334","CUSTOMS_NA":"深稽查处"},
  {"CUSTOMS_CO":"5335","CUSTOMS_NA":"深技术处"},
  {"CUSTOMS_CO":"5336","CUSTOMS_NA":"深办公室"},
  {"CUSTOMS_CO":"5337","CUSTOMS_NA":"大亚湾核"},
  {"CUSTOMS_CO":"5338","CUSTOMS_NA":"惠州港关"},
  {"CUSTOMS_CO":"5339","CUSTOMS_NA":"坪山海关"},
  {"CUSTOMS_CO":"5340","CUSTOMS_NA":"沙湾海关"},
  {"CUSTOMS_CO":"5341","CUSTOMS_NA":"深惠州关"},
  {"CUSTOMS_CO":"5342","CUSTOMS_NA":"深红海办"},
  {"CUSTOMS_CO":"5343","CUSTOMS_NA":"深盐物流"},
  {"CUSTOMS_CO":"5344","CUSTOMS_NA":"惠石化办"},
  {"CUSTOMS_CO":"5345","CUSTOMS_NA":"深圳湾关"},
  {"CUSTOMS_CO":"5346","CUSTOMS_NA":"深机快件"},
  {"CUSTOMS_CO":"5348","CUSTOMS_NA":"深关大铲"},
  {"CUSTOMS_CO":"5349","CUSTOMS_NA":"前海港区"},
  {"CUSTOMS_CO":"5350","CUSTOMS_NA":"大运通关"},
  {"CUSTOMS_CO":"5351","CUSTOMS_NA":"前海保税"},
  {"CUSTOMS_CO":"5352","CUSTOMS_NA":"梅沙海关"},
  {"CUSTOMS_CO":"5353","CUSTOMS_NA":"西九龙关"},
  {"CUSTOMS_CO":"5354","CUSTOMS_NA":"莲塘海关"},
  {"CUSTOMS_CO":"5355","CUSTOMS_NA":"福中海关"},
  {"CUSTOMS_CO":"5356","CUSTOMS_NA":"前海海关"},
  {"CUSTOMS_CO":"5357","CUSTOMS_NA":"观澜海关"},
  {"CUSTOMS_CO":"5358","CUSTOMS_NA":"西沥海关"},
  {"CUSTOMS_CO":"5700","CUSTOMS_NA":"拱北关区"},
  {"CUSTOMS_CO":"5701","CUSTOMS_NA":"拱稽查处"},
  {"CUSTOMS_CO":"5710","CUSTOMS_NA":"闸口海关"},
  {"CUSTOMS_CO":"5720","CUSTOMS_NA":"中山海关"},
  {"CUSTOMS_CO":"5721","CUSTOMS_NA":"中山港"},
  {"CUSTOMS_CO":"5724","CUSTOMS_NA":"中石岐办"},
  {"CUSTOMS_CO":"5725","CUSTOMS_NA":"坦洲货场"},
  {"CUSTOMS_CO":"5726","CUSTOMS_NA":"中山物流"},
  {"CUSTOMS_CO":"5727","CUSTOMS_NA":"小榄港"},
  {"CUSTOMS_CO":"5728","CUSTOMS_NA":"神湾港"},
  {"CUSTOMS_CO":"5729","CUSTOMS_NA":"中山快件"},
  {"CUSTOMS_CO":"5730","CUSTOMS_NA":"香洲海关"},
  {"CUSTOMS_CO":"5740","CUSTOMS_NA":"湾仔海关"},
  {"CUSTOMS_CO":"5741","CUSTOMS_NA":"湾仔船舶"},
  {"CUSTOMS_CO":"5750","CUSTOMS_NA":"九洲海关"},
  {"CUSTOMS_CO":"5760","CUSTOMS_NA":"拱白石办"},
  {"CUSTOMS_CO":"5770","CUSTOMS_NA":"斗门海关"},
  {"CUSTOMS_CO":"5771","CUSTOMS_NA":"斗井岸办"},
  {"CUSTOMS_CO":"5772","CUSTOMS_NA":"斗平沙办"},
  {"CUSTOMS_CO":"5780","CUSTOMS_NA":"高栏海关"},
  {"CUSTOMS_CO":"5782","CUSTOMS_NA":"宏达码头"},
  {"CUSTOMS_CO":"5788","CUSTOMS_NA":"大桥海关"},
  {"CUSTOMS_CO":"5790","CUSTOMS_NA":"拱监管处"},
  {"CUSTOMS_CO":"5791","CUSTOMS_NA":"拱跨工区"},
  {"CUSTOMS_CO":"5792","CUSTOMS_NA":"拱保税区"},
  {"CUSTOMS_CO":"5793","CUSTOMS_NA":"万山海关"},
  {"CUSTOMS_CO":"5794","CUSTOMS_NA":"桂山中途"},
  {"CUSTOMS_CO":"5795","CUSTOMS_NA":"横琴海关"},
  {"CUSTOMS_CO":"5796","CUSTOMS_NA":"澳大校区"},
  {"CUSTOMS_CO":"5798","CUSTOMS_NA":"拱关邮检"},
  {"CUSTOMS_CO":"5799","CUSTOMS_NA":"南屏快件"},
  {"CUSTOMS_CO":"6000","CUSTOMS_NA":"汕头海关"},
  {"CUSTOMS_CO":"6001","CUSTOMS_NA":"汕关货一"},
  {"CUSTOMS_CO":"6002","CUSTOMS_NA":"汕关货二"},
  {"CUSTOMS_CO":"6003","CUSTOMS_NA":"汕关行邮"},
  {"CUSTOMS_CO":"6004","CUSTOMS_NA":"潮汕机场"},
  {"CUSTOMS_CO":"6006","CUSTOMS_NA":"汕关保税"},
  {"CUSTOMS_CO":"6007","CUSTOMS_NA":"汕关业务"},
  {"CUSTOMS_CO":"6008","CUSTOMS_NA":"濠江海关"},
  {"CUSTOMS_CO":"6009","CUSTOMS_NA":"汕关邮包"},
  {"CUSTOMS_CO":"6010","CUSTOMS_NA":"汕保物流"},
  {"CUSTOMS_CO":"6011","CUSTOMS_NA":"揭阳海关"},
  {"CUSTOMS_CO":"6012","CUSTOMS_NA":"普宁海关"},
  {"CUSTOMS_CO":"6013","CUSTOMS_NA":"澄海海关"},
  {"CUSTOMS_CO":"6014","CUSTOMS_NA":"广澳海关"},
  {"CUSTOMS_CO":"6015","CUSTOMS_NA":"南澳海关"},
  {"CUSTOMS_CO":"6016","CUSTOMS_NA":"濠江现场"},
  {"CUSTOMS_CO":"6018","CUSTOMS_NA":"揭关惠来"},
  {"CUSTOMS_CO":"6019","CUSTOMS_NA":"龙湖海关"},
  {"CUSTOMS_CO":"6020","CUSTOMS_NA":"汕港海关"},
  {"CUSTOMS_CO":"6021","CUSTOMS_NA":"潮州海关"},
  {"CUSTOMS_CO":"6022","CUSTOMS_NA":"饶平海关"},
  {"CUSTOMS_CO":"6023","CUSTOMS_NA":"饶平快件"},
  {"CUSTOMS_CO":"6026","CUSTOMS_NA":"汕头综保"},
  {"CUSTOMS_CO":"6028","CUSTOMS_NA":"潮阳海关"},
  {"CUSTOMS_CO":"6031","CUSTOMS_NA":"汕尾海关"},
  {"CUSTOMS_CO":"6032","CUSTOMS_NA":"海城海关"},
  {"CUSTOMS_CO":"6033","CUSTOMS_NA":"尾关陆丰"},
  {"CUSTOMS_CO":"6038","CUSTOMS_NA":"汕关快件"},
  {"CUSTOMS_CO":"6041","CUSTOMS_NA":"梅州海关"},
  {"CUSTOMS_CO":"6042","CUSTOMS_NA":"梅州兴宁"},
  {"CUSTOMS_CO":"6046","CUSTOMS_NA":"梅州综保"},
  {"CUSTOMS_CO":"6400","CUSTOMS_NA":"海口关区"},
  {"CUSTOMS_CO":"6401","CUSTOMS_NA":"海口港"},
  {"CUSTOMS_CO":"6402","CUSTOMS_NA":"三亚海关"},
  {"CUSTOMS_CO":"6403","CUSTOMS_NA":"八所海关"},
  {"CUSTOMS_CO":"6404","CUSTOMS_NA":"洋浦区关"},
  {"CUSTOMS_CO":"6405","CUSTOMS_NA":"海保税区"},
  {"CUSTOMS_CO":"6406","CUSTOMS_NA":"文昌海关"},
  {"CUSTOMS_CO":"6407","CUSTOMS_NA":"美兰机场"},
  {"CUSTOMS_CO":"6408","CUSTOMS_NA":"洋浦港"},
  {"CUSTOMS_CO":"6409","CUSTOMS_NA":"海口综保"},
  {"CUSTOMS_CO":"6410","CUSTOMS_NA":"马村港"},
  {"CUSTOMS_CO":"6411","CUSTOMS_NA":"椰城海关"},
  {"CUSTOMS_CO":"6412","CUSTOMS_NA":"三沙海关"},
  {"CUSTOMS_CO":"6413","CUSTOMS_NA":"博鳌机场"},
  {"CUSTOMS_CO":"6700","CUSTOMS_NA":"湛江关区"},
  {"CUSTOMS_CO":"6701","CUSTOMS_NA":"湛江海关"},
  {"CUSTOMS_CO":"6702","CUSTOMS_NA":"茂名海关"},
  {"CUSTOMS_CO":"6703","CUSTOMS_NA":"徐闻海关"},
  {"CUSTOMS_CO":"6704","CUSTOMS_NA":"海东海关"},
  {"CUSTOMS_CO":"6705","CUSTOMS_NA":"茂名水东"},
  {"CUSTOMS_CO":"6706","CUSTOMS_NA":"湛江吴川"},
  {"CUSTOMS_CO":"6707","CUSTOMS_NA":"廉江海关"},
  {"CUSTOMS_CO":"6708","CUSTOMS_NA":"茂名高州"},
  {"CUSTOMS_CO":"6709","CUSTOMS_NA":"茂名信宜"},
  {"CUSTOMS_CO":"6710","CUSTOMS_NA":"东海岛关"},
  {"CUSTOMS_CO":"6711","CUSTOMS_NA":"霞山海关"},
  {"CUSTOMS_CO":"6712","CUSTOMS_NA":"霞海海关"},
  {"CUSTOMS_CO":"6713","CUSTOMS_NA":"湛江机场"},
  {"CUSTOMS_CO":"6714","CUSTOMS_NA":"湛江博贺"},
  {"CUSTOMS_CO":"6715","CUSTOMS_NA":"湛江快件"},
  {"CUSTOMS_CO":"6716","CUSTOMS_NA":"湛江物流"},
  {"CUSTOMS_CO":"6717","CUSTOMS_NA":"湛江调顺"},
  {"CUSTOMS_CO":"6718","CUSTOMS_NA":"湛江遂溪"},
  {"CUSTOMS_CO":"6800","CUSTOMS_NA":"江门关区"},
  {"CUSTOMS_CO":"6810","CUSTOMS_NA":"江门海关"},
  {"CUSTOMS_CO":"6811","CUSTOMS_NA":"高沙海关"},
  {"CUSTOMS_CO":"6812","CUSTOMS_NA":"外海海关"},
  {"CUSTOMS_CO":"6813","CUSTOMS_NA":"江门旅检"},
  {"CUSTOMS_CO":"6815","CUSTOMS_NA":"外海电商"},
  {"CUSTOMS_CO":"6816","CUSTOMS_NA":"江门车场"},
  {"CUSTOMS_CO":"6817","CUSTOMS_NA":"江门保税"},
  {"CUSTOMS_CO":"6820","CUSTOMS_NA":"新会海关"},
  {"CUSTOMS_CO":"6821","CUSTOMS_NA":"新会港"},
  {"CUSTOMS_CO":"6827","CUSTOMS_NA":"新会稽查"},
  {"CUSTOMS_CO":"6830","CUSTOMS_NA":"台山海关"},
  {"CUSTOMS_CO":"6831","CUSTOMS_NA":"台公益港"},
  {"CUSTOMS_CO":"6837","CUSTOMS_NA":"台山稽查"},
  {"CUSTOMS_CO":"6840","CUSTOMS_NA":"开平海关"},
  {"CUSTOMS_CO":"6841","CUSTOMS_NA":"开平码头"},
  {"CUSTOMS_CO":"6847","CUSTOMS_NA":"开平电商"},
  {"CUSTOMS_CO":"6850","CUSTOMS_NA":"恩平海关"},
  {"CUSTOMS_CO":"6851","CUSTOMS_NA":"恩平港"},
  {"CUSTOMS_CO":"6857","CUSTOMS_NA":"恩平稽查"},
  {"CUSTOMS_CO":"6860","CUSTOMS_NA":"鹤山海关"},
  {"CUSTOMS_CO":"6861","CUSTOMS_NA":"鹤山码头"},
  {"CUSTOMS_CO":"6866","CUSTOMS_NA":"南方电商"},
  {"CUSTOMS_CO":"6867","CUSTOMS_NA":"鹤松电商"},
  {"CUSTOMS_CO":"6870","CUSTOMS_NA":"阳江海关"},
  {"CUSTOMS_CO":"6871","CUSTOMS_NA":"阳江港"},
  {"CUSTOMS_CO":"6872","CUSTOMS_NA":"阳江车场"},
  {"CUSTOMS_CO":"6877","CUSTOMS_NA":"阳江稽查"},
  {"CUSTOMS_CO":"7200","CUSTOMS_NA":"南宁关区"},
  {"CUSTOMS_CO":"7201","CUSTOMS_NA":"邕州海关"},
  {"CUSTOMS_CO":"7202","CUSTOMS_NA":"北海海关"},
  {"CUSTOMS_CO":"7203","CUSTOMS_NA":"梧州海关"},
  {"CUSTOMS_CO":"7204","CUSTOMS_NA":"桂林海关"},
  {"CUSTOMS_CO":"7205","CUSTOMS_NA":"柳州海关"},
  {"CUSTOMS_CO":"7206","CUSTOMS_NA":"防城海关"},
  {"CUSTOMS_CO":"7207","CUSTOMS_NA":"东兴海关"},
  {"CUSTOMS_CO":"7208","CUSTOMS_NA":"凭祥海关"},
  {"CUSTOMS_CO":"7209","CUSTOMS_NA":"贵港海关"},
  {"CUSTOMS_CO":"7210","CUSTOMS_NA":"水口海关"},
  {"CUSTOMS_CO":"7211","CUSTOMS_NA":"龙邦海关"},
  {"CUSTOMS_CO":"7212","CUSTOMS_NA":"钦州海关"},
  {"CUSTOMS_CO":"7213","CUSTOMS_NA":"桂林机办"},
  {"CUSTOMS_CO":"7214","CUSTOMS_NA":"北海综保"},
  {"CUSTOMS_CO":"7215","CUSTOMS_NA":"南关钦保"},
  {"CUSTOMS_CO":"7216","CUSTOMS_NA":"南宁综保"},
  {"CUSTOMS_CO":"7217","CUSTOMS_NA":"钦州港关"},
  {"CUSTOMS_CO":"7218","CUSTOMS_NA":"玉林海关"},
  {"CUSTOMS_CO":"7219","CUSTOMS_NA":"南凭综保"},
  {"CUSTOMS_CO":"7220","CUSTOMS_NA":"友谊关"},
  {"CUSTOMS_CO":"7221","CUSTOMS_NA":"邕机场关"},
  {"CUSTOMS_CO":"7222","CUSTOMS_NA":"邕邮局关"},
  {"CUSTOMS_CO":"7223","CUSTOMS_NA":"贺州海关"},
  {"CUSTOMS_CO":"7224","CUSTOMS_NA":"河池海关"},
  {"CUSTOMS_CO":"7225","CUSTOMS_NA":"爱店海关"},
  {"CUSTOMS_CO":"7226","CUSTOMS_NA":"峒中海关"},
  {"CUSTOMS_CO":"7227","CUSTOMS_NA":"防港保B"},
  {"CUSTOMS_CO":"7228","CUSTOMS_NA":"硕龙海关"},
  {"CUSTOMS_CO":"7229","CUSTOMS_NA":"平孟海关"},
  {"CUSTOMS_CO":"7230","CUSTOMS_NA":"柳州保B"},
  {"CUSTOMS_CO":"7900","CUSTOMS_NA":"成都关区"},
  {"CUSTOMS_CO":"7901","CUSTOMS_NA":"蓉青关"},
  {"CUSTOMS_CO":"7902","CUSTOMS_NA":"蓉机双流"},
  {"CUSTOMS_CO":"7903","CUSTOMS_NA":"蓉乐关"},
  {"CUSTOMS_CO":"7904","CUSTOMS_NA":"蓉攀关"},
  {"CUSTOMS_CO":"7905","CUSTOMS_NA":"蓉绵关"},
  {"CUSTOMS_CO":"7906","CUSTOMS_NA":"蓉邮关"},
  {"CUSTOMS_CO":"7907","CUSTOMS_NA":"蓉盐关"},
  {"CUSTOMS_CO":"7908","CUSTOMS_NA":"蓉内关"},
  {"CUSTOMS_CO":"7909","CUSTOMS_NA":"公路场站"},
  {"CUSTOMS_CO":"7910","CUSTOMS_NA":"蓉机快件"},
  {"CUSTOMS_CO":"7911","CUSTOMS_NA":"蓉泸关"},
  {"CUSTOMS_CO":"7912","CUSTOMS_NA":"蓉戎关"},
  {"CUSTOMS_CO":"7913","CUSTOMS_NA":"蓉南关"},
  {"CUSTOMS_CO":"7914","CUSTOMS_NA":"蓉绵加工"},
  {"CUSTOMS_CO":"7915","CUSTOMS_NA":"蓉锦关"},
  {"CUSTOMS_CO":"7916","CUSTOMS_NA":"蓉锦西区"},
  {"CUSTOMS_CO":"7917","CUSTOMS_NA":"蓉遂关"},
  {"CUSTOMS_CO":"7918","CUSTOMS_NA":"蓉旌关"},
  {"CUSTOMS_CO":"7919","CUSTOMS_NA":"蓉通关"},
  {"CUSTOMS_CO":"7920","CUSTOMS_NA":"蓉机保B"},
  {"CUSTOMS_CO":"7921","CUSTOMS_NA":"蓉泸保B"},
  {"CUSTOMS_CO":"7922","CUSTOMS_NA":"蓉锦双流"},
  {"CUSTOMS_CO":"7923","CUSTOMS_NA":"蓉戎保B"},
  {"CUSTOMS_CO":"7924","CUSTOMS_NA":"蓉青保B"},
  {"CUSTOMS_CO":"7925","CUSTOMS_NA":"蓉新关"},
  {"CUSTOMS_CO":"7926","CUSTOMS_NA":"蓉利关"},
  {"CUSTOMS_CO":"7927","CUSTOMS_NA":"蓉新物流"},
  {"CUSTOMS_CO":"7928","CUSTOMS_NA":"蓉青综保"},
  {"CUSTOMS_CO":"7929","CUSTOMS_NA":"蓉泸综保"},
  {"CUSTOMS_CO":"7930","CUSTOMS_NA":"蓉戎综保"},
  {"CUSTOMS_CO":"7931","CUSTOMS_NA":"蓉锦综保"},
  {"CUSTOMS_CO":"7932","CUSTOMS_NA":"蓉绵综保"},
  {"CUSTOMS_CO":"7933","CUSTOMS_NA":"蓉南保B"},
  {"CUSTOMS_CO":"7934","CUSTOMS_NA":"蓉賨关"},
  {"CUSTOMS_CO":"8000","CUSTOMS_NA":"重庆关区"},
  {"CUSTOMS_CO":"8001","CUSTOMS_NA":"重庆海关"},
  {"CUSTOMS_CO":"8002","CUSTOMS_NA":"两江海关"},
  {"CUSTOMS_CO":"8003","CUSTOMS_NA":"重庆机场"},
  {"CUSTOMS_CO":"8004","CUSTOMS_NA":"重庆邮局"},
  {"CUSTOMS_CO":"8005","CUSTOMS_NA":"万州海关"},
  {"CUSTOMS_CO":"8006","CUSTOMS_NA":"渝州海关"},
  {"CUSTOMS_CO":"8007","CUSTOMS_NA":"重庆水港"},
  {"CUSTOMS_CO":"8008","CUSTOMS_NA":"渝加工区"},
  {"CUSTOMS_CO":"8009","CUSTOMS_NA":"涪陵海关"},
  {"CUSTOMS_CO":"8010","CUSTOMS_NA":"寸滩水港"},
  {"CUSTOMS_CO":"8011","CUSTOMS_NA":"渝关快件"},
  {"CUSTOMS_CO":"8012","CUSTOMS_NA":"两寸海关"},
  {"CUSTOMS_CO":"8013","CUSTOMS_NA":"西永综保"},
  {"CUSTOMS_CO":"8014","CUSTOMS_NA":"西永海关"},
  {"CUSTOMS_CO":"8015","CUSTOMS_NA":"渝贸园区"},
  {"CUSTOMS_CO":"8016","CUSTOMS_NA":"渝铁物流"},
  {"CUSTOMS_CO":"8017","CUSTOMS_NA":"渝公物流"},
  {"CUSTOMS_CO":"8018","CUSTOMS_NA":"黔江海关"},
  {"CUSTOMS_CO":"8019","CUSTOMS_NA":"江津综保"},
  {"CUSTOMS_CO":"8020","CUSTOMS_NA":"永川海关"},
  {"CUSTOMS_CO":"8021","CUSTOMS_NA":"涪陵综保"},
  {"CUSTOMS_CO":"8022","CUSTOMS_NA":"果园保B"},
  {"CUSTOMS_CO":"8300","CUSTOMS_NA":"贵阳海关"},
  {"CUSTOMS_CO":"8301","CUSTOMS_NA":"筑城海关"},
  {"CUSTOMS_CO":"8302","CUSTOMS_NA":"黔机场关"},
  {"CUSTOMS_CO":"8303","CUSTOMS_NA":"遵义海关"},
  {"CUSTOMS_CO":"8304","CUSTOMS_NA":"贵阳综保"},
  {"CUSTOMS_CO":"8305","CUSTOMS_NA":"贵阳现场"},
  {"CUSTOMS_CO":"8306","CUSTOMS_NA":"贵安综保"},
  {"CUSTOMS_CO":"8307","CUSTOMS_NA":"贵安海关"},
  {"CUSTOMS_CO":"8308","CUSTOMS_NA":"六盘水关"},
  {"CUSTOMS_CO":"8309","CUSTOMS_NA":"遵义综保"},
  {"CUSTOMS_CO":"8310","CUSTOMS_NA":"凯里海关"},
  {"CUSTOMS_CO":"8311","CUSTOMS_NA":"毕节海关"},
  {"CUSTOMS_CO":"8312","CUSTOMS_NA":"兴义海关"},
  {"CUSTOMS_CO":"8313","CUSTOMS_NA":"铜仁海关"},
  {"CUSTOMS_CO":"8600","CUSTOMS_NA":"昆明关区"},
  {"CUSTOMS_CO":"8601","CUSTOMS_NA":"滇中海关"},
  {"CUSTOMS_CO":"8602","CUSTOMS_NA":"畹町海关"},
  {"CUSTOMS_CO":"8603","CUSTOMS_NA":"瑞丽海关"},
  {"CUSTOMS_CO":"8604","CUSTOMS_NA":"章凤海关"},
  {"CUSTOMS_CO":"8605","CUSTOMS_NA":"盈江海关"},
  {"CUSTOMS_CO":"8606","CUSTOMS_NA":"孟连海关"},
  {"CUSTOMS_CO":"8607","CUSTOMS_NA":"南伞海关"},
  {"CUSTOMS_CO":"8608","CUSTOMS_NA":"孟定海关"},
  {"CUSTOMS_CO":"8609","CUSTOMS_NA":"打洛海关"},
  {"CUSTOMS_CO":"8610","CUSTOMS_NA":"腾冲海关"},
  {"CUSTOMS_CO":"8611","CUSTOMS_NA":"沧源海关"},
  {"CUSTOMS_CO":"8612","CUSTOMS_NA":"勐腊海关"},
  {"CUSTOMS_CO":"8613","CUSTOMS_NA":"河口海关"},
  {"CUSTOMS_CO":"8614","CUSTOMS_NA":"金水河关"},
  {"CUSTOMS_CO":"8615","CUSTOMS_NA":"天保海关"},
  {"CUSTOMS_CO":"8616","CUSTOMS_NA":"田蓬海关"},
  {"CUSTOMS_CO":"8617","CUSTOMS_NA":"大理海关"},
  {"CUSTOMS_CO":"8618","CUSTOMS_NA":"芒市海关"},
  {"CUSTOMS_CO":"8619","CUSTOMS_NA":"腾驻隆阳"},
  {"CUSTOMS_CO":"8620","CUSTOMS_NA":"昆明机场"},
  {"CUSTOMS_CO":"8621","CUSTOMS_NA":"邮局海关"},
  {"CUSTOMS_CO":"8622","CUSTOMS_NA":"西双版纳"},
  {"CUSTOMS_CO":"8623","CUSTOMS_NA":"丽江海关"},
  {"CUSTOMS_CO":"8624","CUSTOMS_NA":"思茅海关"},
  {"CUSTOMS_CO":"8625","CUSTOMS_NA":"河口山腰"},
  {"CUSTOMS_CO":"8626","CUSTOMS_NA":"怒江海关"},
  {"CUSTOMS_CO":"8627","CUSTOMS_NA":"昆明高新"},
  {"CUSTOMS_CO":"8628","CUSTOMS_NA":"昆明加工"},
  {"CUSTOMS_CO":"8629","CUSTOMS_NA":"香格里拉"},
  {"CUSTOMS_CO":"8631","CUSTOMS_NA":"勐康海关"},
  {"CUSTOMS_CO":"8632","CUSTOMS_NA":"昆明快件"},
  {"CUSTOMS_CO":"8633","CUSTOMS_NA":"红河综保"},
  {"CUSTOMS_CO":"8634","CUSTOMS_NA":"昆明综保"},
  {"CUSTOMS_CO":"8635","CUSTOMS_NA":"昆综口岸"},
  {"CUSTOMS_CO":"8636","CUSTOMS_NA":"高新物流"},
  {"CUSTOMS_CO":"8637","CUSTOMS_NA":"红综口岸"},
  {"CUSTOMS_CO":"8638","CUSTOMS_NA":"磨憨快件"},
  {"CUSTOMS_CO":"8639","CUSTOMS_NA":"机场电商"},
  {"CUSTOMS_CO":"8640","CUSTOMS_NA":"腾俊物流"},
  {"CUSTOMS_CO":"8641","CUSTOMS_NA":"都龙海关"},
  {"CUSTOMS_CO":"8642","CUSTOMS_NA":"瑞驻姐告"},
  {"CUSTOMS_CO":"8643","CUSTOMS_NA":"瑞驻弄岛"},
  {"CUSTOMS_CO":"8644","CUSTOMS_NA":"孟驻临翔"},
  {"CUSTOMS_CO":"8645","CUSTOMS_NA":"西驻关累"},
  {"CUSTOMS_CO":"8646","CUSTOMS_NA":"蒙自海关"},
  {"CUSTOMS_CO":"8647","CUSTOMS_NA":"曲靖海关"},
  {"CUSTOMS_CO":"8648","CUSTOMS_NA":"玉溪海关"},
  {"CUSTOMS_CO":"8800","CUSTOMS_NA":"拉萨海关"},
  {"CUSTOMS_CO":"8801","CUSTOMS_NA":"聂拉木关"},
  {"CUSTOMS_CO":"8802","CUSTOMS_NA":"日喀则关"},
  {"CUSTOMS_CO":"8803","CUSTOMS_NA":"狮泉河关"},
  {"CUSTOMS_CO":"8804","CUSTOMS_NA":"机场海关"},
  {"CUSTOMS_CO":"8805","CUSTOMS_NA":"八廓海关"},
  {"CUSTOMS_CO":"8806","CUSTOMS_NA":"普兰海关"},
  {"CUSTOMS_CO":"8807","CUSTOMS_NA":"亚东海关"},
  {"CUSTOMS_CO":"8808","CUSTOMS_NA":"吉隆海关"},
  {"CUSTOMS_CO":"8809","CUSTOMS_NA":"林芝海关"},
  {"CUSTOMS_CO":"8810","CUSTOMS_NA":"拉萨综保"},
  {"CUSTOMS_CO":"9000","CUSTOMS_NA":"西安关区"},
  {"CUSTOMS_CO":"9001","CUSTOMS_NA":"关中海关"},
  {"CUSTOMS_CO":"9002","CUSTOMS_NA":"咸阳机场"},
  {"CUSTOMS_CO":"9003","CUSTOMS_NA":"宝鸡海关"},
  {"CUSTOMS_CO":"9004","CUSTOMS_NA":"邮局海关"},
  {"CUSTOMS_CO":"9005","CUSTOMS_NA":"陕加工A"},
  {"CUSTOMS_CO":"9006","CUSTOMS_NA":"陕加工B"},
  {"CUSTOMS_CO":"9007","CUSTOMS_NA":"西安综保"},
  {"CUSTOMS_CO":"9008","CUSTOMS_NA":"高新综保"},
  {"CUSTOMS_CO":"9009","CUSTOMS_NA":"车站海关"},
  {"CUSTOMS_CO":"9010","CUSTOMS_NA":"延安海关"},
  {"CUSTOMS_CO":"9011","CUSTOMS_NA":"渭南海关"},
  {"CUSTOMS_CO":"9012","CUSTOMS_NA":"榆林海关"},
  {"CUSTOMS_CO":"9013","CUSTOMS_NA":"西咸物流"},
  {"CUSTOMS_CO":"9014","CUSTOMS_NA":"汉中海关"},
  {"CUSTOMS_CO":"9015","CUSTOMS_NA":"商洛海关"},
  {"CUSTOMS_CO":"9016","CUSTOMS_NA":"航空综保"},
  {"CUSTOMS_CO":"9017","CUSTOMS_NA":"宝鸡综保"},
  {"CUSTOMS_CO":"9400","CUSTOMS_NA":"乌关区"},
  {"CUSTOMS_CO":"9401","CUSTOMS_NA":"乌昌公路"},
  {"CUSTOMS_CO":"9402","CUSTOMS_NA":"霍尔果斯"},
  {"CUSTOMS_CO":"9403","CUSTOMS_NA":"吐尔尕特"},
  {"CUSTOMS_CO":"9404","CUSTOMS_NA":"阿拉山口"},
  {"CUSTOMS_CO":"9405","CUSTOMS_NA":"塔城海关"},
  {"CUSTOMS_CO":"9406","CUSTOMS_NA":"伊宁海关"},
  {"CUSTOMS_CO":"9407","CUSTOMS_NA":"吉木乃关"},
  {"CUSTOMS_CO":"9408","CUSTOMS_NA":"喀什海关"},
  {"CUSTOMS_CO":"9409","CUSTOMS_NA":"红其拉甫"},
  {"CUSTOMS_CO":"9410","CUSTOMS_NA":"阿勒泰关"},
  {"CUSTOMS_CO":"9411","CUSTOMS_NA":"塔克什肯"},
  {"CUSTOMS_CO":"9412","CUSTOMS_NA":"乌拉斯太"},
  {"CUSTOMS_CO":"9413","CUSTOMS_NA":"哈密关"},
  {"CUSTOMS_CO":"9414","CUSTOMS_NA":"红山嘴"},
  {"CUSTOMS_CO":"9415","CUSTOMS_NA":"伊尔克什"},
  {"CUSTOMS_CO":"9416","CUSTOMS_NA":"库尔勒关"},
  {"CUSTOMS_CO":"9417","CUSTOMS_NA":"乌机场关"},
  {"CUSTOMS_CO":"9418","CUSTOMS_NA":"乌加工区"},
  {"CUSTOMS_CO":"9419","CUSTOMS_NA":"都拉塔关"},
  {"CUSTOMS_CO":"9420","CUSTOMS_NA":"乌昌关"},
  {"CUSTOMS_CO":"9421","CUSTOMS_NA":"霍中心A"},
  {"CUSTOMS_CO":"9422","CUSTOMS_NA":"石河子关"},
  {"CUSTOMS_CO":"9423","CUSTOMS_NA":"山口综保"},
  {"CUSTOMS_CO":"9424","CUSTOMS_NA":"喀什综保"},
  {"CUSTOMS_CO":"9425","CUSTOMS_NA":"卡拉苏关"},
  {"CUSTOMS_CO":"9426","CUSTOMS_NA":"奎屯物流"},
  {"CUSTOMS_CO":"9427","CUSTOMS_NA":"中哈合作"},
  {"CUSTOMS_CO":"9428","CUSTOMS_NA":"乌邮局关"},
  {"CUSTOMS_CO":"9429","CUSTOMS_NA":"乌综保区"},
  {"CUSTOMS_CO":"9430","CUSTOMS_NA":"阿克苏关"},
  {"CUSTOMS_CO":"9500","CUSTOMS_NA":"兰州关区"},
  {"CUSTOMS_CO":"9501","CUSTOMS_NA":"金城海关"},
  {"CUSTOMS_CO":"9502","CUSTOMS_NA":"酒泉海关"},
  {"CUSTOMS_CO":"9503","CUSTOMS_NA":"中川机场"},
  {"CUSTOMS_CO":"9504","CUSTOMS_NA":"武威物流"},
  {"CUSTOMS_CO":"9505","CUSTOMS_NA":"天水海关"},
  {"CUSTOMS_CO":"9506","CUSTOMS_NA":"金昌海关"},
  {"CUSTOMS_CO":"9507","CUSTOMS_NA":"兰州综保"},
  {"CUSTOMS_CO":"9508","CUSTOMS_NA":"敦煌机场"},
  {"CUSTOMS_CO":"9509","CUSTOMS_NA":"平凉海关"},
  {"CUSTOMS_CO":"9600","CUSTOMS_NA":"银川海关"},
  {"CUSTOMS_CO":"9601","CUSTOMS_NA":"兴庆海关"},
  {"CUSTOMS_CO":"9602","CUSTOMS_NA":"河东机场"},
  {"CUSTOMS_CO":"9603","CUSTOMS_NA":"石嘴山关"},
  {"CUSTOMS_CO":"9604","CUSTOMS_NA":"银川综保"},
  {"CUSTOMS_CO":"9605","CUSTOMS_NA":"银关快件"},
  {"CUSTOMS_CO":"9606","CUSTOMS_NA":"石嘴山物"},
  {"CUSTOMS_CO":"9607","CUSTOMS_NA":"中卫海关"},
  {"CUSTOMS_CO":"9700","CUSTOMS_NA":"西宁关区"},
  {"CUSTOMS_CO":"9701","CUSTOMS_NA":"西海海关"},
  {"CUSTOMS_CO":"9702","CUSTOMS_NA":"青海物流"},
  {"CUSTOMS_CO":"9703","CUSTOMS_NA":"西宁机场"},
  {"CUSTOMS_CO":"9704","CUSTOMS_NA":"格尔木海"},
  {"CUSTOMS_CO":"9705","CUSTOMS_NA":"西宁综保"},
  {"CUSTOMS_CO":"9900","CUSTOMS_NA":"政法司"},

]
// 商品单位
export const ProdUint = [
  {"key":"035","value":"千克","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"036","value":"克","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"096","value":"毫升","CONV_CODE":"95","CONV_RATIO":"0.001000000000000000020816681711721685132943093776702880859375"},
  {"key":"120","value":"箱","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"122","value":"罐","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"123","value":"桶","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"131","value":"册","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"132","value":"本","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"139","value":"粒","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"140","value":"盒","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"142","value":"瓶","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"001","value":"台","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"006","value":"套","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"007","value":"个","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"008","value":"只","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"010","value":"张","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"011","value":"件","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"012","value":"支","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"014","value":"根","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"017","value":"块","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"018","value":"卷","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"019","value":"副","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"020","value":"片","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"061","value":"千瓦","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"083","value":"盎司","CONV_CODE":"36","CONV_RATIO":"31.10000000000000142108547152020037174224853515625"},
  {"key":"086","value":"码","CONV_CODE":"30","CONV_RATIO":"0.91439999999999999058530875117867253720760345458984375"},
  {"key":"088","value":"英寸","CONV_CODE":"30","CONV_RATIO":"0.025399999999999998967492587098604417406022548675537109375"},
  {"key":"089","value":"寸","CONV_CODE":"30","CONV_RATIO":"0.033300000000000003208544541166702401824295520782470703125"},
  {"key":"095","value":"升","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"032","value":"平方米","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"033","value":"立方米","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"002","value":"座","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"003","value":"辆","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"004","value":"艘","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"005","value":"架","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"009","value":"头","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"013","value":"枝","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"015","value":"条","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"016","value":"把","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"021","value":"组","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"022","value":"份","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"023","value":"幅","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"025","value":"双","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"026","value":"对","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"027","value":"棵","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"028","value":"株","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"029","value":"井","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"030","value":"米","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"031","value":"盘","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"034","value":"筒","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"037","value":"盆","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"038","value":"万个","CONV_CODE":"07","CONV_RATIO":"10000"},
  {"key":"039","value":"具","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"040","value":"百副","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"041","value":"百支","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"042","value":"百把","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"043","value":"百个","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"044","value":"百片","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"045","value":"刀","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"046","value":"疋","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"047","value":"公担","CONV_CODE":"35","CONV_RATIO":"100"},
  {"key":"048","value":"扇","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"049","value":"百枝","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"050","value":"千只","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"051","value":"千块","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"052","value":"千盒","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"053","value":"千枝","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"054","value":"千个","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"055","value":"亿支","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"056","value":"亿个","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"057","value":"万套","CONV_CODE":"06","CONV_RATIO":"10000"},
  {"key":"058","value":"千张","CONV_CODE":"10","CONV_RATIO":"1000"},
  {"key":"059","value":"万张","CONV_CODE":"10","CONV_RATIO":"10000"},
  {"key":"060","value":"千伏安","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"062","value":"千瓦时","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"063","value":"千升","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"067","value":"英尺","CONV_CODE":"30","CONV_RATIO":"0.304800000000000015365486660812166519463062286376953125"},
  {"key":"070","value":"吨","CONV_CODE":"35","CONV_RATIO":"1000"},
  {"key":"071","value":"长吨","CONV_CODE":"35","CONV_RATIO":"1016"},
  {"key":"072","value":"短吨","CONV_CODE":"35","CONV_RATIO":"907.200000000000045474735088646411895751953125"},
  {"key":"073","value":"司马担","CONV_CODE":"35","CONV_RATIO":"60.5"},
  {"key":"074","value":"司马斤","CONV_CODE":"35","CONV_RATIO":"0.604999999999999982236431605997495353221893310546875"},
  {"key":"075","value":"斤","CONV_CODE":"35","CONV_RATIO":"0.5"},
  {"key":"076","value":"磅","CONV_CODE":"35","CONV_RATIO":"0.4536000000000000031974423109204508364200592041015625"},
  {"key":"077","value":"担","CONV_CODE":"35","CONV_RATIO":"100"},
  {"key":"078","value":"英担","CONV_CODE":"35","CONV_RATIO":"50.80239999999999866986399865709245204925537109375"},
  {"key":"079","value":"短担","CONV_CODE":"35","CONV_RATIO":"45.3599999999999994315658113919198513031005859375"},
  {"key":"080","value":"两","CONV_CODE":"35","CONV_RATIO":"0.05000000000000000277555756156289135105907917022705078125"},
  {"key":"081","value":"市担","CONV_CODE":"35","CONV_RATIO":"50"},
  {"key":"084","value":"克拉","CONV_CODE":"36","CONV_RATIO":"0.200000000000000011102230246251565404236316680908203125"},
  {"key":"085","value":"市尺","CONV_CODE":"30","CONV_RATIO":"0.333299999999999985167420391007908619940280914306640625"},
  {"key":"097","value":"英加仑","CONV_CODE":"33","CONV_RATIO":"0.004499999999999999659994198708545809495262801647186279296875"},
  {"key":"098","value":"美加仑","CONV_CODE":"33","CONV_RATIO":"0.00370000000000000016375789613221058971248567104339599609375"},
  {"key":"099","value":"立方英尺","CONV_CODE":"33","CONV_RATIO":"0.028299999999999998767652442666076240129768848419189453125"},
  {"key":"101","value":"立方尺","CONV_CODE":"33","CONV_RATIO":"0.036999999999999998168132009368491708301007747650146484375"},
  {"key":"110","value":"平方码","CONV_CODE":"32","CONV_RATIO":"0.83609999999999995434762922741356305778026580810546875"},
  {"key":"111","value":"平方英尺","CONV_CODE":"32","CONV_RATIO":"0.09289999999999999646949078169200220145285129547119140625"},
  {"key":"112","value":"平方尺","CONV_CODE":"32","CONV_RATIO":"0.11100000000000000144328993201270350255072116851806640625"},
  {"key":"115","value":"英制马力","CONV_CODE":"61","CONV_RATIO":"0.7462999999999999634070491083548404276371002197265625"},
  {"key":"116","value":"公制马力","CONV_CODE":"61","CONV_RATIO":"0.73529999999999995363708649165346287190914154052734375"},
  {"key":"118","value":"令","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"121","value":"批","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"124","value":"扎","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"125","value":"包","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"126","value":"箩","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"127","value":"打","CONV_CODE":"11","CONV_RATIO":"12"},
  {"key":"128","value":"筐","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"129","value":"罗","CONV_CODE":"07","CONV_RATIO":"144"},
  {"key":"130","value":"匹","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"133","value":"发","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"134","value":"枚","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"135","value":"捆","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"136","value":"袋","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"141","value":"合","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"143","value":"千支","CONV_CODE":"00","CONV_RATIO":"1"},
  {"key":"144","value":"万双","CONV_CODE":"25","CONV_RATIO":"10000"},
  {"key":"145","value":"万粒","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"146","value":"千粒","CONV_CODE":"00","CONV_RATIO":"0"},
  {"key":"147","value":"千米","CONV_CODE":"30","CONV_RATIO":"1000"},
  {"key":"148","value":"千英尺","CONV_CODE":"30","CONV_RATIO":"304.80000000000001136868377216160297393798828125"},
  {"key":"149","value":"百万贝可","CONV_CODE":"63","CONV_RATIO":"1"},
  {"key":"163","value":"部","CONV_CODE":"01","CONV_RATIO":"1"},
  {"key":"164","value":"亿株","CONV_CODE":"71","CONV_RATIO":"1"},
  {"key":"170","value":"人份","CONV_CODE":"00","CONV_RATIO":""}
]


export const DeparturePort = [
  {
    code: '110101',
    nameCN: '首都国际机场',
    nameEn: 'Beijing Capital International Airport',
    prot: 'BJS',
    portCode: '1542'
  },{
    code: '310302',
    nameCN: '上海浦东国际机场',
    nameEn: 'Shanghai Pudong International Airport',
    prot: 'PVG',
    portCode: '8479'
  }, {
    code: '372301',
    nameCN: '青岛流亭机场',
    nameEn: 'Qingdao Liuting Airport\n',
    prot: 'TAO',
    portCode: '6599'
  }, {
    code: '399101',
    nameCN: '厦门高崎国际机场',
    nameEn: 'Xiamen Gaoqi International Airport',
    prot: 'XMN',
    portCode: '5712'
  }, {
    code: '410003',
    nameCN: '郑州新郑国际机场',
    nameEn: 'Zhengzhou Xinzheng International Airport',
    prot: 'CGO',
    portCode: '0569'
  }, {
    code: '471001',
    nameCN: '深圳宝安国际机场',
    nameEn: 'Shenzhen Baoan International Airport',
    prot: 'SZX',
    portCode: '0009;8129'
  }, {
    code: '510004',
    nameCN: '成都双流国际机场货场',
    nameEn: 'Chengdu Shuangliu International Airport Huochang',
    prot: 'CTU',
    portCode: '0489;0523'
  }
]
// 离境口岸
export const DepartureData = [
  {
    "code": "110001",
    "nameCN": "北京",
    "nameEN": "Beijing"
  },
  {
    "code": "110002",
    "nameCN": "北京平谷国际陆港",
    "nameEN": "Beijing Pinggu Automobile Lugang"
  },
  {
    "code": "110003",
    "nameCN": "北京天竺综合保税区",
    "nameEN": "Beijing Tianzhu Comprehensive Bonded Zone"
  },
  {
    "code": "110101",
    "nameCN": "首都国际机场",
    "nameEN": "Beijing Capital International Airport"
  },
  {
    "code": "110201",
    "nameCN": "北京丰台货运",
    "nameEN": "Beijing Fengtai Freight"
  },
  {
    "code": "110301",
    "nameCN": "北京朝阳口岸",
    "nameEN": "Beijing Chaoyang Port"
  },
  {
    "code": "110801",
    "nameCN": "北京西站",
    "nameEN": "Beijing Xizhan"
  },
  {
    "code": "120001",
    "nameCN": "天津",
    "nameEN": "Tianjin"
  },
  {
    "code": "120002",
    "nameCN": "北疆港区",
    "nameEN": "Beijiang Gangqu"
  },
  {
    "code": "120003",
    "nameCN": "天津保税物流园区",
    "nameEN": "Tianjin Bonded Logistics Zone"
  },
  {
    "code": "120004",
    "nameCN": "天津港保税区",
    "nameEN": "Tianjingang Free Trade Zone"
  },
  {
    "code": "120011",
    "nameCN": "中国（天津）自由贸易试验区",
    "nameEN": "China (Tianjin) Pilot Free Trade Zone"
  },
  {
    "code": "120201",
    "nameCN": "天津出口加工区",
    "nameEN": "Tianjin Export Processind Zone"
  },
  {
    "code": "120601",
    "nameCN": "天津滨海新区综合保税区",
    "nameEN": "Tianjin Binhai Xinqu Comprehensive Bonded Zone"
  },
  {
    "code": "120801",
    "nameCN": "大沽口港区",
    "nameEN": "Dagukou Gangqu"
  },
  {
    "code": "121001",
    "nameCN": "南疆港区",
    "nameEN": "Nanjiang Gangqu"
  },
  {
    "code": "121002",
    "nameCN": "渤中",
    "nameEN": "Bozhong"
  },
  {
    "code": "121501",
    "nameCN": "东疆港区",
    "nameEN": "Dongjiang Gangqu"
  },
  {
    "code": "121502",
    "nameCN": "天津邮轮母港",
    "nameEN": "Tianjin Youlun Mugang"
  },
  {
    "code": "121503",
    "nameCN": "天津新港客运码头",
    "nameEN": "Tianjin Xingang Passenger Transpor Dock"
  },
  {
    "code": "121504",
    "nameCN": "天津东疆保税港区",
    "nameEN": "Tianjin Dongjiang Free Trade Port Zone"
  },
  {
    "code": "121701",
    "nameCN": "天津滨海国际机场货邮",
    "nameEN": "Tianjin Binhai International Airport Huoyou"
  },
  {
    "code": "121702",
    "nameCN": "天津滨海国际机场T1通道",
    "nameEN": "Tianjin Binhai International Airport T1 tongdao"
  },
  {
    "code": "121703",
    "nameCN": "天津滨海国际机场T2通道",
    "nameEN": "Tianjin Binhai International Airport T2 Tongdao"
  },
  {
    "code": "130001",
    "nameCN": "石家庄",
    "nameEN": "Shijiazhuang"
  },
  {
    "code": "130002",
    "nameCN": "石家庄正定机场",
    "nameEN": "Shijiazhuang Zhengding Airport"
  },
  {
    "code": "130101",
    "nameCN": "秦皇岛",
    "nameEN": "Qinhuangdao"
  },
  {
    "code": "130102",
    "nameCN": "秦皇岛出口加工区",
    "nameEN": "Qinhuangdao Export Processind Zone"
  },
  {
    "code": "130200",
    "nameCN": "河北省唐山市",
    "nameEN": "Hebei Sheng Tangshan Shi"
  },
  {
    "code": "130201",
    "nameCN": "京唐港",
    "nameEN": "Jingtanggang"
  },
  {
    "code": "130202",
    "nameCN": "唐山",
    "nameEN": "Tangshan"
  },
  {
    "code": "130203",
    "nameCN": "曹妃甸港",
    "nameEN": "Caofeidian Harbor"
  },
  {
    "code": "130204",
    "nameCN": "曹妃甸综合保税区",
    "nameEN": "Caofeidian Comprehensive Bonded Zone"
  },
  {
    "code": "130300",
    "nameCN": "河北省秦皇岛市",
    "nameEN": "Hebei Sheng Qinhuangdao Shi"
  },
  {
    "code": "130400",
    "nameCN": "河北省邯郸市",
    "nameEN": "Hebei Sheng Handan Shi"
  },
  {
    "code": "130500",
    "nameCN": "河北省邢台市",
    "nameEN": "Hebei Sheng Xingtai Shi"
  },
  {
    "code": "130600",
    "nameCN": "河北省保定市",
    "nameEN": "Hebei Sheng Baoding Shi"
  },
  {
    "code": "130700",
    "nameCN": "河北省张家口市",
    "nameEN": "Hebei Sheng Zhangjiakou Shi"
  },
  {
    "code": "130701",
    "nameCN": "廊坊出口加工区",
    "nameEN": "Langfang Export Processind Zone"
  },
  {
    "code": "130800",
    "nameCN": "河北省承德市",
    "nameEN": "Hebei Sheng Chengde Shi"
  },
  {
    "code": "130900",
    "nameCN": "河北省沧州市",
    "nameEN": "Hebei Sheng Cangzhou Shi"
  },
  {
    "code": "131000",
    "nameCN": "河北省廊坊市",
    "nameEN": "Hebei Sheng Langfang Shi"
  },
  {
    "code": "131100",
    "nameCN": "河北省衡水市",
    "nameEN": "Hebei Sheng Hengshui Shi"
  },
  {
    "code": "131101",
    "nameCN": "黄骅",
    "nameEN": "Huanghua"
  },
  {
    "code": "131201",
    "nameCN": "石家庄综合保税区",
    "nameEN": "Shijiazhuang Comprehensive Bonded Zone"
  },
  {
    "code": "140001",
    "nameCN": "太原",
    "nameEN": "Taiyuan"
  },
  {
    "code": "140002",
    "nameCN": "太原武宿机场",
    "nameEN": "Taiyuan Wusu Airport"
  },
  {
    "code": "140003",
    "nameCN": "太原武宿综合保税区",
    "nameEN": "Taiyuan Wusu Comprehensive Bonded Zone"
  },
  {
    "code": "140200",
    "nameCN": "山西省大同市",
    "nameEN": "Shanxi Sheng Datong Shi"
  },
  {
    "code": "140300",
    "nameCN": "山西省阳泉市",
    "nameEN": "Shanxi Sheng Yangquan Shi"
  },
  {
    "code": "140400",
    "nameCN": "山西省长治市",
    "nameEN": "Shanxi Sheng Changzhi Shi"
  },
  {
    "code": "140500",
    "nameCN": "山西省晋城市",
    "nameEN": "Shanxi Sheng Jincheng Shi"
  },
  {
    "code": "140600",
    "nameCN": "山西省朔州市",
    "nameEN": "Shanxi Sheng Shouzhou Shi"
  },
  {
    "code": "140700",
    "nameCN": "山西省晋中市",
    "nameEN": "Shanxi Sheng Jinzhong Shi"
  },
  {
    "code": "140800",
    "nameCN": "山西省运城市",
    "nameEN": "Shanxi Sheng Yuncheng Shi"
  },
  {
    "code": "140900",
    "nameCN": "山西省忻州市",
    "nameEN": "Shanxi Sheng Xinzhou Shi"
  },
  {
    "code": "141000",
    "nameCN": "山西省临汾市",
    "nameEN": "Shanxi Sheng Linfen Shi"
  },
  {
    "code": "141100",
    "nameCN": "山西省吕梁市",
    "nameEN": "Shanxi Sheng Luliang Shi"
  },
  {
    "code": "150001",
    "nameCN": "呼和浩特",
    "nameEN": "Hohhot"
  },
  {
    "code": "150002",
    "nameCN": "呼和浩特白塔机场",
    "nameEN": "Hohhot Baita Airport"
  },
  {
    "code": "150003",
    "nameCN": "呼和浩特出口加工区",
    "nameEN": "Hohhot Export Processind Zone"
  },
  {
    "code": "150004",
    "nameCN": "鄂尔多斯伊金霍洛机场",
    "nameEN": "Erdos Ejin Horo Airport"
  },
  {
    "code": "150101",
    "nameCN": "满洲里西郊机场",
    "nameEN": "Manzhouli Xijiao Airport"
  },
  {
    "code": "150102",
    "nameCN": "满洲里铁路",
    "nameEN": "Manzhouli Railway"
  },
  {
    "code": "150103",
    "nameCN": "二卡",
    "nameEN": "Erka"
  },
  {
    "code": "150104",
    "nameCN": "满洲里十八里",
    "nameEN": "Manzhouli Shibali"
  },
  {
    "code": "150105",
    "nameCN": "阿日哈沙特",
    "nameEN": "Arhaxat"
  },
  {
    "code": "150106",
    "nameCN": "满洲里综合保税区",
    "nameEN": "Manzhouli Comprehensive Bonded Zone"
  },
  {
    "code": "150200",
    "nameCN": "内蒙古自治区包头市",
    "nameEN": "Nei Mongol Zizhiqu Baotou Shi"
  },
  {
    "code": "150201",
    "nameCN": "二连浩特铁路",
    "nameEN": "Erlianhaote Railway"
  },
  {
    "code": "150202",
    "nameCN": "二连浩特公路",
    "nameEN": "Erlianhaote Highroad"
  },
  {
    "code": "150300",
    "nameCN": "内蒙古自治区乌海市",
    "nameEN": "Nei Mongol Zizhiqu Wuhai Shi"
  },
  {
    "code": "150301",
    "nameCN": "海拉尔东山机场",
    "nameEN": "Hailar Dongshan Airport"
  },
  {
    "code": "150302",
    "nameCN": "额布都格",
    "nameEN": "Ebuduge"
  },
  {
    "code": "150303",
    "nameCN": "胡列也吐",
    "nameEN": "Hulieyetu"
  },
  {
    "code": "150400",
    "nameCN": "内蒙古自治区赤峰市",
    "nameEN": "Nei Mongol Zizhiqu Chifeng(Ulanhad) Shi"
  },
  {
    "code": "150401",
    "nameCN": "满都拉",
    "nameEN": "Mandula"
  },
  {
    "code": "150500",
    "nameCN": "内蒙古自治区通辽市",
    "nameEN": "Nei Mongol Zizhiqu Tongliao Shi"
  },
  {
    "code": "150600",
    "nameCN": "内蒙古自治区鄂尔多斯市",
    "nameEN": "Nei Mongol Zizhiqu Ordos Shi"
  },
  {
    "code": "150700",
    "nameCN": "内蒙古自治区呼伦贝尔市",
    "nameEN": "Nei Mongol Zizhiqu Hulun Buir Shi"
  },
  {
    "code": "150800",
    "nameCN": "内蒙古自治区巴彦淖尔市",
    "nameEN": "Nei Mongol Zizhiqu Bayannur Shi"
  },
  {
    "code": "150801",
    "nameCN": "黑山头",
    "nameEN": "Heishantou"
  },
  {
    "code": "150802",
    "nameCN": "室韦",
    "nameEN": "Shiwei"
  },
  {
    "code": "150900",
    "nameCN": "内蒙古自治区乌兰察布市",
    "nameEN": "Nei Mongol Zizhiqu Ulanqab Shi"
  },
  {
    "code": "150901",
    "nameCN": "策克",
    "nameEN": "Ceke"
  },
  {
    "code": "151001",
    "nameCN": "珠恩嘎达布其",
    "nameEN": "Zhuengadabuqi"
  },
  {
    "code": "151101",
    "nameCN": "甘其毛都",
    "nameEN": "Ganqmaod"
  },
  {
    "code": "151102",
    "nameCN": "巴格毛都",
    "nameEN": "Bagemaodu"
  },
  {
    "code": "151201",
    "nameCN": "阿尔山",
    "nameEN": "Aershan"
  },
  {
    "code": "152200",
    "nameCN": "内蒙古自治区兴安盟",
    "nameEN": "Nei Mongol Zizhiqu Hinggan Meng"
  },
  {
    "code": "152500",
    "nameCN": "内蒙古自治区锡林郭勒盟",
    "nameEN": "Nei Mongol Zizhiqu Xilin Gol Meng"
  },
  {
    "code": "152900",
    "nameCN": "内蒙古自治区阿拉善盟",
    "nameEN": "Nei Mongol Zizhiqu Alxa Meng"
  },
  {
    "code": "210001",
    "nameCN": "沈阳",
    "nameEN": "Shenyang"
  },
  {
    "code": "210101",
    "nameCN": "大连港大窑湾港区",
    "nameEN": "Dalian Harbor Dayaowan Gangqu"
  },
  {
    "code": "210102",
    "nameCN": "大连北良港区",
    "nameEN": "Dalian Beiliang Gangqu "
  },
  {
    "code": "210103",
    "nameCN": "大连港油品码头港区",
    "nameEN": "Dalian Harbor Youpin Dock Gangqu"
  },
  {
    "code": "210104",
    "nameCN": "大连大窑湾保税港区",
    "nameEN": "Dalian Dayaowan Free Trade Port Zone"
  },
  {
    "code": "210200",
    "nameCN": "辽宁省大连市",
    "nameEN": "Liaoning Sheng Dalian Shi"
  },
  {
    "code": "210300",
    "nameCN": "辽宁省鞍山市",
    "nameEN": "Liaoning Sheng Anshan Shi"
  },
  {
    "code": "210301",
    "nameCN": "沈阳桃仙国际机场",
    "nameEN": "Shenyang Taoxian International Airport"
  },
  {
    "code": "210400",
    "nameCN": "辽宁省抚顺市",
    "nameEN": "Liaoning Sheng Fushun Shi"
  },
  {
    "code": "210401",
    "nameCN": "锦州",
    "nameEN": "Jinzhou"
  },
  {
    "code": "210500",
    "nameCN": "辽宁省本溪市",
    "nameEN": "Liaoning Sheng Benxi Shi"
  },
  {
    "code": "210600",
    "nameCN": "辽宁省丹东市",
    "nameEN": "Liaoning Sheng Dandong Shi"
  },
  {
    "code": "210700",
    "nameCN": "辽宁省锦州市",
    "nameEN": "Liaoning Sheng Jinzhou Shi"
  },
  {
    "code": "210701",
    "nameCN": "丹东港浪头港区",
    "nameEN": "Dandong Harbor Langtou Gangqu"
  },
  {
    "code": "210702",
    "nameCN": "丹东铁路",
    "nameEN": "Dandong Railway"
  },
  {
    "code": "210703",
    "nameCN": "丹东公路",
    "nameEN": "Dandong Highroad"
  },
  {
    "code": "210704",
    "nameCN": "丹东输油管道",
    "nameEN": "Dandong Shuyou Guandao"
  },
  {
    "code": "210705",
    "nameCN": "丹东太平湾",
    "nameEN": "Dandong Taipingwan "
  },
  {
    "code": "210706",
    "nameCN": "丹东长甸河口",
    "nameEN": "Dandong Changdian Hekou"
  },
  {
    "code": "210707",
    "nameCN": "丹东哑巴沟",
    "nameEN": "Dandong Yabagou"
  },
  {
    "code": "210708",
    "nameCN": "丹东马市过货点",
    "nameEN": "Dandong Mashi Guohuodian"
  },
  {
    "code": "210709",
    "nameCN": "丹东安民",
    "nameEN": "Dandong Anmin"
  },
  {
    "code": "210800",
    "nameCN": "辽宁省营口市",
    "nameEN": "Liaoning Sheng Yingkou Shi"
  },
  {
    "code": "210801",
    "nameCN": "丹东港大东港区",
    "nameEN": "Dandong Harbor Dadong Gangqu"
  },
  {
    "code": "210802",
    "nameCN": "丹东大鹿岛",
    "nameEN": "Dandong Daludao"
  },
  {
    "code": "210803",
    "nameCN": "丹东大台子",
    "nameEN": "Dandong Dataizi"
  },
  {
    "code": "210804",
    "nameCN": "丹东一撮毛过货点",
    "nameEN": "Dandong Yicuomao Guohuodian"
  },
  {
    "code": "210805",
    "nameCN": "丹东丹纸码头",
    "nameEN": "Dandong Danzhi Dock"
  },
  {
    "code": "210900",
    "nameCN": "辽宁省阜新市",
    "nameEN": "Liaoning Sheng Fuxin Shi"
  },
  {
    "code": "210901",
    "nameCN": "营口港老港区",
    "nameEN": "Yingkou Harbor Laogangqu"
  },
  {
    "code": "211000",
    "nameCN": "辽宁省辽阳市",
    "nameEN": "Liaoning Sheng Liaoyang Shi"
  },
  {
    "code": "211001",
    "nameCN": "营口港鲅鱼圈港区",
    "nameEN": "Yingkou Harbor Bayuquan Gangqu"
  },
  {
    "code": "211002",
    "nameCN": "营口港仙人岛港区",
    "nameEN": "Yingkou Harbor Xianrendao Gangqu"
  },
  {
    "code": "211003",
    "nameCN": "营口港保税物流园区",
    "nameEN": "Yingkougang Bonded Logistics Zone"
  },
  {
    "code": "211100",
    "nameCN": "辽宁省盘锦市",
    "nameEN": "Liaoning Sheng Panjin Shi"
  },
  {
    "code": "211200",
    "nameCN": "辽宁省铁岭市",
    "nameEN": "Liaoning Sheng Tieling Shi"
  },
  {
    "code": "211300",
    "nameCN": "辽宁省朝阳市",
    "nameEN": "Liaoning Sheng Chaoyang Shi"
  },
  {
    "code": "211400",
    "nameCN": "辽宁省葫芦岛市",
    "nameEN": "Liaoning Sheng Huludao Shi"
  },
  {
    "code": "211401",
    "nameCN": "盘锦港",
    "nameEN": "Panjin Harbor"
  },
  {
    "code": "211501",
    "nameCN": "葫芦岛港",
    "nameEN": "Huludao Harbor"
  },
  {
    "code": "211801",
    "nameCN": "大连周水子国际机场",
    "nameEN": "Dalian Zhoushuizi International Airport"
  },
  {
    "code": "211901",
    "nameCN": "大连港香炉礁港区",
    "nameEN": "Dalian Harbor Xianglujiao Gangqu "
  },
  {
    "code": "211902",
    "nameCN": "大连港老港区",
    "nameEN": "Dalian Harbor laogangqu "
  },
  {
    "code": "211903",
    "nameCN": "大连港大连湾港区",
    "nameEN": "Daliangangdalianwangangqu "
  },
  {
    "code": "211904",
    "nameCN": "大连港汽车码头港区",
    "nameEN": "Dalian Harbor Qiche Dock Gangqu"
  },
  {
    "code": "211905",
    "nameCN": "大连港矿石码头港区",
    "nameEN": "Dalian Harbor Kuangshi Dock Gangqu"
  },
  {
    "code": "211906",
    "nameCN": "旅顺新港",
    "nameEN": "Lushun Xingang"
  },
  {
    "code": "211907",
    "nameCN": "庄河港",
    "nameEN": "Zhuanghe Harbor"
  },
  {
    "code": "211908",
    "nameCN": "大连长海四块石码头",
    "nameEN": "Dalian Changhai Sikuaishi Dock"
  },
  {
    "code": "211909",
    "nameCN": "大连出口加工区",
    "nameEN": "Dalian Export Processind Zone"
  },
  {
    "code": "211910",
    "nameCN": "大连保税区",
    "nameEN": "Dalian Free Trade Zone"
  },
  {
    "code": "212001",
    "nameCN": "长兴岛港",
    "nameEN": "Changxingdao Harbor"
  },
  {
    "code": "212101",
    "nameCN": "沈阳综合保税区",
    "nameEN": "Shenyang Comprehensive Bonded Zone"
  },
  {
    "code": "220001",
    "nameCN": "长春",
    "nameEN": "Changchun"
  },
  {
    "code": "220002",
    "nameCN": "长春龙嘉国际机场",
    "nameEN": "Changchun Longjia International Airport"
  },
  {
    "code": "220003",
    "nameCN": "长春铁路",
    "nameEN": "Changchun Railway"
  },
  {
    "code": "220004",
    "nameCN": "临江",
    "nameEN": "Linjiang"
  },
  {
    "code": "220005",
    "nameCN": "大安",
    "nameEN": "Daan"
  },
  {
    "code": "220006",
    "nameCN": "图们公路",
    "nameEN": "Tumen Highroad"
  },
  {
    "code": "220007",
    "nameCN": "图们铁路",
    "nameEN": "Tumen Railway"
  },
  {
    "code": "220008",
    "nameCN": "船营",
    "nameEN": "Chuanying"
  },
  {
    "code": "220009",
    "nameCN": "档石",
    "nameEN": "Dangshi"
  },
  {
    "code": "220010",
    "nameCN": "下三道沟",
    "nameEN": "Xiasandaogou"
  },
  {
    "code": "220011",
    "nameCN": "长春兴隆综合保税区",
    "nameEN": "Changchun Xinglong Comprehensive Bonded Zone"
  },
  {
    "code": "220101",
    "nameCN": "双目峰公务通道",
    "nameEN": "Shuangmofeng Gongwu Tongdao"
  },
  {
    "code": "220102",
    "nameCN": "延吉朝阳川机场",
    "nameEN": "Yanji Chaoyangchuan Airport"
  },
  {
    "code": "220103",
    "nameCN": "三合",
    "nameEN": "Sanhe"
  },
  {
    "code": "220104",
    "nameCN": "开山屯",
    "nameEN": "Kaishantun"
  },
  {
    "code": "220105",
    "nameCN": "南坪",
    "nameEN": "Nanping"
  },
  {
    "code": "220106",
    "nameCN": "古城里",
    "nameEN": "Guchengli"
  },
  {
    "code": "220200",
    "nameCN": "吉林省吉林市",
    "nameEN": "Jilin Sheng Jilin Shi"
  },
  {
    "code": "220201",
    "nameCN": "珲春公路",
    "nameEN": "Hunchun Highroad"
  },
  {
    "code": "220202",
    "nameCN": "珲春铁路",
    "nameEN": "Hunchun Railway"
  },
  {
    "code": "220203",
    "nameCN": "沙坨子",
    "nameEN": "Shatuozi"
  },
  {
    "code": "220204",
    "nameCN": "圈河",
    "nameEN": "Quanhe"
  },
  {
    "code": "220205",
    "nameCN": "珲春出口加工区",
    "nameEN": "Hunchun Export Processind Zone"
  },
  {
    "code": "220300",
    "nameCN": "吉林省四平市",
    "nameEN": "Jilin Sheng Siping Shi"
  },
  {
    "code": "220400",
    "nameCN": "吉林省辽源市",
    "nameEN": "Jilin Sheng Liaoyuan Shi"
  },
  {
    "code": "220500",
    "nameCN": "吉林省通化市",
    "nameEN": "Jilin Sheng Tonghua Shi"
  },
  {
    "code": "220501",
    "nameCN": "集安铁路",
    "nameEN": "Jian Railway"
  },
  {
    "code": "220502",
    "nameCN": "老虎哨",
    "nameEN": "Laohushao"
  },
  {
    "code": "220503",
    "nameCN": "青石",
    "nameEN": "Qinshi"
  },
  {
    "code": "220504",
    "nameCN": "秋皮村",
    "nameEN": "Qiupicun"
  },
  {
    "code": "220505",
    "nameCN": "集安过货通道",
    "nameEN": "Jian Guohuo Tongdao"
  },
  {
    "code": "220600",
    "nameCN": "吉林省白山市",
    "nameEN": "Jilin Sheng Baishan Shi"
  },
  {
    "code": "220601",
    "nameCN": "长白",
    "nameEN": "Changbai"
  },
  {
    "code": "220602",
    "nameCN": "十三道沟",
    "nameEN": "Shisandaogou"
  },
  {
    "code": "220603",
    "nameCN": "八道沟",
    "nameEN": "Badaogou"
  },
  {
    "code": "220604",
    "nameCN": "南尖头",
    "nameEN": "Nanjiantou"
  },
  {
    "code": "220700",
    "nameCN": "吉林省松原市",
    "nameEN": "Jilin Sheng Songyuan Shi"
  },
  {
    "code": "220701",
    "nameCN": "吉林铁路",
    "nameEN": "Jilin Railway"
  },
  {
    "code": "220800",
    "nameCN": "吉林省白城市",
    "nameEN": "Jilin Sheng Baicheng Shi"
  },
  {
    "code": "222400",
    "nameCN": "吉林省延边朝鲜族自治州",
    "nameEN": "Jilin Sheng Yanbian Chosenzu Zizhizhou"
  },
  {
    "code": "230001",
    "nameCN": "哈尔滨",
    "nameEN": "Harbin"
  },
  {
    "code": "230002",
    "nameCN": "哈尔滨太平国际机场",
    "nameEN": "Harbin Taiping International Airport"
  },
  {
    "code": "230003",
    "nameCN": "嘉荫",
    "nameEN": "Jiayin"
  },
  {
    "code": "230004",
    "nameCN": "漠河",
    "nameEN": "Mohe"
  },
  {
    "code": "230005",
    "nameCN": "绥芬河综合保税区",
    "nameEN": "Suifenhe Comprehensive Bonded Zone"
  },
  {
    "code": "230101",
    "nameCN": "齐齐哈尔三家子机场",
    "nameEN": "Qiqihar Sanjiazi Airport"
  },
  {
    "code": "230200",
    "nameCN": "黑龙江省齐齐哈尔市",
    "nameEN": "Heilongjiang Sheng Qiqihar Shi"
  },
  {
    "code": "230201",
    "nameCN": "大庆",
    "nameEN": "Daqing"
  },
  {
    "code": "230300",
    "nameCN": "黑龙江省鸡西市",
    "nameEN": "Heilongjiang Sheng Jixi Shi"
  },
  {
    "code": "230301",
    "nameCN": "牡丹江海浪机场",
    "nameEN": "Mudanjiang Hailang Airport"
  },
  {
    "code": "230400",
    "nameCN": "黑龙江省鹤岗市",
    "nameEN": "Heilongjiang Sheng Hegang Shi"
  },
  {
    "code": "230401",
    "nameCN": "绥芬河铁路",
    "nameEN": "Suifenhe Railway"
  },
  {
    "code": "230402",
    "nameCN": "绥芬河公路",
    "nameEN": "Suifenhe Highroad"
  },
  {
    "code": "230500",
    "nameCN": "黑龙江省双鸭山市",
    "nameEN": "Heilongjiang Sheng Shuangyashan Shi"
  },
  {
    "code": "230501",
    "nameCN": "虎林",
    "nameEN": "Hulin"
  },
  {
    "code": "230600",
    "nameCN": "黑龙江省大庆市",
    "nameEN": "Heilongjiang Sheng Daqing Shi"
  },
  {
    "code": "230601",
    "nameCN": "密山",
    "nameEN": "Mishan"
  },
  {
    "code": "230700",
    "nameCN": "黑龙江省伊春市",
    "nameEN": "Heilongjiang Sheng Yichun Shi"
  },
  {
    "code": "230701",
    "nameCN": "佳木斯港",
    "nameEN": "Jiamusi Harbor"
  },
  {
    "code": "230702",
    "nameCN": "佳木斯东郊机场",
    "nameEN": "Jiamusi Dongjiao Airport"
  },
  {
    "code": "230703",
    "nameCN": "桦川",
    "nameEN": "Huachuan"
  },
  {
    "code": "230800",
    "nameCN": "黑龙江省佳木斯市",
    "nameEN": "Heilongjiang Sheng Jiamusi Shi"
  },
  {
    "code": "230801",
    "nameCN": "饶河",
    "nameEN": "Raohe"
  },
  {
    "code": "230900",
    "nameCN": "黑龙江省七台河市",
    "nameEN": "Heilongjiang Sheng Qitaihe Shi"
  },
  {
    "code": "230901",
    "nameCN": "同江",
    "nameEN": "Tongjiang"
  },
  {
    "code": "231000",
    "nameCN": "黑龙江省牡丹江市",
    "nameEN": "Heilongjiang Sheng Mudanjiang Shi"
  },
  {
    "code": "231001",
    "nameCN": "抚远",
    "nameEN": "Fuyuan"
  },
  {
    "code": "231100",
    "nameCN": "黑龙江省黑河市",
    "nameEN": "Heilongjiang Sheng Heihe Shi"
  },
  {
    "code": "231101",
    "nameCN": "黑河",
    "nameEN": "Heihe"
  },
  {
    "code": "231102",
    "nameCN": "孙吴港",
    "nameEN": "Sunwu Harbor"
  },
  {
    "code": "231103",
    "nameCN": "孙吴边境通道",
    "nameEN": "Sunwu Bianjing Tongdao"
  },
  {
    "code": "231104",
    "nameCN": "呼玛",
    "nameEN": "Huma"
  },
  {
    "code": "231200",
    "nameCN": "黑龙江省绥化市",
    "nameEN": "Heilongjiang Sheng Suihua Shi"
  },
  {
    "code": "231201",
    "nameCN": "逊克",
    "nameEN": "Xunke"
  },
  {
    "code": "231401",
    "nameCN": "萝北",
    "nameEN": "Luobei"
  },
  {
    "code": "231501",
    "nameCN": "东宁",
    "nameEN": "Dongning"
  },
  {
    "code": "231601",
    "nameCN": "绥滨",
    "nameEN": "Suibin"
  },
  {
    "code": "231602",
    "nameCN": "富锦",
    "nameEN": "Fujin"
  },
  {
    "code": "231701",
    "nameCN": "哈尔滨港",
    "nameEN": "Harbin Harbor"
  },
  {
    "code": "231702",
    "nameCN": "哈尔滨站",
    "nameEN": "Harbin Zhan"
  },
  {
    "code": "232700",
    "nameCN": "黑龙江省大兴安岭地区",
    "nameEN": "Heilongjiang Sheng Da Hinggan Ling Diqu"
  },
  {
    "code": "310001",
    "nameCN": "上海",
    "nameEN": "Shanghai"
  },
  {
    "code": "310002",
    "nameCN": "龙吴",
    "nameEN": "Longwu"
  },
  {
    "code": "310011",
    "nameCN": "中国（上海）自由贸易试验区",
    "nameEN": "China (Shanghai) Pilot Free Trade Zone"
  },
  {
    "code": "310101",
    "nameCN": "上海嘉定出口加工区",
    "nameEN": "Shanghai Jiading Export Processind Zone"
  },
  {
    "code": "310102",
    "nameCN": "上海青浦出口加工区",
    "nameEN": "Shanghai Qngpu Export Processind Zone"
  },
  {
    "code": "310201",
    "nameCN": "上海金桥出口加工区",
    "nameEN": "Shangha Jinqiao Export Processind Zone"
  },
  {
    "code": "310301",
    "nameCN": "上海虹桥国际机场",
    "nameEN": "Shanghai Hongqiao International Airport"
  },
  {
    "code": "310302",
    "nameCN": "上海浦东国际机场",
    "nameEN": "Shanghai Pudong International Airport"
  },
  {
    "code": "310303",
    "nameCN": "上海浦东机场综合保税区",
    "nameEN": "Shanghai Pudong Airport Comprehensive Bonded Zone"
  },
  {
    "code": "310401",
    "nameCN": "罗泾",
    "nameEN": "luojing"
  },
  {
    "code": "310402",
    "nameCN": "吴淞",
    "nameEN": "Wusong"
  },
  {
    "code": "310501",
    "nameCN": "崇明",
    "nameEN": "Chongming"
  },
  {
    "code": "310601",
    "nameCN": "上海闵行出口加工区",
    "nameEN": "Shanghai Minhang Export Processind Zone"
  },
  {
    "code": "310701",
    "nameCN": "外高桥",
    "nameEN": "Waigaoqiao"
  },
  {
    "code": "310702",
    "nameCN": "上海外高桥保税物流园区",
    "nameEN": "Shanghai Waigaoqiao Bonded Logistics Zone"
  },
  {
    "code": "310703",
    "nameCN": "上海外高桥保税区",
    "nameEN": "Shanghai Waigaoqiao Free Trade Zone"
  },
  {
    "code": "310901",
    "nameCN": "上海漕河泾出口加工区",
    "nameEN": "Shanghai Caohejing Export Processind Zone"
  },
  {
    "code": "311001",
    "nameCN": "浦东临港产业作业区",
    "nameEN": "Pudong Lingang Chanye Zuoyequ"
  },
  {
    "code": "311002",
    "nameCN": "洋山港",
    "nameEN": "Yangshan Harbor"
  },
  {
    "code": "311003",
    "nameCN": "洋山保税港区",
    "nameEN": "Yangshan Free Trade Port Zone"
  },
  {
    "code": "311201",
    "nameCN": "上海站",
    "nameEN": "Shanghai Zhan"
  },
  {
    "code": "311301",
    "nameCN": "上海松江出口加工区A区",
    "nameEN": "Shanghai Songjiang Export Processind Zone Zone A"
  },
  {
    "code": "311302",
    "nameCN": "上海松江出口加工区B区",
    "nameEN": "Shanghai Songjiang Export Processind Zone Zone B"
  },
  {
    "code": "320001",
    "nameCN": "南京",
    "nameEN": "Nanjing"
  },
  {
    "code": "320101",
    "nameCN": "南京禄口国际机场",
    "nameEN": "Nanjing Lukou International Airport"
  },
  {
    "code": "320102",
    "nameCN": "南京港",
    "nameEN": "Nanjing Harbor"
  },
  {
    "code": "320103",
    "nameCN": "南京出口加工区",
    "nameEN": "Nanjing Export Processind Zone"
  },
  {
    "code": "320104",
    "nameCN": "南京综合保税区",
    "nameEN": "Nanjing Comprehensive Bonded Zone"
  },
  {
    "code": "320200",
    "nameCN": "江苏省无锡市",
    "nameEN": "Jiangsu Sheng Wuxi Shi"
  },
  {
    "code": "320201",
    "nameCN": "苏州",
    "nameEN": "Suzhou"
  },
  {
    "code": "320202",
    "nameCN": "苏州工业园综合保税区",
    "nameEN": "Suzhou Gongyeyuan Comprehensive Bonded Zone"
  },
  {
    "code": "320203",
    "nameCN": "苏州高新技术产业开发区综合保税区",
    "nameEN": "Suzhou Gaoxinjishu Chanye Kaifaqu Comprehensive Bonded Zone"
  },
  {
    "code": "320204",
    "nameCN": "吴中出口加工区",
    "nameEN": "Wuzhong Export Processind Zone"
  },
  {
    "code": "320300",
    "nameCN": "江苏省徐州市",
    "nameEN": "Jiangsu Sheng Xuzhou Shi"
  },
  {
    "code": "320301",
    "nameCN": "吴江出口加工区",
    "nameEN": "Wujiang Export Processind Zone"
  },
  {
    "code": "320400",
    "nameCN": "江苏省常州市",
    "nameEN": "Jiangsu Sheng Changzhou Shi"
  },
  {
    "code": "320401",
    "nameCN": "昆山综合保税区",
    "nameEN": "Kunshan Comprehensive Bonded Zone"
  },
  {
    "code": "320500",
    "nameCN": "江苏省苏州市",
    "nameEN": "Jiangsu Sheng Suzhou Shi"
  },
  {
    "code": "320501",
    "nameCN": "张家港",
    "nameEN": "Zhangjiagang"
  },
  {
    "code": "320502",
    "nameCN": "张家港保税港区",
    "nameEN": "Zhangjiagang Free Trade Port Zone"
  },
  {
    "code": "320600",
    "nameCN": "江苏省南通市",
    "nameEN": "Jiangsu Sheng Nantong Shi"
  },
  {
    "code": "320601",
    "nameCN": "常熟",
    "nameEN": "Changshu"
  },
  {
    "code": "320602",
    "nameCN": "常熟出口加工区",
    "nameEN": "Changshu Export Processind Zone"
  },
  {
    "code": "320700",
    "nameCN": "江苏省连云港市",
    "nameEN": "Jiangsu Sheng Lianyungang Shi"
  },
  {
    "code": "320701",
    "nameCN": "太仓",
    "nameEN": "Taicang"
  },
  {
    "code": "320702",
    "nameCN": "太仓港综合保税区",
    "nameEN": "Taicanggang Comprehensive Bonded Zone"
  },
  {
    "code": "320800",
    "nameCN": "江苏省淮安市",
    "nameEN": "Jiangsu Sheng Huai'an Shi"
  },
  {
    "code": "320801",
    "nameCN": "无锡",
    "nameEN": "Wuxi"
  },
  {
    "code": "320802",
    "nameCN": "苏南硕放国际机场",
    "nameEN": "Sunan Shuofang International Airport"
  },
  {
    "code": "320803",
    "nameCN": "无锡高新区综合保税区",
    "nameEN": "Wuxi Gaoxinqu Comprehensive Bonded Zone"
  },
  {
    "code": "320804",
    "nameCN": "无锡出口加工区",
    "nameEN": "Wuxi Export Processind Zone"
  },
  {
    "code": "320900",
    "nameCN": "江苏省盐城市",
    "nameEN": "Jiangsu Sheng Yancheng Shi"
  },
  {
    "code": "320901",
    "nameCN": "江阴",
    "nameEN": "Jiangyin"
  },
  {
    "code": "321000",
    "nameCN": "江苏省扬州市",
    "nameEN": "Jiangsu Sheng Yangzhou Shi"
  },
  {
    "code": "321100",
    "nameCN": "江苏省镇江市",
    "nameEN": "Jiangsu Sheng Zhengjiang Shi"
  },
  {
    "code": "321101",
    "nameCN": "南通",
    "nameEN": "Nantong"
  },
  {
    "code": "321103",
    "nameCN": "如皋",
    "nameEN": "Rugao"
  },
  {
    "code": "321104",
    "nameCN": "南通综合保税区",
    "nameEN": "Nantong Comprehensive Bonded Zone"
  },
  {
    "code": "321106",
    "nameCN": "南通机场",
    "nameEN": "Nantong Airport"
  },
  {
    "code": "321200",
    "nameCN": "江苏省泰州市",
    "nameEN": "Jiangsu Sheng Taizhou Shi"
  },
  {
    "code": "321201",
    "nameCN": "连云港",
    "nameEN": "Lianyungang"
  },
  {
    "code": "321202",
    "nameCN": "连云港出口加工区",
    "nameEN": "Lianyungang Export Processind Zone"
  },
  {
    "code": "321300",
    "nameCN": "江苏省宿迁市",
    "nameEN": "Jiangsu Sheng Suqian Shi"
  },
  {
    "code": "321301",
    "nameCN": "镇江",
    "nameEN": "Zhenjiang"
  },
  {
    "code": "321302",
    "nameCN": "镇江出口加工区",
    "nameEN": "Zhenjiang Export Processind Zone"
  },
  {
    "code": "321401",
    "nameCN": "徐州机场",
    "nameEN": "Xuzhou Airport"
  },
  {
    "code": "321501",
    "nameCN": "淮安综合保税区",
    "nameEN": "Huaian Comprehensive Bonded Zone"
  },
  {
    "code": "321502",
    "nameCN": "淮安出口加工区",
    "nameEN": " Huai'an Export Processind Zone"
  },
  {
    "code": "321601",
    "nameCN": "常州",
    "nameEN": "Changzhou"
  },
  {
    "code": "321602",
    "nameCN": "常州出口加工区",
    "nameEN": "Changzhou Export Processind Zone"
  },
  {
    "code": "321603",
    "nameCN": "武进出口加工区",
    "nameEN": "Wujin Export Processind Zone"
  },
  {
    "code": "321604",
    "nameCN": "常州奔牛机场",
    "nameEN": "Changzhou Benniu Airport"
  },
  {
    "code": "321701",
    "nameCN": "盐城机场",
    "nameEN": "Yancheng Airport"
  },
  {
    "code": "321702",
    "nameCN": "射阳",
    "nameEN": "Sheyang"
  },
  {
    "code": "321703",
    "nameCN": "盐城综合保税区",
    "nameEN": "YanchengComprehensive Bonded Zone"
  },
  {
    "code": "321704",
    "nameCN": "大丰",
    "nameEN": "Dafeng"
  },
  {
    "code": "321801",
    "nameCN": "扬州",
    "nameEN": "Yangzhou"
  },
  {
    "code": "321802",
    "nameCN": "扬州出口加工区",
    "nameEN": "Yangzhou Export Processind Zone"
  },
  {
    "code": "321901",
    "nameCN": "高港",
    "nameEN": "Gaogang"
  },
  {
    "code": "321902",
    "nameCN": "泰州",
    "nameEN": "Taizhou"
  },
  {
    "code": "322201",
    "nameCN": "靖江",
    "nameEN": "Jingjiang"
  },
  {
    "code": "322202",
    "nameCN": "泰州出口加工区",
    "nameEN": "Taizhou Export Processind Zone"
  },
  {
    "code": "322401",
    "nameCN": "启东",
    "nameEN": "Qidong"
  },
  {
    "code": "322501",
    "nameCN": "如东洋口",
    "nameEN": "Rudong Yangkou"
  },
  {
    "code": "330001",
    "nameCN": "杭州",
    "nameEN": "Hangzhou"
  },
  {
    "code": "330002",
    "nameCN": "杭州萧山国际机场",
    "nameEN": "Hangzhou Xiaoshan International Airport"
  },
  {
    "code": "330101",
    "nameCN": "温州龙湾国际机场",
    "nameEN": "Wenzhou Longwan International Airport"
  },
  {
    "code": "330102",
    "nameCN": "温州港瓯江港区七里作业区",
    "nameEN": "Wenzhou Harbor Oujiang Port Area Qili Operational Zone"
  },
  {
    "code": "330103",
    "nameCN": "温州港平阳港区",
    "nameEN": "Wenzhou Harbor Pingyang Port Area"
  },
  {
    "code": "330104",
    "nameCN": "温州港状元岙港区",
    "nameEN": "Wenzhou Harbor Zhuangyuanao Port Area"
  },
  {
    "code": "330105",
    "nameCN": "温州港乐清湾港区",
    "nameEN": "Wenzhou Harbor Yueqingwan Port Area"
  },
  {
    "code": "330106",
    "nameCN": "温州港大小门岛港区",
    "nameEN": "Wenzhou Harbor Daxiaomendao Port Areaxia"
  },
  {
    "code": "330200",
    "nameCN": "浙江省宁波市",
    "nameEN": "Zhejiang Sheng Ningbo Shi"
  },
  {
    "code": "330201",
    "nameCN": "金义综合保税区",
    "nameEN": "Jinyi Comprehensive Bonded Zone"
  },
  {
    "code": "330300",
    "nameCN": "浙江省温州市",
    "nameEN": "Zhejiang Sheng Wenzhou Shi"
  },
  {
    "code": "330301",
    "nameCN": "舟山",
    "nameEN": "Zhoushan"
  },
  {
    "code": "330302",
    "nameCN": "舟山定海港区",
    "nameEN": "Zhoushan Dinghai Gangqu"
  },
  {
    "code": "330303",
    "nameCN": "舟山定海岙山油库",
    "nameEN": "Zhoushan Dinghai Aoshan Youku"
  },
  {
    "code": "330304",
    "nameCN": "舟山定海万向油库",
    "nameEN": "Zhoushan Dinghai Wanxiang Youku"
  },
  {
    "code": "330305",
    "nameCN": "舟山老塘山港区",
    "nameEN": "Zhoushan Laotangshan Gangqu"
  },
  {
    "code": "330306",
    "nameCN": "舟山老塘山三期码头",
    "nameEN": "Zhoushan Laotangshan Sanqimatou"
  },
  {
    "code": "330307",
    "nameCN": "舟山老塘山五期码头",
    "nameEN": "Zhoushan Laotangshan Wuqimatou"
  },
  {
    "code": "330308",
    "nameCN": "舟山老塘山册子油库",
    "nameEN": "Zhoushan Laotangshan Cezi Youku"
  },
  {
    "code": "330309",
    "nameCN": "舟山金塘港区",
    "nameEN": "Zhoushan Jintang Gangqu"
  },
  {
    "code": "330310",
    "nameCN": "舟山金塘集装箱码头",
    "nameEN": "Zhoushan Jintang Container Dock"
  },
  {
    "code": "330311",
    "nameCN": "舟山沈家门港区",
    "nameEN": "Zhoushan Shenjiamen Gangqu"
  },
  {
    "code": "330312",
    "nameCN": "舟山沈家门半升洞油库",
    "nameEN": "Zhoushan Shenjiamen Banshengdong Youku"
  },
  {
    "code": "330313",
    "nameCN": "舟山六横港区",
    "nameEN": "Zhoushan Liuheng Gangqu"
  },
  {
    "code": "330314",
    "nameCN": "舟山六横煤电码头",
    "nameEN": "Zhoushan Liuheng Meidian Dock"
  },
  {
    "code": "330315",
    "nameCN": "舟山六横武港码头",
    "nameEN": "Zhoushan Liuheng Wugang Dock"
  },
  {
    "code": "330316",
    "nameCN": "舟山六横金润石油",
    "nameEN": "Zhoushan Liuheng Jinrun Shiyou"
  },
  {
    "code": "330317",
    "nameCN": "舟山衢山港区",
    "nameEN": "Zhoushan Qushan Gangqu"
  },
  {
    "code": "330318",
    "nameCN": "舟山马岙港区",
    "nameEN": "Zhoushan Maao Gangqu"
  },
  {
    "code": "330319",
    "nameCN": "舟山马岙太平洋化工",
    "nameEN": "Zhoushan Maao Taipingyang Huagong"
  },
  {
    "code": "330320",
    "nameCN": "舟山马岙纳海油污",
    "nameEN": "Zhoushan Maao Nahai Youwu"
  },
  {
    "code": "330321",
    "nameCN": "舟山马岙天禄能源",
    "nameEN": "Zhoushan Maao Tianlu Nengyuan"
  },
  {
    "code": "330322",
    "nameCN": "岱山高亭",
    "nameEN": "Daishan Gaoting"
  },
  {
    "code": "330323",
    "nameCN": "舟山港综合保税区",
    "nameEN": "Zhoushangang Comprehensive Bonded Zone"
  },
  {
    "code": "330400",
    "nameCN": "浙江省嘉兴市",
    "nameEN": "Zhejiang Sheng Jiaxing Shi"
  },
  {
    "code": "330401",
    "nameCN": "泗礁",
    "nameEN": "Sijiao"
  },
  {
    "code": "330500",
    "nameCN": "浙江省湖州市",
    "nameEN": "Zhejiang Sheng Huzhou Shi"
  },
  {
    "code": "330501",
    "nameCN": "海门",
    "nameEN": "Haimen"
  },
  {
    "code": "330502",
    "nameCN": "台州",
    "nameEN": "Taizhou"
  },
  {
    "code": "330503",
    "nameCN": "大麦屿",
    "nameEN": "Damaiyu"
  },
  {
    "code": "330600",
    "nameCN": "浙江省绍兴市",
    "nameEN": "Zhejiang Sheng Shaoxing Shi"
  },
  {
    "code": "330700",
    "nameCN": "浙江省金华市",
    "nameEN": "Zhejiang Sheng Jinhua Shi"
  },
  {
    "code": "330701",
    "nameCN": "嘉兴",
    "nameEN": "Jiaxing"
  },
  {
    "code": "330702",
    "nameCN": "嘉兴港",
    "nameEN": "Jiaxing Harbor"
  },
  {
    "code": "330703",
    "nameCN": "嘉兴出口加工区A区",
    "nameEN": "Jiaxing Export Processind Zone Zone A"
  },
  {
    "code": "330704",
    "nameCN": "嘉兴出口加工区B区",
    "nameEN": "Jiaxing Export Processind Zone Zone B"
  },
  {
    "code": "330800",
    "nameCN": "浙江省衢州市",
    "nameEN": "Zhejiang Sheng Quzhou Shi"
  },
  {
    "code": "330801",
    "nameCN": "湖州",
    "nameEN": "Huzhou"
  },
  {
    "code": "330802",
    "nameCN": "湖州南浔",
    "nameEN": "Huzhou Nanxun"
  },
  {
    "code": "330803",
    "nameCN": "湖州安吉川达",
    "nameEN": "Huzhou Anji Chuanda"
  },
  {
    "code": "330900",
    "nameCN": "浙江省舟山市",
    "nameEN": "Zhejiang Sheng Zhoushan Shi"
  },
  {
    "code": "331000",
    "nameCN": "浙江省台州市",
    "nameEN": "Zhejiang Sheng Taizhou Shi"
  },
  {
    "code": "331100",
    "nameCN": "浙江省丽水市",
    "nameEN": "Zhejiang Sheng Lishui Shi"
  },
  {
    "code": "331101",
    "nameCN": "杭州保税物流园区（B型）",
    "nameEN": "Hangzhou Bonded Logistics Zone(B)"
  },
  {
    "code": "331201",
    "nameCN": "义乌",
    "nameEN": "Yiwu"
  },
  {
    "code": "333301",
    "nameCN": "杭州出口加工区",
    "nameEN": "Hangzhou Export Processind Zone"
  },
  {
    "code": "333302",
    "nameCN": "杭州中和保税区",
    "nameEN": "Hangzhou Zhonghe Free Trade Zone"
  },
  {
    "code": "340001",
    "nameCN": "合肥",
    "nameEN": "Hefei"
  },
  {
    "code": "340002",
    "nameCN": "合肥新桥国际机场",
    "nameEN": "Hefei Xinqiao International Airport"
  },
  {
    "code": "340003",
    "nameCN": "合肥新站",
    "nameEN": "Hefei Xinzhan"
  },
  {
    "code": "340004",
    "nameCN": "六安",
    "nameEN": "Luan"
  },
  {
    "code": "340005",
    "nameCN": "芜湖出口加工区",
    "nameEN": "Wuhu Export Processind Zone"
  },
  {
    "code": "340006",
    "nameCN": "合肥出口加工区",
    "nameEN": "Hefei Export Processind Zone"
  },
  {
    "code": "340007",
    "nameCN": "合肥综合保税区",
    "nameEN": "Hefei Comprehensive Bonded Zone"
  },
  {
    "code": "340101",
    "nameCN": "芜湖",
    "nameEN": "Wuhu"
  },
  {
    "code": "340200",
    "nameCN": "安徽省芜湖市",
    "nameEN": "Anhui Sheng Wuhu Shi"
  },
  {
    "code": "340201",
    "nameCN": "安庆",
    "nameEN": "Anqing"
  },
  {
    "code": "340300",
    "nameCN": "安徽省蚌埠市",
    "nameEN": "Anhui Sheng Bengbu Shi"
  },
  {
    "code": "340301",
    "nameCN": "铜陵",
    "nameEN": "Tongling"
  },
  {
    "code": "340400",
    "nameCN": "安徽省淮南市",
    "nameEN": "Anhui Sheng Huainan Shi"
  },
  {
    "code": "340401",
    "nameCN": "马鞍山",
    "nameEN": "Maanshan"
  },
  {
    "code": "340500",
    "nameCN": "安徽省马鞍山市",
    "nameEN": "Anhui Sheng Ma'anshan Shi"
  },
  {
    "code": "340501",
    "nameCN": "蚌埠",
    "nameEN": "Bengbu"
  },
  {
    "code": "340502",
    "nameCN": "淮南",
    "nameEN": "Huainan"
  },
  {
    "code": "340600",
    "nameCN": "安徽省淮北市",
    "nameEN": "Anhui Sheng Huaibei Shi"
  },
  {
    "code": "340601",
    "nameCN": "阜阳",
    "nameEN": "Fuyang"
  },
  {
    "code": "340602",
    "nameCN": "亳州",
    "nameEN": "Bozhou"
  },
  {
    "code": "340700",
    "nameCN": "安徽省铜陵市",
    "nameEN": "Anhui Sheng Tongling Shi"
  },
  {
    "code": "340701",
    "nameCN": "黄山屯溪机场",
    "nameEN": "Huangshan Tunxi Airport"
  },
  {
    "code": "340800",
    "nameCN": "安徽省安庆市",
    "nameEN": "Anhui Sheng Anqing Shi"
  },
  {
    "code": "340801",
    "nameCN": "池州",
    "nameEN": "Chizhou"
  },
  {
    "code": "340901",
    "nameCN": "滁州",
    "nameEN": "Chuzhou"
  },
  {
    "code": "341000",
    "nameCN": "安徽省黄山市",
    "nameEN": "Anhui Sheng Huangshan Shi"
  },
  {
    "code": "341001",
    "nameCN": "宣城",
    "nameEN": "Xuancheng"
  },
  {
    "code": "341100",
    "nameCN": "安徽省滁州市",
    "nameEN": "Anhui Sheng Chuzhou Shi"
  },
  {
    "code": "341200",
    "nameCN": "安徽省阜阳市",
    "nameEN": "Anhui Sheng Fuyang Shi"
  },
  {
    "code": "341201",
    "nameCN": "淮北",
    "nameEN": "Huaibei"
  },
  {
    "code": "341202",
    "nameCN": "宿州",
    "nameEN": "Suzhou"
  },
  {
    "code": "341300",
    "nameCN": "安徽省宿州市",
    "nameEN": "Anhui Sheng Suzhou Shi"
  },
  {
    "code": "341500",
    "nameCN": "安徽省六安市",
    "nameEN": "Anhui Sheng Lu'an Shi"
  },
  {
    "code": "341600",
    "nameCN": "安徽省亳州市",
    "nameEN": "Anhui Sheng Bozhou Shi"
  },
  {
    "code": "341700",
    "nameCN": "安徽省池州市",
    "nameEN": "Anhui Sheng Chizhou Shi"
  },
  {
    "code": "341800",
    "nameCN": "安徽省宣城市",
    "nameEN": "Anhui Sheng Xuncheng Shi"
  },
  {
    "code": "350001",
    "nameCN": "福州",
    "nameEN": "Fuzhou"
  },
  {
    "code": "350002",
    "nameCN": "福州港江阴港区非保税码头",
    "nameEN": "Fuzhou Harbor Jiangyin Gangqu Feibaoshui Dock"
  },
  {
    "code": "350003",
    "nameCN": "福州港平潭金井码头",
    "nameEN": "Fuzhou Harbor Pingtan Jinjing Dock"
  },
  {
    "code": "350004",
    "nameCN": "平潭港口岸澳前港区",
    "nameEN": "Pingtan Harbor Aoqian Gangqu"
  },
  {
    "code": "350005",
    "nameCN": "福州港平潭澳前客滚码头",
    "nameEN": "Fuzhou Harbor Pingtan Aoqiankegun Dock"
  },
  {
    "code": "350006",
    "nameCN": "武夷山机场",
    "nameEN": "Wuyishan Airport"
  },
  {
    "code": "350007",
    "nameCN": "武夷山陆地港",
    "nameEN": "Wuyishan Ludigang"
  },
  {
    "code": "350008",
    "nameCN": "福州保税港区",
    "nameEN": "Fuzhou Free Trade Port Zone"
  },
  {
    "code": "350011",
    "nameCN": "中国（福建）自由贸易试验区",
    "nameEN": "China (Fujian) Pilot Free Trade Zone"
  },
  {
    "code": "350101",
    "nameCN": "泉州港肖厝港区",
    "nameEN": "Quanzhou Harbor Xiaocuo Gangqu"
  },
  {
    "code": "350102",
    "nameCN": "泉州港泉州湾港区",
    "nameEN": "Quanzhou Harbor Quanzhouwan Gangqu"
  },
  {
    "code": "350103",
    "nameCN": "泉州港围头湾港区",
    "nameEN": "Quanzhou Harbor Weitouwan Gangqu"
  },
  {
    "code": "350104",
    "nameCN": "泉州港深沪湾港区",
    "nameEN": "Quanzhou Harbor Shenhuwan Gangqu"
  },
  {
    "code": "350105",
    "nameCN": "泉州港斗尾港区",
    "nameEN": "Quanzhou Harbor Douwei Gangqu"
  },
  {
    "code": "350106",
    "nameCN": "泉州港石井客运码头",
    "nameEN": "Quanzhou Harbor Shijing Passenger Transpor Dock"
  },
  {
    "code": "350107",
    "nameCN": "泉州港肖厝小额贸易点",
    "nameEN": "Quanzhou Harbor Xiaocuo Xiaoemaoyidian"
  },
  {
    "code": "350108",
    "nameCN": "泉州惠安崇武小额贸易点",
    "nameEN": "Quanzhou Huian Chongwu Xiaoemaoyidian"
  },
  {
    "code": "350109",
    "nameCN": "泉州后渚小额贸易点",
    "nameEN": "Quanzhou Houzhu Xiaoemaoyidian"
  },
  {
    "code": "350110",
    "nameCN": "泉州石狮石湖小额贸易点",
    "nameEN": "Quanzhou Shishi Shihu Xiaoemaoyidian"
  },
  {
    "code": "350111",
    "nameCN": "泉州晋江围头小额贸易点",
    "nameEN": "Quanzhou Jinjiang Weitou Xiaoemaoyidian"
  },
  {
    "code": "350112",
    "nameCN": "泉州晋江深沪小额贸易点",
    "nameEN": "Quanzhou Jinjiang Shenhu Xiaoemaoyidian"
  },
  {
    "code": "350113",
    "nameCN": "泉州南安石井小额贸易点",
    "nameEN": "Quanzhou Nanan Shijing Xiaoemaoyidian"
  },
  {
    "code": "350114",
    "nameCN": "泉州晋江陆地港",
    "nameEN": "Quanzhou Jinjiang Ludigang"
  },
  {
    "code": "350115",
    "nameCN": "泉州晋江机场",
    "nameEN": "Quanzhou Jinjiang Airport"
  },
  {
    "code": "350116",
    "nameCN": "泉州出口加工区",
    "nameEN": "Quanzhou Export Processind Zone"
  },
  {
    "code": "350200",
    "nameCN": "福建省厦门市",
    "nameEN": "Fujian Sheng Xiamen Shi"
  },
  {
    "code": "350201",
    "nameCN": "莆田湄洲岛小额贸易点",
    "nameEN": "Putian Meizhoudao Xiaoemaoyidian"
  },
  {
    "code": "350202",
    "nameCN": "莆田港秀屿港区",
    "nameEN": "Putian Harbor Xiuyu Gangqu"
  },
  {
    "code": "350203",
    "nameCN": "莆田港湄洲岛客运码头",
    "nameEN": "Putian Harbor Meizhoudao Passenger Transpor Dock"
  },
  {
    "code": "350204",
    "nameCN": "莆田港东吴港区",
    "nameEN": "Putian Harbor Dongwu Gangqu"
  },
  {
    "code": "350300",
    "nameCN": "福建省莆田市",
    "nameEN": "Fujian Sheng Putian Shi"
  },
  {
    "code": "350301",
    "nameCN": "三明陆地港",
    "nameEN": "Sanming Ludigang"
  },
  {
    "code": "350400",
    "nameCN": "福建省三明市",
    "nameEN": "Fujian Sheng Sanming Shi"
  },
  {
    "code": "350401",
    "nameCN": "福州港马尾客运码头",
    "nameEN": "Fuzhou Harbor Mawei Passenger Transpor Dock"
  },
  {
    "code": "350402",
    "nameCN": "福州港闽江口内港区",
    "nameEN": "Fuzhou Harbor Minjiangkou Neigangqu"
  },
  {
    "code": "350403",
    "nameCN": "福州港马尾小额贸易点",
    "nameEN": "Fuzhou Harbor Mawei Xiaoemaoyidian"
  },
  {
    "code": "350404",
    "nameCN": "福州港连江琯头小额贸易点",
    "nameEN": "Fuzhou Harbor Lianjiang Guantou Xiaoemaoyidian"
  },
  {
    "code": "350405",
    "nameCN": "福州港罗源迹头小额贸易点",
    "nameEN": "Fuzhou Harbor Luoyuan Jitou Xiaoemaoyidian"
  },
  {
    "code": "350406",
    "nameCN": "福州港罗源湾港区",
    "nameEN": "Fuzhou Harbor luoyuanwan Gangqu"
  },
  {
    "code": "350407",
    "nameCN": "福州港黄岐港区",
    "nameEN": "Fuzhou Harbor Huangqi Gangqu"
  },
  {
    "code": "350408",
    "nameCN": "福州港松下港区牛头湾作业区",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Niutouwan Zuoyequ"
  },
  {
    "code": "350409",
    "nameCN": "福州港松下港区长乐松下小额贸易点",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Changlesong Xiaxiaoemaoyidian"
  },
  {
    "code": "350410",
    "nameCN": "福州保税区",
    "nameEN": "Fuzhou Free Trade Zone"
  },
  {
    "code": "350411",
    "nameCN": "福州出口加工区",
    "nameEN": "Fuzhou Export Processind Zone"
  },
  {
    "code": "350500",
    "nameCN": "福建省泉州市",
    "nameEN": "Fujian Sheng Quanzhou Shi"
  },
  {
    "code": "350501",
    "nameCN": "宁德港三都澳港区",
    "nameEN": "Ningde Harbor Sanduao Gangqu"
  },
  {
    "code": "350502",
    "nameCN": "宁德港三沙港区",
    "nameEN": "Ningde Harbor Sansha Gangqu"
  },
  {
    "code": "350503",
    "nameCN": "宁德港沙埕港区",
    "nameEN": "Ningde Harbor Shacheng Gangqu"
  },
  {
    "code": "350504",
    "nameCN": "宁德港赛江港区",
    "nameEN": "Ningde Harbor Saijiang Gangqu"
  },
  {
    "code": "350505",
    "nameCN": "霞浦三沙小额贸易点",
    "nameEN": "Xiapu Sansha Xiaoemaoyidian"
  },
  {
    "code": "350600",
    "nameCN": "福建省漳州市",
    "nameEN": "Fujian Sheng Zhangzhou Shi"
  },
  {
    "code": "350601",
    "nameCN": "福州港松下港区元洪作业区",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Yuanhong Zuoyequ"
  },
  {
    "code": "350602",
    "nameCN": "福州港松下港区南青屿小额贸易点",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Nanqingyu Xiaoemaoyidian"
  },
  {
    "code": "350700",
    "nameCN": "福建省南平市",
    "nameEN": "Fujian Sheng Nanping Shi"
  },
  {
    "code": "350800",
    "nameCN": "福建省龙岩市",
    "nameEN": "Fujian Sheng Longyan Shi"
  },
  {
    "code": "350900",
    "nameCN": "福建省宁德市",
    "nameEN": "Fujian Sheng Ningde Shi"
  },
  {
    "code": "350901",
    "nameCN": "龙岩陆地港",
    "nameEN": "Longyan Ludigang"
  },
  {
    "code": "351101",
    "nameCN": "东山湾东山港区",
    "nameEN": "Dongshanwan Dongshan Gangqu"
  },
  {
    "code": "351102",
    "nameCN": "东山湾诏安港区",
    "nameEN": "Dongshanwan Zhaoan Gangqu"
  },
  {
    "code": "351103",
    "nameCN": "漳州东山铜陵小额贸易点",
    "nameEN": "Zhangzhou Dongshan Tongling Xiaoemaoyidian"
  },
  {
    "code": "351104",
    "nameCN": "漳州云霄礁美小额贸易点",
    "nameEN": "Zhangzhou Yunxiao Jiaomei Xiaoemaoyidian"
  },
  {
    "code": "351105",
    "nameCN": "漳州诏安田厝小额贸易点",
    "nameEN": "Zhangzhou Zhaoan Tiancuo Xiaoemaoyidian"
  },
  {
    "code": "351201",
    "nameCN": "福州长乐国际机场",
    "nameEN": "Fuzhou Changle International Airport"
  },
  {
    "code": "360001",
    "nameCN": "南昌",
    "nameEN": "Nanchang"
  },
  {
    "code": "360002",
    "nameCN": "南昌昌北机场",
    "nameEN": "Nanchang Changbei Airport"
  },
  {
    "code": "360003",
    "nameCN": "南昌出口加工区",
    "nameEN": "Nanchang Export Processind Zone"
  },
  {
    "code": "360101",
    "nameCN": "九江",
    "nameEN": "Jiujiang"
  },
  {
    "code": "360102",
    "nameCN": "九江出口加工区",
    "nameEN": "Jiujiang Export Processind Zone"
  },
  {
    "code": "360200",
    "nameCN": "江西省景德镇市",
    "nameEN": "Jiangxi Sheng Jingdezhen Shi"
  },
  {
    "code": "360300",
    "nameCN": "江西省萍乡市",
    "nameEN": "Jiangxi Sheng Pingxiang Shi"
  },
  {
    "code": "360301",
    "nameCN": "赣州出口加工区",
    "nameEN": "Ganzhou Export Processind Zone"
  },
  {
    "code": "360302",
    "nameCN": "赣州综合保税区",
    "nameEN": "Ganzhou Comprehensive Bonded Zone"
  },
  {
    "code": "360400",
    "nameCN": "江西省九江市",
    "nameEN": "Jiangxi Sheng Jiujiang Shi"
  },
  {
    "code": "360500",
    "nameCN": "江西省新余市",
    "nameEN": "Jiangxi Sheng Xinyu Shi"
  },
  {
    "code": "360600",
    "nameCN": "江西省鹰潭市",
    "nameEN": "Jiangxi Sheng Yingtan Shi"
  },
  {
    "code": "360601",
    "nameCN": "井冈山出口加工区",
    "nameEN": "Jinggnanshan Export Processind Zone"
  },
  {
    "code": "360700",
    "nameCN": "江西省赣州市",
    "nameEN": "Jiangxi Sheng Ganzhou Shi"
  },
  {
    "code": "360800",
    "nameCN": "江西省吉安市",
    "nameEN": "Jiangxi Sheng Ji'an Shi"
  },
  {
    "code": "360900",
    "nameCN": "江西省宜春市",
    "nameEN": "Jiangxi Sheng Yichun Shi"
  },
  {
    "code": "361000",
    "nameCN": "江西省抚州市",
    "nameEN": "Jiangxi Sheng Fuzhou Shi"
  },
  {
    "code": "361100",
    "nameCN": "江西省上饶市",
    "nameEN": "Jiangxi Sheng Shangrao Shi"
  },
  {
    "code": "370001",
    "nameCN": "济南",
    "nameEN": "Jinan"
  },
  {
    "code": "370002",
    "nameCN": "日照",
    "nameEN": "Rizhao"
  },
  {
    "code": "370003",
    "nameCN": "岚山",
    "nameEN": "Lanshan"
  },
  {
    "code": "370101",
    "nameCN": "青岛港",
    "nameEN": "Qingdao Harbor"
  },
  {
    "code": "370102",
    "nameCN": "青岛出口加工区",
    "nameEN": "Qingdao Export Processind Zone"
  },
  {
    "code": "370200",
    "nameCN": "山东省青岛市",
    "nameEN": "Shandong Sheng Qingdao Shi"
  },
  {
    "code": "370201",
    "nameCN": "黄岛",
    "nameEN": "Huangdao"
  },
  {
    "code": "370202",
    "nameCN": "青岛前湾保税港区",
    "nameEN": "Qingdao Qianwan Free Trade Port Zone"
  },
  {
    "code": "370203",
    "nameCN": "青岛西海岸出口加工区",
    "nameEN": "Qingdao Xihaian Export Processind Zone"
  },
  {
    "code": "370300",
    "nameCN": "山东省淄博市",
    "nameEN": "Shandong Sheng Zibo Shi"
  },
  {
    "code": "370301",
    "nameCN": "烟台莱山机场",
    "nameEN": "Yantai Laishan Airport"
  },
  {
    "code": "370302",
    "nameCN": "烟台港",
    "nameEN": "Yantai Harbor"
  },
  {
    "code": "370303",
    "nameCN": "烟台保税港区A区",
    "nameEN": "Yantai Free Trade Port Zone A Qu"
  },
  {
    "code": "370304",
    "nameCN": "烟台保税港区B区",
    "nameEN": "Yantai Free Trade Port Zone B Qu"
  },
  {
    "code": "370400",
    "nameCN": "山东省枣庄市",
    "nameEN": "Shandong Sheng Zaozhuang Shi"
  },
  {
    "code": "370401",
    "nameCN": "石岛",
    "nameEN": "Shidao"
  },
  {
    "code": "370402",
    "nameCN": "龙眼",
    "nameEN": "Longyan"
  },
  {
    "code": "370500",
    "nameCN": "山东省东营市",
    "nameEN": "Shandong Sheng Dongying Shi"
  },
  {
    "code": "370501",
    "nameCN": "龙口",
    "nameEN": "Longkou"
  },
  {
    "code": "370600",
    "nameCN": "山东省烟台市",
    "nameEN": "Shandong Sheng Yantai Shi"
  },
  {
    "code": "370601",
    "nameCN": "莱州",
    "nameEN": "Laizhou"
  },
  {
    "code": "370700",
    "nameCN": "山东省潍坊市",
    "nameEN": "Shandong Sheng Weifang Shi"
  },
  {
    "code": "370701",
    "nameCN": "济南遥墙机场",
    "nameEN": "Jinan Yaoqiang Airport"
  },
  {
    "code": "370702",
    "nameCN": "济南综合保税区",
    "nameEN": "Jinan Comprehensive Bonded Zone"
  },
  {
    "code": "370703",
    "nameCN": "济南出口加工区",
    "nameEN": "Jinan Export Processind Zone"
  },
  {
    "code": "370800",
    "nameCN": "山东省济宁市",
    "nameEN": "Shandong Sheng Jining Shi"
  },
  {
    "code": "370801",
    "nameCN": "济宁站",
    "nameEN": "Jiningzhan"
  },
  {
    "code": "370900",
    "nameCN": "山东省泰安市",
    "nameEN": "Shandong Sheng Tai'an Shi"
  },
  {
    "code": "370901",
    "nameCN": "潍坊",
    "nameEN": "Weifang"
  },
  {
    "code": "370902",
    "nameCN": "潍坊综合保税区",
    "nameEN": "Weifang Comprehensive Bonded Zone"
  },
  {
    "code": "371000",
    "nameCN": "山东省威海市",
    "nameEN": "Shandong Sheng Weihai Shi"
  },
  {
    "code": "371100",
    "nameCN": "山东省日照市",
    "nameEN": "Shandong Sheng Rizhao Shi"
  },
  {
    "code": "371200",
    "nameCN": "山东省莱芜市",
    "nameEN": "Shandong Sheng Laiwu Shi"
  },
  {
    "code": "371201",
    "nameCN": "威海机场",
    "nameEN": "Weihai Airport"
  },
  {
    "code": "371202",
    "nameCN": "威海港",
    "nameEN": "Weihai Harbor"
  },
  {
    "code": "371203",
    "nameCN": "威海出口加工区",
    "nameEN": "Weihai Export Processind Zone"
  },
  {
    "code": "371300",
    "nameCN": "山东省临沂市",
    "nameEN": "Shandong Sheng Linyi Shi"
  },
  {
    "code": "371400",
    "nameCN": "山东省德州市",
    "nameEN": "Shandong Sheng Dezhou Shi"
  },
  {
    "code": "371500",
    "nameCN": "山东省聊城市",
    "nameEN": "Shandong Sheng Liaocheng Shi"
  },
  {
    "code": "371600",
    "nameCN": "山东省滨州市",
    "nameEN": "Shandong Sheng Binzhou Shi"
  },
  {
    "code": "371700",
    "nameCN": "山东省菏泽市",
    "nameEN": "Shandong Sheng Heze Shi"
  },
  {
    "code": "371801",
    "nameCN": "临沂站",
    "nameEN": "Linyizhan"
  },
  {
    "code": "371802",
    "nameCN": "临沂综合保税区",
    "nameEN": "Linyi Comprehensive Bonded Zone"
  },
  {
    "code": "371901",
    "nameCN": "东营",
    "nameEN": "Dongying"
  },
  {
    "code": "371902",
    "nameCN": "东营综合保税区",
    "nameEN": "Dongying Comprehensive Bonded Zone"
  },
  {
    "code": "372301",
    "nameCN": "青岛流亭机场",
    "nameEN": "Qingdao Liuting Airport"
  },
  {
    "code": "372401",
    "nameCN": "蓬莱",
    "nameEN": "Penglai"
  },
  {
    "code": "380001",
    "nameCN": "宁波",
    "nameEN": "Ningbo"
  },
  {
    "code": "380002",
    "nameCN": "宁波栎社机场",
    "nameEN": "Ningbo Lishe Airport"
  },
  {
    "code": "380003",
    "nameCN": "宁波甬江港区",
    "nameEN": "Ningbo Yongjiang Gangqu"
  },
  {
    "code": "380004",
    "nameCN": "宁波出口加工区",
    "nameEN": "Ningbo Export Processind Zone"
  },
  {
    "code": "380005",
    "nameCN": "宁波保税区",
    "nameEN": "Ningbo Free Trade Zone"
  },
  {
    "code": "380101",
    "nameCN": "宁波北仑港港区",
    "nameEN": "Ningbo Beilungang Gangqu"
  },
  {
    "code": "380102",
    "nameCN": "宁波穿山港区",
    "nameEN": "Ningbo Chuanshan Gangqu"
  },
  {
    "code": "380201",
    "nameCN": "慈溪出口加工区",
    "nameEN": "Cixi Export Processind Zone"
  },
  {
    "code": "380701",
    "nameCN": "宁波象山石浦港区",
    "nameEN": "Ningbo Xiangshan Shipu Gangqu"
  },
  {
    "code": "380702",
    "nameCN": "宁波象山港区",
    "nameEN": "Ningbo Xiangshan Gangqu"
  },
  {
    "code": "380801",
    "nameCN": "宁波大榭港区",
    "nameEN": "Ningbo Daxie Gangqu"
  },
  {
    "code": "380901",
    "nameCN": "宁波梅山保税港区",
    "nameEN": "Ningbo Meishan Free Trade Port Zone"
  },
  {
    "code": "381001",
    "nameCN": "宁波镇海港区",
    "nameEN": "Ningbo Zhenhai Gangqu"
  },
  {
    "code": "390001",
    "nameCN": "厦门",
    "nameEN": "Xiamen"
  },
  {
    "code": "390002",
    "nameCN": "厦门邮轮中心",
    "nameEN": "Xiamen Youlun Center"
  },
  {
    "code": "390003",
    "nameCN": "刘五店",
    "nameEN": "Liuwudian"
  },
  {
    "code": "390004",
    "nameCN": "大磴岛",
    "nameEN": "Dadengdao"
  },
  {
    "code": "390005",
    "nameCN": "厦门象屿保税物流园区",
    "nameEN": "Xiamen Xiangyu Bonded Logistics Zone"
  },
  {
    "code": "390007",
    "nameCN": "厦门翔安火炬保税物流园区",
    "nameEN": "Xiamen Xiangan Huoju Bonded Logistics Zone"
  },
  {
    "code": "390008",
    "nameCN": "厦门保税区",
    "nameEN": "Xiamen Free Trade Zone"
  },
  {
    "code": "390101",
    "nameCN": "厦门海沧港区",
    "nameEN": "Xiamen Haicang Gangqu"
  },
  {
    "code": "390102",
    "nameCN": "厦门海沧保税港区",
    "nameEN": "Xiamen Haicang Free Trade Port Zone"
  },
  {
    "code": "390301",
    "nameCN": "漳州招银港区",
    "nameEN": "Zhangzhou Zhaoyin Gangqu"
  },
  {
    "code": "390302",
    "nameCN": "漳州后石港区",
    "nameEN": "Zhangzhou Houshi Gangqu"
  },
  {
    "code": "390303",
    "nameCN": "漳州古雷港区",
    "nameEN": "Zhangzhou Gulei Gangqu"
  },
  {
    "code": "390304",
    "nameCN": "漳州旧镇港区",
    "nameEN": "Zhangzhou Jiuzhen Gangqu"
  },
  {
    "code": "390305",
    "nameCN": "漳州石码港区",
    "nameEN": "Zhangzhou Shima Gangqu"
  },
  {
    "code": "399101",
    "nameCN": "厦门高崎国际机场",
    "nameEN": "Xiamen Gaoqi International Airport"
  },
  {
    "code": "399102",
    "nameCN": "厦门五通码头",
    "nameEN": "Xiamen Wutong Dock"
  },
  {
    "code": "399103",
    "nameCN": "厦门五缘湾码头",
    "nameEN": "Xiamen Wuyuanwan Dock"
  },
  {
    "code": "399501",
    "nameCN": "厦门东渡港区",
    "nameEN": "Xiamen Dongdu Gangqu"
  },
  {
    "code": "410001",
    "nameCN": "郑州",
    "nameEN": "Zhengzhou"
  },
  {
    "code": "410002",
    "nameCN": "郑州查验场",
    "nameEN": "Zhengzhou Check the field"
  },
  {
    "code": "410003",
    "nameCN": "郑州新郑国际机场",
    "nameEN": "Zhengzhou Xinzheng International Airport"
  },
  {
    "code": "410004",
    "nameCN": "郑州站",
    "nameEN": "Zhengzhouzhan"
  },
  {
    "code": "410005",
    "nameCN": "郑州出口加工区",
    "nameEN": "Zhengzhou Export Processind Zone"
  },
  {
    "code": "410101",
    "nameCN": "洛阳北郊机场",
    "nameEN": "Luoyang Beijiao Airport"
  },
  {
    "code": "410200",
    "nameCN": "河南省开封市",
    "nameEN": "Henan Sheng Kaifeng Shi"
  },
  {
    "code": "410300",
    "nameCN": "河南省洛阳市",
    "nameEN": "Henan Sheng Luoyang Shi"
  },
  {
    "code": "410400",
    "nameCN": "河南省平顶山市",
    "nameEN": "Henan Sheng Pingdingshan Shi"
  },
  {
    "code": "410500",
    "nameCN": "河南省安阳市",
    "nameEN": "Henan Sheng Anyang Shi"
  },
  {
    "code": "410501",
    "nameCN": "漯河查验场",
    "nameEN": "Luohe Check the field"
  },
  {
    "code": "410600",
    "nameCN": "河南省鹤壁市",
    "nameEN": "Henan Sheng Hebi Shi"
  },
  {
    "code": "410601",
    "nameCN": "南阳卧龙综合保税区",
    "nameEN": "Nanyang Wolong Comprehensive Bonded Zone"
  },
  {
    "code": "410700",
    "nameCN": "河南省新乡市",
    "nameEN": "Henan Sheng Xinxiang Shi"
  },
  {
    "code": "410800",
    "nameCN": "河南省焦作市",
    "nameEN": "Henan Sheng Jiaozuo Shi"
  },
  {
    "code": "410900",
    "nameCN": "河南省濮阳市",
    "nameEN": "Henan Sheng Puyang Shi"
  },
  {
    "code": "410901",
    "nameCN": "郑州新郑综合保税区",
    "nameEN": "Zhengzhou Xinzheng Comprehensive Bonded Zone"
  },
  {
    "code": "411000",
    "nameCN": "河南省许昌市",
    "nameEN": "Henan Sheng Xuchang Shi"
  },
  {
    "code": "411100",
    "nameCN": "河南省漯河市",
    "nameEN": "Henan Sheng Luohe Shi"
  },
  {
    "code": "411200",
    "nameCN": "河南省三门峡市",
    "nameEN": "Henan Sheng Sanmenxia Shi"
  },
  {
    "code": "411300",
    "nameCN": "河南省南阳市",
    "nameEN": "Henan Sheng Nanyang Shi"
  },
  {
    "code": "411400",
    "nameCN": "河南省商丘市",
    "nameEN": "Henan Sheng Shangqiu Shi"
  },
  {
    "code": "411500",
    "nameCN": "河南省信阳市",
    "nameEN": "Henan Sheng Xingyang Shi"
  },
  {
    "code": "411600",
    "nameCN": "河南省周口市",
    "nameEN": "Henan Sheng Zhoukou Shi"
  },
  {
    "code": "411700",
    "nameCN": "河南省驻马店市",
    "nameEN": "Zhumadian Diqu Zhumadian Shi"
  },
  {
    "code": "419000",
    "nameCN": "河南省省直辖县级行政区划",
    "nameEN": "Henan Sheng Sheng Zhixia Xianji Xingzhengquhua"
  },
  {
    "code": "420001",
    "nameCN": "武汉",
    "nameEN": "Wuhan"
  },
  {
    "code": "420002",
    "nameCN": "武汉天河机场",
    "nameEN": "Wuhan Tianhe Airport"
  },
  {
    "code": "420003",
    "nameCN": "武汉阳逻水运港",
    "nameEN": "Wuhan Yangluo Shuiyun Harbor"
  },
  {
    "code": "420004",
    "nameCN": "武汉出口加工区",
    "nameEN": "Wuhan Export Processind Zone"
  },
  {
    "code": "420005",
    "nameCN": "武汉东西湖保税物流园区",
    "nameEN": "Wuhan Dongxihu Bonded Logistics Zone"
  },
  {
    "code": "420006",
    "nameCN": "武汉东湖综合保税区",
    "nameEN": "Wuhan Donghu Comprehensive Bonded Zone"
  },
  {
    "code": "420007",
    "nameCN": "武汉新港空港综合保税区",
    "nameEN": "Wuhan Xingang Konggang Comprehensive Bonded Zone"
  },
  {
    "code": "420101",
    "nameCN": "荆州盐卡",
    "nameEN": "Jingzhou Yanka"
  },
  {
    "code": "420200",
    "nameCN": "湖北省黄石市",
    "nameEN": "Hubei Sheng Huangshi Shi"
  },
  {
    "code": "420201",
    "nameCN": "襄阳铁路",
    "nameEN": "Xiangyang Railway"
  },
  {
    "code": "420202",
    "nameCN": "襄阳公路",
    "nameEN": "Xiangyang Highroad"
  },
  {
    "code": "420203",
    "nameCN": "十堰公路",
    "nameEN": "Shiyan Highroad"
  },
  {
    "code": "420300",
    "nameCN": "湖北省十堰市",
    "nameEN": "Hubei Sheng Shiyan Shi"
  },
  {
    "code": "420301",
    "nameCN": "宜昌三峡机场",
    "nameEN": "Yichang Sanxia Airport"
  },
  {
    "code": "420302",
    "nameCN": "宜昌水运港",
    "nameEN": "Yichang Shuiyun Harbor"
  },
  {
    "code": "420401",
    "nameCN": "黄石水运港",
    "nameEN": "Huangshi Shuiyun Harbor"
  },
  {
    "code": "420500",
    "nameCN": "湖北省宜昌市",
    "nameEN": "Hubei Sheng Yichang Shi"
  },
  {
    "code": "420600",
    "nameCN": "湖北省襄阳市",
    "nameEN": "Hubei Sheng Xiangyang Shi"
  },
  {
    "code": "420700",
    "nameCN": "湖北省鄂州市",
    "nameEN": "Hubei Sheng Ezhou Shi"
  },
  {
    "code": "420800",
    "nameCN": "湖北省荆门市",
    "nameEN": "Hubei Sheng Jingmen Shi"
  },
  {
    "code": "420900",
    "nameCN": "湖北省孝感市",
    "nameEN": "Hubei Sheng Xiaogan Shi"
  },
  {
    "code": "421000",
    "nameCN": "湖北省荆州市",
    "nameEN": "Hubei Sheng Jingzhou Shi"
  },
  {
    "code": "421100",
    "nameCN": "湖北省黄冈市",
    "nameEN": "Hubei Sheng Huanggang Shi"
  },
  {
    "code": "421200",
    "nameCN": "湖北省咸宁市",
    "nameEN": "Hubei Sheng Xianning Shi"
  },
  {
    "code": "421300",
    "nameCN": "湖北省随州市",
    "nameEN": "Hubei Sheng Suizhou Shi"
  },
  {
    "code": "422800",
    "nameCN": "湖北省恩施土家族苗族自治州",
    "nameEN": "Hubei Sheng Enshi Tujiazu Miaozu Zizhizhou"
  },
  {
    "code": "429000",
    "nameCN": "湖北省省直辖县级行政区划",
    "nameEN": "Hubei Sheng Sheng Zhixia Xianji Xingzhengquhua"
  },
  {
    "code": "430001",
    "nameCN": "长沙",
    "nameEN": "Changsha"
  },
  {
    "code": "430002",
    "nameCN": "长沙黄花国际机场旅检通道",
    "nameEN": "Changsha Huanghua International Airport Passenger-Inspection Tongdao"
  },
  {
    "code": "430003",
    "nameCN": "长沙黄花国际机场货场",
    "nameEN": "Changsha Huanghua International Airport Huochang"
  },
  {
    "code": "430004",
    "nameCN": "张家界荷花国际机场",
    "nameEN": "Zhangjiajie Hehua International Airport "
  },
  {
    "code": "430005",
    "nameCN": "长沙霞凝港",
    "nameEN": "Changsha Xianing Harbor"
  },
  {
    "code": "430006",
    "nameCN": "长沙霞凝铁路",
    "nameEN": "Changsha Xianing Railway"
  },
  {
    "code": "430007",
    "nameCN": "长沙金霞保税物流园区",
    "nameEN": "Changsha Jinxia Bonded Logistics Zone"
  },
  {
    "code": "430008",
    "nameCN": "湘潭综合保税区",
    "nameEN": "Xiangtan Comprehensive Bonded Zone"
  },
  {
    "code": "430009",
    "nameCN": "长沙黄花国际机场国际快件监控中心",
    "nameEN": "Changsha Huanghua International Airport Kuaijian"
  },
  {
    "code": "430101",
    "nameCN": "岳阳城陵矶水运",
    "nameEN": "Yueyang Chenglingji Shuiyun"
  },
  {
    "code": "430103",
    "nameCN": "岳阳城陵矶综合保税区",
    "nameEN": "Yueyang Chenglingji Comprehensive Bonded Zone"
  },
  {
    "code": "430200",
    "nameCN": "湖南省株洲市",
    "nameEN": "Hunan Sheng Zhuzhou Shi"
  },
  {
    "code": "430201",
    "nameCN": "常德盐关水运",
    "nameEN": "Changde Yanguan Shuiyun"
  },
  {
    "code": "430300",
    "nameCN": "湖南省湘潭市",
    "nameEN": "Hunan Sheng Xiangtan Shi"
  },
  {
    "code": "430400",
    "nameCN": "湖南省衡阳市",
    "nameEN": "Hunan Sheng Hengyang Shi"
  },
  {
    "code": "430401",
    "nameCN": "衡阳公路",
    "nameEN": "Hengyang Highroad"
  },
  {
    "code": "430402",
    "nameCN": "衡阳综合保税区",
    "nameEN": "Hengyang Comprehensive Bonded Zone"
  },
  {
    "code": "430500",
    "nameCN": "湖南省邵阳市",
    "nameEN": "Hunan Sheng Shaoyang Shi"
  },
  {
    "code": "430501",
    "nameCN": "郴州公路",
    "nameEN": "Chenzhou Highroad"
  },
  {
    "code": "430502",
    "nameCN": "郴州铁路",
    "nameEN": "Chenzhou Railway"
  },
  {
    "code": "430503",
    "nameCN": "郴州出口加工区",
    "nameEN": "Chenzhou Export Processind Zone"
  },
  {
    "code": "430600",
    "nameCN": "湖南省岳阳市",
    "nameEN": "Hunan Sheng Yueyang Shi"
  },
  {
    "code": "430700",
    "nameCN": "湖南省常德市",
    "nameEN": "Hunan Sheng Changde Shi"
  },
  {
    "code": "430701",
    "nameCN": "湘潭公路",
    "nameEN": "Xiangtan Highroad"
  },
  {
    "code": "430702",
    "nameCN": "长沙黄花综合保税区",
    "nameEN": "Changsha Huanghua Comprehensive Bonded Zone"
  },
  {
    "code": "430800",
    "nameCN": "湖南省张家界市",
    "nameEN": "Hunan Sheng Zhangjiajie Shi"
  },
  {
    "code": "430900",
    "nameCN": "湖南省益阳市",
    "nameEN": "Hunan Sheng Yiyang Shi"
  },
  {
    "code": "431000",
    "nameCN": "湖南省郴州市",
    "nameEN": "Hunan Sheng Chenzhou Shi"
  },
  {
    "code": "431100",
    "nameCN": "湖南省永州市",
    "nameEN": "Hunan Sheng Yongzhou Shi"
  },
  {
    "code": "431200",
    "nameCN": "湖南省怀化市",
    "nameEN": "Hunan Sheng Huaihua Shi"
  },
  {
    "code": "431300",
    "nameCN": "湖南省娄底市",
    "nameEN": "Hunan Sheng Loudi Shi"
  },
  {
    "code": "433100",
    "nameCN": "湖南省湘西土家族苗族自治州",
    "nameEN": "Hunan Sheng Xiangxi Tujiazu Miaozu Zizhizhou"
  },
  {
    "code": "440001",
    "nameCN": "广州",
    "nameEN": "Guangzhou"
  },
  {
    "code": "440002",
    "nameCN": "黄埔港务码头",
    "nameEN": "Huangpu Gangwu Dock"
  },
  {
    "code": "440003",
    "nameCN": "南沙粮食及通用码头",
    "nameEN": "Nansha Liangshi Tongyong Dock"
  },
  {
    "code": "440004",
    "nameCN": "黄埔嘉利仓码头",
    "nameEN": "Huangpu Jialicang Dock"
  },
  {
    "code": "440005",
    "nameCN": "佛山三水西南码头",
    "nameEN": "Foshan Sanshui Xinan Dock"
  },
  {
    "code": "440006",
    "nameCN": "佛山三水港码头",
    "nameEN": "Foshan Sanshui Harbor Dock"
  },
  {
    "code": "440007",
    "nameCN": "佛山三水车检场",
    "nameEN": "Foshan Sanshui Truck Inspection Field"
  },
  {
    "code": "440008",
    "nameCN": "东莞凤岗车检场",
    "nameEN": "Dongguan Fenggang Truck Inspection Field"
  },
  {
    "code": "440009",
    "nameCN": "东莞长安车检场",
    "nameEN": "Dongguan Changan Truck Inspection Field"
  },
  {
    "code": "440010",
    "nameCN": "广州香港马会马匹查验场",
    "nameEN": "Guangzhou Hongkong Jockey Club Horse Inspection Field"
  },
  {
    "code": "440011",
    "nameCN": "中国（广东）自由贸易试验区",
    "nameEN": "China (Guangdong) Pilot Free Trade Zone"
  },
  {
    "code": "440101",
    "nameCN": "广州新沙码头",
    "nameEN": "Guangzhou Xinsha Dock"
  },
  {
    "code": "440102",
    "nameCN": "广州新风码头",
    "nameEN": "Guangzhou Xinfeng Dock"
  },
  {
    "code": "440103",
    "nameCN": "广州河南码头",
    "nameEN": "Guangzhou Henan Dock"
  },
  {
    "code": "440104",
    "nameCN": "广州石榴岗码头",
    "nameEN": "Guangzhou Shiliugang Dock"
  },
  {
    "code": "440105",
    "nameCN": "广州造纸厂码头",
    "nameEN": "Guangzhou Zaozhichang Dock"
  },
  {
    "code": "440106",
    "nameCN": "广州石井滘心港码头",
    "nameEN": "Guangzhou Shijing Jiaoxin Harbor Dock"
  },
  {
    "code": "440107",
    "nameCN": "广州东朗码头",
    "nameEN": "Guangzhou Donglang Dock"
  },
  {
    "code": "440108",
    "nameCN": "广州萝岗车检场",
    "nameEN": "Guangzhou Luogang Truck Inspection Field"
  },
  {
    "code": "440200",
    "nameCN": "广东省韶关市",
    "nameEN": "Guangdong Sheng Shaoguan Shi"
  },
  {
    "code": "440201",
    "nameCN": "韶关新港码头",
    "nameEN": "Shaoguan Xingang Dock"
  },
  {
    "code": "440202",
    "nameCN": "韶关铁路装卸点",
    "nameEN": "Shaoguan Railway Zhuangxiedian"
  },
  {
    "code": "440203",
    "nameCN": "乐昌铁路装卸点",
    "nameEN": "Lechang Railway Zhuangxiedian"
  },
  {
    "code": "440204",
    "nameCN": "韶关车检场",
    "nameEN": "Shaoguan Truck Inspection Field"
  },
  {
    "code": "440300",
    "nameCN": "广东省深圳市",
    "nameEN": "Guangdong Sheng Shenzhen Shi"
  },
  {
    "code": "440301",
    "nameCN": "南海港客运码头",
    "nameEN": "Nanhai Harbor Passenger Transpor Dock"
  },
  {
    "code": "440302",
    "nameCN": "南海三山港",
    "nameEN": "Nanhai Sanshan Harbor"
  },
  {
    "code": "440303",
    "nameCN": "南海九江码头",
    "nameEN": "Nanhai Jiujiang Dock"
  },
  {
    "code": "440304",
    "nameCN": "南海北村码头",
    "nameEN": "Nanhai Beicun Dock"
  },
  {
    "code": "440305",
    "nameCN": "南海平洲南港码头",
    "nameEN": "Nanhai Pingzhou Nangang Dock"
  },
  {
    "code": "440306",
    "nameCN": "南海官窑车检场",
    "nameEN": "Nanhai Guanyao Truck Inspection Field"
  },
  {
    "code": "440307",
    "nameCN": "南海桂江车检场",
    "nameEN": "Nanhai Guijiang Truck Inspection Field"
  },
  {
    "code": "440400",
    "nameCN": "广东省珠海市",
    "nameEN": "Guangdong Sheng Zhuhai Shi"
  },
  {
    "code": "440401",
    "nameCN": "顺德港客运码头",
    "nameEN": "Shunde Harbor Passenger Transpor Dock"
  },
  {
    "code": "440402",
    "nameCN": "顺德容奇货运码头",
    "nameEN": "Shunde Rongqi Freight Dock"
  },
  {
    "code": "440403",
    "nameCN": "顺德食出码头",
    "nameEN": "Shunde Shichu Dock"
  },
  {
    "code": "440404",
    "nameCN": "顺德北滘港货运码头",
    "nameEN": "Shunde Beijiao Harbor Freight Dock"
  },
  {
    "code": "440405",
    "nameCN": "顺德勒流港货运码头",
    "nameEN": "Shunde Leliu Harbor Freight Dock"
  },
  {
    "code": "440406",
    "nameCN": "顺德陈村车检场",
    "nameEN": "Shunde Chenchun Truck Inspection Field"
  },
  {
    "code": "440407",
    "nameCN": "顺德勒流车检场",
    "nameEN": "Shunde Leliu Truck Inspection Field"
  },
  {
    "code": "440408",
    "nameCN": "顺德容奇车检场",
    "nameEN": "Shunde Rongqi Truck Inspection Field"
  },
  {
    "code": "440409",
    "nameCN": "顺德乐从车检场",
    "nameEN": "Shunde Lecong Truck Inspection Field"
  },
  {
    "code": "440410",
    "nameCN": "顺德北窖车检场",
    "nameEN": "Shunde Beiyao Truck Inspection Field"
  },
  {
    "code": "440500",
    "nameCN": "广东省汕头市",
    "nameEN": "Guangdong Sheng Shantou Shi"
  },
  {
    "code": "440501",
    "nameCN": "汕头广澳港港务公司码头",
    "nameEN": "Shantou Guangaogang Port Liability Company Dock"
  },
  {
    "code": "440502",
    "nameCN": "汕头暹罗石油气码头",
    "nameEN": "Shantou Xianluo Shiyouqi Dock"
  },
  {
    "code": "440503",
    "nameCN": "汕头海门电厂码头",
    "nameEN": "Shantou Haimen Dianchang Dock"
  },
  {
    "code": "440504",
    "nameCN": "汕头西堤码头",
    "nameEN": "Shantou Xiti Dock"
  },
  {
    "code": "440505",
    "nameCN": "汕头永泰码头",
    "nameEN": "Shantou Yongtai Dock"
  },
  {
    "code": "440506",
    "nameCN": "汕头大明石油气码头",
    "nameEN": "Shantou Daming Shiyouqi Dock"
  },
  {
    "code": "440507",
    "nameCN": "汕头华润水泥码头",
    "nameEN": "Shantou Huarun Shuini Dock"
  },
  {
    "code": "440508",
    "nameCN": "汕头港务四公司煤码头",
    "nameEN": "Shantou Gangwu Sigongsi Mei Dock"
  },
  {
    "code": "440509",
    "nameCN": "汕头港务三公司煤码头",
    "nameEN": "Shantou Gangwu Sangongsi Mei Dock"
  },
  {
    "code": "440510",
    "nameCN": "汕头国集码头",
    "nameEN": "Shantou Guoji Dock"
  },
  {
    "code": "440511",
    "nameCN": "汕头海通码头",
    "nameEN": "Shantou Haitong Dock"
  },
  {
    "code": "440512",
    "nameCN": "汕头莱芜码头",
    "nameEN": "Shantou Laiwu Dock"
  },
  {
    "code": "440513",
    "nameCN": "汕头前江码头",
    "nameEN": "Shantou Qianjiang Dock"
  },
  {
    "code": "440514",
    "nameCN": "汕头铁路装卸点",
    "nameEN": "Shantou Railway Zhuangxiedian"
  },
  {
    "code": "440515",
    "nameCN": "汕头联成车检场",
    "nameEN": "Shantou Liancheng Truck Inspection Field"
  },
  {
    "code": "440516",
    "nameCN": "汕头濠江车检场",
    "nameEN": "Shantou Haojiang Truck Inspection Field"
  },
  {
    "code": "440517",
    "nameCN": "汕头澄海车检场",
    "nameEN": "Shantou Chenghai Truck Inspection Field"
  },
  {
    "code": "440518",
    "nameCN": "汕头潮阳车检场",
    "nameEN": "Shantou Chaoyang Truck Inspection Field"
  },
  {
    "code": "440519",
    "nameCN": "揭阳潮汕机场",
    "nameEN": "Jieyang Chaoshan Airport"
  },
  {
    "code": "440520",
    "nameCN": "汕头保税区",
    "nameEN": "Shantou Free Trade Zone"
  },
  {
    "code": "440521",
    "nameCN": "汕头海门中转基地码头",
    "nameEN": "Shantou Haimen Zhongzhuan Jidi Dock"
  },
  {
    "code": "440600",
    "nameCN": "广东省佛山市",
    "nameEN": "Guangdong Sheng Foshan Shi"
  },
  {
    "code": "440601",
    "nameCN": "佛山铁路客运站",
    "nameEN": "Foshan Railway Passenger Transport Erlei"
  },
  {
    "code": "440602",
    "nameCN": "佛山澜石码头",
    "nameEN": "Foshan Lanshi Dock"
  },
  {
    "code": "440603",
    "nameCN": "佛山滘口码头",
    "nameEN": "Foshan Jiaokou Dock"
  },
  {
    "code": "440604",
    "nameCN": "佛山新港码头",
    "nameEN": "Foshan Xingang Dock"
  },
  {
    "code": "440605",
    "nameCN": "佛山车检场",
    "nameEN": "Foshan Truck Inspection Field"
  },
  {
    "code": "440700",
    "nameCN": "广东省江门市",
    "nameEN": "Guangdong Sheng Jiangmen Shi"
  },
  {
    "code": "440701",
    "nameCN": "江门港客运码头",
    "nameEN": "Jiangmen Harbor Passenger Transpor Dock"
  },
  {
    "code": "440702",
    "nameCN": "江门鹤山港客运码头",
    "nameEN": "Jiangmen Heshan Harbor Passenger Transpor Dock"
  },
  {
    "code": "440703",
    "nameCN": "江门台山核电重件码头 ",
    "nameEN": "Jiangmen Taishan Nuclear Power Zhongjian Dock"
  },
  {
    "code": "440704",
    "nameCN": "江门台山国华粤电煤码头 ",
    "nameEN": "Jiangmen Taishan Guohua Yuedian Mei Dock"
  },
  {
    "code": "440705",
    "nameCN": "江门台山公益港客运码头",
    "nameEN": "Jiangmen Taishan Gongyi Harbor Passenger Transpor Dock"
  },
  {
    "code": "440706",
    "nameCN": "江门中外运外海货柜码头",
    "nameEN": "Jiangmen Zhongwaiyun Waihai Container Dock"
  },
  {
    "code": "440707",
    "nameCN": "江门国际货柜码头",
    "nameEN": "Jiangmen Guoji Container Dock"
  },
  {
    "code": "440708",
    "nameCN": "江门荷塘码头",
    "nameEN": "Jiangmen Hetang Dock"
  },
  {
    "code": "440709",
    "nameCN": "江门台山公益码头",
    "nameEN": "Jiangmen Taishan Gongyi Dock"
  },
  {
    "code": "440710",
    "nameCN": "江门恩平横板码头",
    "nameEN": "Jiangmen Enping Hengban Dock"
  },
  {
    "code": "440711",
    "nameCN": "江门鹤山港货运码头",
    "nameEN": "Jiangmen Heshangang Freight Dock"
  },
  {
    "code": "440712",
    "nameCN": "江门车检场",
    "nameEN": "Jiangmen Truck Inspection Field"
  },
  {
    "code": "440713",
    "nameCN": "江门台山车检场",
    "nameEN": "Jiangmen Taishan Truck Inspection Field"
  },
  {
    "code": "440714",
    "nameCN": "江门鹤山车检场",
    "nameEN": "Jiangmen Heshan Truck Inspection Field"
  },
  {
    "code": "440715",
    "nameCN": "江门恩平车检场",
    "nameEN": "Jiangmen Enping Truck Inspection Field"
  },
  {
    "code": "440800",
    "nameCN": "广东省湛江市",
    "nameEN": "Guangdong Sheng Zhanjiang Shi"
  },
  {
    "code": "440801",
    "nameCN": "湛江机场",
    "nameEN": "Zhanjiang Airport"
  },
  {
    "code": "440802",
    "nameCN": "湛江港集团公司霞山港区码头",
    "nameEN": "Zhanjiang Harbor Group Company Xiashan Gangqu Dock"
  },
  {
    "code": "440803",
    "nameCN": "湛江南油码头",
    "nameEN": "Zhanjiang Nanyou Dock"
  },
  {
    "code": "440804",
    "nameCN": "湛江港集团公司调顺港区码头",
    "nameEN": "Zhanjiang Harbor Group Company Tiaoshun Gangqu Dock"
  },
  {
    "code": "440805",
    "nameCN": "湛江调顺岛电力公司码头",
    "nameEN": "Zhanjiang Tiaoshundao Dianligongsi Dock"
  },
  {
    "code": "440806",
    "nameCN": "湛江霞海港码头",
    "nameEN": "Zhanjiang Xiahai Harbor Dock"
  },
  {
    "code": "440807",
    "nameCN": "湛江霞海中外运码头",
    "nameEN": "Zhanjiang Xiahai Zhongwaiyun Dock"
  },
  {
    "code": "440808",
    "nameCN": "湛江霞山长桥码头",
    "nameEN": "Zhanjiang Xiashan Changqiao Dock"
  },
  {
    "code": "440809",
    "nameCN": "湛江徐闻海安港码头",
    "nameEN": "Zhanjiang Xuwen Haian Harbor Dock"
  },
  {
    "code": "440810",
    "nameCN": "湛江廉江营仔港码头",
    "nameEN": "Zhanjiang Lianjiang Yingzai Harbor Dock"
  },
  {
    "code": "440811",
    "nameCN": "湛江遂溪北潭港码头",
    "nameEN": "Zhanjiang Suixi Beitan Harbor Dock"
  },
  {
    "code": "440812",
    "nameCN": "湛江雷州流沙港码头",
    "nameEN": "Zhanjiang Leizhou Liusha Harbor Dock"
  },
  {
    "code": "440813",
    "nameCN": "湛江霞海港车检场",
    "nameEN": "Zhanjiang Truck Inspection Field"
  },
  {
    "code": "440814",
    "nameCN": "湛江宝满港集装箱码头",
    "nameEN": "Zhanjiang Baoman Harbor Container Dock"
  },
  {
    "code": "440815",
    "nameCN": "湛江霞山散货码头",
    "nameEN": "Zhanjiang Xiasan Sanhuo Dock"
  },
  {
    "code": "440816",
    "nameCN": "湛江东海岛宝钢基地码头",
    "nameEN": "Zhanjiang Donghaidao Baogangjidi Dock"
  },
  {
    "code": "440817",
    "nameCN": "湛江东海岛宝钢成品码头",
    "nameEN": "Zhanjiang Donghaidao Baogangchengpin Dock"
  },
  {
    "code": "440818",
    "nameCN": "湛江吴川车检场",
    "nameEN": "Zhanjiang Wuchuan Truck Inspection Field"
  },
  {
    "code": "440819",
    "nameCN": "湛江龙腾码头",
    "nameEN": "Zhanjiang longteng Dock"
  },
  {
    "code": "440820",
    "nameCN": "湛江遂溪车检场",
    "nameEN": "Zhanjiang sui'xi Truck Inspection Field"
  },
  {
    "code": "440900",
    "nameCN": "广东省茂名市",
    "nameEN": "Guangdong Sheng Maoming Shi"
  },
  {
    "code": "440901",
    "nameCN": "茂名水东港港口公司双泊位码头",
    "nameEN": "Maoming Shuidong Harbor Port company Shuangbowei Dock"
  },
  {
    "code": "440902",
    "nameCN": "茂名水东港石化公司码头",
    "nameEN": "Maoming Shuidong Harbor Petrochemical Corporation Dock"
  },
  {
    "code": "440903",
    "nameCN": "茂名水东港30万吨级单点",
    "nameEN": "Maoming Shuidong Harbor 0.3 Million Tons Jidandian"
  },
  {
    "code": "440904",
    "nameCN": "茂名水东港天源化工码头",
    "nameEN": "Maoming Shuidong Harbor Tianyuanhuagong Dock"
  },
  {
    "code": "440905",
    "nameCN": "茂名水东港港口公司公用码头",
    "nameEN": "Maoming Shuidong Harbor Port company Public Dock"
  },
  {
    "code": "440906",
    "nameCN": "茂名水东港隆港石油码头",
    "nameEN": "Maoming Shuidong Harbor Longgang Oil Dock"
  },
  {
    "code": "440907",
    "nameCN": "茂名水东港长晟综合码头",
    "nameEN": "Maoming Shuidong Harbor Changcheng Zhonghe Dock"
  },
  {
    "code": "440908",
    "nameCN": "茂名水东港天源煤炭码头",
    "nameEN": "Maoming Shuidong Harbor Tianyuan Coal Dock"
  },
  {
    "code": "440909",
    "nameCN": "茂名博贺港码头",
    "nameEN": "Maoming Bohe Harbor Dock"
  },
  {
    "code": "441001",
    "nameCN": "潮州车检场",
    "nameEN": "Chaozhou Truck Inspection Field"
  },
  {
    "code": "441101",
    "nameCN": "潮州三百门港务码头",
    "nameEN": "Chaozhou Sanbaimen Gangwu Dock"
  },
  {
    "code": "441102",
    "nameCN": "潮州三百门华丰油气码头",
    "nameEN": "Chaozhou Sanbaimen Huafeng Youqi Dock"
  },
  {
    "code": "441103",
    "nameCN": "潮州三百门恒业码头",
    "nameEN": "Chaozhou Sanbaimen Hengye Dock"
  },
  {
    "code": "441104",
    "nameCN": "潮州金狮湾华丰油气码头",
    "nameEN": "Chaozhou Jinshiwan Huafeng Youqi Dock"
  },
  {
    "code": "441105",
    "nameCN": "潮州金狮湾大唐电厂煤码头",
    "nameEN": "Chaozhou Jinshiwan Datang Dianchang Mei Dock"
  },
  {
    "code": "441106",
    "nameCN": "潮州金狮湾亚太一期码头",
    "nameEN": "Chaozhou Jinshiwan Yatai Yiqi Dock"
  },
  {
    "code": "441107",
    "nameCN": "饶平车检场",
    "nameEN": "Raoping Truck Inspection Field"
  },
  {
    "code": "441200",
    "nameCN": "广东省肇庆市",
    "nameEN": "Guangdong Sheng Zhaoqing Shi"
  },
  {
    "code": "441201",
    "nameCN": "肇庆铁路客运站",
    "nameEN": "Zhaoqing Railway Passenger Transport Erlei"
  },
  {
    "code": "441202",
    "nameCN": "肇庆港客运码头",
    "nameEN": "Zhaoqing Harbor Passenger Transpor Dock"
  },
  {
    "code": "441203",
    "nameCN": "肇庆三榕港码头",
    "nameEN": "Zhaoqing Sanrong Harbor Dock"
  },
  {
    "code": "441204",
    "nameCN": "肇庆新港码头",
    "nameEN": "Zhaoqing Xingang Dock"
  },
  {
    "code": "441205",
    "nameCN": "肇庆高要港码头",
    "nameEN": "Zhaoqing Gaoyao Harbor Dock"
  },
  {
    "code": "441206",
    "nameCN": "肇庆德庆康州码头",
    "nameEN": "Zhaoqing Deqing Kangzhou Dock"
  },
  {
    "code": "441207",
    "nameCN": "肇庆四会港码头",
    "nameEN": "Zhaoqing Sihui Harbor Dock"
  },
  {
    "code": "441208",
    "nameCN": "肇庆大旺车检场",
    "nameEN": "Zhaoqing Dawang Truck Inspection Field"
  },
  {
    "code": "441300",
    "nameCN": "广东省惠州市",
    "nameEN": "Guangdong Sheng Huizhou Shi"
  },
  {
    "code": "441301",
    "nameCN": "惠州大澳塘码头 ",
    "nameEN": "Huizhou Daaotang Dock"
  },
  {
    "code": "441302",
    "nameCN": "惠州平海电厂煤码头 ",
    "nameEN": "Huizhou Pinghai Dianchang Mei Dock"
  },
  {
    "code": "441303",
    "nameCN": "惠州碧甲码头 ",
    "nameEN": "Huizhou Bijia Dock"
  },
  {
    "code": "441304",
    "nameCN": "惠州博罗宏兴码头",
    "nameEN": "Huizhou Boluo Hongxing Dock"
  },
  {
    "code": "441305",
    "nameCN": "惠州石湾集装箱码头",
    "nameEN": "Huizhou Shiwan Container Dock"
  },
  {
    "code": "441306",
    "nameCN": "惠州车检场",
    "nameEN": "Huizhou Truck Inspection Field"
  },
  {
    "code": "441307",
    "nameCN": "惠州淡水车检场",
    "nameEN": "Huizhou Danshui Truck Inspection Field"
  },
  {
    "code": "441308",
    "nameCN": "惠州惠东车检场",
    "nameEN": "Huizhou Huidong Truck Inspection Field"
  },
  {
    "code": "441309",
    "nameCN": "惠州红海车检场",
    "nameEN": "Huizhou Honghai Truck Inspection Field"
  },
  {
    "code": "441310",
    "nameCN": "惠州园洲车检场",
    "nameEN": "Huizhou Yuanzhou Truck Inspection Field"
  },
  {
    "code": "441311",
    "nameCN": "惠州中海油基地码头",
    "nameEN": "Huizhou Zhonghaiyou Jidi Dock"
  },
  {
    "code": "441400",
    "nameCN": "广东省梅州市",
    "nameEN": "Guangdong Sheng Meizhou Shi"
  },
  {
    "code": "441401",
    "nameCN": "梅州机场",
    "nameEN": "Meizhou Airport"
  },
  {
    "code": "441402",
    "nameCN": "梅州车检场",
    "nameEN": "Meizhou Truck Inspection Field"
  },
  {
    "code": "441500",
    "nameCN": "广东省汕尾市",
    "nameEN": "Guangdong Sheng Shanwei Shi"
  },
  {
    "code": "441501",
    "nameCN": "汕尾港务码头",
    "nameEN": "Shanwei Gangwu Dock"
  },
  {
    "code": "441502",
    "nameCN": "汕尾电厂码头",
    "nameEN": "Shanwei Dianchang Dock"
  },
  {
    "code": "441503",
    "nameCN": "汕尾万聪码头",
    "nameEN": "Shanwei Wancong Dock"
  },
  {
    "code": "441504",
    "nameCN": "汕尾乌坎码头",
    "nameEN": "Shanwei Wukan Dock"
  },
  {
    "code": "441505",
    "nameCN": "汕尾海丰车检场",
    "nameEN": "Shanwei Haifeng Truck Inspection Field"
  },
  {
    "code": "441506",
    "nameCN": "汕尾陆丰车检场",
    "nameEN": "Shanwei Lufeng Truck Inspection Field"
  },
  {
    "code": "441507",
    "nameCN": "汕尾车检场",
    "nameEN": "Shanwei Truck Inspection Field"
  },
  {
    "code": "441508",
    "nameCN": "汕尾华润海丰电厂码头",
    "nameEN": "Shanwei Huarun Haifeng Dianchang Dock"
  },
  {
    "code": "441600",
    "nameCN": "广东省河源市",
    "nameEN": "Guangdong Sheng Heyuan Shi"
  },
  {
    "code": "441601",
    "nameCN": "河源车检场",
    "nameEN": "Heyuan Truck Inspection Field"
  },
  {
    "code": "441700",
    "nameCN": "广东省阳江市",
    "nameEN": "Guangdong Sheng Yangjiang Shi"
  },
  {
    "code": "441701",
    "nameCN": "阳江港务公司码头",
    "nameEN": "Yangjiang Port Liability Company Dock"
  },
  {
    "code": "441702",
    "nameCN": "阳江良港码头",
    "nameEN": "Yangjiang Lianggang Dock"
  },
  {
    "code": "441703",
    "nameCN": "阳江保丰码头",
    "nameEN": "Yangjiang Baofeng Dock"
  },
  {
    "code": "441704",
    "nameCN": "阳江闸坡码头",
    "nameEN": "Yangjiang Zhapo Dock"
  },
  {
    "code": "441705",
    "nameCN": "阳江东平码头",
    "nameEN": "Yangjiang Dongping Dock"
  },
  {
    "code": "441706",
    "nameCN": "阳江溪头港码头",
    "nameEN": "Yangjiang Xitou Harbor Dock"
  },
  {
    "code": "441707",
    "nameCN": "阳江车检场",
    "nameEN": "Yangjiang Truck Inspection Field"
  },
  {
    "code": "441708",
    "nameCN": "华夏阳西电厂码头",
    "nameEN": "Huaxia Yangxi Dianchang Dock"
  },
  {
    "code": "441800",
    "nameCN": "广东省清远市",
    "nameEN": "Guangdong Sheng Qingyuan Shi"
  },
  {
    "code": "441801",
    "nameCN": "清远新港码头",
    "nameEN": "Qingyuan Xingang Dock"
  },
  {
    "code": "441802",
    "nameCN": "清远英德码头",
    "nameEN": "Qingyuan Yingde Dock"
  },
  {
    "code": "441803",
    "nameCN": "清远铁路装卸点",
    "nameEN": "Qinyuan Railway Zhuangxiedian"
  },
  {
    "code": "441804",
    "nameCN": "清远车检场",
    "nameEN": "Qingyuan Truck Inspection Field"
  },
  {
    "code": "441900",
    "nameCN": "广东省东莞市",
    "nameEN": "Guangdong Sheng Dongguan Shi"
  },
  {
    "code": "441901",
    "nameCN": "东莞铁路客运站",
    "nameEN": "Dongguan Railway Passenger Transport Erlei"
  },
  {
    "code": "441902",
    "nameCN": "东莞虎门港客运码头",
    "nameEN": "Dongguan Humen Harbor Passenger Transpor Dock"
  },
  {
    "code": "441903",
    "nameCN": "东莞海腾码头",
    "nameEN": "Dongguan Haiteng Dock"
  },
  {
    "code": "441904",
    "nameCN": "东莞华润水泥码头 ",
    "nameEN": "Dongguan Huarun Shuini Dock"
  },
  {
    "code": "441905",
    "nameCN": "东莞金明石化码头 ",
    "nameEN": "Dongguan Jinming Petrochemicals Dock"
  },
  {
    "code": "441906",
    "nameCN": "东莞国际货柜码头 ",
    "nameEN": "Dongguan Guoji Container Dock"
  },
  {
    "code": "441907",
    "nameCN": "东莞飞虎石化码头 ",
    "nameEN": "Dongguan Feihu Petrochemicals Dock"
  },
  {
    "code": "441908",
    "nameCN": "东莞荣轩货柜码头 ",
    "nameEN": "Dongguan Rongxuan Container Dock"
  },
  {
    "code": "441909",
    "nameCN": "东莞同舟石化码头 ",
    "nameEN": "Dongguan Tongzhou Petrochemicals Dock"
  },
  {
    "code": "441910",
    "nameCN": "东莞三江石化码头 ",
    "nameEN": "Dongguan Sanjiang Petrochemicals Dock"
  },
  {
    "code": "441911",
    "nameCN": "东莞虎门港5、6号泊位",
    "nameEN": "Dongguan Humen Harbor 5-6 Bowei"
  },
  {
    "code": "441912",
    "nameCN": "东莞九丰石化码头 ",
    "nameEN": "Dongguan Jiufeng Petrochemicals Dock"
  },
  {
    "code": "441913",
    "nameCN": "东莞东洲油气化工码头 ",
    "nameEN": "Dongguan Dongzhou Youqihuagong Dock"
  },
  {
    "code": "441914",
    "nameCN": "东莞虎门港7、8号泊位",
    "nameEN": "Dongguan Humen Harbor 7-8 Bowei"
  },
  {
    "code": "441915",
    "nameCN": "东莞中海油立沙码头 ",
    "nameEN": "Dongguan CNOOC Lisha Dock"
  },
  {
    "code": "441916",
    "nameCN": "东莞南粤码头 ",
    "nameEN": "Dongguan Nanyue Dock"
  },
  {
    "code": "441917",
    "nameCN": "东莞东江口码头 ",
    "nameEN": "Dongguan Dongjiangkou Dock"
  },
  {
    "code": "441918",
    "nameCN": "东莞海昌煤码头 ",
    "nameEN": "Dongguan Haichang Mei Dock"
  },
  {
    "code": "441919",
    "nameCN": "东莞深赤湾散杂货码头 ",
    "nameEN": "Dongguan Shenchiwan Sanzahuo Dock"
  },
  {
    "code": "441920",
    "nameCN": "东莞宏业货柜码头 ",
    "nameEN": "Dongguan Hongye Container Dock"
  },
  {
    "code": "441921",
    "nameCN": "东莞沙角A电厂煤码头 ",
    "nameEN": "Dongguan Shajiao A Dianchang Mei Dock"
  },
  {
    "code": "441922",
    "nameCN": "东莞沙角B电厂煤码头 ",
    "nameEN": "Dongguan Shajiao B Dianchang Mei Dock"
  },
  {
    "code": "441923",
    "nameCN": "东莞沙角C电厂煤码头 ",
    "nameEN": "Dongguan Shajiao C Dianchang Mei Dock"
  },
  {
    "code": "441924",
    "nameCN": "东莞龙通码头",
    "nameEN": "Dongguan Longtong Dock"
  },
  {
    "code": "441925",
    "nameCN": "东莞基业码头",
    "nameEN": "Dongguan Jiye Dock"
  },
  {
    "code": "441926",
    "nameCN": "东莞中外运石龙码头",
    "nameEN": "Dongguan Zhongwaiyun Shilong Dock"
  },
  {
    "code": "441927",
    "nameCN": "东莞马士基码头",
    "nameEN": "Dongguan Mashiji Dock"
  },
  {
    "code": "441928",
    "nameCN": "东莞永安码头",
    "nameEN": "Dongguan Yongan Dock"
  },
  {
    "code": "441929",
    "nameCN": "东莞联通码头",
    "nameEN": "Dongguan Liantong Dock"
  },
  {
    "code": "441930",
    "nameCN": "常平铁路装卸点",
    "nameEN": "Changping Railway Zhuangxiedian"
  },
  {
    "code": "441931",
    "nameCN": "东莞虎门车检场",
    "nameEN": "Dongguan Humen Truck Inspection Field"
  },
  {
    "code": "441932",
    "nameCN": "东莞寮步车检场",
    "nameEN": "Dongguan Liaobu Truck Inspection Field"
  },
  {
    "code": "441933",
    "nameCN": "东莞立沙岛阳鸿石化码头",
    "nameEN": "Dongguan Lishadao Yanghongshihua Dock"
  },
  {
    "code": "441934",
    "nameCN": "东莞立沙岛鸿源油品码头",
    "nameEN": "Dongguan Lishadao Hongyuanyoupin Dock"
  },
  {
    "code": "441935",
    "nameCN": "东莞石龙铁路物流中心",
    "nameEN": "Dongguan Shilong Railway Logistics Zone"
  },
  {
    "code": "441936",
    "nameCN": "东莞联兴化工码头",
    "nameEN": "Dongguanlianxinghuagong Dock"
  },
  {
    "code": "442000",
    "nameCN": "广东省中山市",
    "nameEN": "Guangdong Sheng Zhongshan Shi"
  },
  {
    "code": "442001",
    "nameCN": "中山港货运码头",
    "nameEN": "Zhongshan Harbor Freight Dock"
  },
  {
    "code": "442002",
    "nameCN": "中山港客运码头",
    "nameEN": "Zhongshan Harbor Passenger Transpor Dock"
  },
  {
    "code": "442003",
    "nameCN": "中山港外贸码头",
    "nameEN": "Zhongshan Harbor Foreign Trade Dock"
  },
  {
    "code": "442004",
    "nameCN": "中山石岐纸厂码头",
    "nameEN": "Zhongshan Shiqi Zhichang Dock"
  },
  {
    "code": "442005",
    "nameCN": "中山水出码头",
    "nameEN": "Zhongshan Shuichu Dock"
  },
  {
    "code": "442006",
    "nameCN": "中山小榄码头",
    "nameEN": "Zhongshan Xiaolan Dock"
  },
  {
    "code": "442007",
    "nameCN": "中山神湾码头",
    "nameEN": "Zhongshan Shenwan Dock"
  },
  {
    "code": "442008",
    "nameCN": "中山小榄车检场",
    "nameEN": "Zhongshan Xiaolan Truck Inspection Field"
  },
  {
    "code": "442009",
    "nameCN": "中山保税物流中心车检场",
    "nameEN": "Zhongshan Bonded Logistics Zone Truck Inspection Field"
  },
  {
    "code": "442010",
    "nameCN": "中山神湾游艇码头",
    "nameEN": "Zhongshan Shenwan Youting Dock"
  },
  {
    "code": "442011",
    "nameCN": "中山黄圃多用途码头",
    "nameEN": "Zhongshan Huangpu Duoyongtu Dock"
  },
  {
    "code": "442101",
    "nameCN": "黄埔石化码头",
    "nameEN": "Huangpu Petrochemicals Dock"
  },
  {
    "code": "442102",
    "nameCN": "黄埔新港码头",
    "nameEN": "Huangpu Xingang Dock"
  },
  {
    "code": "442103",
    "nameCN": "黄埔集装箱码头",
    "nameEN": "Huangpu Container Dock"
  },
  {
    "code": "442104",
    "nameCN": "黄埔墩头西基码头",
    "nameEN": "Huangpu Duntou Xiji Dock"
  },
  {
    "code": "442105",
    "nameCN": "黄埔东江口码头",
    "nameEN": "Huangpu Dongjiangkou Dock"
  },
  {
    "code": "442106",
    "nameCN": "黄埔省物资码头",
    "nameEN": "Huangpu Shengwuzi Dock"
  },
  {
    "code": "442107",
    "nameCN": "黄埔广保通码头",
    "nameEN": "Huangpu Guangbaotong Dock"
  },
  {
    "code": "442108",
    "nameCN": "广州开发区东江仓码头",
    "nameEN": "Guangzhou Development Zone Dongjiangcang Dock"
  },
  {
    "code": "442109",
    "nameCN": "黄埔中外运东江仓码头",
    "nameEN": "Huangpu Zhongwaiyun Dongjiangcang Dock"
  },
  {
    "code": "442110",
    "nameCN": "中外运黄埔仓码头",
    "nameEN": "Zhongwaiyun Huangpucang Dock"
  },
  {
    "code": "442111",
    "nameCN": "黄埔庙沙围码头",
    "nameEN": "Huangpu Miaoshawei Dock"
  },
  {
    "code": "442112",
    "nameCN": "黄埔庙头建翔码头",
    "nameEN": "Huangpu Miaotou Jianxiang Dock"
  },
  {
    "code": "442113",
    "nameCN": "黄埔集通码头",
    "nameEN": "Huangpu Jitong Dock"
  },
  {
    "code": "442114",
    "nameCN": "广州开发区车检场",
    "nameEN": "Guangzhou Development Zone Truck Inspection Field"
  },
  {
    "code": "442115",
    "nameCN": "广州保税物流园区",
    "nameEN": "Guangzhou Bonded Logistics Zone"
  },
  {
    "code": "442116",
    "nameCN": "广州保税区",
    "nameEN": "Guangzhou Free Trade Zone"
  },
  {
    "code": "442117",
    "nameCN": "广州出口加工区",
    "nameEN": "Guangzhou Export Processind Zone"
  },
  {
    "code": "442201",
    "nameCN": "广州铁路客运站",
    "nameEN": "Guangzhou Railway Passenger Transport Erlei"
  },
  {
    "code": "442202",
    "nameCN": "广州东圃永业码头",
    "nameEN": "Guangzhou Dongpu Yongye Dock"
  },
  {
    "code": "442301",
    "nameCN": "广州白云国际机场",
    "nameEN": "Guangzhou Baiyun International Airport"
  },
  {
    "code": "442302",
    "nameCN": "广州白云机场综合保税区",
    "nameEN": "Guangzhou Baiyun Airport Comprehensive Bonded Zone"
  },
  {
    "code": "442401",
    "nameCN": "番禺莲花山客运港",
    "nameEN": "Panyu Lianhuashan Passenger Transpor Harbor"
  },
  {
    "code": "442402",
    "nameCN": "番禺莲花山货运港",
    "nameEN": "Panyu Lianhuashan Freight Harbor"
  },
  {
    "code": "442403",
    "nameCN": "番禺沙湾车检场",
    "nameEN": "Panyu Shawan Truck Inspection Field"
  },
  {
    "code": "442501",
    "nameCN": "花都港码头",
    "nameEN": "Huadu Harbor Dock"
  },
  {
    "code": "442502",
    "nameCN": "花都车检场",
    "nameEN": "Huadu Truck Inspection Field"
  },
  {
    "code": "442601",
    "nameCN": "增城新塘港客运码头",
    "nameEN": "Zengcheng Xintang Harbor Passenger Transpor Dock"
  },
  {
    "code": "442602",
    "nameCN": "增城新塘东洲湾码头",
    "nameEN": "Zengcheng Xintang Dongzhouwan Dock"
  },
  {
    "code": "442603",
    "nameCN": "增城新塘口岸码头",
    "nameEN": "Zengcheng Xintang Kouan Dock"
  },
  {
    "code": "442604",
    "nameCN": "增城新塘食出码头",
    "nameEN": "Zengcheng Xintang Shichu Dock"
  },
  {
    "code": "442605",
    "nameCN": "增城新塘车检场",
    "nameEN": "Zengcheng Xintang Truck Inspection Field"
  },
  {
    "code": "442701",
    "nameCN": "从化车检场",
    "nameEN": "Conghua Truck Inspection Field"
  },
  {
    "code": "442801",
    "nameCN": "江门天马码头 ",
    "nameEN": "Jiangmen Tianma Dock"
  },
  {
    "code": "442802",
    "nameCN": "江门新会电厂码头 ",
    "nameEN": "Jiangmen Xinhui Dianchang Dock"
  },
  {
    "code": "442803",
    "nameCN": "江门银湖修船码头 ",
    "nameEN": "Jiangmen Yinhu Xiuchuan Dock"
  },
  {
    "code": "442804",
    "nameCN": "江门宜大化工码头 ",
    "nameEN": "Jiangmen Yida Huagong Dock"
  },
  {
    "code": "442805",
    "nameCN": "新会港客运码头",
    "nameEN": "Xinhui Harbor Passenger Transpor Dock"
  },
  {
    "code": "442806",
    "nameCN": "新会西河口码头",
    "nameEN": "Xinhui Xihekou Dock"
  },
  {
    "code": "442807",
    "nameCN": "新会今古洲码头",
    "nameEN": "Xinhui Jinguzhou Dock"
  },
  {
    "code": "442808",
    "nameCN": "新会睦洲糖纸厂码头",
    "nameEN": "Xinhui Muzhoutang Zhichang Dock"
  },
  {
    "code": "442809",
    "nameCN": "新会大敖集装箱厂码头",
    "nameEN": "Xinhui Daao Container Plant Dock"
  },
  {
    "code": "442810",
    "nameCN": "新会崖门沙石泥码头",
    "nameEN": "Xinhui Yamen Shashini Dock"
  },
  {
    "code": "442811",
    "nameCN": "新会崖西沙石泥码头",
    "nameEN": "Xinhui Yaxi Shashini Dock"
  },
  {
    "code": "442812",
    "nameCN": "新会牛牯岭易燃品码头",
    "nameEN": "Xinhui Niuguling Inflammable Substance Dock"
  },
  {
    "code": "442813",
    "nameCN": "新会车检场",
    "nameEN": "Xinhui Truck Inspection Field"
  },
  {
    "code": "442814",
    "nameCN": "新会航建码头",
    "nameEN": "Xinhui Hangjian Dock"
  },
  {
    "code": "442901",
    "nameCN": "江门三埠港客运码头",
    "nameEN": "Jiangmen Sanbu Harbor Passenger Transpor Dock"
  },
  {
    "code": "442902",
    "nameCN": "江门三埠港货运码头",
    "nameEN": "Jiangmen Sanbugang Freight Dock"
  },
  {
    "code": "442903",
    "nameCN": "江门水口码头",
    "nameEN": "Jiangmen Shuikou Dock"
  },
  {
    "code": "442904",
    "nameCN": "开平车检场",
    "nameEN": "Kaiping Truck Inspection Field"
  },
  {
    "code": "443001",
    "nameCN": "高明港客运码头",
    "nameEN": "Gaoming Harbor Passenger Transpor Dock"
  },
  {
    "code": "443002",
    "nameCN": "高明食出码头",
    "nameEN": "Gaoming Shichu Dock"
  },
  {
    "code": "443003",
    "nameCN": "高明珠江码头",
    "nameEN": "Gaoming Zhujiang Dock"
  },
  {
    "code": "443004",
    "nameCN": "高明车检场",
    "nameEN": "Gaoming Truck Inspection Field"
  },
  {
    "code": "443101",
    "nameCN": "惠州港通用码头 ",
    "nameEN": "Huizhou Harbor Tongyong Dock"
  },
  {
    "code": "443102",
    "nameCN": "惠州港油气码头 ",
    "nameEN": "Huizhou Harbor Youqi Dock"
  },
  {
    "code": "443103",
    "nameCN": "惠州大港石化码头 ",
    "nameEN": "Huizhou Dagang Petrochemicals Dock"
  },
  {
    "code": "443104",
    "nameCN": "惠州泽华石化码头 ",
    "nameEN": "Huizhou Zehua Petrochemicals Dock"
  },
  {
    "code": "443105",
    "nameCN": "惠州国际集装箱码头",
    "nameEN": "Huizhou Guoji Container Dock"
  },
  {
    "code": "443106",
    "nameCN": "惠州马鞭洲石化码头 ",
    "nameEN": "Huizhou Mabianzhou Petrochemicals Dock"
  },
  {
    "code": "443107",
    "nameCN": "惠州中海壳牌马鞭洲码头 ",
    "nameEN": "Huizhou Zhonghai Qiaopai Mabianzhou Dock"
  },
  {
    "code": "443108",
    "nameCN": "惠州中海壳牌东联码头 ",
    "nameEN": "Huizhou Zhonghai Qiaopai Donglian Dock"
  },
  {
    "code": "443109",
    "nameCN": "惠州中海炼油马鞭洲码头",
    "nameEN": "Huizhou Zhonghai Lianyou Mabianzhou Dock"
  },
  {
    "code": "443110",
    "nameCN": "惠州中海炼油东联码头",
    "nameEN": "Huizhou Zhonghai Lianyou Donglian Dock"
  },
  {
    "code": "443111",
    "nameCN": "大亚湾石化区公用石化码头",
    "nameEN": "Dayawan Shihuaqu Gongyong Petrochemicals Dock"
  },
  {
    "code": "443201",
    "nameCN": "揭阳榕江泰丰码头",
    "nameEN": "Jieyang Rongjiang Taifeng Dock"
  },
  {
    "code": "443202",
    "nameCN": "揭阳靖海惠来电厂码头",
    "nameEN": "Jieyang Jinghai Huilai Dianchang Dock"
  },
  {
    "code": "443203",
    "nameCN": "揭阳曲溪码头",
    "nameEN": "Jieyang Quxi Dock"
  },
  {
    "code": "443204",
    "nameCN": "揭阳车检场",
    "nameEN": "Jieyang Truck Inspection Field"
  },
  {
    "code": "443205",
    "nameCN": "揭阳惠来车检场",
    "nameEN": "Jieyang Huilai Truck Inspection Field"
  },
  {
    "code": "443206",
    "nameCN": "揭阳普宁车检场",
    "nameEN": "Jieyang Puning Truck Inspection Field"
  },
  {
    "code": "443207",
    "nameCN": "揭阳神泉中海油码头",
    "nameEN": "Jieyang Shenquan Zhonghaiyou Dock"
  },
  {
    "code": "443301",
    "nameCN": "云浮新港",
    "nameEN": "Yunfu Xingang"
  },
  {
    "code": "443302",
    "nameCN": "云浮罗定车检场",
    "nameEN": "Yunfu Luoding Truck Inspection Field"
  },
  {
    "code": "443303",
    "nameCN": "云浮车检场",
    "nameEN": "Yunfu Truck Inspection Field"
  },
  {
    "code": "443401",
    "nameCN": "南沙港客运码头",
    "nameEN": "Nansha Harbor Passenger Transpor Dock"
  },
  {
    "code": "443402",
    "nameCN": "南沙南伟码头",
    "nameEN": "Nansha Nanwei Dock"
  },
  {
    "code": "443403",
    "nameCN": "南沙东发码头",
    "nameEN": "Nansha Dongfa Dock"
  },
  {
    "code": "443404",
    "nameCN": "南沙港一期码头",
    "nameEN": "Nansha Harbor Yiqi Dock"
  },
  {
    "code": "443405",
    "nameCN": "南沙港二期码头",
    "nameEN": "Nansha Harbor Erqi Dock"
  },
  {
    "code": "443406",
    "nameCN": "南沙汽车码头",
    "nameEN": "Nansha Qiche Dock"
  },
  {
    "code": "443407",
    "nameCN": "南沙港发石化码头",
    "nameEN": "Nansha Gangfa Petrochemicals Dock"
  },
  {
    "code": "443408",
    "nameCN": "南沙小虎石化码头",
    "nameEN": "Nansha Xiaohu Petrochemicals Dock"
  },
  {
    "code": "443409",
    "nameCN": "南沙华润热电煤码头",
    "nameEN": "Nansha Huarun Redianmei Dock"
  },
  {
    "code": "443410",
    "nameCN": "南沙粤海石化码头",
    "nameEN": "Nansha Yuehai Petrochemicals Dock"
  },
  {
    "code": "443411",
    "nameCN": "南沙珠江电厂码头",
    "nameEN": "Nansha Zhujiang Dianchang Dock"
  },
  {
    "code": "443412",
    "nameCN": "南沙中石油码头",
    "nameEN": "Nansha CNPC Dock"
  },
  {
    "code": "443413",
    "nameCN": "南沙中船龙穴船舶维修码头",
    "nameEN": "Nansha Zhongchuan Longxue Chuanbo Weixiu Dock"
  },
  {
    "code": "443414",
    "nameCN": "南沙港建液化气码头",
    "nameEN": "Nansha Harbor Jianyehuaqi Dock"
  },
  {
    "code": "443415",
    "nameCN": "南沙车检场",
    "nameEN": "Nansha Truck Inspection Field"
  },
  {
    "code": "443416",
    "nameCN": "广州南沙保税港区",
    "nameEN": "Guangzhou Nansha Free Trade Port Zone"
  },
  {
    "code": "443417",
    "nameCN": "南沙港三期码头",
    "nameEN": "Nansha Harbor Sanqi Dock"
  },
  {
    "code": "445100",
    "nameCN": "广东省潮州市",
    "nameEN": "Guangdong Sheng Chaozhou Shi"
  },
  {
    "code": "445200",
    "nameCN": "广东省揭阳市",
    "nameEN": "Guangdong Sheng Jieping Shi"
  },
  {
    "code": "445300",
    "nameCN": "广东省云浮市",
    "nameEN": "Guangdong Sheng Yunfu Shi"
  },
  {
    "code": "450001",
    "nameCN": "南宁",
    "nameEN": "Nanning"
  },
  {
    "code": "450002",
    "nameCN": "南宁吴圩机场",
    "nameEN": "Nanning Wuxu Airport"
  },
  {
    "code": "450101",
    "nameCN": "梧州",
    "nameEN": "Wuzhou"
  },
  {
    "code": "450200",
    "nameCN": "广西壮族自治区柳州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Liuzhou Shi"
  },
  {
    "code": "450201",
    "nameCN": "北海福成机场",
    "nameEN": "Beihai Fucheng Airport"
  },
  {
    "code": "450202",
    "nameCN": "北海",
    "nameEN": "Beihai"
  },
  {
    "code": "450203",
    "nameCN": "石头埠",
    "nameEN": "Shitoubu"
  },
  {
    "code": "450204",
    "nameCN": "北海出口加工区",
    "nameEN": "Beihai Export Processind Zone"
  },
  {
    "code": "450300",
    "nameCN": "广西壮族自治区桂林市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Guilin Shi"
  },
  {
    "code": "450301",
    "nameCN": "防城",
    "nameEN": "Fangcheng"
  },
  {
    "code": "450302",
    "nameCN": "茅岭",
    "nameEN": "Maoling"
  },
  {
    "code": "450303",
    "nameCN": "企沙",
    "nameEN": "Qisha"
  },
  {
    "code": "450400",
    "nameCN": "广西壮族自治区梧州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Wuzhou Shi"
  },
  {
    "code": "450401",
    "nameCN": "凭祥友谊关公路",
    "nameEN": "Pingxiang Youyiguan Highroad"
  },
  {
    "code": "450402",
    "nameCN": "凭祥友谊关通道",
    "nameEN": "Pingxiang Youyiguan Tongdao"
  },
  {
    "code": "450403",
    "nameCN": "凭祥浦寨通道",
    "nameEN": "Pingxiang Puzhai Tongdao"
  },
  {
    "code": "450404",
    "nameCN": "凭祥弄尧通道",
    "nameEN": "Pingxinag Nongyao Tongdao"
  },
  {
    "code": "450405",
    "nameCN": "凭祥站",
    "nameEN": "Pingxinagzhan"
  },
  {
    "code": "450406",
    "nameCN": "爱店",
    "nameEN": "Aidian"
  },
  {
    "code": "450407",
    "nameCN": "凭祥综合保税区",
    "nameEN": "Pingxiang Comprehensive Bonded Zone"
  },
  {
    "code": "450500",
    "nameCN": "广西壮族自治区北海市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Beihai Shi"
  },
  {
    "code": "450501",
    "nameCN": "水口",
    "nameEN": "Shuikou"
  },
  {
    "code": "450502",
    "nameCN": "硕龙",
    "nameEN": "Shuolong"
  },
  {
    "code": "450600",
    "nameCN": "广西壮族自治区防城港市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Fangchenggang Shi"
  },
  {
    "code": "450601",
    "nameCN": "东兴",
    "nameEN": "Dongxing"
  },
  {
    "code": "450602",
    "nameCN": "江平",
    "nameEN": "Jiangping"
  },
  {
    "code": "450603",
    "nameCN": "江山",
    "nameEN": "Jiangshan"
  },
  {
    "code": "450604",
    "nameCN": "峒中",
    "nameEN": "Tongzhong"
  },
  {
    "code": "450700",
    "nameCN": "广西壮族自治区钦州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Qinzhou Shi"
  },
  {
    "code": "450701",
    "nameCN": "果子山",
    "nameEN": "Guozishan"
  },
  {
    "code": "450702",
    "nameCN": "钦州",
    "nameEN": "Qinzhou"
  },
  {
    "code": "450800",
    "nameCN": "广西壮族自治区贵港市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Guigang Shi"
  },
  {
    "code": "450801",
    "nameCN": "桂林两江国际机场",
    "nameEN": "Guilin Liangjiang International Airport"
  },
  {
    "code": "450900",
    "nameCN": "广西壮族自治区玉林市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Yulin Shi"
  },
  {
    "code": "450901",
    "nameCN": "柳州",
    "nameEN": "Liuzhou"
  },
  {
    "code": "451000",
    "nameCN": "广西壮族自治区百色市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Bose Shi"
  },
  {
    "code": "451100",
    "nameCN": "广西壮族自治区贺州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Hezhou Shi"
  },
  {
    "code": "451101",
    "nameCN": "贵港",
    "nameEN": "Guigang"
  },
  {
    "code": "451200",
    "nameCN": "广西壮族自治区河池市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Hechi Shi"
  },
  {
    "code": "451201",
    "nameCN": "岳圩",
    "nameEN": "Yuexu"
  },
  {
    "code": "451202",
    "nameCN": "龙邦",
    "nameEN": "Longbang"
  },
  {
    "code": "451203",
    "nameCN": "平孟",
    "nameEN": "Pingmeng"
  },
  {
    "code": "451300",
    "nameCN": "广西壮族自治区来宾市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Laibin Shi"
  },
  {
    "code": "451301",
    "nameCN": "钦州保税港区",
    "nameEN": "Qinzhou Free Trade Port Zone"
  },
  {
    "code": "451400",
    "nameCN": "广西壮族自治区崇左市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Chongzuo Shi"
  },
  {
    "code": "451501",
    "nameCN": "南宁港",
    "nameEN": "Nanning Harbor"
  },
  {
    "code": "460001",
    "nameCN": "海口",
    "nameEN": "Haikou"
  },
  {
    "code": "460002",
    "nameCN": "海口港",
    "nameEN": "Haikou Harbor"
  },
  {
    "code": "460003",
    "nameCN": "马村港",
    "nameEN": "Macun Harbor"
  },
  {
    "code": "460004",
    "nameCN": "海口综合保税区",
    "nameEN": "Haikou Comprehensive Bonded Zone"
  },
  {
    "code": "460005",
    "nameCN": "洋浦保税港区",
    "nameEN": "Yangpu Free Trade Port Zone"
  },
  {
    "code": "460101",
    "nameCN": "三亚凤凰国际机场",
    "nameEN": "Sanya Fenghuang International Airport"
  },
  {
    "code": "460102",
    "nameCN": "三亚港",
    "nameEN": "Sanya Harbor"
  },
  {
    "code": "460200",
    "nameCN": "海南省三亚市",
    "nameEN": "Hainan Sheng Sanya Shi"
  },
  {
    "code": "460201",
    "nameCN": "八所港",
    "nameEN": "Basuo Harbor"
  },
  {
    "code": "460300",
    "nameCN": "海南省三沙市",
    "nameEN": "Hainan Sheng Sansha Shi"
  },
  {
    "code": "460301",
    "nameCN": "洋浦港 ",
    "nameEN": "Yangpu Harbor"
  },
  {
    "code": "460302",
    "nameCN": "洋浦神头港",
    "nameEN": "Yangpu Shentou Harbor"
  },
  {
    "code": "460400",
    "nameCN": "海南省儋州市",
    "nameEN": "Hainan Sheng Danzhou Shi"
  },
  {
    "code": "460401",
    "nameCN": "清澜港",
    "nameEN": "Qinglan Harbor"
  },
  {
    "code": "460402",
    "nameCN": "铺前",
    "nameEN": "Puqian"
  },
  {
    "code": "460403",
    "nameCN": "琼海潭门",
    "nameEN": "Qionghai Tanmen"
  },
  {
    "code": "460501",
    "nameCN": "海口美兰机场",
    "nameEN": "Haikou Meilan Airport"
  },
  {
    "code": "469000",
    "nameCN": "海南省省直辖县级行政区划",
    "nameEN": "Hainan Sheng Sheng Zhixia Xianji Xingzhengquhua"
  },
  {
    "code": "470001",
    "nameCN": "深圳",
    "nameEN": "Shenzhen"
  },
  {
    "code": "470101",
    "nameCN": "蛇口",
    "nameEN": "Shekou"
  },
  {
    "code": "470102",
    "nameCN": "赤湾",
    "nameEN": "Chiwan"
  },
  {
    "code": "470103",
    "nameCN": "东角头",
    "nameEN": "Dongjiaotou"
  },
  {
    "code": "470104",
    "nameCN": "妈湾1号泊位",
    "nameEN": "Mawan 1 Bowei"
  },
  {
    "code": "470105",
    "nameCN": "妈湾2号泊位",
    "nameEN": "Mawan 2 Bowei"
  },
  {
    "code": "470106",
    "nameCN": "妈湾3号泊位",
    "nameEN": "Mawan 3 Bowei"
  },
  {
    "code": "470107",
    "nameCN": "妈湾4号泊位",
    "nameEN": "Mawan 4 Bowei"
  },
  {
    "code": "470201",
    "nameCN": "皇岗",
    "nameEN": "Huanggang"
  },
  {
    "code": "470202",
    "nameCN": "福田",
    "nameEN": "Futian"
  },
  {
    "code": "470301",
    "nameCN": "罗湖",
    "nameEN": "Luhu"
  },
  {
    "code": "470401",
    "nameCN": "文锦渡",
    "nameEN": "Wenjindu"
  },
  {
    "code": "470501",
    "nameCN": "沙头角",
    "nameEN": "Shatoujiao"
  },
  {
    "code": "470502",
    "nameCN": "中英街桥头",
    "nameEN": "Zhongyingjie Qiaotou"
  },
  {
    "code": "470503",
    "nameCN": "深圳沙头角保税区",
    "nameEN": "Shenzhen Shatoujiao Free Trade Zone"
  },
  {
    "code": "470601",
    "nameCN": "盐田",
    "nameEN": "Yantian"
  },
  {
    "code": "470602",
    "nameCN": "下洞码头",
    "nameEN": "Xiadong Dock"
  },
  {
    "code": "470603",
    "nameCN": "LNG码头",
    "nameEN": "LNG Dock"
  },
  {
    "code": "470604",
    "nameCN": "沙鱼冲",
    "nameEN": "Shayuchong"
  },
  {
    "code": "470605",
    "nameCN": "深圳盐田保税物流园区",
    "nameEN": "Shenzhen Yantian Bonded Logistics Zone"
  },
  {
    "code": "470606",
    "nameCN": "深圳盐田保税区",
    "nameEN": "Shenzhen Yantian Free Trade Zone"
  },
  {
    "code": "470701",
    "nameCN": "大亚湾",
    "nameEN": "Dayawan"
  },
  {
    "code": "471001",
    "nameCN": "深圳宝安国际机场",
    "nameEN": "Shenzhen Baoan International Airport"
  },
  {
    "code": "471002",
    "nameCN": "福永码头",
    "nameEN": "Fuyong Dock"
  },
  {
    "code": "471003",
    "nameCN": "机场油轮码头",
    "nameEN": "Jichang Youlun Dock"
  },
  {
    "code": "471101",
    "nameCN": "深圳福田保税区",
    "nameEN": "Shenzhen Futian Free Trade Zone"
  },
  {
    "code": "471301",
    "nameCN": "深圳出口加工区",
    "nameEN": "Shenzhen Export Processind Zone"
  },
  {
    "code": "471401",
    "nameCN": "深圳湾",
    "nameEN": "Shenzhenwan"
  },
  {
    "code": "471601",
    "nameCN": "大铲湾",
    "nameEN": "Dachanwan"
  },
  {
    "code": "471801",
    "nameCN": "妈湾5号泊位",
    "nameEN": "Mawan 5 Bowei"
  },
  {
    "code": "471802",
    "nameCN": "妈湾6号泊位",
    "nameEN": "Mawan 6 Bowei"
  },
  {
    "code": "471803",
    "nameCN": "妈湾7号泊位",
    "nameEN": "Mawan 7 Bowei"
  },
  {
    "code": "471804",
    "nameCN": "深圳前海湾保税港区",
    "nameEN": "Shenzhen Qianhaiwan Free Trade Port Zone"
  },
  {
    "code": "480001",
    "nameCN": "珠海",
    "nameEN": "Zhuhai"
  },
  {
    "code": "480002",
    "nameCN": "拱北货场",
    "nameEN": "Gongbei Huochang"
  },
  {
    "code": "480003",
    "nameCN": "拱北旅检通道",
    "nameEN": "Gongbei Passenger-Inspection Tongdao"
  },
  {
    "code": "480004",
    "nameCN": "香洲",
    "nameEN": "Xiangzhou"
  },
  {
    "code": "480005",
    "nameCN": "九洲货运码头",
    "nameEN": "Jiuzhou Freight Dock"
  },
  {
    "code": "480006",
    "nameCN": "九洲客运码头",
    "nameEN": "Jiuzhou Passenger Transpor Dock"
  },
  {
    "code": "480007",
    "nameCN": "九洲白石货场",
    "nameEN": "Jiuzhou Baishi Huochang"
  },
  {
    "code": "480008",
    "nameCN": "湾仔豪通码头",
    "nameEN": "Wanzai Haotong Dock"
  },
  {
    "code": "480009",
    "nameCN": "湾仔客运码头",
    "nameEN": "Wanzai Passenger Transpor Dock"
  },
  {
    "code": "480010",
    "nameCN": "湾仔西域码头",
    "nameEN": "Wanzai Xiyu Dock"
  },
  {
    "code": "480011",
    "nameCN": "珠海保税区加华码头",
    "nameEN": "Zhuhai Free Trade Zone Jiahua Dock"
  },
  {
    "code": "480012",
    "nameCN": "珠海保税区货场",
    "nameEN": "Zhuhai Free Trade Zone Huochang"
  },
  {
    "code": "480013",
    "nameCN": "珠澳跨境工业区（珠海园区）货场",
    "nameEN": "Zhuao Cross Bonded Industrial Zone Huochang"
  },
  {
    "code": "480014",
    "nameCN": "珠澳跨境工业区（珠海园区）旅检通道",
    "nameEN": "Zhuao Cross Bonded Industrial Zone Passenger-Inspection Tongdao"
  },
  {
    "code": "480015",
    "nameCN": "湾仔洪湾码头",
    "nameEN": "Wanzai Hongwan Dock"
  },
  {
    "code": "480101",
    "nameCN": "斗门客运码头",
    "nameEN": "Doumen Passenger Transpor Dock"
  },
  {
    "code": "480102",
    "nameCN": "斗门新环码头",
    "nameEN": "Doumen Xinhuan Dock"
  },
  {
    "code": "480201",
    "nameCN": "高栏",
    "nameEN": "Gaolan"
  },
  {
    "code": "480202",
    "nameCN": "平沙新码头",
    "nameEN": "Pingsha Xinmatou"
  },
  {
    "code": "480301",
    "nameCN": "万山",
    "nameEN": "Wanshan"
  },
  {
    "code": "480401",
    "nameCN": "横琴",
    "nameEN": "Hengqin"
  },
  {
    "code": "500001",
    "nameCN": "重庆",
    "nameEN": "Chongqing"
  },
  {
    "code": "500002",
    "nameCN": "重庆港",
    "nameEN": "Chongqing Harbor"
  },
  {
    "code": "500101",
    "nameCN": "万州",
    "nameEN": "Wanzhou"
  },
  {
    "code": "500201",
    "nameCN": "九龙坡港",
    "nameEN": "Jiulongpo Harbor"
  },
  {
    "code": "500401",
    "nameCN": "重庆两路寸滩保税港区水港",
    "nameEN": "Chongqing Lianglucuntan Free Trade Port Zone Shuigang"
  },
  {
    "code": "500402",
    "nameCN": "重庆两路寸滩保税港区空港",
    "nameEN": "Chongqing Lianglucuntan Free Trade Port Zone Konggang"
  },
  {
    "code": "500501",
    "nameCN": "重庆西永综合保税区",
    "nameEN": "Chongqing Xiyong Comprehensive Bonded Zone"
  },
  {
    "code": "500601",
    "nameCN": "重庆江北国际机场",
    "nameEN": "Chongqing Jiangbei International Airport"
  },
  {
    "code": "510001",
    "nameCN": "成都",
    "nameEN": "Chengdu"
  },
  {
    "code": "510002",
    "nameCN": "成都国际邮件互换局",
    "nameEN": "Chengdu Guoji Youjian Huhuanju"
  },
  {
    "code": "510003",
    "nameCN": "成都双流国际机场T1航站楼",
    "nameEN": "Chengdu Shuangliu International Airport T1"
  },
  {
    "code": "510004",
    "nameCN": "成都双流国际机场货场",
    "nameEN": "Chengdu Shuangliu International Airport Huochang"
  },
  {
    "code": "510005",
    "nameCN": "成都双流国际机场国际快件",
    "nameEN": "Chengdu Shuangliu International Airport Kuaijian"
  },
  {
    "code": "510006",
    "nameCN": "宜宾港",
    "nameEN": "Yibin Harbor"
  },
  {
    "code": "510007",
    "nameCN": "成都龙泉驿",
    "nameEN": "Chengdu Longquanyi"
  },
  {
    "code": "510008",
    "nameCN": "成都青白江",
    "nameEN": "Chengdu Qingbaijiang"
  },
  {
    "code": "510101",
    "nameCN": "攀枝花",
    "nameEN": "Panzihua"
  },
  {
    "code": "510300",
    "nameCN": "四川省自贡市",
    "nameEN": "Sichuan Sheng Zigong Shi"
  },
  {
    "code": "510400",
    "nameCN": "四川省攀枝花市",
    "nameEN": "Sichuan Sheng Panzhihua Shi"
  },
  {
    "code": "510401",
    "nameCN": "乐山",
    "nameEN": "Leshan"
  },
  {
    "code": "510500",
    "nameCN": "四川省泸州市",
    "nameEN": "Sichuan Sheng Luzhou Shi"
  },
  {
    "code": "510600",
    "nameCN": "四川省德阳市",
    "nameEN": "Sichuan Sheng Deyang Shi"
  },
  {
    "code": "510601",
    "nameCN": "绵阳",
    "nameEN": "Mianyang"
  },
  {
    "code": "510602",
    "nameCN": "绵阳出口加工区",
    "nameEN": "Mianyang Export Processind Zone"
  },
  {
    "code": "510700",
    "nameCN": "四川省绵阳市",
    "nameEN": "Sichuan Sheng Mianyang Shi"
  },
  {
    "code": "510701",
    "nameCN": "泸州港",
    "nameEN": "Luzhou Harbor"
  },
  {
    "code": "510800",
    "nameCN": "四川省广元市",
    "nameEN": "Sichuan Sheng Guangyuan Shi"
  },
  {
    "code": "510900",
    "nameCN": "四川省遂宁市",
    "nameEN": "Sichuan Sheng Suining Shi"
  },
  {
    "code": "511000",
    "nameCN": "四川省内江市",
    "nameEN": "Sichuan Sheng Neijiang Shi"
  },
  {
    "code": "511001",
    "nameCN": "成都高新综合保税区双流园区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Shuangliu Yuanqu"
  },
  {
    "code": "511002",
    "nameCN": "成都高新综合保税区A区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Zone A"
  },
  {
    "code": "511003",
    "nameCN": "成都高新综合保税区B区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Zone B"
  },
  {
    "code": "511004",
    "nameCN": "成都高新综合保税区C区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Zone C"
  },
  {
    "code": "511100",
    "nameCN": "四川省乐山市",
    "nameEN": "Sichuan Sheng Leshan Shi"
  },
  {
    "code": "511300",
    "nameCN": "四川省南充市",
    "nameEN": "Sichuan Sheng Nanchong Shi"
  },
  {
    "code": "511400",
    "nameCN": "四川省眉山市",
    "nameEN": "Sichuan Sheng Meishan Shi"
  },
  {
    "code": "511500",
    "nameCN": "四川省宜宾市",
    "nameEN": "Sichuan Sheng Yibin Shi"
  },
  {
    "code": "511600",
    "nameCN": "四川省广安市",
    "nameEN": "Sichuan Sheng Guang'an Shi"
  },
  {
    "code": "511700",
    "nameCN": "四川省达州市",
    "nameEN": "Sichuan Sheng Dachuan Shi"
  },
  {
    "code": "511800",
    "nameCN": "四川省雅安市",
    "nameEN": "Sichuan Sheng Ya'an Shi"
  },
  {
    "code": "511900",
    "nameCN": "四川省巴中市",
    "nameEN": "Sichuan Sheng Bazhong Shi"
  },
  {
    "code": "512000",
    "nameCN": "四川省资阳市",
    "nameEN": "Sichuan Sheng Ziyang Shi"
  },
  {
    "code": "513200",
    "nameCN": "四川省阿坝藏族羌族自治州",
    "nameEN": "Sichuan Sheng Aba Zangzu Qiangzu Zizhizhou"
  },
  {
    "code": "513300",
    "nameCN": "四川省甘孜藏族自治州",
    "nameEN": "Sichuan Sheng Garze Zangzu Zizhizhou"
  },
  {
    "code": "513400",
    "nameCN": "四川省凉山彝族自治州",
    "nameEN": "Sichuan Sheng Liangshan Yizu Zizhizhou"
  },
  {
    "code": "520001",
    "nameCN": "贵阳",
    "nameEN": "Guiyang"
  },
  {
    "code": "520002",
    "nameCN": "贵阳龙洞堡机场",
    "nameEN": "Guiyang Longdongbao Airport"
  },
  {
    "code": "520003",
    "nameCN": "贵阳综合保税区",
    "nameEN": "Guiyang Comprehensive Bonded Zone"
  },
  {
    "code": "520004",
    "nameCN": "贵安综合保税区",
    "nameEN": "Gui'an Comprehensive Bonded Zone"
  },
  {
    "code": "520200",
    "nameCN": "贵州省六盘水市",
    "nameEN": "Guizhou Sheng Lupanshui Shi"
  },
  {
    "code": "520300",
    "nameCN": "贵州省遵义市",
    "nameEN": "Guizhou Sheng Zunyi Shi"
  },
  {
    "code": "520400",
    "nameCN": "贵州省安顺市",
    "nameEN": "Guizhou Sheng Anshun Shi"
  },
  {
    "code": "520500",
    "nameCN": "贵州省毕节市",
    "nameEN": "Guizhou Sheng Bijie Shi"
  },
  {
    "code": "520600",
    "nameCN": "贵州省铜仁市",
    "nameEN": "Guizhou Sheng Tongren Shi"
  },
  {
    "code": "522300",
    "nameCN": "贵州省黔西南布依族苗族自治州",
    "nameEN": "Guizhou Sheng Qianxinan Buyeizu Miaozu Zizhizhou"
  },
  {
    "code": "522600",
    "nameCN": "贵州省黔东南苗族侗族自治州",
    "nameEN": "Guizhou Sheng Qiandongnan Miaozu Dongzu Zizhizhou"
  },
  {
    "code": "522700",
    "nameCN": "贵州省黔南布依族苗族自治州",
    "nameEN": "Guizhou Sheng Qiannan Buyeizu Miaozu Zizhizhou"
  },
  {
    "code": "530001",
    "nameCN": "昆明",
    "nameEN": "Kunming"
  },
  {
    "code": "530002",
    "nameCN": "昆明出口加工区",
    "nameEN": "Kunming Export Processind Zone"
  },
  {
    "code": "530003",
    "nameCN": "昆明综合保税区",
    "nameEN": "Kunming Comprehensive Bonded Zone"
  },
  {
    "code": "530101",
    "nameCN": "瑞丽",
    "nameEN": "Ruili"
  },
  {
    "code": "530102",
    "nameCN": "姐告",
    "nameEN": "Jiegao"
  },
  {
    "code": "530103",
    "nameCN": "弄岛",
    "nameEN": "Nongdao"
  },
  {
    "code": "530104",
    "nameCN": "畹町",
    "nameEN": "Wanding"
  },
  {
    "code": "530201",
    "nameCN": "芒市",
    "nameEN": "Mangshi"
  },
  {
    "code": "530202",
    "nameCN": "盈江",
    "nameEN": "Yingjiang"
  },
  {
    "code": "530203",
    "nameCN": "章凤",
    "nameEN": "Zhangfeng"
  },
  {
    "code": "530300",
    "nameCN": "云南省曲靖市",
    "nameEN": "Yunnan Sheng Qujing Shi"
  },
  {
    "code": "530301",
    "nameCN": "腾冲",
    "nameEN": "Tengchong"
  },
  {
    "code": "530302",
    "nameCN": "猴桥",
    "nameEN": "Houqiao"
  },
  {
    "code": "530303",
    "nameCN": "滇滩",
    "nameEN": "Diantan"
  },
  {
    "code": "530400",
    "nameCN": "云南省玉溪市",
    "nameEN": "Yunnan Sheng Yuxi Shi"
  },
  {
    "code": "530401",
    "nameCN": "耿马",
    "nameEN": "Gengma"
  },
  {
    "code": "530402",
    "nameCN": "孟定清水河",
    "nameEN": "Mengding Qingshuihe"
  },
  {
    "code": "530403",
    "nameCN": "沧源",
    "nameEN": "Cangyuan"
  },
  {
    "code": "530404",
    "nameCN": "南伞",
    "nameEN": "Nansan"
  },
  {
    "code": "530500",
    "nameCN": "云南省保山市",
    "nameEN": "Yunnan Sheng Baoshan Shi"
  },
  {
    "code": "530501",
    "nameCN": "河口站",
    "nameEN": "Hekouzhan"
  },
  {
    "code": "530502",
    "nameCN": "河口",
    "nameEN": "Hekou"
  },
  {
    "code": "530600",
    "nameCN": "云南省昭通市",
    "nameEN": "Yunnan Sheng Zhaotong Shi"
  },
  {
    "code": "530601",
    "nameCN": "西双版纳",
    "nameEN": "Xishuangbanna"
  },
  {
    "code": "530602",
    "nameCN": "西双版纳国际机场",
    "nameEN": "Xishuangbanna International Airport"
  },
  {
    "code": "530603",
    "nameCN": "景洪港",
    "nameEN": "Jinghong Harbor"
  },
  {
    "code": "530604",
    "nameCN": "打洛",
    "nameEN": "Daluo"
  },
  {
    "code": "530605",
    "nameCN": "大勐龙",
    "nameEN": "Damenglong"
  },
  {
    "code": "530700",
    "nameCN": "云南省丽江市　　　　　　　",
    "nameEN": "Yunnan Sheng Lijiang Shi"
  },
  {
    "code": "530701",
    "nameCN": "普洱",
    "nameEN": "Puer"
  },
  {
    "code": "530702",
    "nameCN": "孟连",
    "nameEN": "Menglian"
  },
  {
    "code": "530703",
    "nameCN": "思茅港",
    "nameEN": "Simao Dixibei"
  },
  {
    "code": "530800",
    "nameCN": "云南省普洱市",
    "nameEN": "Yunnan Sheng Pu'er Shi"
  },
  {
    "code": "530801",
    "nameCN": "勐腊",
    "nameEN": "Mengla"
  },
  {
    "code": "530802",
    "nameCN": "磨憨",
    "nameEN": "Mohan"
  },
  {
    "code": "530803",
    "nameCN": "关累港",
    "nameEN": "Guanlei Harbor"
  },
  {
    "code": "530900",
    "nameCN": "云南省临沧市",
    "nameEN": "Yunnan Sheng Lincang Shi"
  },
  {
    "code": "530901",
    "nameCN": "金平",
    "nameEN": "Jinping"
  },
  {
    "code": "530902",
    "nameCN": "金水河",
    "nameEN": "Jinshuihe"
  },
  {
    "code": "530903",
    "nameCN": "红河综合保税区",
    "nameEN": "Honghe Comprehensive Bonded Zone"
  },
  {
    "code": "531001",
    "nameCN": "麻栗坡",
    "nameEN": "Malipo"
  },
  {
    "code": "531002",
    "nameCN": "天保",
    "nameEN": "Tianbao"
  },
  {
    "code": "531003",
    "nameCN": "田蓬",
    "nameEN": "Tianpeng"
  },
  {
    "code": "531101",
    "nameCN": "大理",
    "nameEN": "Dali"
  },
  {
    "code": "531201",
    "nameCN": "昆明长水国际机场",
    "nameEN": "Kunming Changshui International Airport"
  },
  {
    "code": "531301",
    "nameCN": "丽江三义机场",
    "nameEN": "Lijiang Sanyi Airport"
  },
  {
    "code": "531401",
    "nameCN": "勐康",
    "nameEN": "Mengkang"
  },
  {
    "code": "531402",
    "nameCN": "龙富",
    "nameEN": "Longfu"
  },
  {
    "code": "531501",
    "nameCN": "怒江",
    "nameEN": "Nujiang"
  },
  {
    "code": "531502",
    "nameCN": "片马",
    "nameEN": "Pianma"
  },
  {
    "code": "532300",
    "nameCN": "云南省楚雄彝族自治州",
    "nameEN": "Yunnan Sheng Chuxiong Yizu Zizhizhou"
  },
  {
    "code": "532500",
    "nameCN": "云南省红河哈尼族彝族自治州",
    "nameEN": "Yunnan Sheng Honghe Hanizu Yizu Zizhizhou"
  },
  {
    "code": "532600",
    "nameCN": "云南省文山壮族苗族自治州",
    "nameEN": "Yunnan Sheng Wenshan Zhuangzu Miaozu Zizhizhou"
  },
  {
    "code": "532800",
    "nameCN": "云南省西双版纳傣族自治州",
    "nameEN": "Yunnan Sheng Xishuangbanna Daizu Zizhizhou"
  },
  {
    "code": "532900",
    "nameCN": "云南省大理白族自治州",
    "nameEN": "Yunnan Sheng Dali Baizu Zizhizhou"
  },
  {
    "code": "533100",
    "nameCN": "云南省德宏傣族景颇族自治州",
    "nameEN": "Yunnan Sheng Dehong Daizu Jingpozu Zizhizhou"
  },
  {
    "code": "533300",
    "nameCN": "云南省怒江傈僳族自治州",
    "nameEN": "Yunnan Sheng Nujiang Lisuzu Zizhizhou"
  },
  {
    "code": "533400",
    "nameCN": "云南省迪庆藏族自治州",
    "nameEN": "Yunnan Sheng Deqen Zangzu Zizhizhou"
  },
  {
    "code": "540001",
    "nameCN": "拉萨",
    "nameEN": "Lhasa"
  },
  {
    "code": "540002",
    "nameCN": "拉萨贡嘎机场",
    "nameEN": "Lhasa Gongga Airport"
  },
  {
    "code": "540101",
    "nameCN": "吉隆",
    "nameEN": "Gyirong"
  },
  {
    "code": "540102",
    "nameCN": "樟木",
    "nameEN": "Zham"
  },
  {
    "code": "540103",
    "nameCN": "日屋",
    "nameEN": "Riwo"
  },
  {
    "code": "540200",
    "nameCN": "西藏自治区日喀则市",
    "nameEN": "Xizang Zizhiqu Xigaze Shi"
  },
  {
    "code": "540201",
    "nameCN": "普兰",
    "nameEN": "Burang"
  },
  {
    "code": "540300",
    "nameCN": "西藏自治区昌都市",
    "nameEN": "Xizang Zizhiqu Qamdo Shi"
  },
  {
    "code": "540400",
    "nameCN": "西藏自治区林芝市",
    "nameEN": "Xizang Zizhiqu Nyingchi Shi"
  },
  {
    "code": "540500",
    "nameCN": "西藏自治区山南市",
    "nameEN": "Xizang Zizhiqu Shannan Shi"
  },
  {
    "code": "540600",
    "nameCN": "西藏自治区那曲市",
    "nameEN": "Xizang ZiZhiqu Nagqu Shi"
  },
  {
    "code": "542500",
    "nameCN": "西藏自治区阿里地区",
    "nameEN": "Xizang Zizhiqu Ngari Diqu"
  },
  {
    "code": "610001",
    "nameCN": "西安",
    "nameEN": "Xian"
  },
  {
    "code": "610002",
    "nameCN": "西安咸阳国际机场",
    "nameEN": "Xian Xianyang International Airport"
  },
  {
    "code": "610003",
    "nameCN": "宝鸡",
    "nameEN": "Baoji"
  },
  {
    "code": "610004",
    "nameCN": "汉中",
    "nameEN": "Hanzhong"
  },
  {
    "code": "610005",
    "nameCN": "榆林",
    "nameEN": "Yulin"
  },
  {
    "code": "610006",
    "nameCN": "延安",
    "nameEN": "Yanan"
  },
  {
    "code": "610007",
    "nameCN": "渭南",
    "nameEN": "Weinan"
  },
  {
    "code": "610008",
    "nameCN": "西安综合保税区",
    "nameEN": "Xian Comprehensive Bonded Zone"
  },
  {
    "code": "610009",
    "nameCN": "西安出口加工区",
    "nameEN": "Xian Export Processind Zone"
  },
  {
    "code": "610010",
    "nameCN": "西安高新综合保税区",
    "nameEN": "Xi'an Gaoxin Comprehensive Bonded Zone"
  },
  {
    "code": "610200",
    "nameCN": "陕西省铜川市",
    "nameEN": "Shanxi Sheng Tongchuan Shi"
  },
  {
    "code": "610300",
    "nameCN": "陕西省宝鸡市",
    "nameEN": "Shanxi Sheng Baoji Shi"
  },
  {
    "code": "610400",
    "nameCN": "陕西省咸阳市",
    "nameEN": "Shanxi Sheng Xianyang Shi"
  },
  {
    "code": "610500",
    "nameCN": "陕西省渭南市",
    "nameEN": "Shanxi Sheng Weinan Shi"
  },
  {
    "code": "610600",
    "nameCN": "陕西省延安市",
    "nameEN": "Shanxi Sheng Yan'an Shi"
  },
  {
    "code": "610700",
    "nameCN": "陕西省汉中市",
    "nameEN": "Shanxi Sheng Hanzhong Shi"
  },
  {
    "code": "610800",
    "nameCN": "陕西省榆林市",
    "nameEN": "Shanxi Sheng Yulin Shi"
  },
  {
    "code": "610900",
    "nameCN": "陕西省安康市",
    "nameEN": "Shanxi Sheng Ankang Shi"
  },
  {
    "code": "611000",
    "nameCN": "陕西省商洛市",
    "nameEN": "Shanxi Sheng Shangluo Shi"
  },
  {
    "code": "620001",
    "nameCN": "兰州",
    "nameEN": "Lanzhou"
  },
  {
    "code": "620002",
    "nameCN": "兰州中川机场",
    "nameEN": "Lanzhou Zhongchuan Airport"
  },
  {
    "code": "620003",
    "nameCN": "兰州新区综合保税区",
    "nameEN": "Lanzhou Xinqu Comprehensive Bonded Zone"
  },
  {
    "code": "620101",
    "nameCN": "酒泉",
    "nameEN": "Jiuquan"
  },
  {
    "code": "620102",
    "nameCN": "马鬃山",
    "nameEN": "Mazongshan"
  },
  {
    "code": "620200",
    "nameCN": "甘肃省嘉峪关市",
    "nameEN": "Gansu Sheng Jiayuguan Shi"
  },
  {
    "code": "620300",
    "nameCN": "甘肃省金昌市",
    "nameEN": "Gansu Sheng Jinchang Shi"
  },
  {
    "code": "620400",
    "nameCN": "甘肃省白银市",
    "nameEN": "Gansu Sheng Baiyin Shi"
  },
  {
    "code": "620500",
    "nameCN": "甘肃省天水市",
    "nameEN": "Gansu Sheng Tianshui Shi"
  },
  {
    "code": "620600",
    "nameCN": "甘肃省武威市",
    "nameEN": "Gansu Sheng Wuwei Shi"
  },
  {
    "code": "620700",
    "nameCN": "甘肃省张掖市",
    "nameEN": "Gansu Sheng Zhangye Shi"
  },
  {
    "code": "620800",
    "nameCN": "甘肃省平凉市",
    "nameEN": "Gansu Sheng Pingliang Shi"
  },
  {
    "code": "620900",
    "nameCN": "甘肃省酒泉市",
    "nameEN": "Gansu Sheng Jiuquan Shi"
  },
  {
    "code": "621000",
    "nameCN": "甘肃省庆阳市",
    "nameEN": "Gansu Sheng Qingyang Shi"
  },
  {
    "code": "621100",
    "nameCN": "甘肃省定西市",
    "nameEN": "Gansu Sheng Dingxi Shi"
  },
  {
    "code": "621200",
    "nameCN": "甘肃省陇南市",
    "nameEN": "Gansu Sheng Longnan Diqu"
  },
  {
    "code": "622900",
    "nameCN": "甘肃省临夏回族自治州",
    "nameEN": "Gansu Sheng Linxia Huizu Zizhizhou"
  },
  {
    "code": "623000",
    "nameCN": "甘肃省甘南藏族自治州",
    "nameEN": "Gansu Sheng Gannan Zangzu Zizhizhou"
  },
  {
    "code": "630001",
    "nameCN": "西宁",
    "nameEN": "Xining"
  },
  {
    "code": "630002",
    "nameCN": "西宁曹家堡机场",
    "nameEN": "Xining Caojiabao Airport"
  },
  {
    "code": "630200",
    "nameCN": "青海省海东市",
    "nameEN": "Qinghai Sheng Haidong Shi"
  },
  {
    "code": "632200",
    "nameCN": "青海省海北藏族自治州",
    "nameEN": "Qinghai Sheng Haibei Zangzu Zizhizhou"
  },
  {
    "code": "632300",
    "nameCN": "青海省黄南藏族自治州",
    "nameEN": "Qinghai Sheng Huangnan Zangzu Zizhizhou"
  },
  {
    "code": "632500",
    "nameCN": "青海省海南藏族自治州",
    "nameEN": "Qinghai Sheng Hainan Zangzu Zizhizhou"
  },
  {
    "code": "632600",
    "nameCN": "青海省果洛藏族自治州",
    "nameEN": "Qinghai Sheng Golog Zangzu Zizhizhou"
  },
  {
    "code": "632700",
    "nameCN": "青海省玉树藏族自治州",
    "nameEN": "Qinghai Sheng Yushu Zangzu Zizhizhou"
  },
  {
    "code": "632800",
    "nameCN": "青海省海西蒙古族藏族自治州",
    "nameEN": "Qinghai Sheng Haixi Mongolzu Zangzu Zizhizhou"
  },
  {
    "code": "640001",
    "nameCN": "银川",
    "nameEN": "Yinchuan"
  },
  {
    "code": "640101",
    "nameCN": "银川河东机场",
    "nameEN": "Yinchuan Hedong Airport"
  },
  {
    "code": "640200",
    "nameCN": "宁夏回族自治区石嘴山市",
    "nameEN": "Ningxiahuizu Zizhiqu Shizuishan Shi"
  },
  {
    "code": "640300",
    "nameCN": "宁夏回族自治区吴忠市",
    "nameEN": "Ningxiahuizu Zizhiqu Wuzhong Shi"
  },
  {
    "code": "640400",
    "nameCN": "宁夏回族自治区固原市",
    "nameEN": "Ningxiahuizu Zizhiqu Guyuan Shi"
  },
  {
    "code": "640500",
    "nameCN": "宁夏回族自治区中卫市",
    "nameEN": "Ningxiahuizu Zizhiqu Zhongwei Shi"
  },
  {
    "code": "650001",
    "nameCN": "乌鲁木齐",
    "nameEN": "Urumqi"
  },
  {
    "code": "650002",
    "nameCN": "乌鲁木齐地窝堡国际机场",
    "nameEN": "Urumqi Diwobao International Airport"
  },
  {
    "code": "650101",
    "nameCN": "阿勒泰",
    "nameEN": "Aletai"
  },
  {
    "code": "650102",
    "nameCN": "红山嘴",
    "nameEN": "Hongshanzui"
  },
  {
    "code": "650103",
    "nameCN": "阿黑土别克",
    "nameEN": "Aheitubieke"
  },
  {
    "code": "650104",
    "nameCN": "塔克什肯",
    "nameEN": "Taykexkin "
  },
  {
    "code": "650200",
    "nameCN": "新疆维吾尔自治区克拉玛依市",
    "nameEN": "Xinjiang Uygur Zizhiqu Karamay Shi"
  },
  {
    "code": "650201",
    "nameCN": "巴克图",
    "nameEN": "Baketu"
  },
  {
    "code": "650202",
    "nameCN": "巴克图国际汽车货运",
    "nameEN": "Baketu Automobile Freight Erlei"
  },
  {
    "code": "650301",
    "nameCN": "阿拉山口公路",
    "nameEN": "Alatawshankou Highroad"
  },
  {
    "code": "650302",
    "nameCN": "阿拉山口铁路",
    "nameEN": "Alatawshankou Railway"
  },
  {
    "code": "650303",
    "nameCN": "阿拉山口综合保税区",
    "nameEN": "Alatawshankou Comprehensive Bonded Zone"
  },
  {
    "code": "650400",
    "nameCN": "新疆维吾尔自治区吐鲁番市",
    "nameEN": "Xinjiang Uygur Zizhiqu Turpan Shi"
  },
  {
    "code": "650401",
    "nameCN": "伊犁",
    "nameEN": "Yili"
  },
  {
    "code": "650402",
    "nameCN": "伊犁州国际汽车",
    "nameEN": "Yilizhou Automobile Erlei"
  },
  {
    "code": "650403",
    "nameCN": "木扎尔特",
    "nameEN": "Muzhaerte"
  },
  {
    "code": "650404",
    "nameCN": "都拉塔",
    "nameEN": "Dulata"
  },
  {
    "code": "650500",
    "nameCN": "新疆维吾尔自治区哈密市",
    "nameEN": "Xinjiang Uygur Zizhiqu Hami Shi"
  },
  {
    "code": "650501",
    "nameCN": "霍尔果斯",
    "nameEN": "Horgos"
  },
  {
    "code": "650701",
    "nameCN": "巴州",
    "nameEN": "Bazhouerrlei"
  },
  {
    "code": "650801",
    "nameCN": "喀什",
    "nameEN": "Kashi"
  },
  {
    "code": "650802",
    "nameCN": "其尼瓦格国际汽车",
    "nameEN": "Qiniwage Automabile Erlei"
  },
  {
    "code": "650803",
    "nameCN": "喀什机场",
    "nameEN": "Kashi Airport"
  },
  {
    "code": "650804",
    "nameCN": "红其拉甫",
    "nameEN": "Kunjirap"
  },
  {
    "code": "650805",
    "nameCN": "喀什综合保税区",
    "nameEN": "Kashi Comprehensive Bonded Zone"
  },
  {
    "code": "650901",
    "nameCN": "伊尔克什坦",
    "nameEN": "Yierkeshitan"
  },
  {
    "code": "650902",
    "nameCN": "吐尔尕特",
    "nameEN": "Turugart "
  },
  {
    "code": "650903",
    "nameCN": "阿图什国际汽车",
    "nameEN": "AtushiI Automabile Erlei"
  },
  {
    "code": "651001",
    "nameCN": "吉木乃",
    "nameEN": "Jeminay"
  },
  {
    "code": "651101",
    "nameCN": "卡拉苏",
    "nameEN": "Kalasu"
  },
  {
    "code": "651201",
    "nameCN": "奎屯",
    "nameEN": "Kuitun"
  },
  {
    "code": "651301",
    "nameCN": "霍尔果斯国际边境合作中心(中方配套区)",
    "nameEN": "Horgos Guoji Bianjing Hezuo Center"
  },
  {
    "code": "651401",
    "nameCN": "老爷庙",
    "nameEN": "Laoyemiao"
  },
  {
    "code": "651501",
    "nameCN": "乌拉斯台",
    "nameEN": "Ulastai"
  },
  {
    "code": "651502",
    "nameCN": "乌鲁木齐铁路",
    "nameEN": "Urumqi Railway"
  },
  {
    "code": "651503",
    "nameCN": "乌鲁木齐碾子沟客运站",
    "nameEN": "Urumqi Nianzigou Passenger Transport Erlei"
  },
  {
    "code": "651504",
    "nameCN": "边疆宾馆国际汽车货运",
    "nameEN": "Bianjiangbinguan Automobile Freight Erlei"
  },
  {
    "code": "651505",
    "nameCN": "乌鲁木齐出口加工区",
    "nameEN": "Urumqi Export Processind Zone"
  },
  {
    "code": "652300",
    "nameCN": "新疆维吾尔自治区昌吉回族自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Changji Huizu Zizhizhou"
  },
  {
    "code": "652700",
    "nameCN": "新疆维吾尔自治区博尔塔拉蒙古自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Bortala Mongol Zizhizhou"
  },
  {
    "code": "652800",
    "nameCN": "新疆维吾尔自治区巴音郭楞蒙古自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Bayingolin Mongol Zizhizhou"
  },
  {
    "code": "652900",
    "nameCN": "新疆维吾尔自治区阿克苏地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Aksu Diqu"
  },
  {
    "code": "653000",
    "nameCN": "新疆维吾尔自治区克孜勒苏柯尔克孜自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Kizilsu Kirgiz Zizhizhou"
  },
  {
    "code": "653100",
    "nameCN": "新疆维吾尔自治区喀什地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Kashi Diqu"
  },
  {
    "code": "653200",
    "nameCN": "新疆维吾尔自治区和田地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Hotan Diqu"
  },
  {
    "code": "654000",
    "nameCN": "新疆维吾尔自治区伊犁哈萨克自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Ili Kazak Zizhizhou"
  },
  {
    "code": "654200",
    "nameCN": "新疆维吾尔自治区塔城地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Tacheng Diqu"
  },
  {
    "code": "654300",
    "nameCN": "新疆维吾尔自治区阿勒泰地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Altay Diqu"
  },
  {
    "code": "659000",
    "nameCN": "新疆维吾尔自治区自治区直辖县级行政单位",
    "nameEN": "Xinjiang Uygur Zizhiqu Zizhiqu Zhixia Xianji Xingzhengdanwei"
  },
  {
    "code": "999999",
    "nameCN": "未列出的特殊监管区",
    "nameEN": "Unlisted Special Supervision Areas"
  }
]

// 权限数据
export const orderOptions = [
  {
    "code": "110001",
    "nameCN": "北京",
    "nameEN": "Beijing"
  },
  {
    "code": "110002",
    "nameCN": "北京平谷国际陆港",
    "nameEN": "Beijing Pinggu Automobile Lugang"
  },
  {
    "code": "110003",
    "nameCN": "北京天竺综合保税区",
    "nameEN": "Beijing Tianzhu Comprehensive Bonded Zone"
  },
  {
    "code": "110101",
    "nameCN": "首都国际机场",
    "nameEN": "Beijing Capital International Airport"
  },
  {
    "code": "110201",
    "nameCN": "北京丰台货运",
    "nameEN": "Beijing Fengtai Freight"
  },
  {
    "code": "110301",
    "nameCN": "北京朝阳口岸",
    "nameEN": "Beijing Chaoyang Port"
  },
  {
    "code": "110801",
    "nameCN": "北京西站",
    "nameEN": "Beijing Xizhan"
  },
  {
    "code": "120001",
    "nameCN": "天津",
    "nameEN": "Tianjin"
  },
  {
    "code": "120002",
    "nameCN": "北疆港区",
    "nameEN": "Beijiang Gangqu"
  },
  {
    "code": "120003",
    "nameCN": "天津保税物流园区",
    "nameEN": "Tianjin Bonded Logistics Zone"
  },
  {
    "code": "120004",
    "nameCN": "天津港保税区",
    "nameEN": "Tianjingang Free Trade Zone"
  },
  {
    "code": "120011",
    "nameCN": "中国（天津）自由贸易试验区",
    "nameEN": "China (Tianjin) Pilot Free Trade Zone"
  },
  {
    "code": "120201",
    "nameCN": "天津出口加工区",
    "nameEN": "Tianjin Export Processind Zone"
  },
  {
    "code": "120601",
    "nameCN": "天津滨海新区综合保税区",
    "nameEN": "Tianjin Binhai Xinqu Comprehensive Bonded Zone"
  },
  {
    "code": "120801",
    "nameCN": "大沽口港区",
    "nameEN": "Dagukou Gangqu"
  },
  {
    "code": "121001",
    "nameCN": "南疆港区",
    "nameEN": "Nanjiang Gangqu"
  },
  {
    "code": "121002",
    "nameCN": "渤中",
    "nameEN": "Bozhong"
  },
  {
    "code": "121501",
    "nameCN": "东疆港区",
    "nameEN": "Dongjiang Gangqu"
  },
  {
    "code": "121502",
    "nameCN": "天津邮轮母港",
    "nameEN": "Tianjin Youlun Mugang"
  },
  {
    "code": "121503",
    "nameCN": "天津新港客运码头",
    "nameEN": "Tianjin Xingang Passenger Transpor Dock"
  },
  {
    "code": "121504",
    "nameCN": "天津东疆保税港区",
    "nameEN": "Tianjin Dongjiang Free Trade Port Zone"
  },
  {
    "code": "121701",
    "nameCN": "天津滨海国际机场货邮",
    "nameEN": "Tianjin Binhai International Airport Huoyou"
  },
  {
    "code": "121702",
    "nameCN": "天津滨海国际机场T1通道",
    "nameEN": "Tianjin Binhai International Airport T1 tongdao"
  },
  {
    "code": "121703",
    "nameCN": "天津滨海国际机场T2通道",
    "nameEN": "Tianjin Binhai International Airport T2 Tongdao"
  },
  {
    "code": "130001",
    "nameCN": "石家庄",
    "nameEN": "Shijiazhuang"
  },
  {
    "code": "130002",
    "nameCN": "石家庄正定机场",
    "nameEN": "Shijiazhuang Zhengding Airport"
  },
  {
    "code": "130101",
    "nameCN": "秦皇岛",
    "nameEN": "Qinhuangdao"
  },
  {
    "code": "130102",
    "nameCN": "秦皇岛出口加工区",
    "nameEN": "Qinhuangdao Export Processind Zone"
  },
  {
    "code": "130200",
    "nameCN": "河北省唐山市",
    "nameEN": "Hebei Sheng Tangshan Shi"
  },
  {
    "code": "130201",
    "nameCN": "京唐港",
    "nameEN": "Jingtanggang"
  },
  {
    "code": "130202",
    "nameCN": "唐山",
    "nameEN": "Tangshan"
  },
  {
    "code": "130203",
    "nameCN": "曹妃甸港",
    "nameEN": "Caofeidian Harbor"
  },
  {
    "code": "130204",
    "nameCN": "曹妃甸综合保税区",
    "nameEN": "Caofeidian Comprehensive Bonded Zone"
  },
  {
    "code": "130300",
    "nameCN": "河北省秦皇岛市",
    "nameEN": "Hebei Sheng Qinhuangdao Shi"
  },
  {
    "code": "130400",
    "nameCN": "河北省邯郸市",
    "nameEN": "Hebei Sheng Handan Shi"
  },
  {
    "code": "130500",
    "nameCN": "河北省邢台市",
    "nameEN": "Hebei Sheng Xingtai Shi"
  },
  {
    "code": "130600",
    "nameCN": "河北省保定市",
    "nameEN": "Hebei Sheng Baoding Shi"
  },
  {
    "code": "130700",
    "nameCN": "河北省张家口市",
    "nameEN": "Hebei Sheng Zhangjiakou Shi"
  },
  {
    "code": "130701",
    "nameCN": "廊坊出口加工区",
    "nameEN": "Langfang Export Processind Zone"
  },
  {
    "code": "130800",
    "nameCN": "河北省承德市",
    "nameEN": "Hebei Sheng Chengde Shi"
  },
  {
    "code": "130900",
    "nameCN": "河北省沧州市",
    "nameEN": "Hebei Sheng Cangzhou Shi"
  },
  {
    "code": "131000",
    "nameCN": "河北省廊坊市",
    "nameEN": "Hebei Sheng Langfang Shi"
  },
  {
    "code": "131100",
    "nameCN": "河北省衡水市",
    "nameEN": "Hebei Sheng Hengshui Shi"
  },
  {
    "code": "131101",
    "nameCN": "黄骅",
    "nameEN": "Huanghua"
  },
  {
    "code": "131201",
    "nameCN": "石家庄综合保税区",
    "nameEN": "Shijiazhuang Comprehensive Bonded Zone"
  },
  {
    "code": "140001",
    "nameCN": "太原",
    "nameEN": "Taiyuan"
  },
  {
    "code": "140002",
    "nameCN": "太原武宿机场",
    "nameEN": "Taiyuan Wusu Airport"
  },
  {
    "code": "140003",
    "nameCN": "太原武宿综合保税区",
    "nameEN": "Taiyuan Wusu Comprehensive Bonded Zone"
  },
  {
    "code": "140200",
    "nameCN": "山西省大同市",
    "nameEN": "Shanxi Sheng Datong Shi"
  },
  {
    "code": "140300",
    "nameCN": "山西省阳泉市",
    "nameEN": "Shanxi Sheng Yangquan Shi"
  },
  {
    "code": "140400",
    "nameCN": "山西省长治市",
    "nameEN": "Shanxi Sheng Changzhi Shi"
  },
  {
    "code": "140500",
    "nameCN": "山西省晋城市",
    "nameEN": "Shanxi Sheng Jincheng Shi"
  },
  {
    "code": "140600",
    "nameCN": "山西省朔州市",
    "nameEN": "Shanxi Sheng Shouzhou Shi"
  },
  {
    "code": "140700",
    "nameCN": "山西省晋中市",
    "nameEN": "Shanxi Sheng Jinzhong Shi"
  },
  {
    "code": "140800",
    "nameCN": "山西省运城市",
    "nameEN": "Shanxi Sheng Yuncheng Shi"
  },
  {
    "code": "140900",
    "nameCN": "山西省忻州市",
    "nameEN": "Shanxi Sheng Xinzhou Shi"
  },
  {
    "code": "141000",
    "nameCN": "山西省临汾市",
    "nameEN": "Shanxi Sheng Linfen Shi"
  },
  {
    "code": "141100",
    "nameCN": "山西省吕梁市",
    "nameEN": "Shanxi Sheng Luliang Shi"
  },
  {
    "code": "150001",
    "nameCN": "呼和浩特",
    "nameEN": "Hohhot"
  },
  {
    "code": "150002",
    "nameCN": "呼和浩特白塔机场",
    "nameEN": "Hohhot Baita Airport"
  },
  {
    "code": "150003",
    "nameCN": "呼和浩特出口加工区",
    "nameEN": "Hohhot Export Processind Zone"
  },
  {
    "code": "150004",
    "nameCN": "鄂尔多斯伊金霍洛机场",
    "nameEN": "Erdos Ejin Horo Airport"
  },
  {
    "code": "150101",
    "nameCN": "满洲里西郊机场",
    "nameEN": "Manzhouli Xijiao Airport"
  },
  {
    "code": "150102",
    "nameCN": "满洲里铁路",
    "nameEN": "Manzhouli Railway"
  },
  {
    "code": "150103",
    "nameCN": "二卡",
    "nameEN": "Erka"
  },
  {
    "code": "150104",
    "nameCN": "满洲里十八里",
    "nameEN": "Manzhouli Shibali"
  },
  {
    "code": "150105",
    "nameCN": "阿日哈沙特",
    "nameEN": "Arhaxat"
  },
  {
    "code": "150106",
    "nameCN": "满洲里综合保税区",
    "nameEN": "Manzhouli Comprehensive Bonded Zone"
  },
  {
    "code": "150200",
    "nameCN": "内蒙古自治区包头市",
    "nameEN": "Nei Mongol Zizhiqu Baotou Shi"
  },
  {
    "code": "150201",
    "nameCN": "二连浩特铁路",
    "nameEN": "Erlianhaote Railway"
  },
  {
    "code": "150202",
    "nameCN": "二连浩特公路",
    "nameEN": "Erlianhaote Highroad"
  },
  {
    "code": "150300",
    "nameCN": "内蒙古自治区乌海市",
    "nameEN": "Nei Mongol Zizhiqu Wuhai Shi"
  },
  {
    "code": "150301",
    "nameCN": "海拉尔东山机场",
    "nameEN": "Hailar Dongshan Airport"
  },
  {
    "code": "150302",
    "nameCN": "额布都格",
    "nameEN": "Ebuduge"
  },
  {
    "code": "150303",
    "nameCN": "胡列也吐",
    "nameEN": "Hulieyetu"
  },
  {
    "code": "150400",
    "nameCN": "内蒙古自治区赤峰市",
    "nameEN": "Nei Mongol Zizhiqu Chifeng(Ulanhad) Shi"
  },
  {
    "code": "150401",
    "nameCN": "满都拉",
    "nameEN": "Mandula"
  },
  {
    "code": "150500",
    "nameCN": "内蒙古自治区通辽市",
    "nameEN": "Nei Mongol Zizhiqu Tongliao Shi"
  },
  {
    "code": "150600",
    "nameCN": "内蒙古自治区鄂尔多斯市",
    "nameEN": "Nei Mongol Zizhiqu Ordos Shi"
  },
  {
    "code": "150700",
    "nameCN": "内蒙古自治区呼伦贝尔市",
    "nameEN": "Nei Mongol Zizhiqu Hulun Buir Shi"
  },
  {
    "code": "150800",
    "nameCN": "内蒙古自治区巴彦淖尔市",
    "nameEN": "Nei Mongol Zizhiqu Bayannur Shi"
  },
  {
    "code": "150801",
    "nameCN": "黑山头",
    "nameEN": "Heishantou"
  },
  {
    "code": "150802",
    "nameCN": "室韦",
    "nameEN": "Shiwei"
  },
  {
    "code": "150900",
    "nameCN": "内蒙古自治区乌兰察布市",
    "nameEN": "Nei Mongol Zizhiqu Ulanqab Shi"
  },
  {
    "code": "150901",
    "nameCN": "策克",
    "nameEN": "Ceke"
  },
  {
    "code": "151001",
    "nameCN": "珠恩嘎达布其",
    "nameEN": "Zhuengadabuqi"
  },
  {
    "code": "151101",
    "nameCN": "甘其毛都",
    "nameEN": "Ganqmaod"
  },
  {
    "code": "151102",
    "nameCN": "巴格毛都",
    "nameEN": "Bagemaodu"
  },
  {
    "code": "151201",
    "nameCN": "阿尔山",
    "nameEN": "Aershan"
  },
  {
    "code": "152200",
    "nameCN": "内蒙古自治区兴安盟",
    "nameEN": "Nei Mongol Zizhiqu Hinggan Meng"
  },
  {
    "code": "152500",
    "nameCN": "内蒙古自治区锡林郭勒盟",
    "nameEN": "Nei Mongol Zizhiqu Xilin Gol Meng"
  },
  {
    "code": "152900",
    "nameCN": "内蒙古自治区阿拉善盟",
    "nameEN": "Nei Mongol Zizhiqu Alxa Meng"
  },
  {
    "code": "210001",
    "nameCN": "沈阳",
    "nameEN": "Shenyang"
  },
  {
    "code": "210101",
    "nameCN": "大连港大窑湾港区",
    "nameEN": "Dalian Harbor Dayaowan Gangqu"
  },
  {
    "code": "210102",
    "nameCN": "大连北良港区",
    "nameEN": "Dalian Beiliang Gangqu "
  },
  {
    "code": "210103",
    "nameCN": "大连港油品码头港区",
    "nameEN": "Dalian Harbor Youpin Dock Gangqu"
  },
  {
    "code": "210104",
    "nameCN": "大连大窑湾保税港区",
    "nameEN": "Dalian Dayaowan Free Trade Port Zone"
  },
  {
    "code": "210200",
    "nameCN": "辽宁省大连市",
    "nameEN": "Liaoning Sheng Dalian Shi"
  },
  {
    "code": "210300",
    "nameCN": "辽宁省鞍山市",
    "nameEN": "Liaoning Sheng Anshan Shi"
  },
  {
    "code": "210301",
    "nameCN": "沈阳桃仙国际机场",
    "nameEN": "Shenyang Taoxian International Airport"
  },
  {
    "code": "210400",
    "nameCN": "辽宁省抚顺市",
    "nameEN": "Liaoning Sheng Fushun Shi"
  },
  {
    "code": "210401",
    "nameCN": "锦州",
    "nameEN": "Jinzhou"
  },
  {
    "code": "210500",
    "nameCN": "辽宁省本溪市",
    "nameEN": "Liaoning Sheng Benxi Shi"
  },
  {
    "code": "210600",
    "nameCN": "辽宁省丹东市",
    "nameEN": "Liaoning Sheng Dandong Shi"
  },
  {
    "code": "210700",
    "nameCN": "辽宁省锦州市",
    "nameEN": "Liaoning Sheng Jinzhou Shi"
  },
  {
    "code": "210701",
    "nameCN": "丹东港浪头港区",
    "nameEN": "Dandong Harbor Langtou Gangqu"
  },
  {
    "code": "210702",
    "nameCN": "丹东铁路",
    "nameEN": "Dandong Railway"
  },
  {
    "code": "210703",
    "nameCN": "丹东公路",
    "nameEN": "Dandong Highroad"
  },
  {
    "code": "210704",
    "nameCN": "丹东输油管道",
    "nameEN": "Dandong Shuyou Guandao"
  },
  {
    "code": "210705",
    "nameCN": "丹东太平湾",
    "nameEN": "Dandong Taipingwan "
  },
  {
    "code": "210706",
    "nameCN": "丹东长甸河口",
    "nameEN": "Dandong Changdian Hekou"
  },
  {
    "code": "210707",
    "nameCN": "丹东哑巴沟",
    "nameEN": "Dandong Yabagou"
  },
  {
    "code": "210708",
    "nameCN": "丹东马市过货点",
    "nameEN": "Dandong Mashi Guohuodian"
  },
  {
    "code": "210709",
    "nameCN": "丹东安民",
    "nameEN": "Dandong Anmin"
  },
  {
    "code": "210800",
    "nameCN": "辽宁省营口市",
    "nameEN": "Liaoning Sheng Yingkou Shi"
  },
  {
    "code": "210801",
    "nameCN": "丹东港大东港区",
    "nameEN": "Dandong Harbor Dadong Gangqu"
  },
  {
    "code": "210802",
    "nameCN": "丹东大鹿岛",
    "nameEN": "Dandong Daludao"
  },
  {
    "code": "210803",
    "nameCN": "丹东大台子",
    "nameEN": "Dandong Dataizi"
  },
  {
    "code": "210804",
    "nameCN": "丹东一撮毛过货点",
    "nameEN": "Dandong Yicuomao Guohuodian"
  },
  {
    "code": "210805",
    "nameCN": "丹东丹纸码头",
    "nameEN": "Dandong Danzhi Dock"
  },
  {
    "code": "210900",
    "nameCN": "辽宁省阜新市",
    "nameEN": "Liaoning Sheng Fuxin Shi"
  },
  {
    "code": "210901",
    "nameCN": "营口港老港区",
    "nameEN": "Yingkou Harbor Laogangqu"
  },
  {
    "code": "211000",
    "nameCN": "辽宁省辽阳市",
    "nameEN": "Liaoning Sheng Liaoyang Shi"
  },
  {
    "code": "211001",
    "nameCN": "营口港鲅鱼圈港区",
    "nameEN": "Yingkou Harbor Bayuquan Gangqu"
  },
  {
    "code": "211002",
    "nameCN": "营口港仙人岛港区",
    "nameEN": "Yingkou Harbor Xianrendao Gangqu"
  },
  {
    "code": "211003",
    "nameCN": "营口港保税物流园区",
    "nameEN": "Yingkougang Bonded Logistics Zone"
  },
  {
    "code": "211100",
    "nameCN": "辽宁省盘锦市",
    "nameEN": "Liaoning Sheng Panjin Shi"
  },
  {
    "code": "211200",
    "nameCN": "辽宁省铁岭市",
    "nameEN": "Liaoning Sheng Tieling Shi"
  },
  {
    "code": "211300",
    "nameCN": "辽宁省朝阳市",
    "nameEN": "Liaoning Sheng Chaoyang Shi"
  },
  {
    "code": "211400",
    "nameCN": "辽宁省葫芦岛市",
    "nameEN": "Liaoning Sheng Huludao Shi"
  },
  {
    "code": "211401",
    "nameCN": "盘锦港",
    "nameEN": "Panjin Harbor"
  },
  {
    "code": "211501",
    "nameCN": "葫芦岛港",
    "nameEN": "Huludao Harbor"
  },
  {
    "code": "211801",
    "nameCN": "大连周水子国际机场",
    "nameEN": "Dalian Zhoushuizi International Airport"
  },
  {
    "code": "211901",
    "nameCN": "大连港香炉礁港区",
    "nameEN": "Dalian Harbor Xianglujiao Gangqu "
  },
  {
    "code": "211902",
    "nameCN": "大连港老港区",
    "nameEN": "Dalian Harbor laogangqu "
  },
  {
    "code": "211903",
    "nameCN": "大连港大连湾港区",
    "nameEN": "Daliangangdalianwangangqu "
  },
  {
    "code": "211904",
    "nameCN": "大连港汽车码头港区",
    "nameEN": "Dalian Harbor Qiche Dock Gangqu"
  },
  {
    "code": "211905",
    "nameCN": "大连港矿石码头港区",
    "nameEN": "Dalian Harbor Kuangshi Dock Gangqu"
  },
  {
    "code": "211906",
    "nameCN": "旅顺新港",
    "nameEN": "Lushun Xingang"
  },
  {
    "code": "211907",
    "nameCN": "庄河港",
    "nameEN": "Zhuanghe Harbor"
  },
  {
    "code": "211908",
    "nameCN": "大连长海四块石码头",
    "nameEN": "Dalian Changhai Sikuaishi Dock"
  },
  {
    "code": "211909",
    "nameCN": "大连出口加工区",
    "nameEN": "Dalian Export Processind Zone"
  },
  {
    "code": "211910",
    "nameCN": "大连保税区",
    "nameEN": "Dalian Free Trade Zone"
  },
  {
    "code": "212001",
    "nameCN": "长兴岛港",
    "nameEN": "Changxingdao Harbor"
  },
  {
    "code": "212101",
    "nameCN": "沈阳综合保税区",
    "nameEN": "Shenyang Comprehensive Bonded Zone"
  },
  {
    "code": "220001",
    "nameCN": "长春",
    "nameEN": "Changchun"
  },
  {
    "code": "220002",
    "nameCN": "长春龙嘉国际机场",
    "nameEN": "Changchun Longjia International Airport"
  },
  {
    "code": "220003",
    "nameCN": "长春铁路",
    "nameEN": "Changchun Railway"
  },
  {
    "code": "220004",
    "nameCN": "临江",
    "nameEN": "Linjiang"
  },
  {
    "code": "220005",
    "nameCN": "大安",
    "nameEN": "Daan"
  },
  {
    "code": "220006",
    "nameCN": "图们公路",
    "nameEN": "Tumen Highroad"
  },
  {
    "code": "220007",
    "nameCN": "图们铁路",
    "nameEN": "Tumen Railway"
  },
  {
    "code": "220008",
    "nameCN": "船营",
    "nameEN": "Chuanying"
  },
  {
    "code": "220009",
    "nameCN": "档石",
    "nameEN": "Dangshi"
  },
  {
    "code": "220010",
    "nameCN": "下三道沟",
    "nameEN": "Xiasandaogou"
  },
  {
    "code": "220011",
    "nameCN": "长春兴隆综合保税区",
    "nameEN": "Changchun Xinglong Comprehensive Bonded Zone"
  },
  {
    "code": "220101",
    "nameCN": "双目峰公务通道",
    "nameEN": "Shuangmofeng Gongwu Tongdao"
  },
  {
    "code": "220102",
    "nameCN": "延吉朝阳川机场",
    "nameEN": "Yanji Chaoyangchuan Airport"
  },
  {
    "code": "220103",
    "nameCN": "三合",
    "nameEN": "Sanhe"
  },
  {
    "code": "220104",
    "nameCN": "开山屯",
    "nameEN": "Kaishantun"
  },
  {
    "code": "220105",
    "nameCN": "南坪",
    "nameEN": "Nanping"
  },
  {
    "code": "220106",
    "nameCN": "古城里",
    "nameEN": "Guchengli"
  },
  {
    "code": "220200",
    "nameCN": "吉林省吉林市",
    "nameEN": "Jilin Sheng Jilin Shi"
  },
  {
    "code": "220201",
    "nameCN": "珲春公路",
    "nameEN": "Hunchun Highroad"
  },
  {
    "code": "220202",
    "nameCN": "珲春铁路",
    "nameEN": "Hunchun Railway"
  },
  {
    "code": "220203",
    "nameCN": "沙坨子",
    "nameEN": "Shatuozi"
  },
  {
    "code": "220204",
    "nameCN": "圈河",
    "nameEN": "Quanhe"
  },
  {
    "code": "220205",
    "nameCN": "珲春出口加工区",
    "nameEN": "Hunchun Export Processind Zone"
  },
  {
    "code": "220300",
    "nameCN": "吉林省四平市",
    "nameEN": "Jilin Sheng Siping Shi"
  },
  {
    "code": "220400",
    "nameCN": "吉林省辽源市",
    "nameEN": "Jilin Sheng Liaoyuan Shi"
  },
  {
    "code": "220500",
    "nameCN": "吉林省通化市",
    "nameEN": "Jilin Sheng Tonghua Shi"
  },
  {
    "code": "220501",
    "nameCN": "集安铁路",
    "nameEN": "Jian Railway"
  },
  {
    "code": "220502",
    "nameCN": "老虎哨",
    "nameEN": "Laohushao"
  },
  {
    "code": "220503",
    "nameCN": "青石",
    "nameEN": "Qinshi"
  },
  {
    "code": "220504",
    "nameCN": "秋皮村",
    "nameEN": "Qiupicun"
  },
  {
    "code": "220505",
    "nameCN": "集安过货通道",
    "nameEN": "Jian Guohuo Tongdao"
  },
  {
    "code": "220600",
    "nameCN": "吉林省白山市",
    "nameEN": "Jilin Sheng Baishan Shi"
  },
  {
    "code": "220601",
    "nameCN": "长白",
    "nameEN": "Changbai"
  },
  {
    "code": "220602",
    "nameCN": "十三道沟",
    "nameEN": "Shisandaogou"
  },
  {
    "code": "220603",
    "nameCN": "八道沟",
    "nameEN": "Badaogou"
  },
  {
    "code": "220604",
    "nameCN": "南尖头",
    "nameEN": "Nanjiantou"
  },
  {
    "code": "220700",
    "nameCN": "吉林省松原市",
    "nameEN": "Jilin Sheng Songyuan Shi"
  },
  {
    "code": "220701",
    "nameCN": "吉林铁路",
    "nameEN": "Jilin Railway"
  },
  {
    "code": "220800",
    "nameCN": "吉林省白城市",
    "nameEN": "Jilin Sheng Baicheng Shi"
  },
  {
    "code": "222400",
    "nameCN": "吉林省延边朝鲜族自治州",
    "nameEN": "Jilin Sheng Yanbian Chosenzu Zizhizhou"
  },
  {
    "code": "230001",
    "nameCN": "哈尔滨",
    "nameEN": "Harbin"
  },
  {
    "code": "230002",
    "nameCN": "哈尔滨太平国际机场",
    "nameEN": "Harbin Taiping International Airport"
  },
  {
    "code": "230003",
    "nameCN": "嘉荫",
    "nameEN": "Jiayin"
  },
  {
    "code": "230004",
    "nameCN": "漠河",
    "nameEN": "Mohe"
  },
  {
    "code": "230005",
    "nameCN": "绥芬河综合保税区",
    "nameEN": "Suifenhe Comprehensive Bonded Zone"
  },
  {
    "code": "230101",
    "nameCN": "齐齐哈尔三家子机场",
    "nameEN": "Qiqihar Sanjiazi Airport"
  },
  {
    "code": "230200",
    "nameCN": "黑龙江省齐齐哈尔市",
    "nameEN": "Heilongjiang Sheng Qiqihar Shi"
  },
  {
    "code": "230201",
    "nameCN": "大庆",
    "nameEN": "Daqing"
  },
  {
    "code": "230300",
    "nameCN": "黑龙江省鸡西市",
    "nameEN": "Heilongjiang Sheng Jixi Shi"
  },
  {
    "code": "230301",
    "nameCN": "牡丹江海浪机场",
    "nameEN": "Mudanjiang Hailang Airport"
  },
  {
    "code": "230400",
    "nameCN": "黑龙江省鹤岗市",
    "nameEN": "Heilongjiang Sheng Hegang Shi"
  },
  {
    "code": "230401",
    "nameCN": "绥芬河铁路",
    "nameEN": "Suifenhe Railway"
  },
  {
    "code": "230402",
    "nameCN": "绥芬河公路",
    "nameEN": "Suifenhe Highroad"
  },
  {
    "code": "230500",
    "nameCN": "黑龙江省双鸭山市",
    "nameEN": "Heilongjiang Sheng Shuangyashan Shi"
  },
  {
    "code": "230501",
    "nameCN": "虎林",
    "nameEN": "Hulin"
  },
  {
    "code": "230600",
    "nameCN": "黑龙江省大庆市",
    "nameEN": "Heilongjiang Sheng Daqing Shi"
  },
  {
    "code": "230601",
    "nameCN": "密山",
    "nameEN": "Mishan"
  },
  {
    "code": "230700",
    "nameCN": "黑龙江省伊春市",
    "nameEN": "Heilongjiang Sheng Yichun Shi"
  },
  {
    "code": "230701",
    "nameCN": "佳木斯港",
    "nameEN": "Jiamusi Harbor"
  },
  {
    "code": "230702",
    "nameCN": "佳木斯东郊机场",
    "nameEN": "Jiamusi Dongjiao Airport"
  },
  {
    "code": "230703",
    "nameCN": "桦川",
    "nameEN": "Huachuan"
  },
  {
    "code": "230800",
    "nameCN": "黑龙江省佳木斯市",
    "nameEN": "Heilongjiang Sheng Jiamusi Shi"
  },
  {
    "code": "230801",
    "nameCN": "饶河",
    "nameEN": "Raohe"
  },
  {
    "code": "230900",
    "nameCN": "黑龙江省七台河市",
    "nameEN": "Heilongjiang Sheng Qitaihe Shi"
  },
  {
    "code": "230901",
    "nameCN": "同江",
    "nameEN": "Tongjiang"
  },
  {
    "code": "231000",
    "nameCN": "黑龙江省牡丹江市",
    "nameEN": "Heilongjiang Sheng Mudanjiang Shi"
  },
  {
    "code": "231001",
    "nameCN": "抚远",
    "nameEN": "Fuyuan"
  },
  {
    "code": "231100",
    "nameCN": "黑龙江省黑河市",
    "nameEN": "Heilongjiang Sheng Heihe Shi"
  },
  {
    "code": "231101",
    "nameCN": "黑河",
    "nameEN": "Heihe"
  },
  {
    "code": "231102",
    "nameCN": "孙吴港",
    "nameEN": "Sunwu Harbor"
  },
  {
    "code": "231103",
    "nameCN": "孙吴边境通道",
    "nameEN": "Sunwu Bianjing Tongdao"
  },
  {
    "code": "231104",
    "nameCN": "呼玛",
    "nameEN": "Huma"
  },
  {
    "code": "231200",
    "nameCN": "黑龙江省绥化市",
    "nameEN": "Heilongjiang Sheng Suihua Shi"
  },
  {
    "code": "231201",
    "nameCN": "逊克",
    "nameEN": "Xunke"
  },
  {
    "code": "231401",
    "nameCN": "萝北",
    "nameEN": "Luobei"
  },
  {
    "code": "231501",
    "nameCN": "东宁",
    "nameEN": "Dongning"
  },
  {
    "code": "231601",
    "nameCN": "绥滨",
    "nameEN": "Suibin"
  },
  {
    "code": "231602",
    "nameCN": "富锦",
    "nameEN": "Fujin"
  },
  {
    "code": "231701",
    "nameCN": "哈尔滨港",
    "nameEN": "Harbin Harbor"
  },
  {
    "code": "231702",
    "nameCN": "哈尔滨站",
    "nameEN": "Harbin Zhan"
  },
  {
    "code": "232700",
    "nameCN": "黑龙江省大兴安岭地区",
    "nameEN": "Heilongjiang Sheng Da Hinggan Ling Diqu"
  },
  {
    "code": "310001",
    "nameCN": "上海",
    "nameEN": "Shanghai"
  },
  {
    "code": "310002",
    "nameCN": "龙吴",
    "nameEN": "Longwu"
  },
  {
    "code": "310011",
    "nameCN": "中国（上海）自由贸易试验区",
    "nameEN": "China (Shanghai) Pilot Free Trade Zone"
  },
  {
    "code": "310101",
    "nameCN": "上海嘉定出口加工区",
    "nameEN": "Shanghai Jiading Export Processind Zone"
  },
  {
    "code": "310102",
    "nameCN": "上海青浦出口加工区",
    "nameEN": "Shanghai Qngpu Export Processind Zone"
  },
  {
    "code": "310201",
    "nameCN": "上海金桥出口加工区",
    "nameEN": "Shangha Jinqiao Export Processind Zone"
  },
  {
    "code": "310301",
    "nameCN": "上海虹桥国际机场",
    "nameEN": "Shanghai Hongqiao International Airport"
  },
  {
    "code": "310302",
    "nameCN": "上海浦东国际机场",
    "nameEN": "Shanghai Pudong International Airport"
  },
  {
    "code": "310303",
    "nameCN": "上海浦东机场综合保税区",
    "nameEN": "Shanghai Pudong Airport Comprehensive Bonded Zone"
  },
  {
    "code": "310401",
    "nameCN": "罗泾",
    "nameEN": "luojing"
  },
  {
    "code": "310402",
    "nameCN": "吴淞",
    "nameEN": "Wusong"
  },
  {
    "code": "310501",
    "nameCN": "崇明",
    "nameEN": "Chongming"
  },
  {
    "code": "310601",
    "nameCN": "上海闵行出口加工区",
    "nameEN": "Shanghai Minhang Export Processind Zone"
  },
  {
    "code": "310701",
    "nameCN": "外高桥",
    "nameEN": "Waigaoqiao"
  },
  {
    "code": "310702",
    "nameCN": "上海外高桥保税物流园区",
    "nameEN": "Shanghai Waigaoqiao Bonded Logistics Zone"
  },
  {
    "code": "310703",
    "nameCN": "上海外高桥保税区",
    "nameEN": "Shanghai Waigaoqiao Free Trade Zone"
  },
  {
    "code": "310901",
    "nameCN": "上海漕河泾出口加工区",
    "nameEN": "Shanghai Caohejing Export Processind Zone"
  },
  {
    "code": "311001",
    "nameCN": "浦东临港产业作业区",
    "nameEN": "Pudong Lingang Chanye Zuoyequ"
  },
  {
    "code": "311002",
    "nameCN": "洋山港",
    "nameEN": "Yangshan Harbor"
  },
  {
    "code": "311003",
    "nameCN": "洋山保税港区",
    "nameEN": "Yangshan Free Trade Port Zone"
  },
  {
    "code": "311201",
    "nameCN": "上海站",
    "nameEN": "Shanghai Zhan"
  },
  {
    "code": "311301",
    "nameCN": "上海松江出口加工区A区",
    "nameEN": "Shanghai Songjiang Export Processind Zone Zone A"
  },
  {
    "code": "311302",
    "nameCN": "上海松江出口加工区B区",
    "nameEN": "Shanghai Songjiang Export Processind Zone Zone B"
  },
  {
    "code": "320001",
    "nameCN": "南京",
    "nameEN": "Nanjing"
  },
  {
    "code": "320101",
    "nameCN": "南京禄口国际机场",
    "nameEN": "Nanjing Lukou International Airport"
  },
  {
    "code": "320102",
    "nameCN": "南京港",
    "nameEN": "Nanjing Harbor"
  },
  {
    "code": "320103",
    "nameCN": "南京出口加工区",
    "nameEN": "Nanjing Export Processind Zone"
  },
  {
    "code": "320104",
    "nameCN": "南京综合保税区",
    "nameEN": "Nanjing Comprehensive Bonded Zone"
  },
  {
    "code": "320200",
    "nameCN": "江苏省无锡市",
    "nameEN": "Jiangsu Sheng Wuxi Shi"
  },
  {
    "code": "320201",
    "nameCN": "苏州",
    "nameEN": "Suzhou"
  },
  {
    "code": "320202",
    "nameCN": "苏州工业园综合保税区",
    "nameEN": "Suzhou Gongyeyuan Comprehensive Bonded Zone"
  },
  {
    "code": "320203",
    "nameCN": "苏州高新技术产业开发区综合保税区",
    "nameEN": "Suzhou Gaoxinjishu Chanye Kaifaqu Comprehensive Bonded Zone"
  },
  {
    "code": "320204",
    "nameCN": "吴中出口加工区",
    "nameEN": "Wuzhong Export Processind Zone"
  },
  {
    "code": "320300",
    "nameCN": "江苏省徐州市",
    "nameEN": "Jiangsu Sheng Xuzhou Shi"
  },
  {
    "code": "320301",
    "nameCN": "吴江出口加工区",
    "nameEN": "Wujiang Export Processind Zone"
  },
  {
    "code": "320400",
    "nameCN": "江苏省常州市",
    "nameEN": "Jiangsu Sheng Changzhou Shi"
  },
  {
    "code": "320401",
    "nameCN": "昆山综合保税区",
    "nameEN": "Kunshan Comprehensive Bonded Zone"
  },
  {
    "code": "320500",
    "nameCN": "江苏省苏州市",
    "nameEN": "Jiangsu Sheng Suzhou Shi"
  },
  {
    "code": "320501",
    "nameCN": "张家港",
    "nameEN": "Zhangjiagang"
  },
  {
    "code": "320502",
    "nameCN": "张家港保税港区",
    "nameEN": "Zhangjiagang Free Trade Port Zone"
  },
  {
    "code": "320600",
    "nameCN": "江苏省南通市",
    "nameEN": "Jiangsu Sheng Nantong Shi"
  },
  {
    "code": "320601",
    "nameCN": "常熟",
    "nameEN": "Changshu"
  },
  {
    "code": "320602",
    "nameCN": "常熟出口加工区",
    "nameEN": "Changshu Export Processind Zone"
  },
  {
    "code": "320700",
    "nameCN": "江苏省连云港市",
    "nameEN": "Jiangsu Sheng Lianyungang Shi"
  },
  {
    "code": "320701",
    "nameCN": "太仓",
    "nameEN": "Taicang"
  },
  {
    "code": "320702",
    "nameCN": "太仓港综合保税区",
    "nameEN": "Taicanggang Comprehensive Bonded Zone"
  },
  {
    "code": "320800",
    "nameCN": "江苏省淮安市",
    "nameEN": "Jiangsu Sheng Huai'an Shi"
  },
  {
    "code": "320801",
    "nameCN": "无锡",
    "nameEN": "Wuxi"
  },
  {
    "code": "320802",
    "nameCN": "苏南硕放国际机场",
    "nameEN": "Sunan Shuofang International Airport"
  },
  {
    "code": "320803",
    "nameCN": "无锡高新区综合保税区",
    "nameEN": "Wuxi Gaoxinqu Comprehensive Bonded Zone"
  },
  {
    "code": "320804",
    "nameCN": "无锡出口加工区",
    "nameEN": "Wuxi Export Processind Zone"
  },
  {
    "code": "320900",
    "nameCN": "江苏省盐城市",
    "nameEN": "Jiangsu Sheng Yancheng Shi"
  },
  {
    "code": "320901",
    "nameCN": "江阴",
    "nameEN": "Jiangyin"
  },
  {
    "code": "321000",
    "nameCN": "江苏省扬州市",
    "nameEN": "Jiangsu Sheng Yangzhou Shi"
  },
  {
    "code": "321100",
    "nameCN": "江苏省镇江市",
    "nameEN": "Jiangsu Sheng Zhengjiang Shi"
  },
  {
    "code": "321101",
    "nameCN": "南通",
    "nameEN": "Nantong"
  },
  {
    "code": "321103",
    "nameCN": "如皋",
    "nameEN": "Rugao"
  },
  {
    "code": "321104",
    "nameCN": "南通综合保税区",
    "nameEN": "Nantong Comprehensive Bonded Zone"
  },
  {
    "code": "321106",
    "nameCN": "南通机场",
    "nameEN": "Nantong Airport"
  },
  {
    "code": "321200",
    "nameCN": "江苏省泰州市",
    "nameEN": "Jiangsu Sheng Taizhou Shi"
  },
  {
    "code": "321201",
    "nameCN": "连云港",
    "nameEN": "Lianyungang"
  },
  {
    "code": "321202",
    "nameCN": "连云港出口加工区",
    "nameEN": "Lianyungang Export Processind Zone"
  },
  {
    "code": "321300",
    "nameCN": "江苏省宿迁市",
    "nameEN": "Jiangsu Sheng Suqian Shi"
  },
  {
    "code": "321301",
    "nameCN": "镇江",
    "nameEN": "Zhenjiang"
  },
  {
    "code": "321302",
    "nameCN": "镇江出口加工区",
    "nameEN": "Zhenjiang Export Processind Zone"
  },
  {
    "code": "321401",
    "nameCN": "徐州机场",
    "nameEN": "Xuzhou Airport"
  },
  {
    "code": "321501",
    "nameCN": "淮安综合保税区",
    "nameEN": "Huaian Comprehensive Bonded Zone"
  },
  {
    "code": "321502",
    "nameCN": "淮安出口加工区",
    "nameEN": " Huai'an Export Processind Zone"
  },
  {
    "code": "321601",
    "nameCN": "常州",
    "nameEN": "Changzhou"
  },
  {
    "code": "321602",
    "nameCN": "常州出口加工区",
    "nameEN": "Changzhou Export Processind Zone"
  },
  {
    "code": "321603",
    "nameCN": "武进出口加工区",
    "nameEN": "Wujin Export Processind Zone"
  },
  {
    "code": "321604",
    "nameCN": "常州奔牛机场",
    "nameEN": "Changzhou Benniu Airport"
  },
  {
    "code": "321701",
    "nameCN": "盐城机场",
    "nameEN": "Yancheng Airport"
  },
  {
    "code": "321702",
    "nameCN": "射阳",
    "nameEN": "Sheyang"
  },
  {
    "code": "321703",
    "nameCN": "盐城综合保税区",
    "nameEN": "YanchengComprehensive Bonded Zone"
  },
  {
    "code": "321704",
    "nameCN": "大丰",
    "nameEN": "Dafeng"
  },
  {
    "code": "321801",
    "nameCN": "扬州",
    "nameEN": "Yangzhou"
  },
  {
    "code": "321802",
    "nameCN": "扬州出口加工区",
    "nameEN": "Yangzhou Export Processind Zone"
  },
  {
    "code": "321901",
    "nameCN": "高港",
    "nameEN": "Gaogang"
  },
  {
    "code": "321902",
    "nameCN": "泰州",
    "nameEN": "Taizhou"
  },
  {
    "code": "322201",
    "nameCN": "靖江",
    "nameEN": "Jingjiang"
  },
  {
    "code": "322202",
    "nameCN": "泰州出口加工区",
    "nameEN": "Taizhou Export Processind Zone"
  },
  {
    "code": "322401",
    "nameCN": "启东",
    "nameEN": "Qidong"
  },
  {
    "code": "322501",
    "nameCN": "如东洋口",
    "nameEN": "Rudong Yangkou"
  },
  {
    "code": "330001",
    "nameCN": "杭州",
    "nameEN": "Hangzhou"
  },
  {
    "code": "330002",
    "nameCN": "杭州萧山国际机场",
    "nameEN": "Hangzhou Xiaoshan International Airport"
  },
  {
    "code": "330101",
    "nameCN": "温州龙湾国际机场",
    "nameEN": "Wenzhou Longwan International Airport"
  },
  {
    "code": "330102",
    "nameCN": "温州港瓯江港区七里作业区",
    "nameEN": "Wenzhou Harbor Oujiang Port Area Qili Operational Zone"
  },
  {
    "code": "330103",
    "nameCN": "温州港平阳港区",
    "nameEN": "Wenzhou Harbor Pingyang Port Area"
  },
  {
    "code": "330104",
    "nameCN": "温州港状元岙港区",
    "nameEN": "Wenzhou Harbor Zhuangyuanao Port Area"
  },
  {
    "code": "330105",
    "nameCN": "温州港乐清湾港区",
    "nameEN": "Wenzhou Harbor Yueqingwan Port Area"
  },
  {
    "code": "330106",
    "nameCN": "温州港大小门岛港区",
    "nameEN": "Wenzhou Harbor Daxiaomendao Port Areaxia"
  },
  {
    "code": "330200",
    "nameCN": "浙江省宁波市",
    "nameEN": "Zhejiang Sheng Ningbo Shi"
  },
  {
    "code": "330201",
    "nameCN": "金义综合保税区",
    "nameEN": "Jinyi Comprehensive Bonded Zone"
  },
  {
    "code": "330300",
    "nameCN": "浙江省温州市",
    "nameEN": "Zhejiang Sheng Wenzhou Shi"
  },
  {
    "code": "330301",
    "nameCN": "舟山",
    "nameEN": "Zhoushan"
  },
  {
    "code": "330302",
    "nameCN": "舟山定海港区",
    "nameEN": "Zhoushan Dinghai Gangqu"
  },
  {
    "code": "330303",
    "nameCN": "舟山定海岙山油库",
    "nameEN": "Zhoushan Dinghai Aoshan Youku"
  },
  {
    "code": "330304",
    "nameCN": "舟山定海万向油库",
    "nameEN": "Zhoushan Dinghai Wanxiang Youku"
  },
  {
    "code": "330305",
    "nameCN": "舟山老塘山港区",
    "nameEN": "Zhoushan Laotangshan Gangqu"
  },
  {
    "code": "330306",
    "nameCN": "舟山老塘山三期码头",
    "nameEN": "Zhoushan Laotangshan Sanqimatou"
  },
  {
    "code": "330307",
    "nameCN": "舟山老塘山五期码头",
    "nameEN": "Zhoushan Laotangshan Wuqimatou"
  },
  {
    "code": "330308",
    "nameCN": "舟山老塘山册子油库",
    "nameEN": "Zhoushan Laotangshan Cezi Youku"
  },
  {
    "code": "330309",
    "nameCN": "舟山金塘港区",
    "nameEN": "Zhoushan Jintang Gangqu"
  },
  {
    "code": "330310",
    "nameCN": "舟山金塘集装箱码头",
    "nameEN": "Zhoushan Jintang Container Dock"
  },
  {
    "code": "330311",
    "nameCN": "舟山沈家门港区",
    "nameEN": "Zhoushan Shenjiamen Gangqu"
  },
  {
    "code": "330312",
    "nameCN": "舟山沈家门半升洞油库",
    "nameEN": "Zhoushan Shenjiamen Banshengdong Youku"
  },
  {
    "code": "330313",
    "nameCN": "舟山六横港区",
    "nameEN": "Zhoushan Liuheng Gangqu"
  },
  {
    "code": "330314",
    "nameCN": "舟山六横煤电码头",
    "nameEN": "Zhoushan Liuheng Meidian Dock"
  },
  {
    "code": "330315",
    "nameCN": "舟山六横武港码头",
    "nameEN": "Zhoushan Liuheng Wugang Dock"
  },
  {
    "code": "330316",
    "nameCN": "舟山六横金润石油",
    "nameEN": "Zhoushan Liuheng Jinrun Shiyou"
  },
  {
    "code": "330317",
    "nameCN": "舟山衢山港区",
    "nameEN": "Zhoushan Qushan Gangqu"
  },
  {
    "code": "330318",
    "nameCN": "舟山马岙港区",
    "nameEN": "Zhoushan Maao Gangqu"
  },
  {
    "code": "330319",
    "nameCN": "舟山马岙太平洋化工",
    "nameEN": "Zhoushan Maao Taipingyang Huagong"
  },
  {
    "code": "330320",
    "nameCN": "舟山马岙纳海油污",
    "nameEN": "Zhoushan Maao Nahai Youwu"
  },
  {
    "code": "330321",
    "nameCN": "舟山马岙天禄能源",
    "nameEN": "Zhoushan Maao Tianlu Nengyuan"
  },
  {
    "code": "330322",
    "nameCN": "岱山高亭",
    "nameEN": "Daishan Gaoting"
  },
  {
    "code": "330323",
    "nameCN": "舟山港综合保税区",
    "nameEN": "Zhoushangang Comprehensive Bonded Zone"
  },
  {
    "code": "330400",
    "nameCN": "浙江省嘉兴市",
    "nameEN": "Zhejiang Sheng Jiaxing Shi"
  },
  {
    "code": "330401",
    "nameCN": "泗礁",
    "nameEN": "Sijiao"
  },
  {
    "code": "330500",
    "nameCN": "浙江省湖州市",
    "nameEN": "Zhejiang Sheng Huzhou Shi"
  },
  {
    "code": "330501",
    "nameCN": "海门",
    "nameEN": "Haimen"
  },
  {
    "code": "330502",
    "nameCN": "台州",
    "nameEN": "Taizhou"
  },
  {
    "code": "330503",
    "nameCN": "大麦屿",
    "nameEN": "Damaiyu"
  },
  {
    "code": "330600",
    "nameCN": "浙江省绍兴市",
    "nameEN": "Zhejiang Sheng Shaoxing Shi"
  },
  {
    "code": "330700",
    "nameCN": "浙江省金华市",
    "nameEN": "Zhejiang Sheng Jinhua Shi"
  },
  {
    "code": "330701",
    "nameCN": "嘉兴",
    "nameEN": "Jiaxing"
  },
  {
    "code": "330702",
    "nameCN": "嘉兴港",
    "nameEN": "Jiaxing Harbor"
  },
  {
    "code": "330703",
    "nameCN": "嘉兴出口加工区A区",
    "nameEN": "Jiaxing Export Processind Zone Zone A"
  },
  {
    "code": "330704",
    "nameCN": "嘉兴出口加工区B区",
    "nameEN": "Jiaxing Export Processind Zone Zone B"
  },
  {
    "code": "330800",
    "nameCN": "浙江省衢州市",
    "nameEN": "Zhejiang Sheng Quzhou Shi"
  },
  {
    "code": "330801",
    "nameCN": "湖州",
    "nameEN": "Huzhou"
  },
  {
    "code": "330802",
    "nameCN": "湖州南浔",
    "nameEN": "Huzhou Nanxun"
  },
  {
    "code": "330803",
    "nameCN": "湖州安吉川达",
    "nameEN": "Huzhou Anji Chuanda"
  },
  {
    "code": "330900",
    "nameCN": "浙江省舟山市",
    "nameEN": "Zhejiang Sheng Zhoushan Shi"
  },
  {
    "code": "331000",
    "nameCN": "浙江省台州市",
    "nameEN": "Zhejiang Sheng Taizhou Shi"
  },
  {
    "code": "331100",
    "nameCN": "浙江省丽水市",
    "nameEN": "Zhejiang Sheng Lishui Shi"
  },
  {
    "code": "331101",
    "nameCN": "杭州保税物流园区（B型）",
    "nameEN": "Hangzhou Bonded Logistics Zone(B)"
  },
  {
    "code": "331201",
    "nameCN": "义乌",
    "nameEN": "Yiwu"
  },
  {
    "code": "333301",
    "nameCN": "杭州出口加工区",
    "nameEN": "Hangzhou Export Processind Zone"
  },
  {
    "code": "333302",
    "nameCN": "杭州中和保税区",
    "nameEN": "Hangzhou Zhonghe Free Trade Zone"
  },
  {
    "code": "340001",
    "nameCN": "合肥",
    "nameEN": "Hefei"
  },
  {
    "code": "340002",
    "nameCN": "合肥新桥国际机场",
    "nameEN": "Hefei Xinqiao International Airport"
  },
  {
    "code": "340003",
    "nameCN": "合肥新站",
    "nameEN": "Hefei Xinzhan"
  },
  {
    "code": "340004",
    "nameCN": "六安",
    "nameEN": "Luan"
  },
  {
    "code": "340005",
    "nameCN": "芜湖出口加工区",
    "nameEN": "Wuhu Export Processind Zone"
  },
  {
    "code": "340006",
    "nameCN": "合肥出口加工区",
    "nameEN": "Hefei Export Processind Zone"
  },
  {
    "code": "340007",
    "nameCN": "合肥综合保税区",
    "nameEN": "Hefei Comprehensive Bonded Zone"
  },
  {
    "code": "340101",
    "nameCN": "芜湖",
    "nameEN": "Wuhu"
  },
  {
    "code": "340200",
    "nameCN": "安徽省芜湖市",
    "nameEN": "Anhui Sheng Wuhu Shi"
  },
  {
    "code": "340201",
    "nameCN": "安庆",
    "nameEN": "Anqing"
  },
  {
    "code": "340300",
    "nameCN": "安徽省蚌埠市",
    "nameEN": "Anhui Sheng Bengbu Shi"
  },
  {
    "code": "340301",
    "nameCN": "铜陵",
    "nameEN": "Tongling"
  },
  {
    "code": "340400",
    "nameCN": "安徽省淮南市",
    "nameEN": "Anhui Sheng Huainan Shi"
  },
  {
    "code": "340401",
    "nameCN": "马鞍山",
    "nameEN": "Maanshan"
  },
  {
    "code": "340500",
    "nameCN": "安徽省马鞍山市",
    "nameEN": "Anhui Sheng Ma'anshan Shi"
  },
  {
    "code": "340501",
    "nameCN": "蚌埠",
    "nameEN": "Bengbu"
  },
  {
    "code": "340502",
    "nameCN": "淮南",
    "nameEN": "Huainan"
  },
  {
    "code": "340600",
    "nameCN": "安徽省淮北市",
    "nameEN": "Anhui Sheng Huaibei Shi"
  },
  {
    "code": "340601",
    "nameCN": "阜阳",
    "nameEN": "Fuyang"
  },
  {
    "code": "340602",
    "nameCN": "亳州",
    "nameEN": "Bozhou"
  },
  {
    "code": "340700",
    "nameCN": "安徽省铜陵市",
    "nameEN": "Anhui Sheng Tongling Shi"
  },
  {
    "code": "340701",
    "nameCN": "黄山屯溪机场",
    "nameEN": "Huangshan Tunxi Airport"
  },
  {
    "code": "340800",
    "nameCN": "安徽省安庆市",
    "nameEN": "Anhui Sheng Anqing Shi"
  },
  {
    "code": "340801",
    "nameCN": "池州",
    "nameEN": "Chizhou"
  },
  {
    "code": "340901",
    "nameCN": "滁州",
    "nameEN": "Chuzhou"
  },
  {
    "code": "341000",
    "nameCN": "安徽省黄山市",
    "nameEN": "Anhui Sheng Huangshan Shi"
  },
  {
    "code": "341001",
    "nameCN": "宣城",
    "nameEN": "Xuancheng"
  },
  {
    "code": "341100",
    "nameCN": "安徽省滁州市",
    "nameEN": "Anhui Sheng Chuzhou Shi"
  },
  {
    "code": "341200",
    "nameCN": "安徽省阜阳市",
    "nameEN": "Anhui Sheng Fuyang Shi"
  },
  {
    "code": "341201",
    "nameCN": "淮北",
    "nameEN": "Huaibei"
  },
  {
    "code": "341202",
    "nameCN": "宿州",
    "nameEN": "Suzhou"
  },
  {
    "code": "341300",
    "nameCN": "安徽省宿州市",
    "nameEN": "Anhui Sheng Suzhou Shi"
  },
  {
    "code": "341500",
    "nameCN": "安徽省六安市",
    "nameEN": "Anhui Sheng Lu'an Shi"
  },
  {
    "code": "341600",
    "nameCN": "安徽省亳州市",
    "nameEN": "Anhui Sheng Bozhou Shi"
  },
  {
    "code": "341700",
    "nameCN": "安徽省池州市",
    "nameEN": "Anhui Sheng Chizhou Shi"
  },
  {
    "code": "341800",
    "nameCN": "安徽省宣城市",
    "nameEN": "Anhui Sheng Xuncheng Shi"
  },
  {
    "code": "350001",
    "nameCN": "福州",
    "nameEN": "Fuzhou"
  },
  {
    "code": "350002",
    "nameCN": "福州港江阴港区非保税码头",
    "nameEN": "Fuzhou Harbor Jiangyin Gangqu Feibaoshui Dock"
  },
  {
    "code": "350003",
    "nameCN": "福州港平潭金井码头",
    "nameEN": "Fuzhou Harbor Pingtan Jinjing Dock"
  },
  {
    "code": "350004",
    "nameCN": "平潭港口岸澳前港区",
    "nameEN": "Pingtan Harbor Aoqian Gangqu"
  },
  {
    "code": "350005",
    "nameCN": "福州港平潭澳前客滚码头",
    "nameEN": "Fuzhou Harbor Pingtan Aoqiankegun Dock"
  },
  {
    "code": "350006",
    "nameCN": "武夷山机场",
    "nameEN": "Wuyishan Airport"
  },
  {
    "code": "350007",
    "nameCN": "武夷山陆地港",
    "nameEN": "Wuyishan Ludigang"
  },
  {
    "code": "350008",
    "nameCN": "福州保税港区",
    "nameEN": "Fuzhou Free Trade Port Zone"
  },
  {
    "code": "350011",
    "nameCN": "中国（福建）自由贸易试验区",
    "nameEN": "China (Fujian) Pilot Free Trade Zone"
  },
  {
    "code": "350101",
    "nameCN": "泉州港肖厝港区",
    "nameEN": "Quanzhou Harbor Xiaocuo Gangqu"
  },
  {
    "code": "350102",
    "nameCN": "泉州港泉州湾港区",
    "nameEN": "Quanzhou Harbor Quanzhouwan Gangqu"
  },
  {
    "code": "350103",
    "nameCN": "泉州港围头湾港区",
    "nameEN": "Quanzhou Harbor Weitouwan Gangqu"
  },
  {
    "code": "350104",
    "nameCN": "泉州港深沪湾港区",
    "nameEN": "Quanzhou Harbor Shenhuwan Gangqu"
  },
  {
    "code": "350105",
    "nameCN": "泉州港斗尾港区",
    "nameEN": "Quanzhou Harbor Douwei Gangqu"
  },
  {
    "code": "350106",
    "nameCN": "泉州港石井客运码头",
    "nameEN": "Quanzhou Harbor Shijing Passenger Transpor Dock"
  },
  {
    "code": "350107",
    "nameCN": "泉州港肖厝小额贸易点",
    "nameEN": "Quanzhou Harbor Xiaocuo Xiaoemaoyidian"
  },
  {
    "code": "350108",
    "nameCN": "泉州惠安崇武小额贸易点",
    "nameEN": "Quanzhou Huian Chongwu Xiaoemaoyidian"
  },
  {
    "code": "350109",
    "nameCN": "泉州后渚小额贸易点",
    "nameEN": "Quanzhou Houzhu Xiaoemaoyidian"
  },
  {
    "code": "350110",
    "nameCN": "泉州石狮石湖小额贸易点",
    "nameEN": "Quanzhou Shishi Shihu Xiaoemaoyidian"
  },
  {
    "code": "350111",
    "nameCN": "泉州晋江围头小额贸易点",
    "nameEN": "Quanzhou Jinjiang Weitou Xiaoemaoyidian"
  },
  {
    "code": "350112",
    "nameCN": "泉州晋江深沪小额贸易点",
    "nameEN": "Quanzhou Jinjiang Shenhu Xiaoemaoyidian"
  },
  {
    "code": "350113",
    "nameCN": "泉州南安石井小额贸易点",
    "nameEN": "Quanzhou Nanan Shijing Xiaoemaoyidian"
  },
  {
    "code": "350114",
    "nameCN": "泉州晋江陆地港",
    "nameEN": "Quanzhou Jinjiang Ludigang"
  },
  {
    "code": "350115",
    "nameCN": "泉州晋江机场",
    "nameEN": "Quanzhou Jinjiang Airport"
  },
  {
    "code": "350116",
    "nameCN": "泉州出口加工区",
    "nameEN": "Quanzhou Export Processind Zone"
  },
  {
    "code": "350200",
    "nameCN": "福建省厦门市",
    "nameEN": "Fujian Sheng Xiamen Shi"
  },
  {
    "code": "350201",
    "nameCN": "莆田湄洲岛小额贸易点",
    "nameEN": "Putian Meizhoudao Xiaoemaoyidian"
  },
  {
    "code": "350202",
    "nameCN": "莆田港秀屿港区",
    "nameEN": "Putian Harbor Xiuyu Gangqu"
  },
  {
    "code": "350203",
    "nameCN": "莆田港湄洲岛客运码头",
    "nameEN": "Putian Harbor Meizhoudao Passenger Transpor Dock"
  },
  {
    "code": "350204",
    "nameCN": "莆田港东吴港区",
    "nameEN": "Putian Harbor Dongwu Gangqu"
  },
  {
    "code": "350300",
    "nameCN": "福建省莆田市",
    "nameEN": "Fujian Sheng Putian Shi"
  },
  {
    "code": "350301",
    "nameCN": "三明陆地港",
    "nameEN": "Sanming Ludigang"
  },
  {
    "code": "350400",
    "nameCN": "福建省三明市",
    "nameEN": "Fujian Sheng Sanming Shi"
  },
  {
    "code": "350401",
    "nameCN": "福州港马尾客运码头",
    "nameEN": "Fuzhou Harbor Mawei Passenger Transpor Dock"
  },
  {
    "code": "350402",
    "nameCN": "福州港闽江口内港区",
    "nameEN": "Fuzhou Harbor Minjiangkou Neigangqu"
  },
  {
    "code": "350403",
    "nameCN": "福州港马尾小额贸易点",
    "nameEN": "Fuzhou Harbor Mawei Xiaoemaoyidian"
  },
  {
    "code": "350404",
    "nameCN": "福州港连江琯头小额贸易点",
    "nameEN": "Fuzhou Harbor Lianjiang Guantou Xiaoemaoyidian"
  },
  {
    "code": "350405",
    "nameCN": "福州港罗源迹头小额贸易点",
    "nameEN": "Fuzhou Harbor Luoyuan Jitou Xiaoemaoyidian"
  },
  {
    "code": "350406",
    "nameCN": "福州港罗源湾港区",
    "nameEN": "Fuzhou Harbor luoyuanwan Gangqu"
  },
  {
    "code": "350407",
    "nameCN": "福州港黄岐港区",
    "nameEN": "Fuzhou Harbor Huangqi Gangqu"
  },
  {
    "code": "350408",
    "nameCN": "福州港松下港区牛头湾作业区",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Niutouwan Zuoyequ"
  },
  {
    "code": "350409",
    "nameCN": "福州港松下港区长乐松下小额贸易点",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Changlesong Xiaxiaoemaoyidian"
  },
  {
    "code": "350410",
    "nameCN": "福州保税区",
    "nameEN": "Fuzhou Free Trade Zone"
  },
  {
    "code": "350411",
    "nameCN": "福州出口加工区",
    "nameEN": "Fuzhou Export Processind Zone"
  },
  {
    "code": "350500",
    "nameCN": "福建省泉州市",
    "nameEN": "Fujian Sheng Quanzhou Shi"
  },
  {
    "code": "350501",
    "nameCN": "宁德港三都澳港区",
    "nameEN": "Ningde Harbor Sanduao Gangqu"
  },
  {
    "code": "350502",
    "nameCN": "宁德港三沙港区",
    "nameEN": "Ningde Harbor Sansha Gangqu"
  },
  {
    "code": "350503",
    "nameCN": "宁德港沙埕港区",
    "nameEN": "Ningde Harbor Shacheng Gangqu"
  },
  {
    "code": "350504",
    "nameCN": "宁德港赛江港区",
    "nameEN": "Ningde Harbor Saijiang Gangqu"
  },
  {
    "code": "350505",
    "nameCN": "霞浦三沙小额贸易点",
    "nameEN": "Xiapu Sansha Xiaoemaoyidian"
  },
  {
    "code": "350600",
    "nameCN": "福建省漳州市",
    "nameEN": "Fujian Sheng Zhangzhou Shi"
  },
  {
    "code": "350601",
    "nameCN": "福州港松下港区元洪作业区",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Yuanhong Zuoyequ"
  },
  {
    "code": "350602",
    "nameCN": "福州港松下港区南青屿小额贸易点",
    "nameEN": "Fuzhou Harbor Songxia Gangqu Nanqingyu Xiaoemaoyidian"
  },
  {
    "code": "350700",
    "nameCN": "福建省南平市",
    "nameEN": "Fujian Sheng Nanping Shi"
  },
  {
    "code": "350800",
    "nameCN": "福建省龙岩市",
    "nameEN": "Fujian Sheng Longyan Shi"
  },
  {
    "code": "350900",
    "nameCN": "福建省宁德市",
    "nameEN": "Fujian Sheng Ningde Shi"
  },
  {
    "code": "350901",
    "nameCN": "龙岩陆地港",
    "nameEN": "Longyan Ludigang"
  },
  {
    "code": "351101",
    "nameCN": "东山湾东山港区",
    "nameEN": "Dongshanwan Dongshan Gangqu"
  },
  {
    "code": "351102",
    "nameCN": "东山湾诏安港区",
    "nameEN": "Dongshanwan Zhaoan Gangqu"
  },
  {
    "code": "351103",
    "nameCN": "漳州东山铜陵小额贸易点",
    "nameEN": "Zhangzhou Dongshan Tongling Xiaoemaoyidian"
  },
  {
    "code": "351104",
    "nameCN": "漳州云霄礁美小额贸易点",
    "nameEN": "Zhangzhou Yunxiao Jiaomei Xiaoemaoyidian"
  },
  {
    "code": "351105",
    "nameCN": "漳州诏安田厝小额贸易点",
    "nameEN": "Zhangzhou Zhaoan Tiancuo Xiaoemaoyidian"
  },
  {
    "code": "351201",
    "nameCN": "福州长乐国际机场",
    "nameEN": "Fuzhou Changle International Airport"
  },
  {
    "code": "360001",
    "nameCN": "南昌",
    "nameEN": "Nanchang"
  },
  {
    "code": "360002",
    "nameCN": "南昌昌北机场",
    "nameEN": "Nanchang Changbei Airport"
  },
  {
    "code": "360003",
    "nameCN": "南昌出口加工区",
    "nameEN": "Nanchang Export Processind Zone"
  },
  {
    "code": "360101",
    "nameCN": "九江",
    "nameEN": "Jiujiang"
  },
  {
    "code": "360102",
    "nameCN": "九江出口加工区",
    "nameEN": "Jiujiang Export Processind Zone"
  },
  {
    "code": "360200",
    "nameCN": "江西省景德镇市",
    "nameEN": "Jiangxi Sheng Jingdezhen Shi"
  },
  {
    "code": "360300",
    "nameCN": "江西省萍乡市",
    "nameEN": "Jiangxi Sheng Pingxiang Shi"
  },
  {
    "code": "360301",
    "nameCN": "赣州出口加工区",
    "nameEN": "Ganzhou Export Processind Zone"
  },
  {
    "code": "360302",
    "nameCN": "赣州综合保税区",
    "nameEN": "Ganzhou Comprehensive Bonded Zone"
  },
  {
    "code": "360400",
    "nameCN": "江西省九江市",
    "nameEN": "Jiangxi Sheng Jiujiang Shi"
  },
  {
    "code": "360500",
    "nameCN": "江西省新余市",
    "nameEN": "Jiangxi Sheng Xinyu Shi"
  },
  {
    "code": "360600",
    "nameCN": "江西省鹰潭市",
    "nameEN": "Jiangxi Sheng Yingtan Shi"
  },
  {
    "code": "360601",
    "nameCN": "井冈山出口加工区",
    "nameEN": "Jinggnanshan Export Processind Zone"
  },
  {
    "code": "360700",
    "nameCN": "江西省赣州市",
    "nameEN": "Jiangxi Sheng Ganzhou Shi"
  },
  {
    "code": "360800",
    "nameCN": "江西省吉安市",
    "nameEN": "Jiangxi Sheng Ji'an Shi"
  },
  {
    "code": "360900",
    "nameCN": "江西省宜春市",
    "nameEN": "Jiangxi Sheng Yichun Shi"
  },
  {
    "code": "361000",
    "nameCN": "江西省抚州市",
    "nameEN": "Jiangxi Sheng Fuzhou Shi"
  },
  {
    "code": "361100",
    "nameCN": "江西省上饶市",
    "nameEN": "Jiangxi Sheng Shangrao Shi"
  },
  {
    "code": "370001",
    "nameCN": "济南",
    "nameEN": "Jinan"
  },
  {
    "code": "370002",
    "nameCN": "日照",
    "nameEN": "Rizhao"
  },
  {
    "code": "370003",
    "nameCN": "岚山",
    "nameEN": "Lanshan"
  },
  {
    "code": "370101",
    "nameCN": "青岛港",
    "nameEN": "Qingdao Harbor"
  },
  {
    "code": "370102",
    "nameCN": "青岛出口加工区",
    "nameEN": "Qingdao Export Processind Zone"
  },
  {
    "code": "370200",
    "nameCN": "山东省青岛市",
    "nameEN": "Shandong Sheng Qingdao Shi"
  },
  {
    "code": "370201",
    "nameCN": "黄岛",
    "nameEN": "Huangdao"
  },
  {
    "code": "370202",
    "nameCN": "青岛前湾保税港区",
    "nameEN": "Qingdao Qianwan Free Trade Port Zone"
  },
  {
    "code": "370203",
    "nameCN": "青岛西海岸出口加工区",
    "nameEN": "Qingdao Xihaian Export Processind Zone"
  },
  {
    "code": "370300",
    "nameCN": "山东省淄博市",
    "nameEN": "Shandong Sheng Zibo Shi"
  },
  {
    "code": "370301",
    "nameCN": "烟台莱山机场",
    "nameEN": "Yantai Laishan Airport"
  },
  {
    "code": "370302",
    "nameCN": "烟台港",
    "nameEN": "Yantai Harbor"
  },
  {
    "code": "370303",
    "nameCN": "烟台保税港区A区",
    "nameEN": "Yantai Free Trade Port Zone A Qu"
  },
  {
    "code": "370304",
    "nameCN": "烟台保税港区B区",
    "nameEN": "Yantai Free Trade Port Zone B Qu"
  },
  {
    "code": "370400",
    "nameCN": "山东省枣庄市",
    "nameEN": "Shandong Sheng Zaozhuang Shi"
  },
  {
    "code": "370401",
    "nameCN": "石岛",
    "nameEN": "Shidao"
  },
  {
    "code": "370402",
    "nameCN": "龙眼",
    "nameEN": "Longyan"
  },
  {
    "code": "370500",
    "nameCN": "山东省东营市",
    "nameEN": "Shandong Sheng Dongying Shi"
  },
  {
    "code": "370501",
    "nameCN": "龙口",
    "nameEN": "Longkou"
  },
  {
    "code": "370600",
    "nameCN": "山东省烟台市",
    "nameEN": "Shandong Sheng Yantai Shi"
  },
  {
    "code": "370601",
    "nameCN": "莱州",
    "nameEN": "Laizhou"
  },
  {
    "code": "370700",
    "nameCN": "山东省潍坊市",
    "nameEN": "Shandong Sheng Weifang Shi"
  },
  {
    "code": "370701",
    "nameCN": "济南遥墙机场",
    "nameEN": "Jinan Yaoqiang Airport"
  },
  {
    "code": "370702",
    "nameCN": "济南综合保税区",
    "nameEN": "Jinan Comprehensive Bonded Zone"
  },
  {
    "code": "370703",
    "nameCN": "济南出口加工区",
    "nameEN": "Jinan Export Processind Zone"
  },
  {
    "code": "370800",
    "nameCN": "山东省济宁市",
    "nameEN": "Shandong Sheng Jining Shi"
  },
  {
    "code": "370801",
    "nameCN": "济宁站",
    "nameEN": "Jiningzhan"
  },
  {
    "code": "370900",
    "nameCN": "山东省泰安市",
    "nameEN": "Shandong Sheng Tai'an Shi"
  },
  {
    "code": "370901",
    "nameCN": "潍坊",
    "nameEN": "Weifang"
  },
  {
    "code": "370902",
    "nameCN": "潍坊综合保税区",
    "nameEN": "Weifang Comprehensive Bonded Zone"
  },
  {
    "code": "371000",
    "nameCN": "山东省威海市",
    "nameEN": "Shandong Sheng Weihai Shi"
  },
  {
    "code": "371100",
    "nameCN": "山东省日照市",
    "nameEN": "Shandong Sheng Rizhao Shi"
  },
  {
    "code": "371200",
    "nameCN": "山东省莱芜市",
    "nameEN": "Shandong Sheng Laiwu Shi"
  },
  {
    "code": "371201",
    "nameCN": "威海机场",
    "nameEN": "Weihai Airport"
  },
  {
    "code": "371202",
    "nameCN": "威海港",
    "nameEN": "Weihai Harbor"
  },
  {
    "code": "371203",
    "nameCN": "威海出口加工区",
    "nameEN": "Weihai Export Processind Zone"
  },
  {
    "code": "371300",
    "nameCN": "山东省临沂市",
    "nameEN": "Shandong Sheng Linyi Shi"
  },
  {
    "code": "371400",
    "nameCN": "山东省德州市",
    "nameEN": "Shandong Sheng Dezhou Shi"
  },
  {
    "code": "371500",
    "nameCN": "山东省聊城市",
    "nameEN": "Shandong Sheng Liaocheng Shi"
  },
  {
    "code": "371600",
    "nameCN": "山东省滨州市",
    "nameEN": "Shandong Sheng Binzhou Shi"
  },
  {
    "code": "371700",
    "nameCN": "山东省菏泽市",
    "nameEN": "Shandong Sheng Heze Shi"
  },
  {
    "code": "371801",
    "nameCN": "临沂站",
    "nameEN": "Linyizhan"
  },
  {
    "code": "371802",
    "nameCN": "临沂综合保税区",
    "nameEN": "Linyi Comprehensive Bonded Zone"
  },
  {
    "code": "371901",
    "nameCN": "东营",
    "nameEN": "Dongying"
  },
  {
    "code": "371902",
    "nameCN": "东营综合保税区",
    "nameEN": "Dongying Comprehensive Bonded Zone"
  },
  {
    "code": "372301",
    "nameCN": "青岛流亭机场",
    "nameEN": "Qingdao Liuting Airport"
  },
  {
    "code": "372401",
    "nameCN": "蓬莱",
    "nameEN": "Penglai"
  },
  {
    "code": "380001",
    "nameCN": "宁波",
    "nameEN": "Ningbo"
  },
  {
    "code": "380002",
    "nameCN": "宁波栎社机场",
    "nameEN": "Ningbo Lishe Airport"
  },
  {
    "code": "380003",
    "nameCN": "宁波甬江港区",
    "nameEN": "Ningbo Yongjiang Gangqu"
  },
  {
    "code": "380004",
    "nameCN": "宁波出口加工区",
    "nameEN": "Ningbo Export Processind Zone"
  },
  {
    "code": "380005",
    "nameCN": "宁波保税区",
    "nameEN": "Ningbo Free Trade Zone"
  },
  {
    "code": "380101",
    "nameCN": "宁波北仑港港区",
    "nameEN": "Ningbo Beilungang Gangqu"
  },
  {
    "code": "380102",
    "nameCN": "宁波穿山港区",
    "nameEN": "Ningbo Chuanshan Gangqu"
  },
  {
    "code": "380201",
    "nameCN": "慈溪出口加工区",
    "nameEN": "Cixi Export Processind Zone"
  },
  {
    "code": "380701",
    "nameCN": "宁波象山石浦港区",
    "nameEN": "Ningbo Xiangshan Shipu Gangqu"
  },
  {
    "code": "380702",
    "nameCN": "宁波象山港区",
    "nameEN": "Ningbo Xiangshan Gangqu"
  },
  {
    "code": "380801",
    "nameCN": "宁波大榭港区",
    "nameEN": "Ningbo Daxie Gangqu"
  },
  {
    "code": "380901",
    "nameCN": "宁波梅山保税港区",
    "nameEN": "Ningbo Meishan Free Trade Port Zone"
  },
  {
    "code": "381001",
    "nameCN": "宁波镇海港区",
    "nameEN": "Ningbo Zhenhai Gangqu"
  },
  {
    "code": "390001",
    "nameCN": "厦门",
    "nameEN": "Xiamen"
  },
  {
    "code": "390002",
    "nameCN": "厦门邮轮中心",
    "nameEN": "Xiamen Youlun Center"
  },
  {
    "code": "390003",
    "nameCN": "刘五店",
    "nameEN": "Liuwudian"
  },
  {
    "code": "390004",
    "nameCN": "大磴岛",
    "nameEN": "Dadengdao"
  },
  {
    "code": "390005",
    "nameCN": "厦门象屿保税物流园区",
    "nameEN": "Xiamen Xiangyu Bonded Logistics Zone"
  },
  {
    "code": "390007",
    "nameCN": "厦门翔安火炬保税物流园区",
    "nameEN": "Xiamen Xiangan Huoju Bonded Logistics Zone"
  },
  {
    "code": "390008",
    "nameCN": "厦门保税区",
    "nameEN": "Xiamen Free Trade Zone"
  },
  {
    "code": "390101",
    "nameCN": "厦门海沧港区",
    "nameEN": "Xiamen Haicang Gangqu"
  },
  {
    "code": "390102",
    "nameCN": "厦门海沧保税港区",
    "nameEN": "Xiamen Haicang Free Trade Port Zone"
  },
  {
    "code": "390301",
    "nameCN": "漳州招银港区",
    "nameEN": "Zhangzhou Zhaoyin Gangqu"
  },
  {
    "code": "390302",
    "nameCN": "漳州后石港区",
    "nameEN": "Zhangzhou Houshi Gangqu"
  },
  {
    "code": "390303",
    "nameCN": "漳州古雷港区",
    "nameEN": "Zhangzhou Gulei Gangqu"
  },
  {
    "code": "390304",
    "nameCN": "漳州旧镇港区",
    "nameEN": "Zhangzhou Jiuzhen Gangqu"
  },
  {
    "code": "390305",
    "nameCN": "漳州石码港区",
    "nameEN": "Zhangzhou Shima Gangqu"
  },
  {
    "code": "399101",
    "nameCN": "厦门高崎国际机场",
    "nameEN": "Xiamen Gaoqi International Airport"
  },
  {
    "code": "399102",
    "nameCN": "厦门五通码头",
    "nameEN": "Xiamen Wutong Dock"
  },
  {
    "code": "399103",
    "nameCN": "厦门五缘湾码头",
    "nameEN": "Xiamen Wuyuanwan Dock"
  },
  {
    "code": "399501",
    "nameCN": "厦门东渡港区",
    "nameEN": "Xiamen Dongdu Gangqu"
  },
  {
    "code": "410001",
    "nameCN": "郑州",
    "nameEN": "Zhengzhou"
  },
  {
    "code": "410002",
    "nameCN": "郑州查验场",
    "nameEN": "Zhengzhou Check the field"
  },
  {
    "code": "410003",
    "nameCN": "郑州新郑国际机场",
    "nameEN": "Zhengzhou Xinzheng International Airport"
  },
  {
    "code": "410004",
    "nameCN": "郑州站",
    "nameEN": "Zhengzhouzhan"
  },
  {
    "code": "410005",
    "nameCN": "郑州出口加工区",
    "nameEN": "Zhengzhou Export Processind Zone"
  },
  {
    "code": "410101",
    "nameCN": "洛阳北郊机场",
    "nameEN": "Luoyang Beijiao Airport"
  },
  {
    "code": "410200",
    "nameCN": "河南省开封市",
    "nameEN": "Henan Sheng Kaifeng Shi"
  },
  {
    "code": "410300",
    "nameCN": "河南省洛阳市",
    "nameEN": "Henan Sheng Luoyang Shi"
  },
  {
    "code": "410400",
    "nameCN": "河南省平顶山市",
    "nameEN": "Henan Sheng Pingdingshan Shi"
  },
  {
    "code": "410500",
    "nameCN": "河南省安阳市",
    "nameEN": "Henan Sheng Anyang Shi"
  },
  {
    "code": "410501",
    "nameCN": "漯河查验场",
    "nameEN": "Luohe Check the field"
  },
  {
    "code": "410600",
    "nameCN": "河南省鹤壁市",
    "nameEN": "Henan Sheng Hebi Shi"
  },
  {
    "code": "410601",
    "nameCN": "南阳卧龙综合保税区",
    "nameEN": "Nanyang Wolong Comprehensive Bonded Zone"
  },
  {
    "code": "410700",
    "nameCN": "河南省新乡市",
    "nameEN": "Henan Sheng Xinxiang Shi"
  },
  {
    "code": "410800",
    "nameCN": "河南省焦作市",
    "nameEN": "Henan Sheng Jiaozuo Shi"
  },
  {
    "code": "410900",
    "nameCN": "河南省濮阳市",
    "nameEN": "Henan Sheng Puyang Shi"
  },
  {
    "code": "410901",
    "nameCN": "郑州新郑综合保税区",
    "nameEN": "Zhengzhou Xinzheng Comprehensive Bonded Zone"
  },
  {
    "code": "411000",
    "nameCN": "河南省许昌市",
    "nameEN": "Henan Sheng Xuchang Shi"
  },
  {
    "code": "411100",
    "nameCN": "河南省漯河市",
    "nameEN": "Henan Sheng Luohe Shi"
  },
  {
    "code": "411200",
    "nameCN": "河南省三门峡市",
    "nameEN": "Henan Sheng Sanmenxia Shi"
  },
  {
    "code": "411300",
    "nameCN": "河南省南阳市",
    "nameEN": "Henan Sheng Nanyang Shi"
  },
  {
    "code": "411400",
    "nameCN": "河南省商丘市",
    "nameEN": "Henan Sheng Shangqiu Shi"
  },
  {
    "code": "411500",
    "nameCN": "河南省信阳市",
    "nameEN": "Henan Sheng Xingyang Shi"
  },
  {
    "code": "411600",
    "nameCN": "河南省周口市",
    "nameEN": "Henan Sheng Zhoukou Shi"
  },
  {
    "code": "411700",
    "nameCN": "河南省驻马店市",
    "nameEN": "Zhumadian Diqu Zhumadian Shi"
  },
  {
    "code": "419000",
    "nameCN": "河南省省直辖县级行政区划",
    "nameEN": "Henan Sheng Sheng Zhixia Xianji Xingzhengquhua"
  },
  {
    "code": "420001",
    "nameCN": "武汉",
    "nameEN": "Wuhan"
  },
  {
    "code": "420002",
    "nameCN": "武汉天河机场",
    "nameEN": "Wuhan Tianhe Airport"
  },
  {
    "code": "420003",
    "nameCN": "武汉阳逻水运港",
    "nameEN": "Wuhan Yangluo Shuiyun Harbor"
  },
  {
    "code": "420004",
    "nameCN": "武汉出口加工区",
    "nameEN": "Wuhan Export Processind Zone"
  },
  {
    "code": "420005",
    "nameCN": "武汉东西湖保税物流园区",
    "nameEN": "Wuhan Dongxihu Bonded Logistics Zone"
  },
  {
    "code": "420006",
    "nameCN": "武汉东湖综合保税区",
    "nameEN": "Wuhan Donghu Comprehensive Bonded Zone"
  },
  {
    "code": "420007",
    "nameCN": "武汉新港空港综合保税区",
    "nameEN": "Wuhan Xingang Konggang Comprehensive Bonded Zone"
  },
  {
    "code": "420101",
    "nameCN": "荆州盐卡",
    "nameEN": "Jingzhou Yanka"
  },
  {
    "code": "420200",
    "nameCN": "湖北省黄石市",
    "nameEN": "Hubei Sheng Huangshi Shi"
  },
  {
    "code": "420201",
    "nameCN": "襄阳铁路",
    "nameEN": "Xiangyang Railway"
  },
  {
    "code": "420202",
    "nameCN": "襄阳公路",
    "nameEN": "Xiangyang Highroad"
  },
  {
    "code": "420203",
    "nameCN": "十堰公路",
    "nameEN": "Shiyan Highroad"
  },
  {
    "code": "420300",
    "nameCN": "湖北省十堰市",
    "nameEN": "Hubei Sheng Shiyan Shi"
  },
  {
    "code": "420301",
    "nameCN": "宜昌三峡机场",
    "nameEN": "Yichang Sanxia Airport"
  },
  {
    "code": "420302",
    "nameCN": "宜昌水运港",
    "nameEN": "Yichang Shuiyun Harbor"
  },
  {
    "code": "420401",
    "nameCN": "黄石水运港",
    "nameEN": "Huangshi Shuiyun Harbor"
  },
  {
    "code": "420500",
    "nameCN": "湖北省宜昌市",
    "nameEN": "Hubei Sheng Yichang Shi"
  },
  {
    "code": "420600",
    "nameCN": "湖北省襄阳市",
    "nameEN": "Hubei Sheng Xiangyang Shi"
  },
  {
    "code": "420700",
    "nameCN": "湖北省鄂州市",
    "nameEN": "Hubei Sheng Ezhou Shi"
  },
  {
    "code": "420800",
    "nameCN": "湖北省荆门市",
    "nameEN": "Hubei Sheng Jingmen Shi"
  },
  {
    "code": "420900",
    "nameCN": "湖北省孝感市",
    "nameEN": "Hubei Sheng Xiaogan Shi"
  },
  {
    "code": "421000",
    "nameCN": "湖北省荆州市",
    "nameEN": "Hubei Sheng Jingzhou Shi"
  },
  {
    "code": "421100",
    "nameCN": "湖北省黄冈市",
    "nameEN": "Hubei Sheng Huanggang Shi"
  },
  {
    "code": "421200",
    "nameCN": "湖北省咸宁市",
    "nameEN": "Hubei Sheng Xianning Shi"
  },
  {
    "code": "421300",
    "nameCN": "湖北省随州市",
    "nameEN": "Hubei Sheng Suizhou Shi"
  },
  {
    "code": "422800",
    "nameCN": "湖北省恩施土家族苗族自治州",
    "nameEN": "Hubei Sheng Enshi Tujiazu Miaozu Zizhizhou"
  },
  {
    "code": "429000",
    "nameCN": "湖北省省直辖县级行政区划",
    "nameEN": "Hubei Sheng Sheng Zhixia Xianji Xingzhengquhua"
  },
  {
    "code": "430001",
    "nameCN": "长沙",
    "nameEN": "Changsha"
  },
  {
    "code": "430002",
    "nameCN": "长沙黄花国际机场旅检通道",
    "nameEN": "Changsha Huanghua International Airport Passenger-Inspection Tongdao"
  },
  {
    "code": "430003",
    "nameCN": "长沙黄花国际机场货场",
    "nameEN": "Changsha Huanghua International Airport Huochang"
  },
  {
    "code": "430004",
    "nameCN": "张家界荷花国际机场",
    "nameEN": "Zhangjiajie Hehua International Airport "
  },
  {
    "code": "430005",
    "nameCN": "长沙霞凝港",
    "nameEN": "Changsha Xianing Harbor"
  },
  {
    "code": "430006",
    "nameCN": "长沙霞凝铁路",
    "nameEN": "Changsha Xianing Railway"
  },
  {
    "code": "430007",
    "nameCN": "长沙金霞保税物流园区",
    "nameEN": "Changsha Jinxia Bonded Logistics Zone"
  },
  {
    "code": "430008",
    "nameCN": "湘潭综合保税区",
    "nameEN": "Xiangtan Comprehensive Bonded Zone"
  },
  {
    "code": "430009",
    "nameCN": "长沙黄花国际机场国际快件监控中心",
    "nameEN": "Changsha Huanghua International Airport Kuaijian"
  },
  {
    "code": "430101",
    "nameCN": "岳阳城陵矶水运",
    "nameEN": "Yueyang Chenglingji Shuiyun"
  },
  {
    "code": "430103",
    "nameCN": "岳阳城陵矶综合保税区",
    "nameEN": "Yueyang Chenglingji Comprehensive Bonded Zone"
  },
  {
    "code": "430200",
    "nameCN": "湖南省株洲市",
    "nameEN": "Hunan Sheng Zhuzhou Shi"
  },
  {
    "code": "430201",
    "nameCN": "常德盐关水运",
    "nameEN": "Changde Yanguan Shuiyun"
  },
  {
    "code": "430300",
    "nameCN": "湖南省湘潭市",
    "nameEN": "Hunan Sheng Xiangtan Shi"
  },
  {
    "code": "430400",
    "nameCN": "湖南省衡阳市",
    "nameEN": "Hunan Sheng Hengyang Shi"
  },
  {
    "code": "430401",
    "nameCN": "衡阳公路",
    "nameEN": "Hengyang Highroad"
  },
  {
    "code": "430402",
    "nameCN": "衡阳综合保税区",
    "nameEN": "Hengyang Comprehensive Bonded Zone"
  },
  {
    "code": "430500",
    "nameCN": "湖南省邵阳市",
    "nameEN": "Hunan Sheng Shaoyang Shi"
  },
  {
    "code": "430501",
    "nameCN": "郴州公路",
    "nameEN": "Chenzhou Highroad"
  },
  {
    "code": "430502",
    "nameCN": "郴州铁路",
    "nameEN": "Chenzhou Railway"
  },
  {
    "code": "430503",
    "nameCN": "郴州出口加工区",
    "nameEN": "Chenzhou Export Processind Zone"
  },
  {
    "code": "430600",
    "nameCN": "湖南省岳阳市",
    "nameEN": "Hunan Sheng Yueyang Shi"
  },
  {
    "code": "430700",
    "nameCN": "湖南省常德市",
    "nameEN": "Hunan Sheng Changde Shi"
  },
  {
    "code": "430701",
    "nameCN": "湘潭公路",
    "nameEN": "Xiangtan Highroad"
  },
  {
    "code": "430702",
    "nameCN": "长沙黄花综合保税区",
    "nameEN": "Changsha Huanghua Comprehensive Bonded Zone"
  },
  {
    "code": "430800",
    "nameCN": "湖南省张家界市",
    "nameEN": "Hunan Sheng Zhangjiajie Shi"
  },
  {
    "code": "430900",
    "nameCN": "湖南省益阳市",
    "nameEN": "Hunan Sheng Yiyang Shi"
  },
  {
    "code": "431000",
    "nameCN": "湖南省郴州市",
    "nameEN": "Hunan Sheng Chenzhou Shi"
  },
  {
    "code": "431100",
    "nameCN": "湖南省永州市",
    "nameEN": "Hunan Sheng Yongzhou Shi"
  },
  {
    "code": "431200",
    "nameCN": "湖南省怀化市",
    "nameEN": "Hunan Sheng Huaihua Shi"
  },
  {
    "code": "431300",
    "nameCN": "湖南省娄底市",
    "nameEN": "Hunan Sheng Loudi Shi"
  },
  {
    "code": "433100",
    "nameCN": "湖南省湘西土家族苗族自治州",
    "nameEN": "Hunan Sheng Xiangxi Tujiazu Miaozu Zizhizhou"
  },
  {
    "code": "440001",
    "nameCN": "广州",
    "nameEN": "Guangzhou"
  },
  {
    "code": "440002",
    "nameCN": "黄埔港务码头",
    "nameEN": "Huangpu Gangwu Dock"
  },
  {
    "code": "440003",
    "nameCN": "南沙粮食及通用码头",
    "nameEN": "Nansha Liangshi Tongyong Dock"
  },
  {
    "code": "440004",
    "nameCN": "黄埔嘉利仓码头",
    "nameEN": "Huangpu Jialicang Dock"
  },
  {
    "code": "440005",
    "nameCN": "佛山三水西南码头",
    "nameEN": "Foshan Sanshui Xinan Dock"
  },
  {
    "code": "440006",
    "nameCN": "佛山三水港码头",
    "nameEN": "Foshan Sanshui Harbor Dock"
  },
  {
    "code": "440007",
    "nameCN": "佛山三水车检场",
    "nameEN": "Foshan Sanshui Truck Inspection Field"
  },
  {
    "code": "440008",
    "nameCN": "东莞凤岗车检场",
    "nameEN": "Dongguan Fenggang Truck Inspection Field"
  },
  {
    "code": "440009",
    "nameCN": "东莞长安车检场",
    "nameEN": "Dongguan Changan Truck Inspection Field"
  },
  {
    "code": "440010",
    "nameCN": "广州香港马会马匹查验场",
    "nameEN": "Guangzhou Hongkong Jockey Club Horse Inspection Field"
  },
  {
    "code": "440011",
    "nameCN": "中国（广东）自由贸易试验区",
    "nameEN": "China (Guangdong) Pilot Free Trade Zone"
  },
  {
    "code": "440101",
    "nameCN": "广州新沙码头",
    "nameEN": "Guangzhou Xinsha Dock"
  },
  {
    "code": "440102",
    "nameCN": "广州新风码头",
    "nameEN": "Guangzhou Xinfeng Dock"
  },
  {
    "code": "440103",
    "nameCN": "广州河南码头",
    "nameEN": "Guangzhou Henan Dock"
  },
  {
    "code": "440104",
    "nameCN": "广州石榴岗码头",
    "nameEN": "Guangzhou Shiliugang Dock"
  },
  {
    "code": "440105",
    "nameCN": "广州造纸厂码头",
    "nameEN": "Guangzhou Zaozhichang Dock"
  },
  {
    "code": "440106",
    "nameCN": "广州石井滘心港码头",
    "nameEN": "Guangzhou Shijing Jiaoxin Harbor Dock"
  },
  {
    "code": "440107",
    "nameCN": "广州东朗码头",
    "nameEN": "Guangzhou Donglang Dock"
  },
  {
    "code": "440108",
    "nameCN": "广州萝岗车检场",
    "nameEN": "Guangzhou Luogang Truck Inspection Field"
  },
  {
    "code": "440200",
    "nameCN": "广东省韶关市",
    "nameEN": "Guangdong Sheng Shaoguan Shi"
  },
  {
    "code": "440201",
    "nameCN": "韶关新港码头",
    "nameEN": "Shaoguan Xingang Dock"
  },
  {
    "code": "440202",
    "nameCN": "韶关铁路装卸点",
    "nameEN": "Shaoguan Railway Zhuangxiedian"
  },
  {
    "code": "440203",
    "nameCN": "乐昌铁路装卸点",
    "nameEN": "Lechang Railway Zhuangxiedian"
  },
  {
    "code": "440204",
    "nameCN": "韶关车检场",
    "nameEN": "Shaoguan Truck Inspection Field"
  },
  {
    "code": "440300",
    "nameCN": "广东省深圳市",
    "nameEN": "Guangdong Sheng Shenzhen Shi"
  },
  {
    "code": "440301",
    "nameCN": "南海港客运码头",
    "nameEN": "Nanhai Harbor Passenger Transpor Dock"
  },
  {
    "code": "440302",
    "nameCN": "南海三山港",
    "nameEN": "Nanhai Sanshan Harbor"
  },
  {
    "code": "440303",
    "nameCN": "南海九江码头",
    "nameEN": "Nanhai Jiujiang Dock"
  },
  {
    "code": "440304",
    "nameCN": "南海北村码头",
    "nameEN": "Nanhai Beicun Dock"
  },
  {
    "code": "440305",
    "nameCN": "南海平洲南港码头",
    "nameEN": "Nanhai Pingzhou Nangang Dock"
  },
  {
    "code": "440306",
    "nameCN": "南海官窑车检场",
    "nameEN": "Nanhai Guanyao Truck Inspection Field"
  },
  {
    "code": "440307",
    "nameCN": "南海桂江车检场",
    "nameEN": "Nanhai Guijiang Truck Inspection Field"
  },
  {
    "code": "440400",
    "nameCN": "广东省珠海市",
    "nameEN": "Guangdong Sheng Zhuhai Shi"
  },
  {
    "code": "440401",
    "nameCN": "顺德港客运码头",
    "nameEN": "Shunde Harbor Passenger Transpor Dock"
  },
  {
    "code": "440402",
    "nameCN": "顺德容奇货运码头",
    "nameEN": "Shunde Rongqi Freight Dock"
  },
  {
    "code": "440403",
    "nameCN": "顺德食出码头",
    "nameEN": "Shunde Shichu Dock"
  },
  {
    "code": "440404",
    "nameCN": "顺德北滘港货运码头",
    "nameEN": "Shunde Beijiao Harbor Freight Dock"
  },
  {
    "code": "440405",
    "nameCN": "顺德勒流港货运码头",
    "nameEN": "Shunde Leliu Harbor Freight Dock"
  },
  {
    "code": "440406",
    "nameCN": "顺德陈村车检场",
    "nameEN": "Shunde Chenchun Truck Inspection Field"
  },
  {
    "code": "440407",
    "nameCN": "顺德勒流车检场",
    "nameEN": "Shunde Leliu Truck Inspection Field"
  },
  {
    "code": "440408",
    "nameCN": "顺德容奇车检场",
    "nameEN": "Shunde Rongqi Truck Inspection Field"
  },
  {
    "code": "440409",
    "nameCN": "顺德乐从车检场",
    "nameEN": "Shunde Lecong Truck Inspection Field"
  },
  {
    "code": "440410",
    "nameCN": "顺德北窖车检场",
    "nameEN": "Shunde Beiyao Truck Inspection Field"
  },
  {
    "code": "440500",
    "nameCN": "广东省汕头市",
    "nameEN": "Guangdong Sheng Shantou Shi"
  },
  {
    "code": "440501",
    "nameCN": "汕头广澳港港务公司码头",
    "nameEN": "Shantou Guangaogang Port Liability Company Dock"
  },
  {
    "code": "440502",
    "nameCN": "汕头暹罗石油气码头",
    "nameEN": "Shantou Xianluo Shiyouqi Dock"
  },
  {
    "code": "440503",
    "nameCN": "汕头海门电厂码头",
    "nameEN": "Shantou Haimen Dianchang Dock"
  },
  {
    "code": "440504",
    "nameCN": "汕头西堤码头",
    "nameEN": "Shantou Xiti Dock"
  },
  {
    "code": "440505",
    "nameCN": "汕头永泰码头",
    "nameEN": "Shantou Yongtai Dock"
  },
  {
    "code": "440506",
    "nameCN": "汕头大明石油气码头",
    "nameEN": "Shantou Daming Shiyouqi Dock"
  },
  {
    "code": "440507",
    "nameCN": "汕头华润水泥码头",
    "nameEN": "Shantou Huarun Shuini Dock"
  },
  {
    "code": "440508",
    "nameCN": "汕头港务四公司煤码头",
    "nameEN": "Shantou Gangwu Sigongsi Mei Dock"
  },
  {
    "code": "440509",
    "nameCN": "汕头港务三公司煤码头",
    "nameEN": "Shantou Gangwu Sangongsi Mei Dock"
  },
  {
    "code": "440510",
    "nameCN": "汕头国集码头",
    "nameEN": "Shantou Guoji Dock"
  },
  {
    "code": "440511",
    "nameCN": "汕头海通码头",
    "nameEN": "Shantou Haitong Dock"
  },
  {
    "code": "440512",
    "nameCN": "汕头莱芜码头",
    "nameEN": "Shantou Laiwu Dock"
  },
  {
    "code": "440513",
    "nameCN": "汕头前江码头",
    "nameEN": "Shantou Qianjiang Dock"
  },
  {
    "code": "440514",
    "nameCN": "汕头铁路装卸点",
    "nameEN": "Shantou Railway Zhuangxiedian"
  },
  {
    "code": "440515",
    "nameCN": "汕头联成车检场",
    "nameEN": "Shantou Liancheng Truck Inspection Field"
  },
  {
    "code": "440516",
    "nameCN": "汕头濠江车检场",
    "nameEN": "Shantou Haojiang Truck Inspection Field"
  },
  {
    "code": "440517",
    "nameCN": "汕头澄海车检场",
    "nameEN": "Shantou Chenghai Truck Inspection Field"
  },
  {
    "code": "440518",
    "nameCN": "汕头潮阳车检场",
    "nameEN": "Shantou Chaoyang Truck Inspection Field"
  },
  {
    "code": "440519",
    "nameCN": "揭阳潮汕机场",
    "nameEN": "Jieyang Chaoshan Airport"
  },
  {
    "code": "440520",
    "nameCN": "汕头保税区",
    "nameEN": "Shantou Free Trade Zone"
  },
  {
    "code": "440521",
    "nameCN": "汕头海门中转基地码头",
    "nameEN": "Shantou Haimen Zhongzhuan Jidi Dock"
  },
  {
    "code": "440600",
    "nameCN": "广东省佛山市",
    "nameEN": "Guangdong Sheng Foshan Shi"
  },
  {
    "code": "440601",
    "nameCN": "佛山铁路客运站",
    "nameEN": "Foshan Railway Passenger Transport Erlei"
  },
  {
    "code": "440602",
    "nameCN": "佛山澜石码头",
    "nameEN": "Foshan Lanshi Dock"
  },
  {
    "code": "440603",
    "nameCN": "佛山滘口码头",
    "nameEN": "Foshan Jiaokou Dock"
  },
  {
    "code": "440604",
    "nameCN": "佛山新港码头",
    "nameEN": "Foshan Xingang Dock"
  },
  {
    "code": "440605",
    "nameCN": "佛山车检场",
    "nameEN": "Foshan Truck Inspection Field"
  },
  {
    "code": "440700",
    "nameCN": "广东省江门市",
    "nameEN": "Guangdong Sheng Jiangmen Shi"
  },
  {
    "code": "440701",
    "nameCN": "江门港客运码头",
    "nameEN": "Jiangmen Harbor Passenger Transpor Dock"
  },
  {
    "code": "440702",
    "nameCN": "江门鹤山港客运码头",
    "nameEN": "Jiangmen Heshan Harbor Passenger Transpor Dock"
  },
  {
    "code": "440703",
    "nameCN": "江门台山核电重件码头 ",
    "nameEN": "Jiangmen Taishan Nuclear Power Zhongjian Dock"
  },
  {
    "code": "440704",
    "nameCN": "江门台山国华粤电煤码头 ",
    "nameEN": "Jiangmen Taishan Guohua Yuedian Mei Dock"
  },
  {
    "code": "440705",
    "nameCN": "江门台山公益港客运码头",
    "nameEN": "Jiangmen Taishan Gongyi Harbor Passenger Transpor Dock"
  },
  {
    "code": "440706",
    "nameCN": "江门中外运外海货柜码头",
    "nameEN": "Jiangmen Zhongwaiyun Waihai Container Dock"
  },
  {
    "code": "440707",
    "nameCN": "江门国际货柜码头",
    "nameEN": "Jiangmen Guoji Container Dock"
  },
  {
    "code": "440708",
    "nameCN": "江门荷塘码头",
    "nameEN": "Jiangmen Hetang Dock"
  },
  {
    "code": "440709",
    "nameCN": "江门台山公益码头",
    "nameEN": "Jiangmen Taishan Gongyi Dock"
  },
  {
    "code": "440710",
    "nameCN": "江门恩平横板码头",
    "nameEN": "Jiangmen Enping Hengban Dock"
  },
  {
    "code": "440711",
    "nameCN": "江门鹤山港货运码头",
    "nameEN": "Jiangmen Heshangang Freight Dock"
  },
  {
    "code": "440712",
    "nameCN": "江门车检场",
    "nameEN": "Jiangmen Truck Inspection Field"
  },
  {
    "code": "440713",
    "nameCN": "江门台山车检场",
    "nameEN": "Jiangmen Taishan Truck Inspection Field"
  },
  {
    "code": "440714",
    "nameCN": "江门鹤山车检场",
    "nameEN": "Jiangmen Heshan Truck Inspection Field"
  },
  {
    "code": "440715",
    "nameCN": "江门恩平车检场",
    "nameEN": "Jiangmen Enping Truck Inspection Field"
  },
  {
    "code": "440800",
    "nameCN": "广东省湛江市",
    "nameEN": "Guangdong Sheng Zhanjiang Shi"
  },
  {
    "code": "440801",
    "nameCN": "湛江机场",
    "nameEN": "Zhanjiang Airport"
  },
  {
    "code": "440802",
    "nameCN": "湛江港集团公司霞山港区码头",
    "nameEN": "Zhanjiang Harbor Group Company Xiashan Gangqu Dock"
  },
  {
    "code": "440803",
    "nameCN": "湛江南油码头",
    "nameEN": "Zhanjiang Nanyou Dock"
  },
  {
    "code": "440804",
    "nameCN": "湛江港集团公司调顺港区码头",
    "nameEN": "Zhanjiang Harbor Group Company Tiaoshun Gangqu Dock"
  },
  {
    "code": "440805",
    "nameCN": "湛江调顺岛电力公司码头",
    "nameEN": "Zhanjiang Tiaoshundao Dianligongsi Dock"
  },
  {
    "code": "440806",
    "nameCN": "湛江霞海港码头",
    "nameEN": "Zhanjiang Xiahai Harbor Dock"
  },
  {
    "code": "440807",
    "nameCN": "湛江霞海中外运码头",
    "nameEN": "Zhanjiang Xiahai Zhongwaiyun Dock"
  },
  {
    "code": "440808",
    "nameCN": "湛江霞山长桥码头",
    "nameEN": "Zhanjiang Xiashan Changqiao Dock"
  },
  {
    "code": "440809",
    "nameCN": "湛江徐闻海安港码头",
    "nameEN": "Zhanjiang Xuwen Haian Harbor Dock"
  },
  {
    "code": "440810",
    "nameCN": "湛江廉江营仔港码头",
    "nameEN": "Zhanjiang Lianjiang Yingzai Harbor Dock"
  },
  {
    "code": "440811",
    "nameCN": "湛江遂溪北潭港码头",
    "nameEN": "Zhanjiang Suixi Beitan Harbor Dock"
  },
  {
    "code": "440812",
    "nameCN": "湛江雷州流沙港码头",
    "nameEN": "Zhanjiang Leizhou Liusha Harbor Dock"
  },
  {
    "code": "440813",
    "nameCN": "湛江霞海港车检场",
    "nameEN": "Zhanjiang Truck Inspection Field"
  },
  {
    "code": "440814",
    "nameCN": "湛江宝满港集装箱码头",
    "nameEN": "Zhanjiang Baoman Harbor Container Dock"
  },
  {
    "code": "440815",
    "nameCN": "湛江霞山散货码头",
    "nameEN": "Zhanjiang Xiasan Sanhuo Dock"
  },
  {
    "code": "440816",
    "nameCN": "湛江东海岛宝钢基地码头",
    "nameEN": "Zhanjiang Donghaidao Baogangjidi Dock"
  },
  {
    "code": "440817",
    "nameCN": "湛江东海岛宝钢成品码头",
    "nameEN": "Zhanjiang Donghaidao Baogangchengpin Dock"
  },
  {
    "code": "440818",
    "nameCN": "湛江吴川车检场",
    "nameEN": "Zhanjiang Wuchuan Truck Inspection Field"
  },
  {
    "code": "440819",
    "nameCN": "湛江龙腾码头",
    "nameEN": "Zhanjiang longteng Dock"
  },
  {
    "code": "440820",
    "nameCN": "湛江遂溪车检场",
    "nameEN": "Zhanjiang sui'xi Truck Inspection Field"
  },
  {
    "code": "440900",
    "nameCN": "广东省茂名市",
    "nameEN": "Guangdong Sheng Maoming Shi"
  },
  {
    "code": "440901",
    "nameCN": "茂名水东港港口公司双泊位码头",
    "nameEN": "Maoming Shuidong Harbor Port company Shuangbowei Dock"
  },
  {
    "code": "440902",
    "nameCN": "茂名水东港石化公司码头",
    "nameEN": "Maoming Shuidong Harbor Petrochemical Corporation Dock"
  },
  {
    "code": "440903",
    "nameCN": "茂名水东港30万吨级单点",
    "nameEN": "Maoming Shuidong Harbor 0.3 Million Tons Jidandian"
  },
  {
    "code": "440904",
    "nameCN": "茂名水东港天源化工码头",
    "nameEN": "Maoming Shuidong Harbor Tianyuanhuagong Dock"
  },
  {
    "code": "440905",
    "nameCN": "茂名水东港港口公司公用码头",
    "nameEN": "Maoming Shuidong Harbor Port company Public Dock"
  },
  {
    "code": "440906",
    "nameCN": "茂名水东港隆港石油码头",
    "nameEN": "Maoming Shuidong Harbor Longgang Oil Dock"
  },
  {
    "code": "440907",
    "nameCN": "茂名水东港长晟综合码头",
    "nameEN": "Maoming Shuidong Harbor Changcheng Zhonghe Dock"
  },
  {
    "code": "440908",
    "nameCN": "茂名水东港天源煤炭码头",
    "nameEN": "Maoming Shuidong Harbor Tianyuan Coal Dock"
  },
  {
    "code": "440909",
    "nameCN": "茂名博贺港码头",
    "nameEN": "Maoming Bohe Harbor Dock"
  },
  {
    "code": "441001",
    "nameCN": "潮州车检场",
    "nameEN": "Chaozhou Truck Inspection Field"
  },
  {
    "code": "441101",
    "nameCN": "潮州三百门港务码头",
    "nameEN": "Chaozhou Sanbaimen Gangwu Dock"
  },
  {
    "code": "441102",
    "nameCN": "潮州三百门华丰油气码头",
    "nameEN": "Chaozhou Sanbaimen Huafeng Youqi Dock"
  },
  {
    "code": "441103",
    "nameCN": "潮州三百门恒业码头",
    "nameEN": "Chaozhou Sanbaimen Hengye Dock"
  },
  {
    "code": "441104",
    "nameCN": "潮州金狮湾华丰油气码头",
    "nameEN": "Chaozhou Jinshiwan Huafeng Youqi Dock"
  },
  {
    "code": "441105",
    "nameCN": "潮州金狮湾大唐电厂煤码头",
    "nameEN": "Chaozhou Jinshiwan Datang Dianchang Mei Dock"
  },
  {
    "code": "441106",
    "nameCN": "潮州金狮湾亚太一期码头",
    "nameEN": "Chaozhou Jinshiwan Yatai Yiqi Dock"
  },
  {
    "code": "441107",
    "nameCN": "饶平车检场",
    "nameEN": "Raoping Truck Inspection Field"
  },
  {
    "code": "441200",
    "nameCN": "广东省肇庆市",
    "nameEN": "Guangdong Sheng Zhaoqing Shi"
  },
  {
    "code": "441201",
    "nameCN": "肇庆铁路客运站",
    "nameEN": "Zhaoqing Railway Passenger Transport Erlei"
  },
  {
    "code": "441202",
    "nameCN": "肇庆港客运码头",
    "nameEN": "Zhaoqing Harbor Passenger Transpor Dock"
  },
  {
    "code": "441203",
    "nameCN": "肇庆三榕港码头",
    "nameEN": "Zhaoqing Sanrong Harbor Dock"
  },
  {
    "code": "441204",
    "nameCN": "肇庆新港码头",
    "nameEN": "Zhaoqing Xingang Dock"
  },
  {
    "code": "441205",
    "nameCN": "肇庆高要港码头",
    "nameEN": "Zhaoqing Gaoyao Harbor Dock"
  },
  {
    "code": "441206",
    "nameCN": "肇庆德庆康州码头",
    "nameEN": "Zhaoqing Deqing Kangzhou Dock"
  },
  {
    "code": "441207",
    "nameCN": "肇庆四会港码头",
    "nameEN": "Zhaoqing Sihui Harbor Dock"
  },
  {
    "code": "441208",
    "nameCN": "肇庆大旺车检场",
    "nameEN": "Zhaoqing Dawang Truck Inspection Field"
  },
  {
    "code": "441300",
    "nameCN": "广东省惠州市",
    "nameEN": "Guangdong Sheng Huizhou Shi"
  },
  {
    "code": "441301",
    "nameCN": "惠州大澳塘码头 ",
    "nameEN": "Huizhou Daaotang Dock"
  },
  {
    "code": "441302",
    "nameCN": "惠州平海电厂煤码头 ",
    "nameEN": "Huizhou Pinghai Dianchang Mei Dock"
  },
  {
    "code": "441303",
    "nameCN": "惠州碧甲码头 ",
    "nameEN": "Huizhou Bijia Dock"
  },
  {
    "code": "441304",
    "nameCN": "惠州博罗宏兴码头",
    "nameEN": "Huizhou Boluo Hongxing Dock"
  },
  {
    "code": "441305",
    "nameCN": "惠州石湾集装箱码头",
    "nameEN": "Huizhou Shiwan Container Dock"
  },
  {
    "code": "441306",
    "nameCN": "惠州车检场",
    "nameEN": "Huizhou Truck Inspection Field"
  },
  {
    "code": "441307",
    "nameCN": "惠州淡水车检场",
    "nameEN": "Huizhou Danshui Truck Inspection Field"
  },
  {
    "code": "441308",
    "nameCN": "惠州惠东车检场",
    "nameEN": "Huizhou Huidong Truck Inspection Field"
  },
  {
    "code": "441309",
    "nameCN": "惠州红海车检场",
    "nameEN": "Huizhou Honghai Truck Inspection Field"
  },
  {
    "code": "441310",
    "nameCN": "惠州园洲车检场",
    "nameEN": "Huizhou Yuanzhou Truck Inspection Field"
  },
  {
    "code": "441311",
    "nameCN": "惠州中海油基地码头",
    "nameEN": "Huizhou Zhonghaiyou Jidi Dock"
  },
  {
    "code": "441400",
    "nameCN": "广东省梅州市",
    "nameEN": "Guangdong Sheng Meizhou Shi"
  },
  {
    "code": "441401",
    "nameCN": "梅州机场",
    "nameEN": "Meizhou Airport"
  },
  {
    "code": "441402",
    "nameCN": "梅州车检场",
    "nameEN": "Meizhou Truck Inspection Field"
  },
  {
    "code": "441500",
    "nameCN": "广东省汕尾市",
    "nameEN": "Guangdong Sheng Shanwei Shi"
  },
  {
    "code": "441501",
    "nameCN": "汕尾港务码头",
    "nameEN": "Shanwei Gangwu Dock"
  },
  {
    "code": "441502",
    "nameCN": "汕尾电厂码头",
    "nameEN": "Shanwei Dianchang Dock"
  },
  {
    "code": "441503",
    "nameCN": "汕尾万聪码头",
    "nameEN": "Shanwei Wancong Dock"
  },
  {
    "code": "441504",
    "nameCN": "汕尾乌坎码头",
    "nameEN": "Shanwei Wukan Dock"
  },
  {
    "code": "441505",
    "nameCN": "汕尾海丰车检场",
    "nameEN": "Shanwei Haifeng Truck Inspection Field"
  },
  {
    "code": "441506",
    "nameCN": "汕尾陆丰车检场",
    "nameEN": "Shanwei Lufeng Truck Inspection Field"
  },
  {
    "code": "441507",
    "nameCN": "汕尾车检场",
    "nameEN": "Shanwei Truck Inspection Field"
  },
  {
    "code": "441508",
    "nameCN": "汕尾华润海丰电厂码头",
    "nameEN": "Shanwei Huarun Haifeng Dianchang Dock"
  },
  {
    "code": "441600",
    "nameCN": "广东省河源市",
    "nameEN": "Guangdong Sheng Heyuan Shi"
  },
  {
    "code": "441601",
    "nameCN": "河源车检场",
    "nameEN": "Heyuan Truck Inspection Field"
  },
  {
    "code": "441700",
    "nameCN": "广东省阳江市",
    "nameEN": "Guangdong Sheng Yangjiang Shi"
  },
  {
    "code": "441701",
    "nameCN": "阳江港务公司码头",
    "nameEN": "Yangjiang Port Liability Company Dock"
  },
  {
    "code": "441702",
    "nameCN": "阳江良港码头",
    "nameEN": "Yangjiang Lianggang Dock"
  },
  {
    "code": "441703",
    "nameCN": "阳江保丰码头",
    "nameEN": "Yangjiang Baofeng Dock"
  },
  {
    "code": "441704",
    "nameCN": "阳江闸坡码头",
    "nameEN": "Yangjiang Zhapo Dock"
  },
  {
    "code": "441705",
    "nameCN": "阳江东平码头",
    "nameEN": "Yangjiang Dongping Dock"
  },
  {
    "code": "441706",
    "nameCN": "阳江溪头港码头",
    "nameEN": "Yangjiang Xitou Harbor Dock"
  },
  {
    "code": "441707",
    "nameCN": "阳江车检场",
    "nameEN": "Yangjiang Truck Inspection Field"
  },
  {
    "code": "441708",
    "nameCN": "华夏阳西电厂码头",
    "nameEN": "Huaxia Yangxi Dianchang Dock"
  },
  {
    "code": "441800",
    "nameCN": "广东省清远市",
    "nameEN": "Guangdong Sheng Qingyuan Shi"
  },
  {
    "code": "441801",
    "nameCN": "清远新港码头",
    "nameEN": "Qingyuan Xingang Dock"
  },
  {
    "code": "441802",
    "nameCN": "清远英德码头",
    "nameEN": "Qingyuan Yingde Dock"
  },
  {
    "code": "441803",
    "nameCN": "清远铁路装卸点",
    "nameEN": "Qinyuan Railway Zhuangxiedian"
  },
  {
    "code": "441804",
    "nameCN": "清远车检场",
    "nameEN": "Qingyuan Truck Inspection Field"
  },
  {
    "code": "441900",
    "nameCN": "广东省东莞市",
    "nameEN": "Guangdong Sheng Dongguan Shi"
  },
  {
    "code": "441901",
    "nameCN": "东莞铁路客运站",
    "nameEN": "Dongguan Railway Passenger Transport Erlei"
  },
  {
    "code": "441902",
    "nameCN": "东莞虎门港客运码头",
    "nameEN": "Dongguan Humen Harbor Passenger Transpor Dock"
  },
  {
    "code": "441903",
    "nameCN": "东莞海腾码头",
    "nameEN": "Dongguan Haiteng Dock"
  },
  {
    "code": "441904",
    "nameCN": "东莞华润水泥码头 ",
    "nameEN": "Dongguan Huarun Shuini Dock"
  },
  {
    "code": "441905",
    "nameCN": "东莞金明石化码头 ",
    "nameEN": "Dongguan Jinming Petrochemicals Dock"
  },
  {
    "code": "441906",
    "nameCN": "东莞国际货柜码头 ",
    "nameEN": "Dongguan Guoji Container Dock"
  },
  {
    "code": "441907",
    "nameCN": "东莞飞虎石化码头 ",
    "nameEN": "Dongguan Feihu Petrochemicals Dock"
  },
  {
    "code": "441908",
    "nameCN": "东莞荣轩货柜码头 ",
    "nameEN": "Dongguan Rongxuan Container Dock"
  },
  {
    "code": "441909",
    "nameCN": "东莞同舟石化码头 ",
    "nameEN": "Dongguan Tongzhou Petrochemicals Dock"
  },
  {
    "code": "441910",
    "nameCN": "东莞三江石化码头 ",
    "nameEN": "Dongguan Sanjiang Petrochemicals Dock"
  },
  {
    "code": "441911",
    "nameCN": "东莞虎门港5、6号泊位",
    "nameEN": "Dongguan Humen Harbor 5-6 Bowei"
  },
  {
    "code": "441912",
    "nameCN": "东莞九丰石化码头 ",
    "nameEN": "Dongguan Jiufeng Petrochemicals Dock"
  },
  {
    "code": "441913",
    "nameCN": "东莞东洲油气化工码头 ",
    "nameEN": "Dongguan Dongzhou Youqihuagong Dock"
  },
  {
    "code": "441914",
    "nameCN": "东莞虎门港7、8号泊位",
    "nameEN": "Dongguan Humen Harbor 7-8 Bowei"
  },
  {
    "code": "441915",
    "nameCN": "东莞中海油立沙码头 ",
    "nameEN": "Dongguan CNOOC Lisha Dock"
  },
  {
    "code": "441916",
    "nameCN": "东莞南粤码头 ",
    "nameEN": "Dongguan Nanyue Dock"
  },
  {
    "code": "441917",
    "nameCN": "东莞东江口码头 ",
    "nameEN": "Dongguan Dongjiangkou Dock"
  },
  {
    "code": "441918",
    "nameCN": "东莞海昌煤码头 ",
    "nameEN": "Dongguan Haichang Mei Dock"
  },
  {
    "code": "441919",
    "nameCN": "东莞深赤湾散杂货码头 ",
    "nameEN": "Dongguan Shenchiwan Sanzahuo Dock"
  },
  {
    "code": "441920",
    "nameCN": "东莞宏业货柜码头 ",
    "nameEN": "Dongguan Hongye Container Dock"
  },
  {
    "code": "441921",
    "nameCN": "东莞沙角A电厂煤码头 ",
    "nameEN": "Dongguan Shajiao A Dianchang Mei Dock"
  },
  {
    "code": "441922",
    "nameCN": "东莞沙角B电厂煤码头 ",
    "nameEN": "Dongguan Shajiao B Dianchang Mei Dock"
  },
  {
    "code": "441923",
    "nameCN": "东莞沙角C电厂煤码头 ",
    "nameEN": "Dongguan Shajiao C Dianchang Mei Dock"
  },
  {
    "code": "441924",
    "nameCN": "东莞龙通码头",
    "nameEN": "Dongguan Longtong Dock"
  },
  {
    "code": "441925",
    "nameCN": "东莞基业码头",
    "nameEN": "Dongguan Jiye Dock"
  },
  {
    "code": "441926",
    "nameCN": "东莞中外运石龙码头",
    "nameEN": "Dongguan Zhongwaiyun Shilong Dock"
  },
  {
    "code": "441927",
    "nameCN": "东莞马士基码头",
    "nameEN": "Dongguan Mashiji Dock"
  },
  {
    "code": "441928",
    "nameCN": "东莞永安码头",
    "nameEN": "Dongguan Yongan Dock"
  },
  {
    "code": "441929",
    "nameCN": "东莞联通码头",
    "nameEN": "Dongguan Liantong Dock"
  },
  {
    "code": "441930",
    "nameCN": "常平铁路装卸点",
    "nameEN": "Changping Railway Zhuangxiedian"
  },
  {
    "code": "441931",
    "nameCN": "东莞虎门车检场",
    "nameEN": "Dongguan Humen Truck Inspection Field"
  },
  {
    "code": "441932",
    "nameCN": "东莞寮步车检场",
    "nameEN": "Dongguan Liaobu Truck Inspection Field"
  },
  {
    "code": "441933",
    "nameCN": "东莞立沙岛阳鸿石化码头",
    "nameEN": "Dongguan Lishadao Yanghongshihua Dock"
  },
  {
    "code": "441934",
    "nameCN": "东莞立沙岛鸿源油品码头",
    "nameEN": "Dongguan Lishadao Hongyuanyoupin Dock"
  },
  {
    "code": "441935",
    "nameCN": "东莞石龙铁路物流中心",
    "nameEN": "Dongguan Shilong Railway Logistics Zone"
  },
  {
    "code": "441936",
    "nameCN": "东莞联兴化工码头",
    "nameEN": "Dongguanlianxinghuagong Dock"
  },
  {
    "code": "442000",
    "nameCN": "广东省中山市",
    "nameEN": "Guangdong Sheng Zhongshan Shi"
  },
  {
    "code": "442001",
    "nameCN": "中山港货运码头",
    "nameEN": "Zhongshan Harbor Freight Dock"
  },
  {
    "code": "442002",
    "nameCN": "中山港客运码头",
    "nameEN": "Zhongshan Harbor Passenger Transpor Dock"
  },
  {
    "code": "442003",
    "nameCN": "中山港外贸码头",
    "nameEN": "Zhongshan Harbor Foreign Trade Dock"
  },
  {
    "code": "442004",
    "nameCN": "中山石岐纸厂码头",
    "nameEN": "Zhongshan Shiqi Zhichang Dock"
  },
  {
    "code": "442005",
    "nameCN": "中山水出码头",
    "nameEN": "Zhongshan Shuichu Dock"
  },
  {
    "code": "442006",
    "nameCN": "中山小榄码头",
    "nameEN": "Zhongshan Xiaolan Dock"
  },
  {
    "code": "442007",
    "nameCN": "中山神湾码头",
    "nameEN": "Zhongshan Shenwan Dock"
  },
  {
    "code": "442008",
    "nameCN": "中山小榄车检场",
    "nameEN": "Zhongshan Xiaolan Truck Inspection Field"
  },
  {
    "code": "442009",
    "nameCN": "中山保税物流中心车检场",
    "nameEN": "Zhongshan Bonded Logistics Zone Truck Inspection Field"
  },
  {
    "code": "442010",
    "nameCN": "中山神湾游艇码头",
    "nameEN": "Zhongshan Shenwan Youting Dock"
  },
  {
    "code": "442011",
    "nameCN": "中山黄圃多用途码头",
    "nameEN": "Zhongshan Huangpu Duoyongtu Dock"
  },
  {
    "code": "442101",
    "nameCN": "黄埔石化码头",
    "nameEN": "Huangpu Petrochemicals Dock"
  },
  {
    "code": "442102",
    "nameCN": "黄埔新港码头",
    "nameEN": "Huangpu Xingang Dock"
  },
  {
    "code": "442103",
    "nameCN": "黄埔集装箱码头",
    "nameEN": "Huangpu Container Dock"
  },
  {
    "code": "442104",
    "nameCN": "黄埔墩头西基码头",
    "nameEN": "Huangpu Duntou Xiji Dock"
  },
  {
    "code": "442105",
    "nameCN": "黄埔东江口码头",
    "nameEN": "Huangpu Dongjiangkou Dock"
  },
  {
    "code": "442106",
    "nameCN": "黄埔省物资码头",
    "nameEN": "Huangpu Shengwuzi Dock"
  },
  {
    "code": "442107",
    "nameCN": "黄埔广保通码头",
    "nameEN": "Huangpu Guangbaotong Dock"
  },
  {
    "code": "442108",
    "nameCN": "广州开发区东江仓码头",
    "nameEN": "Guangzhou Development Zone Dongjiangcang Dock"
  },
  {
    "code": "442109",
    "nameCN": "黄埔中外运东江仓码头",
    "nameEN": "Huangpu Zhongwaiyun Dongjiangcang Dock"
  },
  {
    "code": "442110",
    "nameCN": "中外运黄埔仓码头",
    "nameEN": "Zhongwaiyun Huangpucang Dock"
  },
  {
    "code": "442111",
    "nameCN": "黄埔庙沙围码头",
    "nameEN": "Huangpu Miaoshawei Dock"
  },
  {
    "code": "442112",
    "nameCN": "黄埔庙头建翔码头",
    "nameEN": "Huangpu Miaotou Jianxiang Dock"
  },
  {
    "code": "442113",
    "nameCN": "黄埔集通码头",
    "nameEN": "Huangpu Jitong Dock"
  },
  {
    "code": "442114",
    "nameCN": "广州开发区车检场",
    "nameEN": "Guangzhou Development Zone Truck Inspection Field"
  },
  {
    "code": "442115",
    "nameCN": "广州保税物流园区",
    "nameEN": "Guangzhou Bonded Logistics Zone"
  },
  {
    "code": "442116",
    "nameCN": "广州保税区",
    "nameEN": "Guangzhou Free Trade Zone"
  },
  {
    "code": "442117",
    "nameCN": "广州出口加工区",
    "nameEN": "Guangzhou Export Processind Zone"
  },
  {
    "code": "442201",
    "nameCN": "广州铁路客运站",
    "nameEN": "Guangzhou Railway Passenger Transport Erlei"
  },
  {
    "code": "442202",
    "nameCN": "广州东圃永业码头",
    "nameEN": "Guangzhou Dongpu Yongye Dock"
  },
  {
    "code": "442301",
    "nameCN": "广州白云国际机场",
    "nameEN": "Guangzhou Baiyun International Airport"
  },
  {
    "code": "442302",
    "nameCN": "广州白云机场综合保税区",
    "nameEN": "Guangzhou Baiyun Airport Comprehensive Bonded Zone"
  },
  {
    "code": "442401",
    "nameCN": "番禺莲花山客运港",
    "nameEN": "Panyu Lianhuashan Passenger Transpor Harbor"
  },
  {
    "code": "442402",
    "nameCN": "番禺莲花山货运港",
    "nameEN": "Panyu Lianhuashan Freight Harbor"
  },
  {
    "code": "442403",
    "nameCN": "番禺沙湾车检场",
    "nameEN": "Panyu Shawan Truck Inspection Field"
  },
  {
    "code": "442501",
    "nameCN": "花都港码头",
    "nameEN": "Huadu Harbor Dock"
  },
  {
    "code": "442502",
    "nameCN": "花都车检场",
    "nameEN": "Huadu Truck Inspection Field"
  },
  {
    "code": "442601",
    "nameCN": "增城新塘港客运码头",
    "nameEN": "Zengcheng Xintang Harbor Passenger Transpor Dock"
  },
  {
    "code": "442602",
    "nameCN": "增城新塘东洲湾码头",
    "nameEN": "Zengcheng Xintang Dongzhouwan Dock"
  },
  {
    "code": "442603",
    "nameCN": "增城新塘口岸码头",
    "nameEN": "Zengcheng Xintang Kouan Dock"
  },
  {
    "code": "442604",
    "nameCN": "增城新塘食出码头",
    "nameEN": "Zengcheng Xintang Shichu Dock"
  },
  {
    "code": "442605",
    "nameCN": "增城新塘车检场",
    "nameEN": "Zengcheng Xintang Truck Inspection Field"
  },
  {
    "code": "442701",
    "nameCN": "从化车检场",
    "nameEN": "Conghua Truck Inspection Field"
  },
  {
    "code": "442801",
    "nameCN": "江门天马码头 ",
    "nameEN": "Jiangmen Tianma Dock"
  },
  {
    "code": "442802",
    "nameCN": "江门新会电厂码头 ",
    "nameEN": "Jiangmen Xinhui Dianchang Dock"
  },
  {
    "code": "442803",
    "nameCN": "江门银湖修船码头 ",
    "nameEN": "Jiangmen Yinhu Xiuchuan Dock"
  },
  {
    "code": "442804",
    "nameCN": "江门宜大化工码头 ",
    "nameEN": "Jiangmen Yida Huagong Dock"
  },
  {
    "code": "442805",
    "nameCN": "新会港客运码头",
    "nameEN": "Xinhui Harbor Passenger Transpor Dock"
  },
  {
    "code": "442806",
    "nameCN": "新会西河口码头",
    "nameEN": "Xinhui Xihekou Dock"
  },
  {
    "code": "442807",
    "nameCN": "新会今古洲码头",
    "nameEN": "Xinhui Jinguzhou Dock"
  },
  {
    "code": "442808",
    "nameCN": "新会睦洲糖纸厂码头",
    "nameEN": "Xinhui Muzhoutang Zhichang Dock"
  },
  {
    "code": "442809",
    "nameCN": "新会大敖集装箱厂码头",
    "nameEN": "Xinhui Daao Container Plant Dock"
  },
  {
    "code": "442810",
    "nameCN": "新会崖门沙石泥码头",
    "nameEN": "Xinhui Yamen Shashini Dock"
  },
  {
    "code": "442811",
    "nameCN": "新会崖西沙石泥码头",
    "nameEN": "Xinhui Yaxi Shashini Dock"
  },
  {
    "code": "442812",
    "nameCN": "新会牛牯岭易燃品码头",
    "nameEN": "Xinhui Niuguling Inflammable Substance Dock"
  },
  {
    "code": "442813",
    "nameCN": "新会车检场",
    "nameEN": "Xinhui Truck Inspection Field"
  },
  {
    "code": "442814",
    "nameCN": "新会航建码头",
    "nameEN": "Xinhui Hangjian Dock"
  },
  {
    "code": "442901",
    "nameCN": "江门三埠港客运码头",
    "nameEN": "Jiangmen Sanbu Harbor Passenger Transpor Dock"
  },
  {
    "code": "442902",
    "nameCN": "江门三埠港货运码头",
    "nameEN": "Jiangmen Sanbugang Freight Dock"
  },
  {
    "code": "442903",
    "nameCN": "江门水口码头",
    "nameEN": "Jiangmen Shuikou Dock"
  },
  {
    "code": "442904",
    "nameCN": "开平车检场",
    "nameEN": "Kaiping Truck Inspection Field"
  },
  {
    "code": "443001",
    "nameCN": "高明港客运码头",
    "nameEN": "Gaoming Harbor Passenger Transpor Dock"
  },
  {
    "code": "443002",
    "nameCN": "高明食出码头",
    "nameEN": "Gaoming Shichu Dock"
  },
  {
    "code": "443003",
    "nameCN": "高明珠江码头",
    "nameEN": "Gaoming Zhujiang Dock"
  },
  {
    "code": "443004",
    "nameCN": "高明车检场",
    "nameEN": "Gaoming Truck Inspection Field"
  },
  {
    "code": "443101",
    "nameCN": "惠州港通用码头 ",
    "nameEN": "Huizhou Harbor Tongyong Dock"
  },
  {
    "code": "443102",
    "nameCN": "惠州港油气码头 ",
    "nameEN": "Huizhou Harbor Youqi Dock"
  },
  {
    "code": "443103",
    "nameCN": "惠州大港石化码头 ",
    "nameEN": "Huizhou Dagang Petrochemicals Dock"
  },
  {
    "code": "443104",
    "nameCN": "惠州泽华石化码头 ",
    "nameEN": "Huizhou Zehua Petrochemicals Dock"
  },
  {
    "code": "443105",
    "nameCN": "惠州国际集装箱码头",
    "nameEN": "Huizhou Guoji Container Dock"
  },
  {
    "code": "443106",
    "nameCN": "惠州马鞭洲石化码头 ",
    "nameEN": "Huizhou Mabianzhou Petrochemicals Dock"
  },
  {
    "code": "443107",
    "nameCN": "惠州中海壳牌马鞭洲码头 ",
    "nameEN": "Huizhou Zhonghai Qiaopai Mabianzhou Dock"
  },
  {
    "code": "443108",
    "nameCN": "惠州中海壳牌东联码头 ",
    "nameEN": "Huizhou Zhonghai Qiaopai Donglian Dock"
  },
  {
    "code": "443109",
    "nameCN": "惠州中海炼油马鞭洲码头",
    "nameEN": "Huizhou Zhonghai Lianyou Mabianzhou Dock"
  },
  {
    "code": "443110",
    "nameCN": "惠州中海炼油东联码头",
    "nameEN": "Huizhou Zhonghai Lianyou Donglian Dock"
  },
  {
    "code": "443111",
    "nameCN": "大亚湾石化区公用石化码头",
    "nameEN": "Dayawan Shihuaqu Gongyong Petrochemicals Dock"
  },
  {
    "code": "443201",
    "nameCN": "揭阳榕江泰丰码头",
    "nameEN": "Jieyang Rongjiang Taifeng Dock"
  },
  {
    "code": "443202",
    "nameCN": "揭阳靖海惠来电厂码头",
    "nameEN": "Jieyang Jinghai Huilai Dianchang Dock"
  },
  {
    "code": "443203",
    "nameCN": "揭阳曲溪码头",
    "nameEN": "Jieyang Quxi Dock"
  },
  {
    "code": "443204",
    "nameCN": "揭阳车检场",
    "nameEN": "Jieyang Truck Inspection Field"
  },
  {
    "code": "443205",
    "nameCN": "揭阳惠来车检场",
    "nameEN": "Jieyang Huilai Truck Inspection Field"
  },
  {
    "code": "443206",
    "nameCN": "揭阳普宁车检场",
    "nameEN": "Jieyang Puning Truck Inspection Field"
  },
  {
    "code": "443207",
    "nameCN": "揭阳神泉中海油码头",
    "nameEN": "Jieyang Shenquan Zhonghaiyou Dock"
  },
  {
    "code": "443301",
    "nameCN": "云浮新港",
    "nameEN": "Yunfu Xingang"
  },
  {
    "code": "443302",
    "nameCN": "云浮罗定车检场",
    "nameEN": "Yunfu Luoding Truck Inspection Field"
  },
  {
    "code": "443303",
    "nameCN": "云浮车检场",
    "nameEN": "Yunfu Truck Inspection Field"
  },
  {
    "code": "443401",
    "nameCN": "南沙港客运码头",
    "nameEN": "Nansha Harbor Passenger Transpor Dock"
  },
  {
    "code": "443402",
    "nameCN": "南沙南伟码头",
    "nameEN": "Nansha Nanwei Dock"
  },
  {
    "code": "443403",
    "nameCN": "南沙东发码头",
    "nameEN": "Nansha Dongfa Dock"
  },
  {
    "code": "443404",
    "nameCN": "南沙港一期码头",
    "nameEN": "Nansha Harbor Yiqi Dock"
  },
  {
    "code": "443405",
    "nameCN": "南沙港二期码头",
    "nameEN": "Nansha Harbor Erqi Dock"
  },
  {
    "code": "443406",
    "nameCN": "南沙汽车码头",
    "nameEN": "Nansha Qiche Dock"
  },
  {
    "code": "443407",
    "nameCN": "南沙港发石化码头",
    "nameEN": "Nansha Gangfa Petrochemicals Dock"
  },
  {
    "code": "443408",
    "nameCN": "南沙小虎石化码头",
    "nameEN": "Nansha Xiaohu Petrochemicals Dock"
  },
  {
    "code": "443409",
    "nameCN": "南沙华润热电煤码头",
    "nameEN": "Nansha Huarun Redianmei Dock"
  },
  {
    "code": "443410",
    "nameCN": "南沙粤海石化码头",
    "nameEN": "Nansha Yuehai Petrochemicals Dock"
  },
  {
    "code": "443411",
    "nameCN": "南沙珠江电厂码头",
    "nameEN": "Nansha Zhujiang Dianchang Dock"
  },
  {
    "code": "443412",
    "nameCN": "南沙中石油码头",
    "nameEN": "Nansha CNPC Dock"
  },
  {
    "code": "443413",
    "nameCN": "南沙中船龙穴船舶维修码头",
    "nameEN": "Nansha Zhongchuan Longxue Chuanbo Weixiu Dock"
  },
  {
    "code": "443414",
    "nameCN": "南沙港建液化气码头",
    "nameEN": "Nansha Harbor Jianyehuaqi Dock"
  },
  {
    "code": "443415",
    "nameCN": "南沙车检场",
    "nameEN": "Nansha Truck Inspection Field"
  },
  {
    "code": "443416",
    "nameCN": "广州南沙保税港区",
    "nameEN": "Guangzhou Nansha Free Trade Port Zone"
  },
  {
    "code": "443417",
    "nameCN": "南沙港三期码头",
    "nameEN": "Nansha Harbor Sanqi Dock"
  },
  {
    "code": "445100",
    "nameCN": "广东省潮州市",
    "nameEN": "Guangdong Sheng Chaozhou Shi"
  },
  {
    "code": "445200",
    "nameCN": "广东省揭阳市",
    "nameEN": "Guangdong Sheng Jieping Shi"
  },
  {
    "code": "445300",
    "nameCN": "广东省云浮市",
    "nameEN": "Guangdong Sheng Yunfu Shi"
  },
  {
    "code": "450001",
    "nameCN": "南宁",
    "nameEN": "Nanning"
  },
  {
    "code": "450002",
    "nameCN": "南宁吴圩机场",
    "nameEN": "Nanning Wuxu Airport"
  },
  {
    "code": "450101",
    "nameCN": "梧州",
    "nameEN": "Wuzhou"
  },
  {
    "code": "450200",
    "nameCN": "广西壮族自治区柳州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Liuzhou Shi"
  },
  {
    "code": "450201",
    "nameCN": "北海福成机场",
    "nameEN": "Beihai Fucheng Airport"
  },
  {
    "code": "450202",
    "nameCN": "北海",
    "nameEN": "Beihai"
  },
  {
    "code": "450203",
    "nameCN": "石头埠",
    "nameEN": "Shitoubu"
  },
  {
    "code": "450204",
    "nameCN": "北海出口加工区",
    "nameEN": "Beihai Export Processind Zone"
  },
  {
    "code": "450300",
    "nameCN": "广西壮族自治区桂林市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Guilin Shi"
  },
  {
    "code": "450301",
    "nameCN": "防城",
    "nameEN": "Fangcheng"
  },
  {
    "code": "450302",
    "nameCN": "茅岭",
    "nameEN": "Maoling"
  },
  {
    "code": "450303",
    "nameCN": "企沙",
    "nameEN": "Qisha"
  },
  {
    "code": "450400",
    "nameCN": "广西壮族自治区梧州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Wuzhou Shi"
  },
  {
    "code": "450401",
    "nameCN": "凭祥友谊关公路",
    "nameEN": "Pingxiang Youyiguan Highroad"
  },
  {
    "code": "450402",
    "nameCN": "凭祥友谊关通道",
    "nameEN": "Pingxiang Youyiguan Tongdao"
  },
  {
    "code": "450403",
    "nameCN": "凭祥浦寨通道",
    "nameEN": "Pingxiang Puzhai Tongdao"
  },
  {
    "code": "450404",
    "nameCN": "凭祥弄尧通道",
    "nameEN": "Pingxinag Nongyao Tongdao"
  },
  {
    "code": "450405",
    "nameCN": "凭祥站",
    "nameEN": "Pingxinagzhan"
  },
  {
    "code": "450406",
    "nameCN": "爱店",
    "nameEN": "Aidian"
  },
  {
    "code": "450407",
    "nameCN": "凭祥综合保税区",
    "nameEN": "Pingxiang Comprehensive Bonded Zone"
  },
  {
    "code": "450500",
    "nameCN": "广西壮族自治区北海市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Beihai Shi"
  },
  {
    "code": "450501",
    "nameCN": "水口",
    "nameEN": "Shuikou"
  },
  {
    "code": "450502",
    "nameCN": "硕龙",
    "nameEN": "Shuolong"
  },
  {
    "code": "450600",
    "nameCN": "广西壮族自治区防城港市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Fangchenggang Shi"
  },
  {
    "code": "450601",
    "nameCN": "东兴",
    "nameEN": "Dongxing"
  },
  {
    "code": "450602",
    "nameCN": "江平",
    "nameEN": "Jiangping"
  },
  {
    "code": "450603",
    "nameCN": "江山",
    "nameEN": "Jiangshan"
  },
  {
    "code": "450604",
    "nameCN": "峒中",
    "nameEN": "Tongzhong"
  },
  {
    "code": "450700",
    "nameCN": "广西壮族自治区钦州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Qinzhou Shi"
  },
  {
    "code": "450701",
    "nameCN": "果子山",
    "nameEN": "Guozishan"
  },
  {
    "code": "450702",
    "nameCN": "钦州",
    "nameEN": "Qinzhou"
  },
  {
    "code": "450800",
    "nameCN": "广西壮族自治区贵港市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Guigang Shi"
  },
  {
    "code": "450801",
    "nameCN": "桂林两江国际机场",
    "nameEN": "Guilin Liangjiang International Airport"
  },
  {
    "code": "450900",
    "nameCN": "广西壮族自治区玉林市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Yulin Shi"
  },
  {
    "code": "450901",
    "nameCN": "柳州",
    "nameEN": "Liuzhou"
  },
  {
    "code": "451000",
    "nameCN": "广西壮族自治区百色市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Bose Shi"
  },
  {
    "code": "451100",
    "nameCN": "广西壮族自治区贺州市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Hezhou Shi"
  },
  {
    "code": "451101",
    "nameCN": "贵港",
    "nameEN": "Guigang"
  },
  {
    "code": "451200",
    "nameCN": "广西壮族自治区河池市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Hechi Shi"
  },
  {
    "code": "451201",
    "nameCN": "岳圩",
    "nameEN": "Yuexu"
  },
  {
    "code": "451202",
    "nameCN": "龙邦",
    "nameEN": "Longbang"
  },
  {
    "code": "451203",
    "nameCN": "平孟",
    "nameEN": "Pingmeng"
  },
  {
    "code": "451300",
    "nameCN": "广西壮族自治区来宾市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Laibin Shi"
  },
  {
    "code": "451301",
    "nameCN": "钦州保税港区",
    "nameEN": "Qinzhou Free Trade Port Zone"
  },
  {
    "code": "451400",
    "nameCN": "广西壮族自治区崇左市",
    "nameEN": "Guangxi Zhuangzu Zizhiqu Chongzuo Shi"
  },
  {
    "code": "451501",
    "nameCN": "南宁港",
    "nameEN": "Nanning Harbor"
  },
  {
    "code": "460001",
    "nameCN": "海口",
    "nameEN": "Haikou"
  },
  {
    "code": "460002",
    "nameCN": "海口港",
    "nameEN": "Haikou Harbor"
  },
  {
    "code": "460003",
    "nameCN": "马村港",
    "nameEN": "Macun Harbor"
  },
  {
    "code": "460004",
    "nameCN": "海口综合保税区",
    "nameEN": "Haikou Comprehensive Bonded Zone"
  },
  {
    "code": "460005",
    "nameCN": "洋浦保税港区",
    "nameEN": "Yangpu Free Trade Port Zone"
  },
  {
    "code": "460101",
    "nameCN": "三亚凤凰国际机场",
    "nameEN": "Sanya Fenghuang International Airport"
  },
  {
    "code": "460102",
    "nameCN": "三亚港",
    "nameEN": "Sanya Harbor"
  },
  {
    "code": "460200",
    "nameCN": "海南省三亚市",
    "nameEN": "Hainan Sheng Sanya Shi"
  },
  {
    "code": "460201",
    "nameCN": "八所港",
    "nameEN": "Basuo Harbor"
  },
  {
    "code": "460300",
    "nameCN": "海南省三沙市",
    "nameEN": "Hainan Sheng Sansha Shi"
  },
  {
    "code": "460301",
    "nameCN": "洋浦港 ",
    "nameEN": "Yangpu Harbor"
  },
  {
    "code": "460302",
    "nameCN": "洋浦神头港",
    "nameEN": "Yangpu Shentou Harbor"
  },
  {
    "code": "460400",
    "nameCN": "海南省儋州市",
    "nameEN": "Hainan Sheng Danzhou Shi"
  },
  {
    "code": "460401",
    "nameCN": "清澜港",
    "nameEN": "Qinglan Harbor"
  },
  {
    "code": "460402",
    "nameCN": "铺前",
    "nameEN": "Puqian"
  },
  {
    "code": "460403",
    "nameCN": "琼海潭门",
    "nameEN": "Qionghai Tanmen"
  },
  {
    "code": "460501",
    "nameCN": "海口美兰机场",
    "nameEN": "Haikou Meilan Airport"
  },
  {
    "code": "469000",
    "nameCN": "海南省省直辖县级行政区划",
    "nameEN": "Hainan Sheng Sheng Zhixia Xianji Xingzhengquhua"
  },
  {
    "code": "470001",
    "nameCN": "深圳",
    "nameEN": "Shenzhen"
  },
  {
    "code": "470101",
    "nameCN": "蛇口",
    "nameEN": "Shekou"
  },
  {
    "code": "470102",
    "nameCN": "赤湾",
    "nameEN": "Chiwan"
  },
  {
    "code": "470103",
    "nameCN": "东角头",
    "nameEN": "Dongjiaotou"
  },
  {
    "code": "470104",
    "nameCN": "妈湾1号泊位",
    "nameEN": "Mawan 1 Bowei"
  },
  {
    "code": "470105",
    "nameCN": "妈湾2号泊位",
    "nameEN": "Mawan 2 Bowei"
  },
  {
    "code": "470106",
    "nameCN": "妈湾3号泊位",
    "nameEN": "Mawan 3 Bowei"
  },
  {
    "code": "470107",
    "nameCN": "妈湾4号泊位",
    "nameEN": "Mawan 4 Bowei"
  },
  {
    "code": "470201",
    "nameCN": "皇岗",
    "nameEN": "Huanggang"
  },
  {
    "code": "470202",
    "nameCN": "福田",
    "nameEN": "Futian"
  },
  {
    "code": "470301",
    "nameCN": "罗湖",
    "nameEN": "Luhu"
  },
  {
    "code": "470401",
    "nameCN": "文锦渡",
    "nameEN": "Wenjindu"
  },
  {
    "code": "470501",
    "nameCN": "沙头角",
    "nameEN": "Shatoujiao"
  },
  {
    "code": "470502",
    "nameCN": "中英街桥头",
    "nameEN": "Zhongyingjie Qiaotou"
  },
  {
    "code": "470503",
    "nameCN": "深圳沙头角保税区",
    "nameEN": "Shenzhen Shatoujiao Free Trade Zone"
  },
  {
    "code": "470601",
    "nameCN": "盐田",
    "nameEN": "Yantian"
  },
  {
    "code": "470602",
    "nameCN": "下洞码头",
    "nameEN": "Xiadong Dock"
  },
  {
    "code": "470603",
    "nameCN": "LNG码头",
    "nameEN": "LNG Dock"
  },
  {
    "code": "470604",
    "nameCN": "沙鱼冲",
    "nameEN": "Shayuchong"
  },
  {
    "code": "470605",
    "nameCN": "深圳盐田保税物流园区",
    "nameEN": "Shenzhen Yantian Bonded Logistics Zone"
  },
  {
    "code": "470606",
    "nameCN": "深圳盐田保税区",
    "nameEN": "Shenzhen Yantian Free Trade Zone"
  },
  {
    "code": "470701",
    "nameCN": "大亚湾",
    "nameEN": "Dayawan"
  },
  {
    "code": "471001",
    "nameCN": "深圳宝安国际机场",
    "nameEN": "Shenzhen Baoan International Airport"
  },
  {
    "code": "471002",
    "nameCN": "福永码头",
    "nameEN": "Fuyong Dock"
  },
  {
    "code": "471003",
    "nameCN": "机场油轮码头",
    "nameEN": "Jichang Youlun Dock"
  },
  {
    "code": "471101",
    "nameCN": "深圳福田保税区",
    "nameEN": "Shenzhen Futian Free Trade Zone"
  },
  {
    "code": "471301",
    "nameCN": "深圳出口加工区",
    "nameEN": "Shenzhen Export Processind Zone"
  },
  {
    "code": "471401",
    "nameCN": "深圳湾",
    "nameEN": "Shenzhenwan"
  },
  {
    "code": "471601",
    "nameCN": "大铲湾",
    "nameEN": "Dachanwan"
  },
  {
    "code": "471801",
    "nameCN": "妈湾5号泊位",
    "nameEN": "Mawan 5 Bowei"
  },
  {
    "code": "471802",
    "nameCN": "妈湾6号泊位",
    "nameEN": "Mawan 6 Bowei"
  },
  {
    "code": "471803",
    "nameCN": "妈湾7号泊位",
    "nameEN": "Mawan 7 Bowei"
  },
  {
    "code": "471804",
    "nameCN": "深圳前海湾保税港区",
    "nameEN": "Shenzhen Qianhaiwan Free Trade Port Zone"
  },
  {
    "code": "480001",
    "nameCN": "珠海",
    "nameEN": "Zhuhai"
  },
  {
    "code": "480002",
    "nameCN": "拱北货场",
    "nameEN": "Gongbei Huochang"
  },
  {
    "code": "480003",
    "nameCN": "拱北旅检通道",
    "nameEN": "Gongbei Passenger-Inspection Tongdao"
  },
  {
    "code": "480004",
    "nameCN": "香洲",
    "nameEN": "Xiangzhou"
  },
  {
    "code": "480005",
    "nameCN": "九洲货运码头",
    "nameEN": "Jiuzhou Freight Dock"
  },
  {
    "code": "480006",
    "nameCN": "九洲客运码头",
    "nameEN": "Jiuzhou Passenger Transpor Dock"
  },
  {
    "code": "480007",
    "nameCN": "九洲白石货场",
    "nameEN": "Jiuzhou Baishi Huochang"
  },
  {
    "code": "480008",
    "nameCN": "湾仔豪通码头",
    "nameEN": "Wanzai Haotong Dock"
  },
  {
    "code": "480009",
    "nameCN": "湾仔客运码头",
    "nameEN": "Wanzai Passenger Transpor Dock"
  },
  {
    "code": "480010",
    "nameCN": "湾仔西域码头",
    "nameEN": "Wanzai Xiyu Dock"
  },
  {
    "code": "480011",
    "nameCN": "珠海保税区加华码头",
    "nameEN": "Zhuhai Free Trade Zone Jiahua Dock"
  },
  {
    "code": "480012",
    "nameCN": "珠海保税区货场",
    "nameEN": "Zhuhai Free Trade Zone Huochang"
  },
  {
    "code": "480013",
    "nameCN": "珠澳跨境工业区（珠海园区）货场",
    "nameEN": "Zhuao Cross Bonded Industrial Zone Huochang"
  },
  {
    "code": "480014",
    "nameCN": "珠澳跨境工业区（珠海园区）旅检通道",
    "nameEN": "Zhuao Cross Bonded Industrial Zone Passenger-Inspection Tongdao"
  },
  {
    "code": "480015",
    "nameCN": "湾仔洪湾码头",
    "nameEN": "Wanzai Hongwan Dock"
  },
  {
    "code": "480101",
    "nameCN": "斗门客运码头",
    "nameEN": "Doumen Passenger Transpor Dock"
  },
  {
    "code": "480102",
    "nameCN": "斗门新环码头",
    "nameEN": "Doumen Xinhuan Dock"
  },
  {
    "code": "480201",
    "nameCN": "高栏",
    "nameEN": "Gaolan"
  },
  {
    "code": "480202",
    "nameCN": "平沙新码头",
    "nameEN": "Pingsha Xinmatou"
  },
  {
    "code": "480301",
    "nameCN": "万山",
    "nameEN": "Wanshan"
  },
  {
    "code": "480401",
    "nameCN": "横琴",
    "nameEN": "Hengqin"
  },
  {
    "code": "500001",
    "nameCN": "重庆",
    "nameEN": "Chongqing"
  },
  {
    "code": "500002",
    "nameCN": "重庆港",
    "nameEN": "Chongqing Harbor"
  },
  {
    "code": "500101",
    "nameCN": "万州",
    "nameEN": "Wanzhou"
  },
  {
    "code": "500201",
    "nameCN": "九龙坡港",
    "nameEN": "Jiulongpo Harbor"
  },
  {
    "code": "500401",
    "nameCN": "重庆两路寸滩保税港区水港",
    "nameEN": "Chongqing Lianglucuntan Free Trade Port Zone Shuigang"
  },
  {
    "code": "500402",
    "nameCN": "重庆两路寸滩保税港区空港",
    "nameEN": "Chongqing Lianglucuntan Free Trade Port Zone Konggang"
  },
  {
    "code": "500501",
    "nameCN": "重庆西永综合保税区",
    "nameEN": "Chongqing Xiyong Comprehensive Bonded Zone"
  },
  {
    "code": "500601",
    "nameCN": "重庆江北国际机场",
    "nameEN": "Chongqing Jiangbei International Airport"
  },
  {
    "code": "510001",
    "nameCN": "成都",
    "nameEN": "Chengdu"
  },
  {
    "code": "510002",
    "nameCN": "成都国际邮件互换局",
    "nameEN": "Chengdu Guoji Youjian Huhuanju"
  },
  {
    "code": "510003",
    "nameCN": "成都双流国际机场T1航站楼",
    "nameEN": "Chengdu Shuangliu International Airport T1"
  },
  {
    "code": "510004",
    "nameCN": "成都双流国际机场货场",
    "nameEN": "Chengdu Shuangliu International Airport Huochang"
  },
  {
    "code": "510005",
    "nameCN": "成都双流国际机场国际快件",
    "nameEN": "Chengdu Shuangliu International Airport Kuaijian"
  },
  {
    "code": "510006",
    "nameCN": "宜宾港",
    "nameEN": "Yibin Harbor"
  },
  {
    "code": "510007",
    "nameCN": "成都龙泉驿",
    "nameEN": "Chengdu Longquanyi"
  },
  {
    "code": "510008",
    "nameCN": "成都青白江",
    "nameEN": "Chengdu Qingbaijiang"
  },
  {
    "code": "510101",
    "nameCN": "攀枝花",
    "nameEN": "Panzihua"
  },
  {
    "code": "510300",
    "nameCN": "四川省自贡市",
    "nameEN": "Sichuan Sheng Zigong Shi"
  },
  {
    "code": "510400",
    "nameCN": "四川省攀枝花市",
    "nameEN": "Sichuan Sheng Panzhihua Shi"
  },
  {
    "code": "510401",
    "nameCN": "乐山",
    "nameEN": "Leshan"
  },
  {
    "code": "510500",
    "nameCN": "四川省泸州市",
    "nameEN": "Sichuan Sheng Luzhou Shi"
  },
  {
    "code": "510600",
    "nameCN": "四川省德阳市",
    "nameEN": "Sichuan Sheng Deyang Shi"
  },
  {
    "code": "510601",
    "nameCN": "绵阳",
    "nameEN": "Mianyang"
  },
  {
    "code": "510602",
    "nameCN": "绵阳出口加工区",
    "nameEN": "Mianyang Export Processind Zone"
  },
  {
    "code": "510700",
    "nameCN": "四川省绵阳市",
    "nameEN": "Sichuan Sheng Mianyang Shi"
  },
  {
    "code": "510701",
    "nameCN": "泸州港",
    "nameEN": "Luzhou Harbor"
  },
  {
    "code": "510800",
    "nameCN": "四川省广元市",
    "nameEN": "Sichuan Sheng Guangyuan Shi"
  },
  {
    "code": "510900",
    "nameCN": "四川省遂宁市",
    "nameEN": "Sichuan Sheng Suining Shi"
  },
  {
    "code": "511000",
    "nameCN": "四川省内江市",
    "nameEN": "Sichuan Sheng Neijiang Shi"
  },
  {
    "code": "511001",
    "nameCN": "成都高新综合保税区双流园区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Shuangliu Yuanqu"
  },
  {
    "code": "511002",
    "nameCN": "成都高新综合保税区A区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Zone A"
  },
  {
    "code": "511003",
    "nameCN": "成都高新综合保税区B区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Zone B"
  },
  {
    "code": "511004",
    "nameCN": "成都高新综合保税区C区",
    "nameEN": "Chengdu Gaoxin Comprehensive Bonded Zone Zone C"
  },
  {
    "code": "511100",
    "nameCN": "四川省乐山市",
    "nameEN": "Sichuan Sheng Leshan Shi"
  },
  {
    "code": "511300",
    "nameCN": "四川省南充市",
    "nameEN": "Sichuan Sheng Nanchong Shi"
  },
  {
    "code": "511400",
    "nameCN": "四川省眉山市",
    "nameEN": "Sichuan Sheng Meishan Shi"
  },
  {
    "code": "511500",
    "nameCN": "四川省宜宾市",
    "nameEN": "Sichuan Sheng Yibin Shi"
  },
  {
    "code": "511600",
    "nameCN": "四川省广安市",
    "nameEN": "Sichuan Sheng Guang'an Shi"
  },
  {
    "code": "511700",
    "nameCN": "四川省达州市",
    "nameEN": "Sichuan Sheng Dachuan Shi"
  },
  {
    "code": "511800",
    "nameCN": "四川省雅安市",
    "nameEN": "Sichuan Sheng Ya'an Shi"
  },
  {
    "code": "511900",
    "nameCN": "四川省巴中市",
    "nameEN": "Sichuan Sheng Bazhong Shi"
  },
  {
    "code": "512000",
    "nameCN": "四川省资阳市",
    "nameEN": "Sichuan Sheng Ziyang Shi"
  },
  {
    "code": "513200",
    "nameCN": "四川省阿坝藏族羌族自治州",
    "nameEN": "Sichuan Sheng Aba Zangzu Qiangzu Zizhizhou"
  },
  {
    "code": "513300",
    "nameCN": "四川省甘孜藏族自治州",
    "nameEN": "Sichuan Sheng Garze Zangzu Zizhizhou"
  },
  {
    "code": "513400",
    "nameCN": "四川省凉山彝族自治州",
    "nameEN": "Sichuan Sheng Liangshan Yizu Zizhizhou"
  },
  {
    "code": "520001",
    "nameCN": "贵阳",
    "nameEN": "Guiyang"
  },
  {
    "code": "520002",
    "nameCN": "贵阳龙洞堡机场",
    "nameEN": "Guiyang Longdongbao Airport"
  },
  {
    "code": "520003",
    "nameCN": "贵阳综合保税区",
    "nameEN": "Guiyang Comprehensive Bonded Zone"
  },
  {
    "code": "520004",
    "nameCN": "贵安综合保税区",
    "nameEN": "Gui'an Comprehensive Bonded Zone"
  },
  {
    "code": "520200",
    "nameCN": "贵州省六盘水市",
    "nameEN": "Guizhou Sheng Lupanshui Shi"
  },
  {
    "code": "520300",
    "nameCN": "贵州省遵义市",
    "nameEN": "Guizhou Sheng Zunyi Shi"
  },
  {
    "code": "520400",
    "nameCN": "贵州省安顺市",
    "nameEN": "Guizhou Sheng Anshun Shi"
  },
  {
    "code": "520500",
    "nameCN": "贵州省毕节市",
    "nameEN": "Guizhou Sheng Bijie Shi"
  },
  {
    "code": "520600",
    "nameCN": "贵州省铜仁市",
    "nameEN": "Guizhou Sheng Tongren Shi"
  },
  {
    "code": "522300",
    "nameCN": "贵州省黔西南布依族苗族自治州",
    "nameEN": "Guizhou Sheng Qianxinan Buyeizu Miaozu Zizhizhou"
  },
  {
    "code": "522600",
    "nameCN": "贵州省黔东南苗族侗族自治州",
    "nameEN": "Guizhou Sheng Qiandongnan Miaozu Dongzu Zizhizhou"
  },
  {
    "code": "522700",
    "nameCN": "贵州省黔南布依族苗族自治州",
    "nameEN": "Guizhou Sheng Qiannan Buyeizu Miaozu Zizhizhou"
  },
  {
    "code": "530001",
    "nameCN": "昆明",
    "nameEN": "Kunming"
  },
  {
    "code": "530002",
    "nameCN": "昆明出口加工区",
    "nameEN": "Kunming Export Processind Zone"
  },
  {
    "code": "530003",
    "nameCN": "昆明综合保税区",
    "nameEN": "Kunming Comprehensive Bonded Zone"
  },
  {
    "code": "530101",
    "nameCN": "瑞丽",
    "nameEN": "Ruili"
  },
  {
    "code": "530102",
    "nameCN": "姐告",
    "nameEN": "Jiegao"
  },
  {
    "code": "530103",
    "nameCN": "弄岛",
    "nameEN": "Nongdao"
  },
  {
    "code": "530104",
    "nameCN": "畹町",
    "nameEN": "Wanding"
  },
  {
    "code": "530201",
    "nameCN": "芒市",
    "nameEN": "Mangshi"
  },
  {
    "code": "530202",
    "nameCN": "盈江",
    "nameEN": "Yingjiang"
  },
  {
    "code": "530203",
    "nameCN": "章凤",
    "nameEN": "Zhangfeng"
  },
  {
    "code": "530300",
    "nameCN": "云南省曲靖市",
    "nameEN": "Yunnan Sheng Qujing Shi"
  },
  {
    "code": "530301",
    "nameCN": "腾冲",
    "nameEN": "Tengchong"
  },
  {
    "code": "530302",
    "nameCN": "猴桥",
    "nameEN": "Houqiao"
  },
  {
    "code": "530303",
    "nameCN": "滇滩",
    "nameEN": "Diantan"
  },
  {
    "code": "530400",
    "nameCN": "云南省玉溪市",
    "nameEN": "Yunnan Sheng Yuxi Shi"
  },
  {
    "code": "530401",
    "nameCN": "耿马",
    "nameEN": "Gengma"
  },
  {
    "code": "530402",
    "nameCN": "孟定清水河",
    "nameEN": "Mengding Qingshuihe"
  },
  {
    "code": "530403",
    "nameCN": "沧源",
    "nameEN": "Cangyuan"
  },
  {
    "code": "530404",
    "nameCN": "南伞",
    "nameEN": "Nansan"
  },
  {
    "code": "530500",
    "nameCN": "云南省保山市",
    "nameEN": "Yunnan Sheng Baoshan Shi"
  },
  {
    "code": "530501",
    "nameCN": "河口站",
    "nameEN": "Hekouzhan"
  },
  {
    "code": "530502",
    "nameCN": "河口",
    "nameEN": "Hekou"
  },
  {
    "code": "530600",
    "nameCN": "云南省昭通市",
    "nameEN": "Yunnan Sheng Zhaotong Shi"
  },
  {
    "code": "530601",
    "nameCN": "西双版纳",
    "nameEN": "Xishuangbanna"
  },
  {
    "code": "530602",
    "nameCN": "西双版纳国际机场",
    "nameEN": "Xishuangbanna International Airport"
  },
  {
    "code": "530603",
    "nameCN": "景洪港",
    "nameEN": "Jinghong Harbor"
  },
  {
    "code": "530604",
    "nameCN": "打洛",
    "nameEN": "Daluo"
  },
  {
    "code": "530605",
    "nameCN": "大勐龙",
    "nameEN": "Damenglong"
  },
  {
    "code": "530700",
    "nameCN": "云南省丽江市　　　　　　　",
    "nameEN": "Yunnan Sheng Lijiang Shi"
  },
  {
    "code": "530701",
    "nameCN": "普洱",
    "nameEN": "Puer"
  },
  {
    "code": "530702",
    "nameCN": "孟连",
    "nameEN": "Menglian"
  },
  {
    "code": "530703",
    "nameCN": "思茅港",
    "nameEN": "Simao Dixibei"
  },
  {
    "code": "530800",
    "nameCN": "云南省普洱市",
    "nameEN": "Yunnan Sheng Pu'er Shi"
  },
  {
    "code": "530801",
    "nameCN": "勐腊",
    "nameEN": "Mengla"
  },
  {
    "code": "530802",
    "nameCN": "磨憨",
    "nameEN": "Mohan"
  },
  {
    "code": "530803",
    "nameCN": "关累港",
    "nameEN": "Guanlei Harbor"
  },
  {
    "code": "530900",
    "nameCN": "云南省临沧市",
    "nameEN": "Yunnan Sheng Lincang Shi"
  },
  {
    "code": "530901",
    "nameCN": "金平",
    "nameEN": "Jinping"
  },
  {
    "code": "530902",
    "nameCN": "金水河",
    "nameEN": "Jinshuihe"
  },
  {
    "code": "530903",
    "nameCN": "红河综合保税区",
    "nameEN": "Honghe Comprehensive Bonded Zone"
  },
  {
    "code": "531001",
    "nameCN": "麻栗坡",
    "nameEN": "Malipo"
  },
  {
    "code": "531002",
    "nameCN": "天保",
    "nameEN": "Tianbao"
  },
  {
    "code": "531003",
    "nameCN": "田蓬",
    "nameEN": "Tianpeng"
  },
  {
    "code": "531101",
    "nameCN": "大理",
    "nameEN": "Dali"
  },
  {
    "code": "531201",
    "nameCN": "昆明长水国际机场",
    "nameEN": "Kunming Changshui International Airport"
  },
  {
    "code": "531301",
    "nameCN": "丽江三义机场",
    "nameEN": "Lijiang Sanyi Airport"
  },
  {
    "code": "531401",
    "nameCN": "勐康",
    "nameEN": "Mengkang"
  },
  {
    "code": "531402",
    "nameCN": "龙富",
    "nameEN": "Longfu"
  },
  {
    "code": "531501",
    "nameCN": "怒江",
    "nameEN": "Nujiang"
  },
  {
    "code": "531502",
    "nameCN": "片马",
    "nameEN": "Pianma"
  },
  {
    "code": "532300",
    "nameCN": "云南省楚雄彝族自治州",
    "nameEN": "Yunnan Sheng Chuxiong Yizu Zizhizhou"
  },
  {
    "code": "532500",
    "nameCN": "云南省红河哈尼族彝族自治州",
    "nameEN": "Yunnan Sheng Honghe Hanizu Yizu Zizhizhou"
  },
  {
    "code": "532600",
    "nameCN": "云南省文山壮族苗族自治州",
    "nameEN": "Yunnan Sheng Wenshan Zhuangzu Miaozu Zizhizhou"
  },
  {
    "code": "532800",
    "nameCN": "云南省西双版纳傣族自治州",
    "nameEN": "Yunnan Sheng Xishuangbanna Daizu Zizhizhou"
  },
  {
    "code": "532900",
    "nameCN": "云南省大理白族自治州",
    "nameEN": "Yunnan Sheng Dali Baizu Zizhizhou"
  },
  {
    "code": "533100",
    "nameCN": "云南省德宏傣族景颇族自治州",
    "nameEN": "Yunnan Sheng Dehong Daizu Jingpozu Zizhizhou"
  },
  {
    "code": "533300",
    "nameCN": "云南省怒江傈僳族自治州",
    "nameEN": "Yunnan Sheng Nujiang Lisuzu Zizhizhou"
  },
  {
    "code": "533400",
    "nameCN": "云南省迪庆藏族自治州",
    "nameEN": "Yunnan Sheng Deqen Zangzu Zizhizhou"
  },
  {
    "code": "540001",
    "nameCN": "拉萨",
    "nameEN": "Lhasa"
  },
  {
    "code": "540002",
    "nameCN": "拉萨贡嘎机场",
    "nameEN": "Lhasa Gongga Airport"
  },
  {
    "code": "540101",
    "nameCN": "吉隆",
    "nameEN": "Gyirong"
  },
  {
    "code": "540102",
    "nameCN": "樟木",
    "nameEN": "Zham"
  },
  {
    "code": "540103",
    "nameCN": "日屋",
    "nameEN": "Riwo"
  },
  {
    "code": "540200",
    "nameCN": "西藏自治区日喀则市",
    "nameEN": "Xizang Zizhiqu Xigaze Shi"
  },
  {
    "code": "540201",
    "nameCN": "普兰",
    "nameEN": "Burang"
  },
  {
    "code": "540300",
    "nameCN": "西藏自治区昌都市",
    "nameEN": "Xizang Zizhiqu Qamdo Shi"
  },
  {
    "code": "540400",
    "nameCN": "西藏自治区林芝市",
    "nameEN": "Xizang Zizhiqu Nyingchi Shi"
  },
  {
    "code": "540500",
    "nameCN": "西藏自治区山南市",
    "nameEN": "Xizang Zizhiqu Shannan Shi"
  },
  {
    "code": "540600",
    "nameCN": "西藏自治区那曲市",
    "nameEN": "Xizang ZiZhiqu Nagqu Shi"
  },
  {
    "code": "542500",
    "nameCN": "西藏自治区阿里地区",
    "nameEN": "Xizang Zizhiqu Ngari Diqu"
  },
  {
    "code": "610001",
    "nameCN": "西安",
    "nameEN": "Xian"
  },
  {
    "code": "610002",
    "nameCN": "西安咸阳国际机场",
    "nameEN": "Xian Xianyang International Airport"
  },
  {
    "code": "610003",
    "nameCN": "宝鸡",
    "nameEN": "Baoji"
  },
  {
    "code": "610004",
    "nameCN": "汉中",
    "nameEN": "Hanzhong"
  },
  {
    "code": "610005",
    "nameCN": "榆林",
    "nameEN": "Yulin"
  },
  {
    "code": "610006",
    "nameCN": "延安",
    "nameEN": "Yanan"
  },
  {
    "code": "610007",
    "nameCN": "渭南",
    "nameEN": "Weinan"
  },
  {
    "code": "610008",
    "nameCN": "西安综合保税区",
    "nameEN": "Xian Comprehensive Bonded Zone"
  },
  {
    "code": "610009",
    "nameCN": "西安出口加工区",
    "nameEN": "Xian Export Processind Zone"
  },
  {
    "code": "610010",
    "nameCN": "西安高新综合保税区",
    "nameEN": "Xi'an Gaoxin Comprehensive Bonded Zone"
  },
  {
    "code": "610200",
    "nameCN": "陕西省铜川市",
    "nameEN": "Shanxi Sheng Tongchuan Shi"
  },
  {
    "code": "610300",
    "nameCN": "陕西省宝鸡市",
    "nameEN": "Shanxi Sheng Baoji Shi"
  },
  {
    "code": "610400",
    "nameCN": "陕西省咸阳市",
    "nameEN": "Shanxi Sheng Xianyang Shi"
  },
  {
    "code": "610500",
    "nameCN": "陕西省渭南市",
    "nameEN": "Shanxi Sheng Weinan Shi"
  },
  {
    "code": "610600",
    "nameCN": "陕西省延安市",
    "nameEN": "Shanxi Sheng Yan'an Shi"
  },
  {
    "code": "610700",
    "nameCN": "陕西省汉中市",
    "nameEN": "Shanxi Sheng Hanzhong Shi"
  },
  {
    "code": "610800",
    "nameCN": "陕西省榆林市",
    "nameEN": "Shanxi Sheng Yulin Shi"
  },
  {
    "code": "610900",
    "nameCN": "陕西省安康市",
    "nameEN": "Shanxi Sheng Ankang Shi"
  },
  {
    "code": "611000",
    "nameCN": "陕西省商洛市",
    "nameEN": "Shanxi Sheng Shangluo Shi"
  },
  {
    "code": "620001",
    "nameCN": "兰州",
    "nameEN": "Lanzhou"
  },
  {
    "code": "620002",
    "nameCN": "兰州中川机场",
    "nameEN": "Lanzhou Zhongchuan Airport"
  },
  {
    "code": "620003",
    "nameCN": "兰州新区综合保税区",
    "nameEN": "Lanzhou Xinqu Comprehensive Bonded Zone"
  },
  {
    "code": "620101",
    "nameCN": "酒泉",
    "nameEN": "Jiuquan"
  },
  {
    "code": "620102",
    "nameCN": "马鬃山",
    "nameEN": "Mazongshan"
  },
  {
    "code": "620200",
    "nameCN": "甘肃省嘉峪关市",
    "nameEN": "Gansu Sheng Jiayuguan Shi"
  },
  {
    "code": "620300",
    "nameCN": "甘肃省金昌市",
    "nameEN": "Gansu Sheng Jinchang Shi"
  },
  {
    "code": "620400",
    "nameCN": "甘肃省白银市",
    "nameEN": "Gansu Sheng Baiyin Shi"
  },
  {
    "code": "620500",
    "nameCN": "甘肃省天水市",
    "nameEN": "Gansu Sheng Tianshui Shi"
  },
  {
    "code": "620600",
    "nameCN": "甘肃省武威市",
    "nameEN": "Gansu Sheng Wuwei Shi"
  },
  {
    "code": "620700",
    "nameCN": "甘肃省张掖市",
    "nameEN": "Gansu Sheng Zhangye Shi"
  },
  {
    "code": "620800",
    "nameCN": "甘肃省平凉市",
    "nameEN": "Gansu Sheng Pingliang Shi"
  },
  {
    "code": "620900",
    "nameCN": "甘肃省酒泉市",
    "nameEN": "Gansu Sheng Jiuquan Shi"
  },
  {
    "code": "621000",
    "nameCN": "甘肃省庆阳市",
    "nameEN": "Gansu Sheng Qingyang Shi"
  },
  {
    "code": "621100",
    "nameCN": "甘肃省定西市",
    "nameEN": "Gansu Sheng Dingxi Shi"
  },
  {
    "code": "621200",
    "nameCN": "甘肃省陇南市",
    "nameEN": "Gansu Sheng Longnan Diqu"
  },
  {
    "code": "622900",
    "nameCN": "甘肃省临夏回族自治州",
    "nameEN": "Gansu Sheng Linxia Huizu Zizhizhou"
  },
  {
    "code": "623000",
    "nameCN": "甘肃省甘南藏族自治州",
    "nameEN": "Gansu Sheng Gannan Zangzu Zizhizhou"
  },
  {
    "code": "630001",
    "nameCN": "西宁",
    "nameEN": "Xining"
  },
  {
    "code": "630002",
    "nameCN": "西宁曹家堡机场",
    "nameEN": "Xining Caojiabao Airport"
  },
  {
    "code": "630200",
    "nameCN": "青海省海东市",
    "nameEN": "Qinghai Sheng Haidong Shi"
  },
  {
    "code": "632200",
    "nameCN": "青海省海北藏族自治州",
    "nameEN": "Qinghai Sheng Haibei Zangzu Zizhizhou"
  },
  {
    "code": "632300",
    "nameCN": "青海省黄南藏族自治州",
    "nameEN": "Qinghai Sheng Huangnan Zangzu Zizhizhou"
  },
  {
    "code": "632500",
    "nameCN": "青海省海南藏族自治州",
    "nameEN": "Qinghai Sheng Hainan Zangzu Zizhizhou"
  },
  {
    "code": "632600",
    "nameCN": "青海省果洛藏族自治州",
    "nameEN": "Qinghai Sheng Golog Zangzu Zizhizhou"
  },
  {
    "code": "632700",
    "nameCN": "青海省玉树藏族自治州",
    "nameEN": "Qinghai Sheng Yushu Zangzu Zizhizhou"
  },
  {
    "code": "632800",
    "nameCN": "青海省海西蒙古族藏族自治州",
    "nameEN": "Qinghai Sheng Haixi Mongolzu Zangzu Zizhizhou"
  },
  {
    "code": "640001",
    "nameCN": "银川",
    "nameEN": "Yinchuan"
  },
  {
    "code": "640101",
    "nameCN": "银川河东机场",
    "nameEN": "Yinchuan Hedong Airport"
  },
  {
    "code": "640200",
    "nameCN": "宁夏回族自治区石嘴山市",
    "nameEN": "Ningxiahuizu Zizhiqu Shizuishan Shi"
  },
  {
    "code": "640300",
    "nameCN": "宁夏回族自治区吴忠市",
    "nameEN": "Ningxiahuizu Zizhiqu Wuzhong Shi"
  },
  {
    "code": "640400",
    "nameCN": "宁夏回族自治区固原市",
    "nameEN": "Ningxiahuizu Zizhiqu Guyuan Shi"
  },
  {
    "code": "640500",
    "nameCN": "宁夏回族自治区中卫市",
    "nameEN": "Ningxiahuizu Zizhiqu Zhongwei Shi"
  },
  {
    "code": "650001",
    "nameCN": "乌鲁木齐",
    "nameEN": "Urumqi"
  },
  {
    "code": "650002",
    "nameCN": "乌鲁木齐地窝堡国际机场",
    "nameEN": "Urumqi Diwobao International Airport"
  },
  {
    "code": "650101",
    "nameCN": "阿勒泰",
    "nameEN": "Aletai"
  },
  {
    "code": "650102",
    "nameCN": "红山嘴",
    "nameEN": "Hongshanzui"
  },
  {
    "code": "650103",
    "nameCN": "阿黑土别克",
    "nameEN": "Aheitubieke"
  },
  {
    "code": "650104",
    "nameCN": "塔克什肯",
    "nameEN": "Taykexkin "
  },
  {
    "code": "650200",
    "nameCN": "新疆维吾尔自治区克拉玛依市",
    "nameEN": "Xinjiang Uygur Zizhiqu Karamay Shi"
  },
  {
    "code": "650201",
    "nameCN": "巴克图",
    "nameEN": "Baketu"
  },
  {
    "code": "650202",
    "nameCN": "巴克图国际汽车货运",
    "nameEN": "Baketu Automobile Freight Erlei"
  },
  {
    "code": "650301",
    "nameCN": "阿拉山口公路",
    "nameEN": "Alatawshankou Highroad"
  },
  {
    "code": "650302",
    "nameCN": "阿拉山口铁路",
    "nameEN": "Alatawshankou Railway"
  },
  {
    "code": "650303",
    "nameCN": "阿拉山口综合保税区",
    "nameEN": "Alatawshankou Comprehensive Bonded Zone"
  },
  {
    "code": "650400",
    "nameCN": "新疆维吾尔自治区吐鲁番市",
    "nameEN": "Xinjiang Uygur Zizhiqu Turpan Shi"
  },
  {
    "code": "650401",
    "nameCN": "伊犁",
    "nameEN": "Yili"
  },
  {
    "code": "650402",
    "nameCN": "伊犁州国际汽车",
    "nameEN": "Yilizhou Automobile Erlei"
  },
  {
    "code": "650403",
    "nameCN": "木扎尔特",
    "nameEN": "Muzhaerte"
  },
  {
    "code": "650404",
    "nameCN": "都拉塔",
    "nameEN": "Dulata"
  },
  {
    "code": "650500",
    "nameCN": "新疆维吾尔自治区哈密市",
    "nameEN": "Xinjiang Uygur Zizhiqu Hami Shi"
  },
  {
    "code": "650501",
    "nameCN": "霍尔果斯",
    "nameEN": "Horgos"
  },
  {
    "code": "650701",
    "nameCN": "巴州",
    "nameEN": "Bazhouerrlei"
  },
  {
    "code": "650801",
    "nameCN": "喀什",
    "nameEN": "Kashi"
  },
  {
    "code": "650802",
    "nameCN": "其尼瓦格国际汽车",
    "nameEN": "Qiniwage Automabile Erlei"
  },
  {
    "code": "650803",
    "nameCN": "喀什机场",
    "nameEN": "Kashi Airport"
  },
  {
    "code": "650804",
    "nameCN": "红其拉甫",
    "nameEN": "Kunjirap"
  },
  {
    "code": "650805",
    "nameCN": "喀什综合保税区",
    "nameEN": "Kashi Comprehensive Bonded Zone"
  },
  {
    "code": "650901",
    "nameCN": "伊尔克什坦",
    "nameEN": "Yierkeshitan"
  },
  {
    "code": "650902",
    "nameCN": "吐尔尕特",
    "nameEN": "Turugart "
  },
  {
    "code": "650903",
    "nameCN": "阿图什国际汽车",
    "nameEN": "AtushiI Automabile Erlei"
  },
  {
    "code": "651001",
    "nameCN": "吉木乃",
    "nameEN": "Jeminay"
  },
  {
    "code": "651101",
    "nameCN": "卡拉苏",
    "nameEN": "Kalasu"
  },
  {
    "code": "651201",
    "nameCN": "奎屯",
    "nameEN": "Kuitun"
  },
  {
    "code": "651301",
    "nameCN": "霍尔果斯国际边境合作中心(中方配套区)",
    "nameEN": "Horgos Guoji Bianjing Hezuo Center"
  },
  {
    "code": "651401",
    "nameCN": "老爷庙",
    "nameEN": "Laoyemiao"
  },
  {
    "code": "651501",
    "nameCN": "乌拉斯台",
    "nameEN": "Ulastai"
  },
  {
    "code": "651502",
    "nameCN": "乌鲁木齐铁路",
    "nameEN": "Urumqi Railway"
  },
  {
    "code": "651503",
    "nameCN": "乌鲁木齐碾子沟客运站",
    "nameEN": "Urumqi Nianzigou Passenger Transport Erlei"
  },
  {
    "code": "651504",
    "nameCN": "边疆宾馆国际汽车货运",
    "nameEN": "Bianjiangbinguan Automobile Freight Erlei"
  },
  {
    "code": "651505",
    "nameCN": "乌鲁木齐出口加工区",
    "nameEN": "Urumqi Export Processind Zone"
  },
  {
    "code": "652300",
    "nameCN": "新疆维吾尔自治区昌吉回族自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Changji Huizu Zizhizhou"
  },
  {
    "code": "652700",
    "nameCN": "新疆维吾尔自治区博尔塔拉蒙古自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Bortala Mongol Zizhizhou"
  },
  {
    "code": "652800",
    "nameCN": "新疆维吾尔自治区巴音郭楞蒙古自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Bayingolin Mongol Zizhizhou"
  },
  {
    "code": "652900",
    "nameCN": "新疆维吾尔自治区阿克苏地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Aksu Diqu"
  },
  {
    "code": "653000",
    "nameCN": "新疆维吾尔自治区克孜勒苏柯尔克孜自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Kizilsu Kirgiz Zizhizhou"
  },
  {
    "code": "653100",
    "nameCN": "新疆维吾尔自治区喀什地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Kashi Diqu"
  },
  {
    "code": "653200",
    "nameCN": "新疆维吾尔自治区和田地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Hotan Diqu"
  },
  {
    "code": "654000",
    "nameCN": "新疆维吾尔自治区伊犁哈萨克自治州",
    "nameEN": "Xinjiang Uygur Zizhiqu Ili Kazak Zizhizhou"
  },
  {
    "code": "654200",
    "nameCN": "新疆维吾尔自治区塔城地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Tacheng Diqu"
  },
  {
    "code": "654300",
    "nameCN": "新疆维吾尔自治区阿勒泰地区",
    "nameEN": "Xinjiang Uygur Zizhiqu Altay Diqu"
  },
  {
    "code": "659000",
    "nameCN": "新疆维吾尔自治区自治区直辖县级行政单位",
    "nameEN": "Xinjiang Uygur Zizhiqu Zizhiqu Zhixia Xianji Xingzhengdanwei"
  },
  {
    "code": "999999",
    "nameCN": "未列出的特殊监管区",
    "nameEN": "Unlisted Special Supervision Areas"
  }
]

export const customOptions = [
  {
    'permissionCode': 'customers:create',
    'permissionDescription': '添加新客户',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'customers:maintain',
    'permissionDescription': '客户信息维护',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'customers:delete',
    'permissionDescription': '删除客户',
    'type': 'BUTTON'
}]

export const employeeOptions = [
  {
    'permissionCode': 'staff:create',
    'permissionDescription': '添加新员工',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'staff:delete',
    'permissionDescription': '移除员工',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'staff:permission:transfer',
    'permissionDescription': '移交管理权限',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'staff:maintain',
    'permissionDescription': '员工信息维护',
    'type': 'BUTTON'
}]

export const roleOptions = [
  {
    'permissionCode': 'user-roles:grant:SUPER_ADMIN',
    'permissionDescription': '授予超级管理员的权限',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'user-roles:grant:ADMIN',
    'permissionDescription': '授予ADMIN的权限',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'user-roles:grant:OPERATOR',
    'permissionDescription': '授予OPERATOR的权限',
    'type': 'BUTTON'
  },
  {
    'permissionCode': 'user-roles:grant:CUSTOMER',
    'permissionDescription': '授予CUSTOMER的权限',
    'type': 'BUTTON'
}]

export const portOptions = [
  {
    'permissionCode': 'ports:add-slic',
    'permissionDescription': '添加SLIC到口岸',
    'type': 'BUTTON'
}]

export const exceptionTrackingInfo = {
  trackingNumber: '',
  operator: '',
  serviceType: '',
  shipperUpsId: '',
  shipperAccount: '',
  shipperName: '',
  shipperCompany: '',
  shipperAddress: '',
  shipperPhone: '',
  recipientUpsId: '',
  recipientAccount: '',
  recipientName: '',
  recipientChineseName: '',
  recipientAddress: '',
  recipientCompany: '',
  recipientPhone: '',
  packageType: '',
  packageWeight: '',
  packageVolume: '',
  packageDeclaredValue: '',
  currencyCode: 'CNY',
  products: [
    {
      productDescription: '',
      productDescriptionEnglish: '',
      htsCode: ''
    }
  ],
  altBroker: '',
  declareType: [],
  businessUnit: '',
  businessUnitScc: '',
  businessUnitCode: '',
  isImport: false,
  portCode: '',
  packageNumber: '',
  packageGrossWeight: '',
  packageNetWeight: '',
  altBrokerInput: ''
}

export const exceptionInfo = {
  exceptionDetails: [
    {
      exceptionCode: '',
      exceptionDescription: '',
      exceptionHandling: ''
    }
  ],
  isExchangeHtsCodeChecked: false,
  isExchangeCreditCodeChecked: false,
  isUpdateProductDescriptionChecked: false,
  isUpdateProductDeclareElementChecked: false,
  isExchangeCustomsCodeChecked: false,
  isPersonalIdChecked: false,
  isPassportChecked: false,
  isPoaChecked: false,
  isElectronicProxyChecked: false,
  isWaybillChecked: false,
  isPackingListChecked: false,
  isCommercialInvoiceChecked: false,
  isTradeContractChecked: false,
  isProxyProtocolChecked: false,
  isPriceExemptionChecked: false,
  isFactSheetChecked: false,
  isLegalInspectionChecked: false,
  isOriginCertificateChecked: false,
  otherDocuments: [''],
  sendToWechat: '',
  sendToEmail: '',
  sendToSms: '',
  personalPhone: '',
  personalEmail: '',
  otherDescriptions: [''],
  exceptionSummary: ''
}

export const contact = {
  shipperWechat: '',
  shipperEmail: '',
  shipperSms: '',
  recipientWechat: '',
  recipientEmail: '',
  recipientSms: '',
  upsAccount: '',
  upsAccountWechat: '',
  upsAccountEmail: '',
  upsAccountSms: ''
}

export const declareTypeOption = [
  {
    value: 'A',
    label: 'A类',
    children:[{
      value: '个人资料',
      label: '个人资料',
    }]
  },
  {
    value: 'B',
    label: 'B类',
    children:[{
      value: '个人物品',
      label: '个人物品',
    },{
      value: '分运行李',
      label: '分运行李',
    }]
  },
  {
    value: 'C',
    label: 'C类',
    children:[{
      value: 'KJ3/快速清关',
      label: 'KJ3/快速清关',
    }]
  },
  {
    value: 'D',
    label: 'D类',
    children:[{
      value: '一般贸易',
      label: '一般贸易',
    },{
      value: '货样广告品',
      label: '货样广告品',
    },{
      value: '免费提供',
      label: '免费提供',
    },{
      value: '进/来料加工',
      label: '进/来料加工',
    },{
      value: '进料成品退换',
      label: '进料成品退换',
    },{
      value: '无代价抵偿',
      label: '无代价抵偿',
    },{
      value: '退运',
      label: '退运',
    },{
      value: '放弃',
      label: '放弃',
    },{
      value: '修理物品',
      label: '修理物品',
    },{
      value: '低值辅料',
      label: '低值辅料',
    }]
  }
]

export const ShippingPaymentTypes = [
  {
    label: 'FD',
    value: 'FD'
  },
  {
    label: 'FC',
    value: 'FC'
  },
  {
    label: 'PP',
    value: 'PP'
  }
]

export const BillTerms = ['P/P', 'F/C', 'F/D']

export const TaxPaymentTypes = [
  {
    label: 'UPS垫付',
    value: '0'
  },
  {
    label: '月结',
    value: '1'
  },
  {
    label: '电子支付',
    value: '2'
  },
  {
    label: '发件人支付',
    value: '3'
  }
]

export const declarationTypes = [
  {
    label: '个人物品申报(B类)出口报关',
    value: 'OB'
  },
  {
    label: '低值货物快件(C类)出口报关',
    value: 'OC'
  },
  {
    label: '正式申报类货物(D类)出口报关',
    value: 'OD'
  },
  {
    label: '个人物品申报(B类)进口报关',
    value: 'IB'
  },
  {
    label: '低值货物快件(C类)进口报关',
    value: 'IC'
  },
  {
    label: '正式申报类货物(D类)进口报关',
    value: 'ID'
  }
]
